var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/data/parks/magic-kingdom.json
var magic_kingdom_default;
var init_magic_kingdom = __esm({
  "src/data/parks/magic-kingdom.json"() {
    magic_kingdom_default = {
      id: "magic-kingdom",
      name: "Magic Kingdom",
      abbreviation: "MK",
      location: "Walt Disney World Resort, Orlando, FL",
      description: "The most magical place on earth, featuring classic Disney attractions, beloved characters, and timeless stories brought to life across six themed lands.",
      openingTime: "09:00",
      closingTime: "22:00"
    };
  }
});

// src/data/parks/epcot.json
var epcot_default;
var init_epcot = __esm({
  "src/data/parks/epcot.json"() {
    epcot_default = {
      id: "epcot",
      name: "EPCOT",
      abbreviation: "EP",
      location: "Walt Disney World Resort, Orlando, FL",
      description: "Celebrate human achievement and international culture in this park dedicated to technological innovation and world showcase.",
      openingTime: "09:00",
      closingTime: "21:00"
    };
  }
});

// src/data/parks/hollywood-studios.json
var hollywood_studios_default;
var init_hollywood_studios = __esm({
  "src/data/parks/hollywood-studios.json"() {
    hollywood_studios_default = {
      id: "hollywood-studios",
      name: "Hollywood Studios",
      abbreviation: "HS",
      location: "Walt Disney World Resort, Orlando, FL",
      description: "Step into the magic of movies and television at this park celebrating the art of filmmaking, from classic Hollywood to modern blockbusters.",
      openingTime: "09:00",
      closingTime: "21:30"
    };
  }
});

// src/data/parks/animal-kingdom.json
var animal_kingdom_default;
var init_animal_kingdom = __esm({
  "src/data/parks/animal-kingdom.json"() {
    animal_kingdom_default = {
      id: "animal-kingdom",
      name: "Animal Kingdom",
      abbreviation: "AK",
      location: "Walt Disney World Resort, Orlando, FL",
      description: "Discover the magic of nature in this zoological theme park featuring real animals, thrilling attractions, and immersive lands including Pandora - The World of Avatar.",
      openingTime: "08:00",
      closingTime: "20:00"
    };
  }
});

// src/data/parks/index.ts
var parks_exports = {};
__export(parks_exports, {
  getPark: () => getPark,
  getParks: () => getParks,
  parks: () => parks
});
var parks, getPark, getParks;
var init_parks = __esm({
  "src/data/parks/index.ts"() {
    "use strict";
    init_magic_kingdom();
    init_epcot();
    init_hollywood_studios();
    init_animal_kingdom();
    parks = [
      magic_kingdom_default,
      epcot_default,
      hollywood_studios_default,
      animal_kingdom_default
    ];
    getPark = (id) => {
      return parks.find((park) => park.id === id);
    };
    getParks = () => {
      return parks;
    };
  }
});

// src/data/schedules/entertainment-schedules.json
var entertainment_schedules_default;
var init_entertainment_schedules = __esm({
  "src/data/schedules/entertainment-schedules.json"() {
    entertainment_schedules_default = {
      "magic-kingdom": {
        "mk-festival-fantasy-parade": {
          showTimes: ["2:00 PM"],
          lastUpdated: "2025-01-15",
          notes: "Single daily performance"
        },
        "mk-happily-ever-after": {
          showTimes: ["9:00 PM"],
          lastUpdated: "2025-01-15",
          notes: "Nightly fireworks spectacular"
        },
        "mk-disney-starlight": {
          showTimes: ["8:00 PM", "10:00 PM"],
          lastUpdated: "2025-01-15",
          notes: "Twice nightly when available, not during special events"
        },
        "mk-dapper-dans": {
          showTimes: ["Multiple times daily"],
          lastUpdated: "2025-01-15",
          notes: "Check My Disney Experience app for current times"
        }
      },
      epcot: {
        "epcot-luminous": {
          showTimes: ["9:00 PM"],
          lastUpdated: "2025-01-15",
          notes: "Nightly fireworks spectacular"
        },
        "epcot-celebracion-encanto": {
          showTimes: ["9:45 AM", "10:45 AM", "11:45 AM", "1:30 PM", "2:30 PM", "3:30 PM"],
          lastUpdated: "2025-01-15",
          notes: "Multiple daily performances"
        },
        "epcot-mariachi-cobre": {
          showTimes: ["Multiple times daily"],
          lastUpdated: "2025-01-15",
          notes: "Check My Disney Experience app for current times"
        },
        "epcot-voices-of-liberty": {
          showTimes: ["Multiple times daily"],
          lastUpdated: "2025-01-15",
          notes: "Usually before American Adventure shows"
        }
      },
      "hollywood-studios": {
        "hs-fantasmic": {
          showTimes: ["8:30 PM", "10:00 PM"],
          lastUpdated: "2025-01-15",
          notes: "Twice nightly when available, may have single show on select dates"
        },
        "hs-star-wars-march": {
          showTimes: ["Multiple times daily"],
          lastUpdated: "2025-01-15",
          notes: "Check My Disney Experience app for current times"
        }
      },
      "animal-kingdom": {
        _placeholder: {
          showTimes: [],
          lastUpdated: "2025-01-15",
          notes: "Entertainment data to be added"
        }
      }
    };
  }
});

// src/data/do/rides/magic-kingdom-rides.json
var magic_kingdom_rides_default;
var init_magic_kingdom_rides = __esm({
  "src/data/do/rides/magic-kingdom-rides.json"() {
    magic_kingdom_rides_default = [
      {
        id: "space-mountain",
        parkId: "magic-kingdom",
        name: "Space Mountain",
        description: "Blast off on a thrilling indoor roller coaster through space in complete darkness, with only stars and cosmic projections lighting your way.",
        location: "Tomorrowland",
        type: "ride",
        duration: 3,
        heightRequirement: 44,
        intensity: "high",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "space-mountain-tip-1",
            content: "Best time to ride is during parades or fireworks when crowds are elsewhere",
            category: "best_time",
            priority: 5
          },
          {
            id: "space-mountain-tip-2",
            content: "Right side of the rocket tends to be smoother than left side",
            category: "strategy",
            priority: 4
          },
          {
            id: "space-mountain-tip-3",
            content: "Keep your head back against the headrest to avoid neck strain",
            category: "general",
            priority: 3
          }
        ],
        tags: [
          "thrill",
          "classic",
          "popular"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: true,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          bigDrops: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "haunted-mansion",
        parkId: "magic-kingdom",
        name: "Haunted Mansion",
        description: "Tour a ghost-filled mansion in your Doom Buggy and discover 999 happy haunts in this classic Disney dark ride.",
        location: "Liberty Square",
        type: "ride",
        duration: 9,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "haunted-mansion-tip-1",
            content: "Look for hidden Mickeys throughout the attraction, especially in the ballroom scene",
            category: "photo",
            priority: 3
          },
          {
            id: "haunted-mansion-tip-2",
            content: "The stretching room works differently - don't look up too early",
            category: "general",
            priority: 4
          },
          {
            id: "haunted-mansion-tip-3",
            content: "Great alternative during busy times since it has high capacity",
            category: "strategy",
            priority: 5
          }
        ],
        tags: [
          "family-friendly",
          "classic",
          "high-capacity"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          scary: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "pirates-of-the-caribbean",
        parkId: "magic-kingdom",
        name: "Pirates of the Caribbean",
        description: "Set sail through a world of swashbuckling pirates and treasure-filled adventures in this immersive boat ride.",
        location: "Adventureland",
        type: "ride",
        duration: 8,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "pirates-tip-1",
            content: "Sit on the right side for better views of the auction scene",
            category: "strategy",
            priority: 4
          },
          {
            id: "pirates-tip-2",
            content: "Watch for the talking skull and crossbones - they give warnings",
            category: "general",
            priority: 3
          },
          {
            id: "pirates-tip-3",
            content: "Great choice during hot weather - it's air conditioned and cool inside",
            category: "best_time",
            priority: 4
          }
        ],
        tags: [
          "boat-ride",
          "family-friendly",
          "classic",
          "air-conditioned",
          "immersive"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "big-thunder-mountain",
        parkId: "magic-kingdom",
        name: "Big Thunder Mountain Railroad",
        description: "Race through a mining cavern aboard a runaway mine train in the wildest ride in the wilderness. CURRENTLY CLOSED for refurbishment until 2026.",
        location: "Frontierland",
        type: "ride",
        duration: 3,
        heightRequirement: 40,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "big-thunder-tip-1",
            content: "ATTRACTION CLOSED: Closed January 6, 2025 for lengthy refurbishment, reopening in 2026",
            category: "strategy",
            priority: 5
          },
          {
            id: "big-thunder-tip-2",
            content: "Back row provides the best experience with more airtime (when operational)",
            category: "strategy",
            priority: 4
          },
          {
            id: "big-thunder-tip-3",
            content: "Great first coaster for kids - smooth and not too intense",
            category: "general",
            priority: 4
          }
        ],
        tags: [
          "coaster",
          "family-friendly",
          "outdoor",
          "scenic",
          "moderate-thrill",
          "temporarily-closed"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "jungle-cruise",
        parkId: "magic-kingdom",
        name: "Jungle Cruise",
        description: "Navigate dangerous waters and encounter exotic animals on this classic boat tour with your wise-cracking skipper.",
        location: "Adventureland",
        type: "ride",
        duration: 10,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "jungle-cruise-tip-1",
            content: "Each skipper has different jokes - multiple rides can be very different",
            category: "general",
            priority: 4
          },
          {
            id: "jungle-cruise-tip-2",
            content: "Back of the boat gives best views but middle seats are most comfortable",
            category: "strategy",
            priority: 3
          },
          {
            id: "jungle-cruise-tip-3",
            content: "Skip during busy times - wait can be long for a 10-minute ride",
            category: "best_time",
            priority: 5
          }
        ],
        tags: [
          "boat-ride",
          "family-friendly",
          "comedy",
          "classic",
          "outdoor"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      },
      {
        id: "its-a-small-world",
        parkId: "magic-kingdom",
        name: `"it's a small world"`,
        description: "Cruise through different countries and cultures while listening to the famous song performed by audio-animatronic dolls.",
        location: "Fantasyland",
        type: "ride",
        duration: 11,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "small-world-tip-1",
            content: "Look for hidden Disney characters throughout the ride",
            category: "photo",
            priority: 3
          },
          {
            id: "small-world-tip-2",
            content: "Great for hot days - fully air conditioned and relaxing",
            category: "best_time",
            priority: 4
          },
          {
            id: "small-world-tip-3",
            content: "Perfect for all ages and a good rest break",
            category: "general",
            priority: 4
          }
        ],
        tags: [
          "boat-ride",
          "family-friendly",
          "classic",
          "air-conditioned",
          "relaxing"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "seven-dwarfs-mine-train",
        parkId: "magic-kingdom",
        name: "Seven Dwarfs Mine Train",
        description: "Join the Seven Dwarfs on a swaying, musical mine car adventure through the diamond mine from Snow White.",
        location: "Fantasyland",
        type: "ride",
        duration: 3,
        heightRequirement: 38,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "seven-dwarfs-tip-1",
            content: "Most popular ride in park - get Lightning Lane or rope drop",
            category: "best_time",
            priority: 5
          },
          {
            id: "seven-dwarfs-tip-2",
            content: "Cars sway side to side - unique experience among Disney coasters",
            category: "general",
            priority: 4
          },
          {
            id: "seven-dwarfs-tip-3",
            content: "Beautiful at night with all the lighting effects",
            category: "photo",
            priority: 4
          }
        ],
        tags: [
          "coaster",
          "family-friendly",
          "new",
          "popular",
          "immersive"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: true,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "peter-pans-flight",
        parkId: "magic-kingdom",
        name: "Peter Pan's Flight",
        description: "Soar over London and Neverland in a flying pirate ship on this beloved dark ride through the Peter Pan story.",
        location: "Fantasyland",
        type: "ride",
        duration: 3,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "peter-pan-tip-1",
            content: "Always has long waits despite being short - use Lightning Lane",
            category: "strategy",
            priority: 5
          },
          {
            id: "peter-pan-tip-2",
            content: "Flying over London is magical - one of Disney's best dark ride moments",
            category: "general",
            priority: 4
          },
          {
            id: "peter-pan-tip-3",
            content: "Try to ride early morning or during parades",
            category: "best_time",
            priority: 4
          }
        ],
        tags: [
          "dark-ride",
          "family-friendly",
          "classic",
          "popular",
          "short"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "buzz-lightyear",
        parkId: "magic-kingdom",
        name: "Buzz Lightyear's Space Ranger Spin",
        description: "Help Buzz Lightyear defeat Emperor Zurg by shooting targets with laser cannons in this interactive dark ride. CURRENTLY CLOSED for refurbishment until 2026.",
        location: "Tomorrowland",
        type: "ride",
        duration: 4,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "buzz-tip-1",
            content: "ATTRACTION CLOSED: Closed August 4, 2025 for refurbishment, reopening in 2026",
            category: "strategy",
            priority: 5
          },
          {
            id: "buzz-tip-2",
            content: "Aim for triangular targets for highest points - they're worth 100,000 (when operational)",
            category: "strategy",
            priority: 4
          },
          {
            id: "buzz-tip-3",
            content: "Great for competitive families - everyone gets a score",
            category: "general",
            priority: 4
          }
        ],
        tags: [
          "interactive",
          "family-friendly",
          "shooting",
          "competitive",
          "toy-story",
          "temporarily-closed"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: true,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "tianas-bayou-adventure",
        parkId: "magic-kingdom",
        name: "Tiana's Bayou Adventure",
        description: "Join Princess Tiana and Louis on a musical log flume adventure through the bayou as they prepare for a Mardi Gras celebration, ending with a thrilling drop.",
        location: "Frontierland",
        type: "ride",
        duration: 11,
        heightRequirement: 40,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "tiana-tip-1",
            content: "You will get wet - front seats get wettest, back stays driest",
            category: "strategy",
            priority: 5
          },
          {
            id: "tiana-tip-2",
            content: "Perfect on hot days but avoid when it's cold",
            category: "best_time",
            priority: 5
          },
          {
            id: "tiana-tip-3",
            content: "Photo taken right before the big drop - make it count!",
            category: "photo",
            priority: 4
          },
          {
            id: "tiana-tip-4",
            content: "Brand new attraction - extremely popular, use Lightning Lane or arrive early",
            category: "strategy",
            priority: 5
          }
        ],
        tags: [
          "log-flume",
          "water-ride",
          "thrill",
          "new",
          "photo-op",
          "princess-tiana"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: true,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "mad-tea-party",
        parkId: "magic-kingdom",
        name: "Mad Tea Party",
        description: "Spin around in colorful teacups at this whimsical attraction inspired by Alice in Wonderland.",
        location: "Fantasyland",
        type: "ride",
        duration: 2,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "tea-party-tip-1",
            content: "You control how fast you spin - turn the wheel in the center",
            category: "strategy",
            priority: 5
          },
          {
            id: "tea-party-tip-2",
            content: "Skip if you're prone to motion sickness",
            category: "general",
            priority: 4
          },
          {
            id: "tea-party-tip-3",
            content: "Great for kids but can have long waits for a short ride",
            category: "best_time",
            priority: 3
          }
        ],
        tags: [
          "spinning",
          "family-friendly",
          "outdoor",
          "classic",
          "alice"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: true,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: true,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "dumbo",
        parkId: "magic-kingdom",
        name: "Dumbo the Flying Elephant",
        description: "Soar through the sky on the back of everyone's favorite flying elephant in this classic kiddie ride.",
        location: "Fantasyland",
        type: "ride",
        duration: 2,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "dumbo-tip-1",
            content: "Use the pager system - grab a pager instead of standing in line",
            category: "strategy",
            priority: 5
          },
          {
            id: "dumbo-tip-2",
            content: "You control how high you fly with the joystick",
            category: "general",
            priority: 4
          },
          {
            id: "dumbo-tip-3",
            content: "Great views of Fantasyland from the top",
            category: "photo",
            priority: 3
          }
        ],
        tags: [
          "kiddie-ride",
          "family-friendly",
          "outdoor",
          "classic",
          "views"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "astro-orbitor",
        parkId: "magic-kingdom",
        name: "Astro Orbitor",
        description: "Pilot your own rocket ship high above Tomorrowland in this spinning ride with great views.",
        location: "Tomorrowland",
        type: "ride",
        duration: 2,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "astro-tip-1",
            content: "Best views in Magic Kingdom from the highest position",
            category: "photo",
            priority: 4
          },
          {
            id: "astro-tip-2",
            content: "Can be scary for young kids due to height",
            category: "general",
            priority: 4
          },
          {
            id: "astro-tip-3",
            content: "Long load time - usually not worth the wait",
            category: "best_time",
            priority: 3
          }
        ],
        tags: [
          "spinning",
          "family-friendly",
          "outdoor",
          "views",
          "height"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: true,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: true,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "magic-carpets",
        parkId: "magic-kingdom",
        name: "The Magic Carpets of Aladdin",
        description: "Take flight on a colorful magic carpet while avoiding the spitting camels below.",
        location: "Adventureland",
        type: "ride",
        duration: 2,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "carpets-tip-1",
            content: "Watch out for the spitting camels - they really spray water!",
            category: "general",
            priority: 4
          },
          {
            id: "carpets-tip-2",
            content: "Similar to Dumbo but with water effects",
            category: "strategy",
            priority: 3
          },
          {
            id: "carpets-tip-3",
            content: "Front seat controls up/down, back seat controls tilt",
            category: "strategy",
            priority: 4
          }
        ],
        tags: [
          "kiddie-ride",
          "family-friendly",
          "outdoor",
          "water-effects",
          "aladdin"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: true,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "tomorrowland-peoplemover",
        parkId: "magic-kingdom",
        name: "Tomorrowland Transit Authority PeopleMover",
        description: "Take a relaxing elevated tour of Tomorrowland on this slow-moving transportation system.",
        location: "Tomorrowland",
        type: "ride",
        duration: 10,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "peoplemover-tip-1",
            content: "Perfect for rest breaks - rarely has a wait and fully air-conditioned",
            category: "best_time",
            priority: 5
          },
          {
            id: "peoplemover-tip-2",
            content: "Great views inside Space Mountain and other Tomorrowland attractions",
            category: "photo",
            priority: 4
          },
          {
            id: "peoplemover-tip-3",
            content: "Walt Disney originally envisioned this as transportation for EPCOT",
            category: "general",
            priority: 3
          }
        ],
        tags: [
          "transportation",
          "relaxing",
          "air-conditioned",
          "classic",
          "views"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "tomorrowland-speedway",
        parkId: "magic-kingdom",
        name: "Tomorrowland Speedway",
        description: "Race around a track in your own gas-powered Indy-style race car on this classic attraction.",
        location: "Tomorrowland",
        type: "ride",
        duration: 4,
        heightRequirement: 32,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "speedway-tip-1",
            content: "Cars are on rails but you can make them go faster by pressing the pedal harder",
            category: "strategy",
            priority: 4
          },
          {
            id: "speedway-tip-2",
            content: "Can be very loud and smelly - not ideal for sensitive guests",
            category: "general",
            priority: 4
          },
          {
            id: "speedway-tip-3",
            content: "Often has long waits for what it offers - consider Lightning Lane",
            category: "best_time",
            priority: 3
          }
        ],
        tags: [
          "driving",
          "outdoor",
          "classic",
          "loud",
          "gas-powered"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: true,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "under-the-sea",
        parkId: "magic-kingdom",
        name: "Under the Sea ~ Journey of The Little Mermaid",
        description: "Join Ariel and friends in a musical adventure through the story of The Little Mermaid.",
        location: "Fantasyland",
        type: "ride",
        duration: 6,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "little-mermaid-tip-1",
            content: "High capacity ride with typically short waits",
            category: "best_time",
            priority: 5
          },
          {
            id: "little-mermaid-tip-2",
            content: "Look for Sebastian and Flounder throughout the underwater scenes",
            category: "photo",
            priority: 3
          },
          {
            id: "little-mermaid-tip-3",
            content: "Great for all ages and perfect introduction to Disney dark rides",
            category: "general",
            priority: 4
          }
        ],
        tags: [
          "dark-ride",
          "family-friendly",
          "musical",
          "little-mermaid",
          "high-capacity"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "main-street-vehicles",
        parkId: "magic-kingdom",
        name: "Main Street Vehicles",
        description: "Take a one-way trip down Main Street U.S.A. in vintage vehicles including trolleys, omnibuses, and fire engines.",
        location: "Main Street U.S.A.",
        type: "transportation",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "main-street-vehicles-tip-1",
            content: "Only run during less busy times and may close due to crowds",
            category: "best_time",
            priority: 4
          },
          {
            id: "main-street-vehicles-tip-2",
            content: "Great photo opportunity and vintage Disney charm",
            category: "photo",
            priority: 4
          },
          {
            id: "main-street-vehicles-tip-3",
            content: "One-way only from Town Square to Central Plaza",
            category: "strategy",
            priority: 3
          }
        ],
        tags: [
          "transportation",
          "vintage",
          "main-street",
          "photo-op",
          "classic"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "walt-disney-railroad",
        parkId: "magic-kingdom",
        name: "Walt Disney World Railroad",
        description: "Take a scenic train ride around Magic Kingdom with stops at Main Street, Frontierland, and Fantasyland.",
        location: "Main Street U.S.A.",
        type: "transportation",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "railroad-tip-1",
            content: "Great way to rest your feet and see the park from different angles",
            category: "strategy",
            priority: 5
          },
          {
            id: "railroad-tip-2",
            content: "Full loop takes 20 minutes, or hop off at any of the three stations",
            category: "general",
            priority: 4
          },
          {
            id: "railroad-tip-3",
            content: "Best views of the park's backstage areas during the ride",
            category: "photo",
            priority: 3
          }
        ],
        tags: [
          "transportation",
          "scenic",
          "relaxing",
          "classic",
          "multi-station"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "barnstormer",
        parkId: "magic-kingdom",
        name: "The Barnstormer",
        description: "Take flight with Goofy on this kid-friendly roller coaster in the Storybook Circus area.",
        location: "Fantasyland",
        type: "ride",
        duration: 1,
        heightRequirement: 35,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "barnstormer-tip-1",
            content: "Perfect first roller coaster for young kids",
            category: "general",
            priority: 5
          },
          {
            id: "barnstormer-tip-2",
            content: "Very short ride - often not worth long waits",
            category: "best_time",
            priority: 4
          },
          {
            id: "barnstormer-tip-3",
            content: "Great views of Fantasyland from the top",
            category: "photo",
            priority: 3
          }
        ],
        tags: [
          "kiddie-coaster",
          "goofy",
          "short",
          "family-friendly",
          "first-coaster"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "tron-lightcycle-run",
        parkId: "magic-kingdom",
        name: "TRON Lightcycle / Run",
        description: "Board a lightcycle and launch into the Grid for a high-speed adventure through the digital frontier inspired by Disney's TRON films.",
        location: "Tomorrowland",
        type: "ride",
        duration: 2,
        heightRequirement: 48,
        intensity: "high",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "tron-tip-1",
            content: "Virtual queue required - join at park opening or 1pm",
            category: "strategy",
            priority: 5
          },
          {
            id: "tron-tip-2",
            content: "Store loose items in lockers before riding - they're free for the ride duration",
            category: "strategy",
            priority: 5
          },
          {
            id: "tron-tip-3",
            content: "Individual Lightning Lane available for purchase",
            category: "strategy",
            priority: 4
          },
          {
            id: "tron-tip-4",
            content: "Incredible at night with the canopy lit up",
            category: "photo",
            priority: 4
          }
        ],
        tags: [
          "virtual-queue",
          "newest",
          "indoor-outdoor",
          "futuristic",
          "high-speed"
        ],
        features: {
          multiPass: false,
          singlePass: true,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: true,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          launchSpeed: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "many-adventures-winnie-pooh",
        parkId: "magic-kingdom",
        name: "The Many Adventures of Winnie the Pooh",
        description: "Join Pooh, Piglet, Eeyore, and Tigger on a whimsical journey through the Hundred Acre Wood in honey pot vehicles.",
        location: "Fantasyland",
        type: "ride",
        duration: 4,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "pooh-tip-1",
            content: "Look for interactive elements like the spinning honey pot and bouncing with Tigger",
            category: "general",
            priority: 4
          },
          {
            id: "pooh-tip-2",
            content: "Great for all ages - perfect first dark ride for young children",
            category: "general",
            priority: 4
          },
          {
            id: "pooh-tip-3",
            content: "Usually shorter waits compared to other Fantasyland dark rides",
            category: "best_time",
            priority: 3
          }
        ],
        tags: [
          "dark-ride",
          "family-friendly",
          "winnie-the-pooh",
          "classic",
          "interactive"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "prince-charming-carrousel",
        parkId: "magic-kingdom",
        name: "Prince Charming Regal Carrousel",
        description: "Take a spin on Cinderella's royal carrousel featuring 90 hand-painted horses in the shadow of Cinderella Castle.",
        location: "Fantasyland",
        type: "ride",
        duration: 2,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "carrousel-tip-1",
            content: "Look for Cinderella's horse - it has a golden ribbon in its tail",
            category: "photo",
            priority: 4
          },
          {
            id: "carrousel-tip-2",
            content: "Great views of Cinderella Castle while riding",
            category: "photo",
            priority: 3
          },
          {
            id: "carrousel-tip-3",
            content: "Perfect for all ages - very gentle ride",
            category: "general",
            priority: 3
          }
        ],
        tags: [
          "classic",
          "cinderella",
          "gentle",
          "all-ages",
          "historic"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      }
    ];
  }
});

// src/data/do/rides/epcot-rides.json
var epcot_rides_default;
var init_epcot_rides = __esm({
  "src/data/do/rides/epcot-rides.json"() {
    epcot_rides_default = [
      {
        id: "epcot-spaceship-earth",
        parkId: "epcot",
        name: "Spaceship Earth",
        description: "Journey through the history of human communication in EPCOT's iconic geodesic sphere, from cave paintings to the digital age.",
        location: "World Celebration",
        type: "ride",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true
        },
        tips: [
          {
            id: "se-tip-1",
            content: "Currently closed for refurbishment until Thanksgiving 2025. Check official Disney app for reopening updates.",
            category: "general",
            priority: 5
          }
        ],
        tags: [
          "temporarily-closed"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "epcot-test-track",
        parkId: "epcot",
        name: "Test Track 3.0",
        description: "Design your own vehicle and put it through high-speed automotive testing on this reimagined attraction with World of Motion inspiration.",
        location: "World Discovery",
        type: "ride",
        duration: 5,
        heightRequirement: 40,
        intensity: "high",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "tt-tip-1",
            content: "Newly reimagined attraction reopened July 2025. Single rider line available for shorter waits.",
            category: "strategy",
            priority: 4
          },
          {
            id: "tt-tip-2",
            content: "Design phase can take time - have your group discuss preferences beforehand.",
            category: "strategy",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: true,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: true,
          launchSpeed: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "epcot-guardians-cosmic-rewind",
        parkId: "epcot",
        name: "Guardians of the Galaxy: Cosmic Rewind",
        description: "Join the Guardians on a time-traveling adventure through space on this reverse-launch spinning coaster with a rocking soundtrack.",
        location: "World Discovery",
        type: "ride",
        duration: 3,
        heightRequirement: 42,
        intensity: "extreme",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "gc-tip-1",
            content: "No longer requires virtual queue as of February 2025. Standby line now available!",
            category: "strategy",
            priority: 5
          },
          {
            id: "gc-tip-2",
            content: "Each ride features a different soundtrack. Multiple rides for different songs!",
            category: "general",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: false,
          singlePass: true,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: true,
          loudSounds: true,
          strobeEffects: true,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          launchSpeed: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "epcot-mission-space",
        parkId: "epcot",
        name: "Mission: SPACE",
        description: "Experience the thrill of space exploration with this intense centrifugal simulator mission to Mars. Choose Orange (intense) or Green (less intense).",
        location: "World Discovery",
        type: "ride",
        duration: 5,
        heightRequirement: 40,
        intensity: "high",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "ms-tip-1",
            content: "Orange version is very intense with spinning. Green version has no spinning motion.",
            category: "strategy",
            priority: 5
          },
          {
            id: "ms-tip-2",
            content: "Don't eat a heavy meal before riding. Motion sickness is common on Orange.",
            category: "general",
            priority: 4
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: true,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "epcot-soarin",
        parkId: "epcot",
        name: "Soarin' Around the World",
        description: "Soar over breathtaking landscapes and iconic landmarks from around the world in this immersive flight experience.",
        location: "World Nature",
        type: "ride",
        duration: 5,
        heightRequirement: 40,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "so-tip-1",
            content: "Center seats in theaters A and B provide the best experience with less distortion.",
            category: "strategy",
            priority: 4
          },
          {
            id: "so-tip-2",
            content: "Experience includes scent effects - notice the orange groves and ocean air!",
            category: "general",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "epcot-living-with-land",
        parkId: "epcot",
        name: "Living with the Land",
        description: "Take a peaceful boat tour through innovative greenhouses and agricultural research labs showcasing sustainable farming techniques.",
        location: "World Nature",
        type: "ride",
        duration: 14,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true
        },
        tips: [
          {
            id: "lw-tip-1",
            content: "Behind the Seeds tour available for deeper dive into the greenhouse research.",
            category: "general",
            priority: 3
          },
          {
            id: "lw-tip-2",
            content: "Great attraction for all ages and perfect air-conditioned break from Florida heat.",
            category: "strategy",
            priority: 2
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "epcot-seas-nemo",
        parkId: "epcot",
        name: "The Seas with Nemo & Friends",
        description: "Join Nemo, Dory, and friends on an underwater adventure that ends with viewing real marine life in one of the world's largest aquariums.",
        location: "World Nature",
        type: "ride",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true
        },
        tips: [
          {
            id: "sn-tip-1",
            content: "Don't miss the massive aquarium after the ride - spend time exploring the marine exhibits.",
            category: "general",
            priority: 4
          },
          {
            id: "sn-tip-2",
            content: "Look for Turtle Talk with Crush nearby for more underwater fun.",
            category: "strategy",
            priority: 2
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "epcot-imagination-figment",
        parkId: "epcot",
        name: "Journey Into Imagination with Figment",
        description: "Follow the mischievous Figment through Dr. Nigel Channing's sensory labs for a wild ride that engages all five senses.",
        location: "World Nature",
        type: "ride",
        duration: 6,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true
        },
        tips: [
          {
            id: "ji-tip-1",
            content: "Don't miss ImageWorks playground upstairs after the ride for hands-on experiments.",
            category: "general",
            priority: 3
          },
          {
            id: "ji-tip-2",
            content: "Strong scents and loud noises throughout - be prepared for sensory overload!",
            category: "accessibility",
            priority: 4
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "epcot-frozen-ever-after",
        parkId: "epcot",
        name: "Frozen Ever After",
        description: "Join Anna, Elsa, and Olaf for a magical boat journey through Arendelle during the Summer Snow Day celebration.",
        location: "World Showcase - Norway",
        type: "ride",
        duration: 5,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: true
        },
        tips: [
          {
            id: "fe-tip-1",
            content: "One of the most popular attractions at EPCOT. Use Lightning Lane or rope drop strategy.",
            category: "strategy",
            priority: 5
          },
          {
            id: "fe-tip-2",
            content: "Small drops and backward sections may surprise some guests.",
            category: "general",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: true,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "epcot-gran-fiesta-tour",
        parkId: "epcot",
        name: "Gran Fiesta Tour Starring The Three Caballeros",
        description: "Take a colorful boat ride through Mexico with Donald Duck, Jos\xE9 Carioca, and Panchito as they prepare for their concert.",
        location: "World Showcase - Mexico",
        type: "ride",
        duration: 7,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true
        },
        tips: [
          {
            id: "gf-tip-1",
            content: "Hidden gem with usually short waits. Great for families with young children.",
            category: "strategy",
            priority: 3
          },
          {
            id: "gf-tip-2",
            content: "Explore the Mexico pavilion marketplace before or after riding.",
            category: "general",
            priority: 2
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "epcot-remy-ratatouille",
        parkId: "epcot",
        name: "Remy's Ratatouille Adventure",
        description: "Shrink down to Remy's size and scurry through Gusteau's restaurant kitchen in this immersive trackless adventure.",
        location: "World Showcase - France",
        type: "ride",
        duration: 5,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: true
        },
        tips: [
          {
            id: "rr-tip-1",
            content: "No height requirement makes this perfect for families. Very popular, so use Lightning Lane.",
            category: "strategy",
            priority: 4
          },
          {
            id: "rr-tip-2",
            content: "4D effects include water, air, and scent - you'll feel like you're really in the kitchen!",
            category: "general",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: true,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      }
    ];
  }
});

// src/data/do/rides/hollywood-studios-rides.json
var hollywood_studios_rides_default;
var init_hollywood_studios_rides = __esm({
  "src/data/do/rides/hollywood-studios-rides.json"() {
    hollywood_studios_rides_default = [
      {
        id: "dhs-rise-of-resistance",
        parkId: "hollywood-studios",
        name: "Star Wars: Rise of the Resistance",
        description: "Join the Resistance in an epic battle against the First Order in this immersive, multi-stage experience featuring trackless vehicles and life-size AT-ATs.",
        location: "Star Wars: Galaxy's Edge",
        type: "ride",
        duration: 20,
        heightRequirement: 40,
        intensity: "high",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "ror-tip-1",
            content: "Most popular attraction in the park. Purchase Individual Lightning Lane, use single rider line, or arrive at rope drop.",
            category: "strategy",
            priority: 5
          },
          {
            id: "ror-tip-2",
            content: "Single rider line now available for shorter waits if riding alone.",
            category: "strategy",
            priority: 5
          },
          {
            id: "ror-tip-3",
            content: "Multi-stage experience includes walking, so allow extra time for the full experience.",
            category: "general",
            priority: 4
          }
        ],
        tags: [],
        features: {
          multiPass: false,
          singlePass: true,
          singleRider: true,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: true,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "dhs-millennium-falcon",
        parkId: "hollywood-studios",
        name: "Millennium Falcon: Smugglers Run",
        description: "Take the controls of the famous Millennium Falcon on a customized smuggling mission where your actions determine the outcome.",
        location: "Star Wars: Galaxy's Edge",
        type: "ride",
        duration: 7,
        heightRequirement: 38,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "mf-tip-1",
            content: "Pilot positions provide the most interactive experience, but all roles are fun and important.",
            category: "strategy",
            priority: 4
          },
          {
            id: "mf-tip-2",
            content: "Your performance affects the ship's condition - work as a team!",
            category: "general",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: true,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "dhs-tower-of-terror",
        parkId: "hollywood-studios",
        name: "The Twilight Zone Tower of Terror",
        description: "Step into a haunted hotel elevator for a spine-tingling 13-story drop experience through the Twilight Zone.",
        location: "Sunset Boulevard",
        type: "ride",
        duration: 10,
        heightRequirement: 40,
        intensity: "high",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false
        },
        tips: [
          {
            id: "tot-tip-1",
            content: "Multiple drop sequences make each ride unique. The elevator actually pulls you down faster than gravity!",
            category: "general",
            priority: 4
          },
          {
            id: "tot-tip-2",
            content: "On-ride photo taken during the drop sequence - keep your eyes open!",
            category: "photo",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          scary: true,
          bigDrops: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "dhs-rock-n-roller-coaster",
        parkId: "hollywood-studios",
        name: "Rock 'n' Roller Coaster Starring Aerosmith",
        description: "Launch from 0 to 60 mph in 2.8 seconds on this indoor roller coaster featuring Aerosmith's greatest hits in the dark.",
        location: "Sunset Boulevard",
        type: "ride",
        duration: 3,
        heightRequirement: 48,
        intensity: "extreme",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false
        },
        tips: [
          {
            id: "rnr-tip-1",
            content: "Will be re-themed to The Muppets in 2026. Experience the Aerosmith version while you can!",
            category: "general",
            priority: 5
          },
          {
            id: "rnr-tip-2",
            content: "Synchronized soundtrack makes each seat have a slightly different musical experience.",
            category: "general",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: true,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          launchSpeed: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "dhs-mickey-minnie-railway",
        parkId: "hollywood-studios",
        name: "Mickey & Minnie's Runaway Railway",
        description: "Join Mickey and Minnie on a zany adventure through a cartoon world in Disney's first Mickey Mouse ride-through attraction.",
        location: "Hollywood Boulevard",
        type: "ride",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true
        },
        tips: [
          {
            id: "mm-tip-1",
            content: "First Mickey Mouse-themed ride ever! Perfect for all ages and very popular with families.",
            category: "general",
            priority: 4
          },
          {
            id: "mm-tip-2",
            content: "Trackless technology means each ride can be slightly different - multiple rides recommended!",
            category: "strategy",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "dhs-slinky-dog-dash",
        parkId: "hollywood-studios",
        name: "Slinky Dog Dash",
        description: "Andy has built a roller coaster in his backyard using his Slinky Dog toy. Enjoy gentle thrills with great views of Toy Story Land.",
        location: "Toy Story Land",
        type: "ride",
        duration: 2,
        heightRequirement: 38,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: false
        },
        tips: [
          {
            id: "sdd-tip-1",
            content: "Very popular family coaster. Use Lightning Lane or rope drop strategy for shorter waits.",
            category: "strategy",
            priority: 4
          },
          {
            id: "sdd-tip-2",
            content: "Great views of the entire Toy Story Land from the coaster's high points.",
            category: "photo",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: true,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "dhs-star-tours",
        parkId: "hollywood-studios",
        name: "Star Tours \u2013 The Adventures Continue",
        description: "Experience a 3D space adventure with multiple storylines and destinations across the Star Wars galaxy.",
        location: "Echo Lake",
        type: "ride",
        duration: 7,
        heightRequirement: 40,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "st-tip-1",
            content: "Over 70 possible combinations of scenes! Multiple rides for different experiences.",
            category: "strategy",
            priority: 4
          },
          {
            id: "st-tip-2",
            content: "3D glasses required - those with vision issues should inform Cast Members.",
            category: "accessibility",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "dhs-toy-story-mania",
        parkId: "hollywood-studios",
        name: "Toy Story Mania!",
        description: "Pull the string on a virtual cannon and compete in 4D carnival games alongside your favorite Toy Story characters.",
        location: "Toy Story Land",
        type: "ride",
        duration: 8,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true
        },
        tips: [
          {
            id: "tsm-tip-1",
            content: "Competitive shooting gallery - practice your aim and try to beat your family's scores!",
            category: "strategy",
            priority: 3
          },
          {
            id: "tsm-tip-2",
            content: "4D effects include scents and air bursts that enhance the carnival game experience.",
            category: "general",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "dhs-alien-swirling-saucers",
        parkId: "hollywood-studios",
        name: "Alien Swirling Saucers",
        description: "The aliens have powered up their flying saucers for a spinning adventure set to energetic space music.",
        location: "Toy Story Land",
        type: "ride",
        duration: 2,
        heightRequirement: 32,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "ass-tip-1",
            content: "Similar to Mad Tea Party but with Toy Story theming. Control your spin level with the wheel.",
            category: "strategy",
            priority: 3
          },
          {
            id: "ass-tip-2",
            content: "Outdoor ride - can close due to weather. Plan accordingly.",
            category: "general",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: true,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      }
    ];
  }
});

// src/data/do/rides/animal-kingdom-rides.json
var animal_kingdom_rides_default;
var init_animal_kingdom_rides = __esm({
  "src/data/do/rides/animal-kingdom-rides.json"() {
    animal_kingdom_rides_default = [
      {
        id: "ak-avatar-flight-passage",
        parkId: "animal-kingdom",
        name: "Avatar Flight of Passage",
        description: "Soar on the back of a mountain banshee through Pandora's floating mountains and bioluminescent forests in this breathtaking 3D flight experience.",
        location: "Pandora - The World of Avatar",
        type: "ride",
        duration: 5,
        heightRequirement: 44,
        intensity: "high",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "afp-tip-1",
            content: "Most popular attraction at Animal Kingdom. Purchase Individual Lightning Lane or arrive at park opening.",
            category: "strategy",
            priority: 5
          },
          {
            id: "afp-tip-2",
            content: "Motion simulator experience - those prone to motion sickness should use caution.",
            category: "accessibility",
            priority: 4
          }
        ],
        tags: [],
        features: {
          multiPass: false,
          singlePass: true,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: true,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "ak-navi-river-journey",
        parkId: "animal-kingdom",
        name: "Na'vi River Journey",
        description: "Navigate through a mystical bioluminescent rainforest aboard reed boats in search of the Na'vi Shaman of Songs.",
        location: "Pandora - The World of Avatar",
        type: "ride",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "nrj-tip-1",
            content: "Stunning visual effects and animatronics. Perfect for all ages and Pandora fans.",
            category: "general",
            priority: 3
          },
          {
            id: "nrj-tip-2",
            content: "Transfer device available to assist with wheelchair accessibility.",
            category: "accessibility",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: true,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "ak-kilimanjaro-safaris",
        parkId: "animal-kingdom",
        name: "Kilimanjaro Safaris",
        description: "Embark on an 18-minute African safari adventure to see live lions, elephants, giraffes, and other magnificent animals in their habitats.",
        location: "Africa - Harambe",
        type: "ride",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true
        },
        tips: [
          {
            id: "ks-tip-1",
            content: "Animals are most active in early morning and late afternoon. Multiple rides recommended!",
            category: "strategy",
            priority: 4
          },
          {
            id: "ks-tip-2",
            content: "Each safari is different depending on animal activity. Bring a camera with zoom lens.",
            category: "photo",
            priority: 4
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      },
      {
        id: "ak-expedition-everest",
        parkId: "animal-kingdom",
        name: "Expedition Everest - Legend of the Forbidden Mountain",
        description: "Race through the Himalayas on this thrilling roller coaster and come face-to-face with the legendary Yeti on Mount Everest.",
        location: "Asia - Anandapur",
        type: "ride",
        duration: 3,
        heightRequirement: 44,
        intensity: "high",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "ee-tip-1",
            content: "Features both forward and backward sections. The 80-foot drop is thrilling!",
            category: "general",
            priority: 4
          },
          {
            id: "ee-tip-2",
            content: "Single rider line available for shorter waits. Mountain views during climb are spectacular.",
            category: "strategy",
            priority: 3
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: true,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          bigDrops: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "ak-kali-river-rapids",
        parkId: "animal-kingdom",
        name: "Kali River Rapids",
        description: "Navigate churning rapids on this white-water adventure through an Asian rainforest while learning about environmental conservation.",
        location: "Asia - Anandapur",
        type: "ride",
        duration: 6,
        heightRequirement: 38,
        intensity: "high",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "krr-tip-1",
            content: "SEASONAL CLOSURE: Closes October 6, 2025 for refurbishment, reopening December 2025",
            category: "strategy",
            priority: 5
          },
          {
            id: "krr-tip-2",
            content: "You WILL get soaked! Bring waterproof bags for phones and valuables.",
            category: "strategy",
            priority: 5
          },
          {
            id: "krr-tip-3",
            content: "Other guests can spray you with water cannons from the bridge - beware!",
            category: "general",
            priority: 4
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: true,
          spinningMotion: true,
          loudSounds: true,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "ak-dinosaur",
        parkId: "animal-kingdom",
        name: "DINOSAUR",
        description: "Travel back 65 million years to rescue an iguanodon from extinction while dodging meteors and carnivorous dinosaurs.",
        location: "DinoLand U.S.A.",
        type: "ride",
        duration: 4,
        heightRequirement: 40,
        intensity: "high",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true
        },
        tips: [
          {
            id: "dino-tip-1",
            content: "CLOSING FEBRUARY 2, 2026: Being reimagined as Indiana Jones Adventure for Tropical Americas land. Experience it while you can!",
            category: "strategy",
            priority: 5
          },
          {
            id: "dino-tip-2",
            content: "Very dark and intense with realistic dinosaur encounters. Not recommended for young children.",
            category: "accessibility",
            priority: 4
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: true,
          mobileCheckin: false,
          photoPass: true,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: true,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          scary: true,
          heightRequirement: true,
          motionSensitivity: true,
          pregnancyAdvisory: true,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: true
        }
      },
      {
        id: "ak-wildlife-express-train",
        parkId: "animal-kingdom",
        name: "Wildlife Express Train",
        description: "Take a scenic 1.2-mile train journey to Rafiki's Planet Watch with behind-the-scenes views of animal care areas.",
        location: "Africa to Rafiki's Planet Watch",
        type: "transportation",
        duration: 7,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true
        },
        tips: [
          {
            id: "wet-tip-1",
            content: "Only way to reach Rafiki's Planet Watch. Great for families with young children.",
            category: "strategy",
            priority: 3
          },
          {
            id: "wet-tip-2",
            content: "Behind-the-scenes views during the journey. Round-trip transportation included.",
            category: "general",
            priority: 2
          }
        ],
        tags: [],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      }
    ];
  }
});

// src/data/do/shows/magic-kingdom-shows.json
var magic_kingdom_shows_default;
var init_magic_kingdom_shows = __esm({
  "src/data/do/shows/magic-kingdom-shows.json"() {
    magic_kingdom_shows_default = [
      {
        id: "mk-country-bear-jamboree",
        parkId: "magic-kingdom",
        name: "Country Bear Jamboree",
        description: "A classic Disney attraction featuring an entertaining cast of audio-animatronic bears performing country and western songs.",
        location: "Frontierland",
        type: "show",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "cbj-tip-1",
            category: "general",
            content: "Great air-conditioned break from the Florida heat with classic Disney charm.",
            priority: 2
          }
        ],
        tags: ["classic", "family-friendly", "air-conditioned", "nostalgic"],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["10:00 AM", "11:30 AM", "1:00 PM", "2:30 PM", "4:00 PM", "5:30 PM", "7:00 PM"]
      },
      {
        id: "mk-philharmagic",
        parkId: "magic-kingdom",
        name: "Mickey's PhilharMagic",
        description: "A 3D film starring Donald Duck and featuring classic Disney songs and characters in a magical musical adventure.",
        location: "Fantasyland",
        type: "show",
        duration: 12,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "philhar-tip-1",
            category: "general",
            content: "Sit in the center for the best 3D effects and don't miss the special scents and wind effects!",
            priority: 1
          }
        ],
        tags: ["3D", "music", "family-friendly", "air-conditioned"],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: true,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Continuous showings every 20 minutes"]
      },
      {
        id: "mk-enchanted-tiki-room",
        parkId: "magic-kingdom",
        name: "Walt Disney's Enchanted Tiki Room",
        description: "Experience the original audio-animatronic show featuring tropical birds, flowers, and tikis singing in an immersive Polynesian-themed theater.",
        location: "Adventureland",
        type: "show",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "tiki-room-tip-1",
            category: "general",
            content: "The very first audio-animatronic attraction created by Walt Disney - a piece of Disney history.",
            priority: 4
          },
          {
            id: "tiki-room-tip-2",
            category: "best_time",
            content: "Perfect air-conditioned break during hot Florida days with rarely any wait.",
            priority: 5
          },
          {
            id: "tiki-room-tip-3",
            category: "general",
            content: "Watch for special effects including the thunderstorm and fountain finale.",
            priority: 3
          }
        ],
        tags: [
          "classic",
          "historic",
          "audio-animatronic",
          "tropical",
          "air-conditioned",
          "original-attraction"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["10:15 AM", "11:45 AM", "1:15 PM", "2:45 PM", "4:15 PM", "5:45 PM", "7:15 PM"]
      },
      {
        id: "mk-monsters-inc-laugh-floor",
        parkId: "magic-kingdom",
        name: "Monsters Inc. Laugh Floor",
        description: "Interactive comedy show featuring Mike Wazowski and other monsters from Monsters Inc. in a live, improvisational performance that includes audience participation.",
        location: "Tomorrowland",
        type: "show",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "laugh-floor-tip-1",
            category: "general",
            content: "Interactive show - audience participation encouraged! Mike may call on guests for jokes or comments.",
            priority: 5
          },
          {
            id: "laugh-floor-tip-2",
            category: "strategy",
            content: "Submit jokes via text before the show starts - they might use yours during the performance!",
            priority: 4
          },
          {
            id: "laugh-floor-tip-3",
            category: "best_time",
            content: "Perfect air-conditioned break with typically short waits - great for hot days",
            priority: 4
          }
        ],
        tags: [
          "interactive",
          "comedy",
          "monsters-inc",
          "audience-participation",
          "air-conditioned",
          "family-friendly"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Varies by day - check Disney app for current schedule"]
      },
      {
        id: "mk-hall-of-presidents",
        parkId: "magic-kingdom",
        name: "The Hall of Presidents",
        description: "Experience American history through an inspiring film and audio-animatronic presentation featuring all U.S. Presidents, including speeches from the current and founding presidents.",
        location: "Liberty Square",
        type: "show",
        duration: 25,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "hall-presidents-tip-1",
            category: "general",
            content: "Historic attraction that's been a Magic Kingdom staple since opening - great for American history buffs",
            priority: 4
          },
          {
            id: "hall-presidents-tip-2",
            category: "best_time",
            content: "Perfect air-conditioned break during hot days with comfortable seating and rarely long waits",
            priority: 5
          },
          {
            id: "hall-presidents-tip-3",
            category: "general",
            content: "Features all 46 presidents in audio-animatronic form - look for the detailed craftsmanship",
            priority: 3
          }
        ],
        tags: [
          "historic",
          "educational",
          "american-history",
          "audio-animatronic",
          "air-conditioned",
          "classic"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Multiple times daily - check Disney app for current schedule"]
      },
      {
        id: "mk-carousel-of-progress",
        parkId: "magic-kingdom",
        name: "Walt Disney's Carousel of Progress",
        description: "Experience a century of American progress through the eyes of an audio-animatronic family in this rotating theater show that was personally created by Walt Disney.",
        location: "Tomorrowland",
        type: "show",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "carousel-progress-tip-1",
            category: "general",
            content: "Walt Disney's personal favorite attraction - one of the few he directly created and narrated",
            priority: 5
          },
          {
            id: "carousel-progress-tip-2",
            category: "best_time",
            content: "Perfect air-conditioned break with comfortable seating and typically no wait",
            priority: 5
          },
          {
            id: "carousel-progress-tip-3",
            category: "general",
            content: "Rotating theater takes you through different time periods - listen for the catchy theme song!",
            priority: 4
          }
        ],
        tags: [
          "classic",
          "historic",
          "walt-disney-original",
          "audio-animatronic",
          "air-conditioned",
          "rotating-theater"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: true,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Continuous performances throughout the day"]
      }
    ];
  }
});

// src/data/do/shows/epcot-shows.json
var epcot_shows_default;
var init_epcot_shows = __esm({
  "src/data/do/shows/epcot-shows.json"() {
    epcot_shows_default = [
      {
        id: "epcot-american-adventure",
        parkId: "epcot",
        name: "The American Adventure",
        description: "An inspiring Audio-Animatronics show chronicling American history with Mark Twain and Benjamin Franklin as hosts.",
        location: "American Adventure Pavilion",
        type: "show",
        duration: 29,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "american-adventure-tip-1",
            category: "general",
            content: "The Voices of Liberty often perform in the rotunda before shows. A great patriotic experience.",
            priority: 2
          }
        ],
        tags: ["american-history", "audio-animatronics", "educational", "patriotic"],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Every 30 minutes"]
      },
      {
        id: "epcot-awesome-planet",
        parkId: "epcot",
        name: "Awesome Planet",
        description: "A breathtaking film showcasing the beauty and diversity of our planet, narrated by Ty Burrell.",
        location: "The Land Pavilion",
        type: "show",
        duration: 18,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "awesome-planet-tip-1",
            category: "general",
            content: "Great air-conditioned break with beautiful nature cinematography. Perfect for all ages.",
            priority: 2
          }
        ],
        tags: ["nature", "documentary", "educational", "family-friendly"],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Every 20 minutes"]
      },
      {
        id: "epcot-beauty-beast-sing-along",
        parkId: "epcot",
        name: "Beauty and the Beast Sing-Along",
        description: "Join Belle, Beast, and the enchanted objects for a delightful sing-along retelling of the beloved Beauty and the Beast story with live performers and audience participation.",
        location: "France Pavilion",
        type: "show",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "beauty-beast-sing-tip-1",
            category: "general",
            content: "Interactive sing-along - don't be shy about participating with the songs!",
            priority: 5
          },
          {
            id: "beauty-beast-sing-tip-2",
            category: "best_time",
            content: "Great air-conditioned break in World Showcase with comfortable theater seating",
            priority: 4
          },
          {
            id: "beauty-beast-sing-tip-3",
            category: "general",
            content: "Perfect for Beauty and the Beast fans and families with young children",
            priority: 4
          }
        ],
        tags: [
          "sing-along",
          "beauty-and-the-beast",
          "interactive",
          "family-friendly",
          "air-conditioned",
          "live-performers"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Multiple times daily - check Disney app for current schedule"]
      },
      {
        id: "epcot-canada-far-wide",
        parkId: "epcot",
        name: "Canada Far and Wide in Circle-Vision 360",
        description: "Experience the breathtaking beauty of Canada through a 360-degree film showcasing the country's stunning landscapes, cities, and natural wonders.",
        location: "Canada Pavilion",
        type: "show",
        duration: 18,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "canada-far-wide-tip-1",
            category: "general",
            content: "360-degree film - you'll need to stand and turn to see all the action around you",
            priority: 5
          },
          {
            id: "canada-far-wide-tip-2",
            category: "best_time",
            content: "Great air-conditioned break in World Showcase with spectacular Canadian scenery",
            priority: 4
          },
          {
            id: "canada-far-wide-tip-3",
            category: "general",
            content: "Features stunning footage of Canadian Rockies, cities, and natural landmarks",
            priority: 3
          }
        ],
        tags: [
          "circle-vision",
          "360-degree",
          "canada",
          "documentary",
          "nature",
          "air-conditioned"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: true,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: true,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Continuous showings throughout the day"]
      },
      {
        id: "epcot-disney-pixar-short-film-festival",
        parkId: "epcot",
        name: "Disney and Pixar Short Film Festival",
        description: "Enjoy a collection of beloved Disney and Pixar animated shorts in 3D, featuring characters like Mickey Mouse and stories from Pixar's acclaimed short films.",
        location: "Future World",
        type: "show",
        duration: 18,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "short-film-festival-tip-1",
            category: "general",
            content: "3D film experience featuring rotating collection of Disney and Pixar animated shorts",
            priority: 4
          },
          {
            id: "short-film-festival-tip-2",
            category: "best_time",
            content: "Perfect air-conditioned break with comfortable seating - great for all ages",
            priority: 5
          },
          {
            id: "short-film-festival-tip-3",
            category: "general",
            content: "Features beloved characters and award-winning Pixar storytelling in short format",
            priority: 3
          }
        ],
        tags: [
          "3d-film",
          "pixar",
          "disney-animation",
          "short-films",
          "family-friendly",
          "air-conditioned"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Continuous showings every 20 minutes"]
      },
      {
        id: "epcot-turtle-talk-with-crush",
        parkId: "epcot",
        name: "Turtle Talk With Crush",
        description: "Have a real-time conversation with Crush, the 150-year-old sea turtle from Finding Nemo, in this interactive show where Crush responds to audience questions and comments.",
        location: "The Seas with Nemo & Friends Pavilion",
        type: "show",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "turtle-talk-tip-1",
            category: "general",
            content: "Interactive show - Crush can see and respond to kids in the audience in real time!",
            priority: 5
          },
          {
            id: "turtle-talk-tip-2",
            category: "strategy",
            content: "Kids love this - sit up front and encourage them to wave and ask questions",
            priority: 4
          },
          {
            id: "turtle-talk-tip-3",
            category: "best_time",
            content: "Great air-conditioned break with typically short waits - perfect for families",
            priority: 4
          }
        ],
        tags: [
          "interactive",
          "finding-nemo",
          "crush",
          "kids-favorite",
          "family-friendly",
          "air-conditioned"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Multiple times daily - check Disney app for current schedule"]
      }
    ];
  }
});

// src/data/do/shows/hollywood-studios-shows.json
var hollywood_studios_shows_default;
var init_hollywood_studios_shows = __esm({
  "src/data/do/shows/hollywood-studios-shows.json"() {
    hollywood_studios_shows_default = [
      {
        id: "hs-frozen-sing-along",
        parkId: "hollywood-studios",
        name: "For the First Time in Forever: A Frozen Sing-Along Celebration",
        description: "Join Anna, Elsa, and the kingdom of Arendelle for a fun, interactive sing-along celebration featuring songs from the hit film Frozen.",
        location: "Echo Lake",
        type: "show",
        duration: 30,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "frozen-tip-1",
            category: "best_time",
            content: "Shows can fill up quickly, especially during peak seasons. Arrive 15-20 minutes early.",
            priority: 1
          }
        ],
        tags: ["interactive", "family-friendly", "music", "air-conditioned", "frozen"],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["11:00 AM", "12:30 PM", "2:00 PM", "3:30 PM", "5:00 PM", "6:30 PM"]
      },
      {
        id: "hs-indiana-jones-stunt",
        parkId: "hollywood-studios",
        name: "Indiana Jones Epic Stunt Spectacular!",
        description: "Experience the thrills and excitement of movie-making magic as stunt performers recreate famous scenes from Raiders of the Lost Ark.",
        location: "Echo Lake",
        type: "show",
        duration: 30,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "indy-tip-1",
            category: "general",
            content: "Sit in the center sections for the best view of all the action sequences.",
            priority: 2
          }
        ],
        tags: ["stunts", "action", "loud", "special-effects"],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: true,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: true,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["12:00 PM", "2:30 PM", "4:00 PM", "5:30 PM"]
      },
      {
        id: "hs-vacation-fun-mickey-minnie",
        parkId: "hollywood-studios",
        name: "Vacation Fun - An Original Animated Short with Mickey & Minnie",
        description: "Enjoy a delightful animated short film featuring Mickey Mouse and Minnie Mouse on a fun vacation adventure, created exclusively for Disney's Hollywood Studios.",
        location: "Grand Avenue",
        type: "show",
        duration: 10,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "vacation-fun-tip-1",
            category: "general",
            content: "Short and sweet animated film perfect for Mickey Mouse fans and families with young kids",
            priority: 4
          },
          {
            id: "vacation-fun-tip-2",
            category: "best_time",
            content: "Great air-conditioned break with comfortable seating and typically short waits",
            priority: 5
          },
          {
            id: "vacation-fun-tip-3",
            category: "general",
            content: "Original Disney animation created exclusively for Hollywood Studios",
            priority: 3
          }
        ],
        tags: [
          "mickey-mouse",
          "minnie-mouse",
          "animated-short",
          "family-friendly",
          "air-conditioned",
          "exclusive"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Continuous showings every 15 minutes"]
      },
      {
        id: "hs-disney-jr-play-and-dance",
        parkId: "hollywood-studios",
        name: "Disney Jr. Play and Dance!",
        description: "Join favorite Disney Junior characters for an interactive musical celebration featuring singing, dancing, and audience participation with beloved preschool characters.",
        location: "Animation Courtyard",
        type: "show",
        duration: 25,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "disney-jr-tip-1",
            category: "general",
            content: "Perfect for families with preschoolers - interactive show with singing and dancing",
            priority: 5
          },
          {
            id: "disney-jr-tip-2",
            category: "strategy",
            content: "Arrive early for best seats - kids love to dance along with the characters",
            priority: 4
          },
          {
            id: "disney-jr-tip-3",
            category: "best_time",
            content: "Great air-conditioned break featuring beloved Disney Junior characters",
            priority: 4
          }
        ],
        tags: [
          "disney-junior",
          "interactive",
          "preschool",
          "singing",
          "dancing",
          "family-friendly"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Multiple times daily - check Disney app for current schedule"]
      },
      {
        id: "hs-disney-villains-unfairly-ever-after",
        parkId: "hollywood-studios",
        name: "Disney Villains: Unfairly Ever After",
        description: "Join Disney's most notorious villains as they take over the stage to tell their side of the story in this wickedly entertaining musical show featuring iconic villain songs.",
        location: "Theater of the Stars",
        type: "show",
        duration: 30,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "villains-show-tip-1",
            category: "general",
            content: "Features beloved Disney villains telling their side of classic fairy tales with humor and music",
            priority: 5
          },
          {
            id: "villains-show-tip-2",
            category: "strategy",
            content: "Popular show - arrive 20-30 minutes early for best seating, especially during busy seasons",
            priority: 4
          },
          {
            id: "villains-show-tip-3",
            category: "general",
            content: "Great for Disney villain fans and families - entertaining mix of comedy and classic villain songs",
            priority: 4
          }
        ],
        tags: [
          "disney-villains",
          "musical",
          "comedy",
          "family-friendly",
          "outdoor-theater",
          "live-performers"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: true,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true,
        showTimes: ["Multiple times daily - check Disney app for current schedule"]
      },
      {
        id: "hs-little-mermaid-musical-adventure",
        parkId: "hollywood-studios",
        name: "The Little Mermaid \u2013 A Musical Adventure",
        description: "Join Ariel on her journey from under the sea to the surface world in this new condensed musical featuring beloved songs from Disney's The Little Mermaid.",
        location: "Animation Courtyard",
        type: "show",
        duration: 25,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "mermaid-musical-tip-1",
            category: "general",
            content: "New condensed musical featuring classic Little Mermaid songs like 'Under the Sea' and 'Part of Your World'",
            priority: 5
          },
          {
            id: "mermaid-musical-tip-2",
            category: "strategy",
            content: "Popular new show - arrive early for best seating as it's still drawing crowds",
            priority: 4
          },
          {
            id: "mermaid-musical-tip-3",
            category: "general",
            content: "Perfect for Little Mermaid fans and families with kids who love Disney princess stories",
            priority: 4
          }
        ],
        tags: [
          "little-mermaid",
          "musical",
          "ariel",
          "princess",
          "new-show",
          "family-friendly"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: true,
        showTimes: ["Multiple times daily - check Disney app for current schedule"]
      }
    ];
  }
});

// src/data/do/shows/animal-kingdom-shows.json
var animal_kingdom_shows_default;
var init_animal_kingdom_shows = __esm({
  "src/data/do/shows/animal-kingdom-shows.json"() {
    animal_kingdom_shows_default = [
      {
        id: "ak-festival-of-lion-king",
        parkId: "animal-kingdom",
        name: "Festival of the Lion King",
        description: "A spectacular live musical celebrating the story of The Lion King with acrobatics, puppetry, and audience participation.",
        location: "Theater in the Wild, Africa",
        type: "show",
        duration: 30,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "lion-king-tip-1",
            category: "strategy",
            content: "This is a must-do show! Get FastPass+ or arrive 30 minutes early. Sit in the center sections for best view.",
            priority: 1
          }
        ],
        tags: ["lion-king", "musical", "acrobatics", "puppetry", "interactive"],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: true,
        singleRider: false,
        photoService: true,
        showTimes: ["Multiple times daily"]
      },
      {
        id: "ak-finding-nemo-musical",
        parkId: "animal-kingdom",
        name: "Finding Nemo - The Big Blue... and Beyond!",
        description: "A colorful musical retelling the story of Finding Nemo with puppetry, music, and underwater magic.",
        location: "Theater in the Wild, DinoLand U.S.A.",
        type: "show",
        duration: 40,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "nemo-musical-tip-1",
            category: "general",
            content: "Great for families with young children. The puppetry and music are outstanding!",
            priority: 2
          }
        ],
        tags: ["finding-nemo", "musical", "puppetry", "family-friendly", "underwater"],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: true,
        singleRider: false,
        photoService: true,
        showTimes: ["Multiple times daily"]
      },
      {
        id: "ak-zootopia-better-zoogether",
        parkId: "animal-kingdom",
        name: "Zootopia: Better Zoogether!",
        description: "OPENING NOVEMBER 7, 2025. A new immersive theater experience featuring Judy Hopps and Nick Wilde from Zootopia, replacing It's Tough to be a Bug!",
        location: "Tree of Life Theater",
        type: "show",
        duration: 10,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "zootopia-tip-1",
            category: "strategy",
            content: "OPENING SOON: New show debuts November 7, 2025 with Nick Wilde and Judy Hopps meet & greet",
            priority: 5
          },
          {
            id: "zootopia-tip-2",
            category: "general",
            content: "Replaces It's Tough to be a Bug! in the iconic Tree of Life Theater",
            priority: 4
          }
        ],
        tags: ["zootopia", "new", "family-friendly", "tree-of-life", "opening-soon"],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: true,
        showTimes: ["Opening November 7, 2025"]
      },
      {
        id: "ak-feathered-friends-in-flight",
        parkId: "animal-kingdom",
        name: "Feathered Friends in Flight!",
        description: "An outdoor bird show at Rafiki's Planet Watch featuring exotic birds from around the world demonstrating their natural behaviors and conservation messages.",
        location: "Rafiki's Planet Watch",
        type: "show",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "feathered-friends-tip-1",
            category: "general",
            content: "Outdoor bird show featuring exotic birds in natural behaviors - educational and entertaining",
            priority: 4
          },
          {
            id: "feathered-friends-tip-2",
            category: "strategy",
            content: "Take Wildlife Express Train to reach Rafiki's Planet Watch - combine with other attractions there",
            priority: 4
          },
          {
            id: "feathered-friends-tip-3",
            category: "best_time",
            content: "Outdoor show - check weather conditions and showtimes may vary seasonally",
            priority: 3
          }
        ],
        tags: [
          "birds",
          "outdoor-show",
          "conservation",
          "educational",
          "rafikis-planet-watch",
          "family-friendly"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: true,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: ["Multiple times daily - check Disney app for current schedule"]
      }
    ];
  }
});

// src/data/do/experiences/magic-kingdom-experiences.json
var magic_kingdom_experiences_default;
var init_magic_kingdom_experiences = __esm({
  "src/data/do/experiences/magic-kingdom-experiences.json"() {
    magic_kingdom_experiences_default = [
      {
        id: "swiss-family-treehouse",
        parkId: "magic-kingdom",
        name: "Swiss Family Treehouse",
        description: "Climb through the ingenious multi-story treehouse home of the Swiss Family Robinson. Explore their clever inventions and enjoy views of Adventureland from 116 stairs up. CURRENTLY CLOSED for refurbishment with reopening delayed.",
        location: "Adventureland",
        type: "experience",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: false,
          transferRequired: true,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "treehouse-tip-1",
            category: "strategy",
            content: "ATTRACTION CLOSED: Currently closed for refurbishment, reopening delayed beyond original date",
            priority: 5
          },
          {
            id: "treehouse-tip-2",
            category: "photo",
            content: "When open, visit at night for magical views of Adventureland from the top (when operational)",
            priority: 4
          },
          {
            id: "treehouse-tip-3",
            category: "general",
            content: "Involves climbing 116 stairs - take your time and enjoy the story details",
            priority: 3
          }
        ],
        tags: [
          "walkthrough",
          "swiss-family-robinson",
          "adventure",
          "stairs",
          "views",
          "temporarily-closed"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: false,
          transferRequired: true,
          rainSafe: false
        }
      },
      {
        id: "enchanted-forest-exploration",
        parkId: "magic-kingdom",
        name: "Enchanted Forest Area Exploration",
        description: "Wander through the beautifully themed Enchanted Forest section of New Fantasyland, featuring fairy tale theming and character interactions throughout the area.",
        location: "Fantasyland",
        type: "experience",
        duration: 30,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "enchanted-forest-tip-1",
            category: "general",
            content: "Beautiful fairy tale theming throughout - perfect for photos and atmosphere",
            priority: 4
          },
          {
            id: "enchanted-forest-tip-2",
            category: "character",
            content: "Ariel meets as a mermaid at Ariel's Grotto in this area",
            priority: 4
          },
          {
            id: "enchanted-forest-tip-3",
            category: "general",
            content: "Part of New Fantasyland expansion - immersive Disney fairy tale experience",
            priority: 3
          }
        ],
        tags: [
          "fairy-tale",
          "new-fantasyland",
          "character-interactions",
          "themed-walking",
          "photo-ops"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      },
      {
        id: "storybook-circus-exploration",
        parkId: "magic-kingdom",
        name: "Storybook Circus Area Exploration",
        description: "Explore the circus-themed area of New Fantasyland featuring character meet-and-greets at Pete's Silly Sideshow and immersive carnival theming.",
        location: "Fantasyland",
        type: "experience",
        duration: 30,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "storybook-circus-tip-1",
            category: "character",
            content: "Visit Pete's Silly Sideshow for character meets with Donald, Goofy, Minnie, and Daisy",
            priority: 5
          },
          {
            id: "storybook-circus-tip-2",
            category: "general",
            content: "Interactive fun with The Storybook Circus Giggle Gang performers",
            priority: 4
          },
          {
            id: "storybook-circus-tip-3",
            category: "general",
            content: "Circus theming throughout with vintage carnival atmosphere",
            priority: 3
          }
        ],
        tags: [
          "circus",
          "character-meets",
          "new-fantasyland",
          "carnival",
          "interactive-performers"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      },
      {
        id: "enchanted-tales-with-belle",
        parkId: "magic-kingdom",
        name: "Enchanted Tales with Belle",
        description: "Join Belle in an interactive storytelling experience where guests become part of the Beauty and the Beast story in Maurice's cottage and Beast's library.",
        location: "Fantasyland",
        type: "experience",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "belle-tip-1",
            category: "strategy",
            content: "Interactive show where guests participate in telling the story - great for shy kids to get involved.",
            priority: 5
          },
          {
            id: "belle-tip-2",
            category: "photo",
            content: "Beautiful sets including Maurice's cottage and Beast's library with amazing detail and props.",
            priority: 4
          },
          {
            id: "belle-tip-3",
            category: "general",
            content: "Part of the New Fantasyland expansion - immersive Beauty and the Beast experience.",
            priority: 3
          }
        ],
        tags: [
          "interactive",
          "storytelling",
          "beauty-and-the-beast",
          "belle",
          "new-fantasyland",
          "family-friendly"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "pirates-adventure-treasures-seven-seas",
        parkId: "magic-kingdom",
        name: "A Pirate's Adventure ~ Treasures of the Seven Seas",
        description: "Use a talisman and special map to embark on an interactive treasure hunt through Adventureland, following clues and activating magical effects to uncover pirate treasures.",
        location: "Adventureland",
        type: "experience",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "pirates-adventure-tip-1",
            category: "strategy",
            content: "Pick up your complimentary talisman and map at The Crow's Nest near Pirates of the Caribbean",
            priority: 5
          },
          {
            id: "pirates-adventure-tip-2",
            category: "general",
            content: "Great activity for kids - interactive treasure hunt with magical effects throughout Adventureland",
            priority: 4
          },
          {
            id: "pirates-adventure-tip-3",
            category: "best_time",
            content: "Perfect activity for hot days as you can take breaks in shade and air conditioning between locations",
            priority: 3
          }
        ],
        tags: [
          "interactive",
          "treasure-hunt",
          "pirates",
          "family-friendly",
          "walking",
          "adventureland"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      },
      {
        id: "bibbidi-bobbidi-boutique",
        parkId: "magic-kingdom",
        name: "Bibbidi Bobbidi Boutique",
        description: "A magical makeover experience where children ages 3-12 can be transformed into their favorite Disney princess or knight. Professional stylists provide hair, makeup, and costume styling in a fairy tale salon setting.",
        location: "Fantasyland",
        type: "experience",
        duration: 60,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "boutique-tip-1",
            category: "reservation",
            content: "Advance reservations required - book 60 days ahead as this experience fills up quickly",
            priority: 5
          },
          {
            id: "boutique-tip-2",
            category: "planning",
            content: "Schedule for mid-day so your child can enjoy the rest of the day in their costume",
            priority: 5
          },
          {
            id: "boutique-tip-3",
            category: "photo",
            content: "Perfect opportunity for character meet-and-greets and photos throughout the park afterward",
            priority: 4
          },
          {
            id: "boutique-tip-4",
            category: "general",
            content: "Available for ages 3-12 only - bring comfortable shoes for your child to change into",
            priority: 4
          },
          {
            id: "boutique-tip-5",
            category: "budget",
            content: "Premium experience with additional costs for packages, photos, and costume accessories",
            priority: 3
          }
        ],
        tags: [
          "princess",
          "makeover",
          "character-experience",
          "reservations-required",
          "premium",
          "ages-3-12",
          "costume",
          "fantasy"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      }
    ];
  }
});

// src/data/do/experiences/epcot-experiences.json
var epcot_experiences_default;
var init_epcot_experiences = __esm({
  "src/data/do/experiences/epcot-experiences.json"() {
    epcot_experiences_default = [
      {
        id: "epcot-living-seas-exploration",
        parkId: "epcot",
        name: "The Seas with Nemo & Friends Pavilion Exploration",
        description: "Explore the massive aquarium and marine exhibits in one of the world's largest man-made ocean environments.",
        location: "Future World",
        type: "experience",
        duration: 45,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "living-seas-tip-1",
            category: "general",
            content: "Great for all ages. Take time to read the educational displays and watch for manatees and sea turtles.",
            priority: 2
          }
        ],
        tags: [
          "aquarium",
          "marine-life",
          "educational",
          "family-friendly",
          "exploration"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "epcot-world-showcase-promenade",
        parkId: "epcot",
        name: "World Showcase Promenade Walk",
        description: "Take a leisurely walk around the World Showcase lagoon, exploring 11 country pavilions with unique architecture, food, and culture.",
        location: "World Showcase",
        type: "experience",
        duration: 120,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "world-showcase-tip-1",
            category: "general",
            content: "Perfect for a relaxing afternoon. Try snacks from different countries and check out the unique shops.",
            priority: 2
          }
        ],
        tags: [
          "cultural",
          "walking",
          "international",
          "shopping",
          "dining"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "epcot-journey-of-water-moana",
        parkId: "epcot",
        name: "Journey of Water, Inspired by Moana",
        description: "A self-guided walkthrough experience where guests interact with magical water that comes to life, inspired by Disney's Moana and celebrating the natural water cycle.",
        location: "Future World",
        type: "experience",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "journey-water-tip-1",
            category: "general",
            content: "Interactive water features respond to your movements - great for kids and families",
            priority: 5
          },
          {
            id: "journey-water-tip-2",
            category: "strategy",
            content: "You may get slightly wet from the interactive water elements - plan accordingly",
            priority: 4
          },
          {
            id: "journey-water-tip-3",
            category: "photo",
            content: "Beautiful outdoor setting with unique water effects - perfect for photos",
            priority: 4
          }
        ],
        tags: [
          "moana",
          "interactive",
          "water-features",
          "walkthrough",
          "family-friendly",
          "newest-attraction"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: true,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true
      }
    ];
  }
});

// src/data/do/experiences/hollywood-studios-experiences.json
var hollywood_studios_experiences_default;
var init_hollywood_studios_experiences = __esm({
  "src/data/do/experiences/hollywood-studios-experiences.json"() {
    hollywood_studios_experiences_default = [
      {
        id: "hs-star-wars-launch-bay",
        parkId: "hollywood-studios",
        name: "Star Wars Launch Bay Exploration",
        description: "PERMANENTLY CLOSED as of September 25, 2025. Former Star Wars exhibit space in Animation Courtyard closed to make way for The Walt Disney Studios experience.",
        location: "Animation Courtyard",
        type: "experience",
        duration: 30,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "launch-bay-tip-1",
            category: "strategy",
            content: "PERMANENTLY CLOSED: Closed September 25, 2025 along with entire Animation Courtyard area",
            priority: 5
          }
        ],
        tags: [
          "star-wars",
          "exhibits",
          "permanently-closed",
          "animation-courtyard"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "hs-toy-story-land-playground",
        parkId: "hollywood-studios",
        name: "Toy Story Land Exploration",
        description: "Explore Andy's backyard as if you've been shrunk down to toy size. Great for photos and soaking in the Toy Story atmosphere.",
        location: "Toy Story Land",
        type: "experience",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "toy-story-land-tip-1",
            category: "general",
            content: "Best during cooler parts of the day. Great for Instagram photos with the oversized toys and decorations.",
            priority: 2
          }
        ],
        tags: [
          "toy-story",
          "pixar",
          "photo-opportunities",
          "themed-area",
          "family-friendly"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "hs-galaxy-edge-exploration",
        parkId: "hollywood-studios",
        name: "Star Wars: Galaxy's Edge Exploration",
        description: "Explore the planet Batuu, browse unique shops, and immerse yourself in the Star Wars universe beyond the main attractions.",
        location: "Star Wars: Galaxy's Edge",
        type: "experience",
        duration: 60,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "galaxys-edge-tip-1",
            category: "general",
            content: "Try blue milk, build a lightsaber at Savi's Workshop, or create a droid at Droid Depot for the full experience.",
            priority: 1
          }
        ],
        tags: [
          "star-wars",
          "batuu",
          "shopping",
          "immersive",
          "themed-area"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      }
    ];
  }
});

// src/data/do/experiences/animal-kingdom-experiences.json
var animal_kingdom_experiences_default;
var init_animal_kingdom_experiences = __esm({
  "src/data/do/experiences/animal-kingdom-experiences.json"() {
    animal_kingdom_experiences_default = [
      {
        id: "ak-discovery-island-trails",
        parkId: "animal-kingdom",
        name: "Discovery Island Trails",
        description: "Explore winding trails around the Tree of Life with animal exhibits, gardens, and peaceful walkways.",
        location: "Discovery Island",
        type: "experience",
        duration: 30,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "discovery-trails-tip-1",
            category: "general",
            content: "Perfect for a peaceful walk. Look closely at the Tree of Life carvings - there are over 300 animals depicted!",
            priority: 2
          }
        ],
        tags: [
          "walking",
          "nature",
          "tree-of-life",
          "peaceful",
          "animals"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "ak-maharajah-jungle-trek",
        parkId: "animal-kingdom",
        name: "Maharajah Jungle Trek",
        description: "Walk through lush Asian forests and ruins while observing Malayan tapirs, Komodo dragons, tigers, and exotic birds.",
        location: "Asia",
        type: "experience",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "jungle-trek-tip-1",
            category: "strategy",
            content: "Best in morning or late afternoon when animals are more active. Bring water and take your time.",
            priority: 1
          }
        ],
        tags: [
          "animals",
          "tigers",
          "walking-trail",
          "asia",
          "nature"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "ak-gorilla-falls-exploration",
        parkId: "animal-kingdom",
        name: "Gorilla Falls Exploration Trail",
        description: "Walk through African research station exhibits and observe hippos, crocodiles, meerkats, and other African wildlife.",
        location: "Africa",
        type: "experience",
        duration: 25,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "gorilla-falls-tip-1",
            category: "general",
            content: "Don't miss the underwater hippo viewing area - it's amazing when they're swimming!",
            priority: 2
          }
        ],
        tags: [
          "animals",
          "africa",
          "hippos",
          "gorillas",
          "walking-trail"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "ak-oasis-exhibits",
        parkId: "animal-kingdom",
        name: "The Oasis Exhibits",
        description: "Explore the peaceful entrance area of Animal Kingdom with lush gardens, waterfalls, and animal exhibits including giant anteaters, tapirs, and exotic birds.",
        location: "The Oasis",
        type: "experience",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "oasis-tip-1",
            category: "general",
            content: "Perfect way to start or end your Animal Kingdom visit - peaceful gardens with unique animals",
            priority: 4
          },
          {
            id: "oasis-tip-2",
            category: "strategy",
            content: "Often overlooked by guests rushing to attractions - take time to explore the winding paths",
            priority: 3
          },
          {
            id: "oasis-tip-3",
            category: "photo",
            content: "Beautiful photo opportunities with waterfalls, gardens, and unique animals like giant anteaters",
            priority: 3
          }
        ],
        tags: [
          "entrance",
          "gardens",
          "animals",
          "peaceful",
          "walkthrough",
          "often-missed"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "ak-conservation-station",
        parkId: "animal-kingdom",
        name: "Conservation Station",
        description: "Educational facility at Rafiki's Planet Watch featuring interactive exhibits about animal care, conservation efforts, and veterinary sciences with behind-the-scenes animal care areas.",
        location: "Rafiki's Planet Watch",
        type: "experience",
        duration: 30,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: true
        },
        tips: [
          {
            id: "conservation-station-tip-1",
            category: "general",
            content: "Educational and inspiring - learn about Disney's real conservation efforts and animal care",
            priority: 4
          },
          {
            id: "conservation-station-tip-2",
            category: "strategy",
            content: "Take Wildlife Express Train to reach Rafiki's Planet Watch - plan 1-2 hours for full experience",
            priority: 4
          },
          {
            id: "conservation-station-tip-3",
            category: "general",
            content: "Watch veterinary procedures through viewing windows and interactive animal encounters",
            priority: 3
          }
        ],
        tags: [
          "conservation",
          "educational",
          "veterinary",
          "behind-the-scenes",
          "rafikis-planet-watch",
          "interactive"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "ak-affection-section",
        parkId: "animal-kingdom",
        name: "Affection Section",
        description: "Interactive petting zoo area at Rafiki's Planet Watch where guests can meet and interact with friendly domestic animals including goats, sheep, and other farm animals.",
        location: "Rafiki's Planet Watch",
        type: "experience",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "affection-section-tip-1",
            category: "general",
            content: "Perfect for young children - hands-on animal interactions with friendly farm animals",
            priority: 5
          },
          {
            id: "affection-section-tip-2",
            category: "strategy",
            content: "Take Wildlife Express Train to reach - combine with Conservation Station visit",
            priority: 4
          },
          {
            id: "affection-section-tip-3",
            category: "general",
            content: "Great place for kids to pet and brush goats, sheep, and other gentle animals",
            priority: 4
          }
        ],
        tags: [
          "petting-zoo",
          "interactive",
          "kids-favorite",
          "farm-animals",
          "rafikis-planet-watch",
          "hands-on"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "ak-wilderness-explorers",
        parkId: "animal-kingdom",
        name: "Wilderness Explorers",
        description: "Interactive scavenger hunt experience inspired by Disney\u2022Pixar's Up where guests earn badges by completing activities and learning about animals throughout Animal Kingdom.",
        location: "Park-wide",
        type: "experience",
        duration: 120,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "wilderness-explorers-tip-1",
            category: "strategy",
            content: "Start at Wilderness Explorers headquarters near entrance - collect handbook and earn badges throughout the day",
            priority: 5
          },
          {
            id: "wilderness-explorers-tip-2",
            category: "general",
            content: "Perfect activity for families with kids - educational and engaging way to explore the entire park",
            priority: 5
          },
          {
            id: "wilderness-explorers-tip-3",
            category: "strategy",
            content: "Complete activities while waiting for attractions or during meal breaks - great way to maximize your day",
            priority: 4
          }
        ],
        tags: [
          "interactive",
          "scavenger-hunt",
          "up",
          "badges",
          "educational",
          "park-wide",
          "family-activity"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      }
    ];
  }
});

// src/data/do/meet-greets/magic-kingdom-meet-greets.json
var magic_kingdom_meet_greets_default;
var init_magic_kingdom_meet_greets = __esm({
  "src/data/do/meet-greets/magic-kingdom-meet-greets.json"() {
    magic_kingdom_meet_greets_default = [
      {
        id: "mk-mickey-townhall",
        parkId: "magic-kingdom",
        name: "Meet Mickey Mouse at Town Square Theater",
        description: "Meet the one and only Mickey Mouse in his dressing room backstage at the Town Square Theater for photos and autographs.",
        location: "Main Street U.S.A.",
        type: "meet_greet",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "mickey-tip-1",
            category: "strategy",
            content: "Get a FastPass+ or arrive early in the morning for shorter wait times.",
            priority: 1
          }
        ],
        tags: [
          "classic",
          "must-do",
          "photos",
          "autographs"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: true,
        singleRider: false,
        photoService: true,
        characters: [
          "Mickey Mouse"
        ]
      },
      {
        id: "mk-princess-fairytale-hall",
        parkId: "magic-kingdom",
        name: "Princess Fairytale Hall",
        description: "Meet Disney Princesses in their royal reception hall in Fantasyland for photos and magical moments.",
        location: "Fantasyland",
        type: "meet_greet",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "princess-tip-1",
            category: "best_time",
            content: "Princesses rotate throughout the day - check the app for current lineup.",
            priority: 2
          }
        ],
        tags: [
          "princesses",
          "photos",
          "autographs",
          "magical"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: true,
        singleRider: false,
        photoService: true,
        characters: [
          "Cinderella",
          "Rapunzel",
          "Tiana",
          "Elena"
        ]
      },
      {
        id: "mk-ariel-grotto",
        parkId: "magic-kingdom",
        name: "Meet Ariel at Her Grotto",
        description: "Meet Princess Ariel in her magical undersea grotto in the Enchanted Forest area of New Fantasyland, complete with waterfalls and underwater theming.",
        location: "Fantasyland",
        type: "meet_greet",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "ariel-tip-1",
            category: "strategy",
            content: "Ariel appears as a mermaid - one of the few places to meet her in her iconic form.",
            priority: 5
          },
          {
            id: "ariel-tip-2",
            category: "photo",
            content: "Beautiful underwater grotto theming makes for stunning photos with waterfalls and sea elements.",
            priority: 4
          },
          {
            id: "ariel-tip-3",
            category: "general",
            content: "Located in the Enchanted Forest section of New Fantasyland near Beast's Castle.",
            priority: 3
          }
        ],
        tags: [
          "princess",
          "ariel",
          "little-mermaid",
          "grotto",
          "new-fantasyland",
          "underwater-theming"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: true,
        singleRider: false,
        photoService: true,
        characters: [
          "Ariel"
        ]
      }
    ];
  }
});

// src/data/do/meet-greets/epcot-meet-greets.json
var epcot_meet_greets_default;
var init_epcot_meet_greets = __esm({
  "src/data/do/meet-greets/epcot-meet-greets.json"() {
    epcot_meet_greets_default = [
      {
        id: "epcot-anna-elsa",
        parkId: "epcot",
        name: "Meet Anna and Elsa at Royal Sommerhus",
        description: "Meet the royal sisters from Frozen in their Norwegian summer home in the Norway Pavilion.",
        location: "Norway Pavilion",
        type: "meet_greet",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "anna-elsa-tip-1",
            category: "strategy",
            content: "Very popular meet & greet. Get Lightning Lane or arrive at park opening for shorter waits.",
            priority: 1
          }
        ],
        tags: [
          "frozen",
          "princesses",
          "norway",
          "sisters",
          "popular"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: true,
        singleRider: false,
        photoService: true,
        characters: [
          "Anna",
          "Elsa"
        ]
      },
      {
        id: "epcot-joy-sadness",
        parkId: "epcot",
        name: "Meet Joy and Sadness from Inside Out",
        description: "Meet the colorful emotions Joy and Sadness from Disney\u2022Pixar's Inside Out.",
        location: "The Imagination! Pavilion",
        type: "meet_greet",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "joy-sadness-tip-1",
            category: "general",
            content: "Great character interaction with lots of fun photo opportunities and emotional conversations!",
            priority: 2
          }
        ],
        tags: [
          "inside-out",
          "emotions",
          "pixar",
          "colorful",
          "interactive"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: true,
        characters: [
          "Joy",
          "Sadness"
        ]
      }
    ];
  }
});

// src/data/do/meet-greets/hollywood-studios-meet-greets.json
var hollywood_studios_meet_greets_default;
var init_hollywood_studios_meet_greets = __esm({
  "src/data/do/meet-greets/hollywood-studios-meet-greets.json"() {
    hollywood_studios_meet_greets_default = [
      {
        id: "hs-star-wars-characters",
        parkId: "hollywood-studios",
        name: "Star Wars Characters at Launch Bay",
        description: "Meet iconic Star Wars characters including Kylo Ren, Chewbacca, and BB-8 in the Star Wars Launch Bay.",
        location: "Star Wars Launch Bay",
        type: "meet_greet",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "star-wars-tip-1",
            category: "strategy",
            content: "Characters rotate throughout the day. Check the My Disney Experience app for current character schedules.",
            priority: 1
          }
        ],
        tags: [
          "star-wars",
          "kylo-ren",
          "chewbacca",
          "bb-8",
          "launch-bay"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: true,
        characters: [
          "Kylo Ren",
          "Chewbacca",
          "BB-8"
        ]
      },
      {
        id: "hs-woody-buzz",
        parkId: "hollywood-studios",
        name: "Meet Woody and Buzz at Toy Story Land",
        description: "Meet the iconic Toy Story duo Woody and Buzz Lightyear in Andy's backyard at Toy Story Land.",
        location: "Toy Story Land",
        type: "meet_greet",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "woody-buzz-tip-1",
            category: "strategy",
            content: "Very popular meet & greet. Visit early in the morning or use Lightning Lane for shorter waits.",
            priority: 1
          }
        ],
        tags: [
          "toy-story",
          "woody",
          "buzz-lightyear",
          "pixar",
          "popular"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: true,
        singleRider: false,
        photoService: true,
        characters: [
          "Woody",
          "Buzz Lightyear"
        ]
      },
      {
        id: "hs-mickey-minnie-runaway-railway",
        parkId: "hollywood-studios",
        name: "Meet Mickey and Minnie at Red Carpet Dreams",
        description: "Meet Mickey and Minnie Mouse in their Hollywood glamour outfits at this special character greeting.",
        location: "Grand Avenue",
        type: "meet_greet",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "mickey-minnie-hollywood-tip-1",
            category: "general",
            content: "Mickey and Minnie are in their special Hollywood outfits here - great for unique photos!",
            priority: 2
          }
        ],
        tags: [
          "mickey-mouse",
          "minnie-mouse",
          "hollywood",
          "classic",
          "glamour"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true,
        characters: [
          "Mickey Mouse",
          "Minnie Mouse"
        ]
      }
    ];
  }
});

// src/data/do/meet-greets/animal-kingdom-meet-greets.json
var animal_kingdom_meet_greets_default;
var init_animal_kingdom_meet_greets = __esm({
  "src/data/do/meet-greets/animal-kingdom-meet-greets.json"() {
    animal_kingdom_meet_greets_default = [
      {
        id: "ak-russell-dug",
        parkId: "animal-kingdom",
        name: "Meet Russell and Dug from Up",
        description: "Meet the adventurous Wilderness Explorer Russell and the lovable talking dog Dug from Disney\u2022Pixar's Up.",
        location: "Discovery Island Trails",
        type: "meet_greet",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "russell-dug-tip-1",
            category: "general",
            content: "Great character interaction! Russell loves to talk about earning badges and Dug is always excited to meet new friends.",
            priority: 2
          }
        ],
        tags: [
          "up",
          "russell",
          "dug",
          "pixar",
          "wilderness-explorer"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true,
        characters: [
          "Russell",
          "Dug"
        ]
      },
      {
        id: "ak-pocahontas",
        parkId: "animal-kingdom",
        name: "Meet Pocahontas at Character Landing",
        description: "Meet the brave and free-spirited Pocahontas in her natural forest setting, perfect for the Animal Kingdom atmosphere.",
        location: "Discovery Island",
        type: "meet_greet",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "pocahontas-tip-1",
            category: "general",
            content: "Pocahontas loves to talk about nature and animals - perfect for the Animal Kingdom setting!",
            priority: 2
          }
        ],
        tags: [
          "pocahontas",
          "nature",
          "princess",
          "forest",
          "animal-kingdom-exclusive"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true,
        characters: [
          "Pocahontas"
        ]
      },
      {
        id: "ak-mickey-minnie-adventurers-outpost",
        parkId: "animal-kingdom",
        name: "Meet Mickey and Minnie at Adventurers Outpost",
        description: "Meet Mickey and Minnie Mouse in their safari adventure gear at the Adventurers Outpost on Discovery Island.",
        location: "Discovery Island - Adventurers Outpost",
        type: "meet_greet",
        duration: 5,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "mickey-minnie-safari-tip-1",
            category: "strategy",
            content: "One of the most popular meet & greets in Animal Kingdom. Get Lightning Lane or visit early for shorter waits.",
            priority: 1
          }
        ],
        tags: [
          "mickey-mouse",
          "minnie-mouse",
          "safari",
          "adventure",
          "popular"
        ],
        features: {
          multiPass: true,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: true,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: true,
        singleRider: false,
        photoService: true,
        characters: [
          "Mickey Mouse",
          "Minnie Mouse"
        ]
      }
    ];
  }
});

// src/data/do/entertainment/magic-kingdom-entertainment.json
var magic_kingdom_entertainment_default;
var init_magic_kingdom_entertainment = __esm({
  "src/data/do/entertainment/magic-kingdom-entertainment.json"() {
    magic_kingdom_entertainment_default = [
      {
        id: "mk-festival-fantasy-parade",
        parkId: "magic-kingdom",
        name: "Festival of Fantasy Parade",
        description: "A spectacular daytime parade featuring beloved Disney characters, elaborate floats, and the dragon from Sleeping Beauty.",
        location: "Main Street U.S.A. to Frontierland",
        type: "entertainment",
        duration: 12,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "parade-tip-1",
            category: "best_time",
            content: "Arrive 30-45 minutes early for good viewing spots along Main Street or Frontierland.",
            priority: 1
          }
        ],
        tags: [
          "parade",
          "characters",
          "music",
          "outdoor",
          "family-friendly"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true
      },
      {
        id: "mk-happily-ever-after",
        parkId: "magic-kingdom",
        name: "Happily Ever After",
        description: "A spectacular nighttime fireworks spectacular featuring projection mapping on Cinderella Castle with Disney's most beloved songs.",
        location: "Cinderella Castle",
        type: "entertainment",
        duration: 18,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "hea-tip-1",
            category: "best_time",
            content: "Arrive 60-90 minutes early for prime viewing spots on Main Street or in front of the castle.",
            priority: 1
          }
        ],
        tags: [
          "fireworks",
          "nighttime",
          "castle",
          "projection",
          "music"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: true,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true
      },
      {
        id: "mk-disney-starlight",
        parkId: "magic-kingdom",
        name: "Disney Starlight: Dream the Night Away",
        description: "A spectacular nighttime parade featuring illuminated floats, beloved Disney characters, and magical lighting effects. Currently runs twice nightly when available.",
        location: "Main Street U.S.A. to Frontierland",
        type: "entertainment",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "starlight-tip-1",
            category: "strategy",
            content: "Not available on Mickey's Not-So-Scary Halloween Party nights in September/October",
            priority: 5
          },
          {
            id: "starlight-tip-2",
            category: "best_time",
            content: "Arrive 45-60 minutes early for prime viewing spots - extremely popular",
            priority: 5
          },
          {
            id: "starlight-tip-3",
            category: "strategy",
            content: "Show times vary by season - check My Disney Experience app for current schedule",
            priority: 4
          }
        ],
        tags: [
          "nighttime-parade",
          "characters",
          "illuminated",
          "new",
          "popular",
          "twice-nightly"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: true,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true
      },
      {
        id: "mk-dapper-dans",
        parkId: "magic-kingdom",
        name: "The Dapper Dans",
        description: "A barbershop quartet that performs classic Disney songs and popular tunes throughout Main Street U.S.A.",
        location: "Main Street U.S.A.",
        type: "entertainment",
        duration: 10,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "dapper-tip-1",
            category: "general",
            content: "Check the My Disney Experience app for performance times - they move around Main Street throughout the day.",
            priority: 2
          }
        ],
        tags: [
          "music",
          "street-performers",
          "barbershop",
          "classic"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      }
    ];
  }
});

// src/data/do/entertainment/epcot-entertainment.json
var epcot_entertainment_default;
var init_epcot_entertainment = __esm({
  "src/data/do/entertainment/epcot-entertainment.json"() {
    epcot_entertainment_default = [
      {
        id: "epcot-luminous",
        parkId: "epcot",
        name: "Luminous: The Symphony of Us",
        description: "A spectacular nighttime fireworks experience celebrating human connection with synchronized pyrotechnics, choreographed fountains, lasers, and fire torches on World Showcase Lagoon.",
        location: "World Showcase Lagoon",
        type: "entertainment",
        duration: 17,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "luminous-tip-1",
            category: "best_time",
            content: "360\xB0 experience - best viewing along World Showcase Promenade. Arrive 45-60 minutes early for prime spots.",
            priority: 1
          }
        ],
        tags: [
          "fireworks",
          "nighttime",
          "lagoon",
          "lasers",
          "world-showcase"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: true,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true
      },
      {
        id: "epcot-celebracion-encanto",
        parkId: "epcot",
        name: "\xA1Celebraci\xF3n Encanto!",
        description: "Dance, sing, and celebrate with the marvelous Madrigal family in this interactive sing-along show featuring beloved characters and songs from Disney's Encanto.",
        location: "CommuniCore Plaza Stage",
        type: "entertainment",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "encanto-tip-1",
            category: "general",
            content: "Now a full-time offering at EPCOT! Interactive show perfect for families with young children.",
            priority: 4
          },
          {
            id: "encanto-tip-2",
            category: "strategy",
            content: "Multiple showtimes throughout the day - check My Disney Experience app for current schedule.",
            priority: 3
          }
        ],
        tags: [
          "encanto",
          "sing-along",
          "interactive",
          "family-friendly",
          "stage-show",
          "new"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: true,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "epcot-mariachi-cobre",
        parkId: "epcot",
        name: "Mariachi Cobre",
        description: "Authentic mariachi music performances at the Mexico Pavilion in World Showcase.",
        location: "Mexico Pavilion",
        type: "entertainment",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "mariachi-tip-1",
            category: "general",
            content: "Performances typically happen multiple times throughout the day near the Mexico Pavilion entrance.",
            priority: 2
          }
        ],
        tags: [
          "music",
          "world-showcase",
          "cultural",
          "mexico",
          "live-performance"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      },
      {
        id: "epcot-voices-of-liberty",
        parkId: "epcot",
        name: "Voices of Liberty",
        description: "An a cappella group performing American folk songs and patriotic music at the American Adventure pavilion.",
        location: "American Adventure Pavilion",
        type: "entertainment",
        duration: 12,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "voices-tip-1",
            category: "general",
            content: "Performances usually take place in the rotunda before American Adventure shows.",
            priority: 2
          }
        ],
        tags: [
          "music",
          "american",
          "a-cappella",
          "patriotic",
          "world-showcase"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        },
        lightningLane: false,
        singleRider: false,
        photoService: false
      }
    ];
  }
});

// src/data/do/entertainment/hollywood-studios-entertainment.json
var hollywood_studios_entertainment_default;
var init_hollywood_studios_entertainment = __esm({
  "src/data/do/entertainment/hollywood-studios-entertainment.json"() {
    hollywood_studios_entertainment_default = [
      {
        id: "hs-fantasmic",
        parkId: "hollywood-studios",
        name: "Fantasmic!",
        description: "Mickey Mouse's imagination creates a magical nighttime spectacular with water effects, fireworks, and classic Disney villains.",
        location: "Hollywood Hills Amphitheater",
        type: "entertainment",
        duration: 25,
        intensity: "moderate",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "fantasmic-tip-1",
            category: "strategy",
            content: "Book a Fantasmic! dining package for guaranteed seating, or arrive 90+ minutes early for standby.",
            priority: 1
          }
        ],
        tags: [
          "nighttime",
          "water-show",
          "fireworks",
          "mickey",
          "villains"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: true,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true
      },
      {
        id: "hs-star-wars-march",
        parkId: "hollywood-studios",
        name: "Star Wars: A Galaxy Far, Far Away",
        description: "A live stage show featuring Star Wars characters, music, and special effects in front of the Chinese Theatre.",
        location: "Center Stage",
        type: "entertainment",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "sw-show-tip-1",
            category: "best_time",
            content: "Check the My Disney Experience app for show times - they vary seasonally.",
            priority: 2
          }
        ],
        tags: [
          "star-wars",
          "live-show",
          "characters",
          "special-effects"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: true,
          interactiveElements: false,
          characterMeet: true,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true
      }
    ];
  }
});

// src/data/do/entertainment/animal-kingdom-entertainment.json
var animal_kingdom_entertainment_default;
var init_animal_kingdom_entertainment = __esm({
  "src/data/do/entertainment/animal-kingdom-entertainment.json"() {
    animal_kingdom_entertainment_default = [
      {
        id: "ak-tree-of-life-awakenings",
        parkId: "animal-kingdom",
        name: "Tree of Life Awakenings",
        description: "Magical projections bring the Tree of Life to life with stories of animals and nature after dark.",
        location: "Discovery Island",
        type: "entertainment",
        duration: 3,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "tree-awakenings-tip-1",
            category: "general",
            content: "Shows run every 10 minutes after dark. Best viewing is from the bridge or walkways around Discovery Island.",
            priority: 2
          }
        ],
        tags: [
          "tree-of-life",
          "projections",
          "nighttime",
          "animals",
          "nature"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: true,
        showTimes: [
          "Every 10 minutes after dark"
        ]
      },
      {
        id: "ak-drummers-burudika",
        parkId: "animal-kingdom",
        name: "Burudika",
        description: "High-energy African drumming and dancing performances celebrating the music and culture of Africa.",
        location: "Harambe Village",
        type: "entertainment",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "burudika-tip-1",
            category: "general",
            content: "Performances are interactive - don't be shy about participating in the dancing and drumming!",
            priority: 2
          }
        ],
        tags: [
          "african",
          "drumming",
          "dancing",
          "cultural",
          "interactive"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: true,
          strobeEffects: false,
          interactiveElements: true,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        },
        lightningLane: false,
        singleRider: false,
        photoService: false,
        showTimes: [
          "Multiple times daily"
        ]
      }
    ];
  }
});

// src/data/do/transportation/magic-kingdom-transportation.json
var magic_kingdom_transportation_default;
var init_magic_kingdom_transportation = __esm({
  "src/data/do/transportation/magic-kingdom-transportation.json"() {
    magic_kingdom_transportation_default = [
      {
        id: "mk-monorail-express",
        parkId: "magic-kingdom",
        name: "Magic Kingdom Express Monorail",
        description: "Direct monorail line from Transportation and Ticket Center (TTC) to Magic Kingdom entrance, offering the fastest route to the park.",
        location: "Transportation and Ticket Center to Magic Kingdom",
        type: "transportation",
        duration: 10,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "mk-monorail-tip-1",
            category: "strategy",
            content: "Monorail is typically faster than ferry boats, especially during busy periods",
            priority: 4
          },
          {
            id: "mk-monorail-tip-2",
            category: "best_time",
            content: "Operates 30 minutes before park opening to 1 hour after closing",
            priority: 3
          }
        ],
        tags: [
          "monorail",
          "express",
          "ttc",
          "fast"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "mk-ferry-boat",
        parkId: "magic-kingdom",
        name: "Magic Kingdom Ferry Boats",
        description: "Large ferry boats crossing Seven Seas Lagoon between TTC and Magic Kingdom, carrying up to 600 guests per boat with scenic lagoon views.",
        location: "Transportation and Ticket Center to Magic Kingdom",
        type: "transportation",
        duration: 12,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "mk-ferry-tip-1",
            category: "general",
            content: "Offers beautiful views of Magic Kingdom, Grand Floridian, and Polynesian resorts",
            priority: 3
          },
          {
            id: "mk-ferry-tip-2",
            category: "strategy",
            content: "6-minute crossing, but total trip time 10-12 minutes with loading/unloading",
            priority: 4
          }
        ],
        tags: [
          "ferry",
          "boat",
          "scenic",
          "lagoon"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      },
      {
        id: "mk-resort-monorail",
        parkId: "magic-kingdom",
        name: "Resort Monorail Loop",
        description: "Monorail loop connecting Magic Kingdom with Grand Floridian, Polynesian, and TTC, providing transportation to resort areas.",
        location: "Magic Kingdom - Grand Floridian - Polynesian - TTC Loop",
        type: "transportation",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "mk-resort-monorail-tip-1",
            category: "strategy",
            content: "Use this line to visit resort hotels for dining or shopping",
            priority: 3
          },
          {
            id: "mk-resort-monorail-tip-2",
            category: "general",
            content: "Longer route than Express Monorail but offers resort access",
            priority: 2
          }
        ],
        tags: [
          "monorail",
          "resort",
          "loop",
          "hotels"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "mk-bus-transportation",
        parkId: "magic-kingdom",
        name: "Disney Bus Service to Magic Kingdom",
        description: "Complimentary bus transportation from Disney resort hotels to Magic Kingdom, with real-time arrival information available.",
        location: "Various Disney Resort Hotels to Magic Kingdom",
        type: "transportation",
        duration: 25,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "mk-bus-tip-1",
            category: "best_time",
            content: "Buses run 45 minutes before park opening to 1 hour after closing",
            priority: 4
          },
          {
            id: "mk-bus-tip-2",
            category: "strategy",
            content: "Check real-time arrival displays at resort bus stops for wait times",
            priority: 3
          }
        ],
        tags: [
          "bus",
          "resort",
          "complimentary",
          "real-time"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "mk-water-taxi-gold-flag",
        parkId: "magic-kingdom",
        name: "Gold Flag Water Taxi",
        description: "Water transportation connecting Magic Kingdom with Grand Floridian and Polynesian resorts via Seven Seas Lagoon.",
        location: "Magic Kingdom - Grand Floridian - Polynesian Loop",
        type: "transportation",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "mk-water-taxi-tip-1",
            category: "general",
            content: "Scenic boat ride with views of lagoon and resort hotels",
            priority: 3
          },
          {
            id: "mk-water-taxi-tip-2",
            category: "strategy",
            content: "Colored flags indicate different routes - look for Gold Flag",
            priority: 2
          }
        ],
        tags: [
          "water-taxi",
          "boat",
          "gold-flag",
          "scenic"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      },
      {
        id: "mk-walt-disney-world-railroad",
        parkId: "magic-kingdom",
        name: "Walt Disney World Railroad",
        description: "Vintage steam-powered train providing scenic transportation around Magic Kingdom. CURRENTLY OPERATING IN SHUTTLE MODE between Main Street USA and Storybook Circus (Fantasyland) stations only due to construction.",
        location: "Main Street USA to Storybook Circus (Shuttle Mode)",
        type: "transportation",
        duration: 10,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "mk-railroad-tip-1",
            category: "strategy",
            content: "SHUTTLE MODE: Only operates between Main Street USA and Storybook Circus due to construction",
            priority: 5
          },
          {
            id: "mk-railroad-tip-2",
            category: "general",
            content: "Great way to rest your feet and see unique views of the park",
            priority: 4
          },
          {
            id: "mk-railroad-tip-3",
            category: "strategy",
            content: "Frontierland station closed - 2/3 of track unavailable due to Cars Land construction",
            priority: 4
          }
        ],
        tags: [
          "railroad",
          "train",
          "vintage",
          "scenic",
          "shuttle-mode",
          "limited-service"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: true,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      }
    ];
  }
});

// src/data/do/transportation/epcot-transportation.json
var epcot_transportation_default;
var init_epcot_transportation = __esm({
  "src/data/do/transportation/epcot-transportation.json"() {
    epcot_transportation_default = [
      {
        id: "epcot-monorail",
        parkId: "epcot",
        name: "EPCOT Monorail Line",
        description: "Monorail system connecting EPCOT to Magic Kingdom via TTC, with track passing through World Celebration and around Spaceship Earth.",
        location: "EPCOT Main Entrance to TTC and Magic Kingdom",
        type: "transportation",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "epcot-monorail-tip-1",
            category: "general",
            content: "Track loops around World Celebration and Spaceship Earth for scenic views",
            priority: 3
          },
          {
            id: "epcot-monorail-tip-2",
            category: "strategy",
            content: "Most direct route to Magic Kingdom from EPCOT",
            priority: 4
          }
        ],
        tags: [
          "monorail",
          "magic-kingdom",
          "ttc",
          "scenic"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "epcot-skyliner",
        parkId: "epcot",
        name: "Disney Skyliner from EPCOT",
        description: "Gondola transportation system connecting EPCOT International Gateway to Hollywood Studios via Caribbean Beach Resort hub.",
        location: "EPCOT International Gateway to Hollywood Studios",
        type: "transportation",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "epcot-skyliner-tip-1",
            category: "strategy",
            content: "Access from International Gateway, not main EPCOT entrance",
            priority: 4
          },
          {
            id: "epcot-skyliner-tip-2",
            category: "general",
            content: "Provides aerial views and connects to Riviera, Caribbean Beach, Art of Animation, and Pop Century resorts",
            priority: 3
          }
        ],
        tags: [
          "skyliner",
          "gondola",
          "international-gateway",
          "hollywood-studios"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      },
      {
        id: "epcot-bus-transportation",
        parkId: "epcot",
        name: "Disney Bus Service to EPCOT",
        description: "Complimentary bus transportation from Disney resort hotels to EPCOT, with wait times available in My Disney Experience app.",
        location: "Various Disney Resort Hotels to EPCOT",
        type: "transportation",
        duration: 25,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "epcot-bus-tip-1",
            category: "strategy",
            content: "Check My Disney Experience app for real-time bus wait times",
            priority: 4
          },
          {
            id: "epcot-bus-tip-2",
            category: "general",
            content: "Available from most Disney resort hotels throughout the day",
            priority: 3
          }
        ],
        tags: [
          "bus",
          "resort",
          "my-disney-experience",
          "wait-times"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "epcot-friendship-boats",
        parkId: "epcot",
        name: "Friendship Boats from EPCOT",
        description: "Boat transportation connecting EPCOT International Gateway to nearby resorts including BoardWalk, Beach Club, Yacht Club, and Swan & Dolphin.",
        location: "EPCOT International Gateway to BoardWalk Area Resorts",
        type: "transportation",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "epcot-friendship-tip-1",
            category: "general",
            content: "Scenic boat ride along Crescent Lake to BoardWalk area resorts",
            priority: 3
          },
          {
            id: "epcot-friendship-tip-2",
            category: "strategy",
            content: "Access from International Gateway, connects to Hollywood Studios",
            priority: 4
          }
        ],
        tags: [
          "friendship-boats",
          "international-gateway",
          "boardwalk",
          "scenic"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      },
      {
        id: "epcot-world-showcase-water-taxi",
        parkId: "epcot",
        name: "World Showcase Water Taxi",
        description: "Internal water transportation across World Showcase Lagoon, operating on two routes within EPCOT.",
        location: "World Showcase Lagoon (within EPCOT)",
        type: "transportation",
        duration: 10,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "epcot-water-taxi-tip-1",
            category: "strategy",
            content: "Saves walking time around World Showcase Lagoon",
            priority: 4
          },
          {
            id: "epcot-water-taxi-tip-2",
            category: "best_time",
            content: "Hours vary based on weather and water conditions",
            priority: 3
          }
        ],
        tags: [
          "water-taxi",
          "world-showcase",
          "lagoon",
          "internal"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      }
    ];
  }
});

// src/data/do/transportation/hollywood-studios-transportation.json
var hollywood_studios_transportation_default;
var init_hollywood_studios_transportation = __esm({
  "src/data/do/transportation/hollywood-studios-transportation.json"() {
    hollywood_studios_transportation_default = [
      {
        id: "hs-skyliner",
        parkId: "hollywood-studios",
        name: "Disney Skyliner from Hollywood Studios",
        description: "Gondola transportation system connecting Hollywood Studios to EPCOT via Caribbean Beach Resort, and to Art of Animation, Pop Century, and Riviera resorts.",
        location: "Hollywood Studios to EPCOT and Skyliner Resort Hotels",
        type: "transportation",
        duration: 17,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "hs-skyliner-tip-1",
            category: "strategy",
            content: "Transfer required at Caribbean Beach Resort for EPCOT connection",
            priority: 4
          },
          {
            id: "hs-skyliner-tip-2",
            category: "best_time",
            content: "Starts 60 minutes before park opening, runs 90 minutes after closing",
            priority: 3
          },
          {
            id: "hs-skyliner-tip-3",
            category: "general",
            content: "Shuts down during severe weather with bus backup provided",
            priority: 3
          }
        ],
        tags: [
          "skyliner",
          "gondola",
          "epcot",
          "caribbean-beach"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      },
      {
        id: "hs-bus-transportation",
        parkId: "hollywood-studios",
        name: "Disney Bus Service from Hollywood Studios",
        description: "Complimentary bus transportation from Hollywood Studios to Disney resort hotels and other theme parks, running from 6:30-7:00 AM until 2 hours after park closing.",
        location: "Hollywood Studios to Disney Resort Hotels and Other Parks",
        type: "transportation",
        duration: 25,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "hs-bus-tip-1",
            category: "best_time",
            content: "Service runs from early morning until 2 hours after park closing",
            priority: 4
          },
          {
            id: "hs-bus-tip-2",
            category: "strategy",
            content: "Primary option for resorts not on Skyliner or boat routes",
            priority: 3
          }
        ],
        tags: [
          "bus",
          "resort",
          "theme-parks",
          "backup"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "hs-friendship-boats",
        parkId: "hollywood-studios",
        name: "Friendship Boats from Hollywood Studios",
        description: "Boat transportation connecting Hollywood Studios to BoardWalk area resorts including Swan, Dolphin, Yacht Club, Beach Club, and BoardWalk Inn.",
        location: "Hollywood Studios to BoardWalk Area Resorts and EPCOT",
        type: "transportation",
        duration: 20,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "hs-friendship-tip-1",
            category: "best_time",
            content: "Operates 8:30 AM until 60 minutes after park closing",
            priority: 3
          },
          {
            id: "hs-friendship-tip-2",
            category: "general",
            content: "Scenic boat ride connecting to EPCOT International Gateway",
            priority: 3
          }
        ],
        tags: [
          "friendship-boats",
          "boardwalk",
          "epcot",
          "scenic"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      },
      {
        id: "hs-walking-paths",
        parkId: "hollywood-studios",
        name: "Walking Paths from Hollywood Studios",
        description: "Pedestrian walkways connecting Hollywood Studios to nearby BoardWalk area resorts for guests preferring to walk.",
        location: "Hollywood Studios to BoardWalk, Beach Club, Yacht Club, Swan & Dolphin",
        type: "transportation",
        duration: 15,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "hs-walking-tip-1",
            category: "strategy",
            content: "Pleasant walk to BoardWalk area resorts, about 10-15 minutes",
            priority: 3
          },
          {
            id: "hs-walking-tip-2",
            category: "general",
            content: "Available 24/7 and not affected by weather like boats or Skyliner",
            priority: 2
          }
        ],
        tags: [
          "walking",
          "pedestrian",
          "boardwalk",
          "exercise"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      }
    ];
  }
});

// src/data/do/transportation/animal-kingdom-transportation.json
var animal_kingdom_transportation_default;
var init_animal_kingdom_transportation = __esm({
  "src/data/do/transportation/animal-kingdom-transportation.json"() {
    animal_kingdom_transportation_default = [
      {
        id: "ak-bus-transportation",
        parkId: "animal-kingdom",
        name: "Disney Bus Service from Animal Kingdom",
        description: "Complimentary bus transportation from Animal Kingdom to all Disney resort hotels and theme parks, running approximately every 20-30 minutes with GPS tracking.",
        location: "Animal Kingdom to Disney Resort Hotels and Other Parks",
        type: "transportation",
        duration: 25,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "ak-bus-tip-1",
            category: "strategy",
            content: "GPS tracking provides real-time wait times, buses arrive every 20 minutes or less",
            priority: 4
          },
          {
            id: "ak-bus-tip-2",
            category: "general",
            content: "Primary transportation option - Animal Kingdom has no monorail or Skyliner access",
            priority: 3
          },
          {
            id: "ak-bus-tip-3",
            category: "general",
            content: "Bus stop divided into three sections with deluxe resorts at gates 10-26",
            priority: 2
          }
        ],
        tags: [
          "bus",
          "primary",
          "gps-tracking",
          "resort-hotels"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: true,
          outdoorExperience: false,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: true
        }
      },
      {
        id: "ak-parking-trams",
        parkId: "animal-kingdom",
        name: "Animal Kingdom Parking Lot Trams",
        description: "Complimentary tram service from Animal Kingdom parking lots (Unicorn, Dinosaur, Giraffe, Yeti) to park entrance, returning after hiatus.",
        location: "Animal Kingdom Parking Lots to Park Entrance",
        type: "transportation",
        duration: 8,
        intensity: "low",
        accessibility: {
          wheelchairAccessible: true,
          transferRequired: false,
          serviceAnimalsAllowed: true,
          signLanguageAvailable: false
        },
        tips: [
          {
            id: "ak-tram-tip-1",
            category: "strategy",
            content: "Highly recommended for distant lots like Dinosaur, Giraffe, and Yeti",
            priority: 4
          },
          {
            id: "ak-tram-tip-2",
            category: "general",
            content: "Trams have returned to service - save your walking energy for inside the park",
            priority: 3
          },
          {
            id: "ak-tram-tip-3",
            category: "general",
            content: "Does not service disability/preferred parking lots, which are closer to entrance",
            priority: 2
          }
        ],
        tags: [
          "tram",
          "parking",
          "returned",
          "energy-saving"
        ],
        features: {
          multiPass: false,
          singlePass: false,
          singleRider: false,
          riderSwitch: false,
          mobileCheckin: false,
          photoPass: false,
          darkRide: false,
          getsWet: false,
          spinningMotion: false,
          loudSounds: false,
          strobeEffects: false,
          interactiveElements: false,
          characterMeet: false,
          livePerformance: false,
          airConditioning: false,
          outdoorExperience: true,
          heightRequirement: false,
          motionSensitivity: false,
          pregnancyAdvisory: false,
          wheelchairAccessible: true,
          transferRequired: false,
          rainSafe: false
        }
      }
    ];
  }
});

// src/data/do/index.ts
var do_exports = {};
__export(do_exports, {
  entertainment: () => entertainment,
  experiences: () => experiences,
  getAllDoItems: () => getAllDoItems,
  getDoItemById: () => getDoItemById,
  getDoItemsByPark: () => getDoItemsByPark,
  getDoItemsByType: () => getDoItemsByType,
  getEntertainmentSchedules: () => getEntertainmentSchedules,
  getEntertainmentShowTimes: () => getEntertainmentShowTimes,
  meetGreets: () => meetGreets,
  rides: () => rides,
  shows: () => shows,
  transportation: () => transportation
});
var getEntertainmentShowTimes, getEntertainmentSchedules, rides, shows, experiences, meetGreets, entertainment, transportation, getAllDoItems, getDoItemsByPark, getDoItemsByType, getDoItemById;
var init_do = __esm({
  "src/data/do/index.ts"() {
    "use strict";
    init_entertainment_schedules();
    init_magic_kingdom_rides();
    init_epcot_rides();
    init_hollywood_studios_rides();
    init_animal_kingdom_rides();
    init_magic_kingdom_shows();
    init_epcot_shows();
    init_hollywood_studios_shows();
    init_animal_kingdom_shows();
    init_magic_kingdom_experiences();
    init_epcot_experiences();
    init_hollywood_studios_experiences();
    init_animal_kingdom_experiences();
    init_magic_kingdom_meet_greets();
    init_epcot_meet_greets();
    init_hollywood_studios_meet_greets();
    init_animal_kingdom_meet_greets();
    init_magic_kingdom_entertainment();
    init_epcot_entertainment();
    init_hollywood_studios_entertainment();
    init_animal_kingdom_entertainment();
    init_magic_kingdom_transportation();
    init_epcot_transportation();
    init_hollywood_studios_transportation();
    init_animal_kingdom_transportation();
    getEntertainmentShowTimes = (parkId, entertainmentId) => {
      const schedules = entertainment_schedules_default;
      const schedule = schedules[parkId]?.[entertainmentId];
      return schedule?.showTimes || [];
    };
    getEntertainmentSchedules = () => {
      return entertainment_schedules_default;
    };
    rides = [
      // Legacy data from rides files (filtered by type)
      ...magic_kingdom_rides_default.filter((item) => item.type === "ride"),
      ...epcot_rides_default.filter((item) => item.type === "ride"),
      ...hollywood_studios_rides_default.filter((item) => item.type === "ride"),
      ...animal_kingdom_rides_default.filter((item) => item.type === "ride")
    ];
    shows = [
      // Category-specific data only (no legacy duplication)
      ...magic_kingdom_shows_default,
      ...epcot_shows_default,
      ...hollywood_studios_shows_default,
      ...animal_kingdom_shows_default
    ];
    experiences = [
      // Category-specific data only (no legacy duplication)
      ...magic_kingdom_experiences_default,
      ...epcot_experiences_default,
      ...hollywood_studios_experiences_default,
      ...animal_kingdom_experiences_default
    ];
    meetGreets = [
      // Category-specific data only (no legacy duplication)
      ...magic_kingdom_meet_greets_default,
      ...epcot_meet_greets_default,
      ...hollywood_studios_meet_greets_default,
      ...animal_kingdom_meet_greets_default
    ];
    entertainment = [
      // Category-specific data only (no legacy duplication)
      ...magic_kingdom_entertainment_default,
      ...epcot_entertainment_default,
      ...hollywood_studios_entertainment_default,
      ...animal_kingdom_entertainment_default
    ];
    transportation = [
      // Category-specific data only (no legacy duplication)
      ...magic_kingdom_transportation_default,
      ...epcot_transportation_default,
      ...hollywood_studios_transportation_default,
      ...animal_kingdom_transportation_default
    ];
    getAllDoItems = () => {
      return [...rides, ...shows, ...experiences, ...meetGreets, ...entertainment, ...transportation];
    };
    getDoItemsByPark = (parkId) => {
      return getAllDoItems().filter((item) => item.parkId === parkId);
    };
    getDoItemsByType = (type) => {
      return getAllDoItems().filter((item) => item.type === type);
    };
    getDoItemById = (id) => {
      return getAllDoItems().find((item) => item.id === id);
    };
  }
});

// src/data/eat/quick-service/magic-kingdom-quick-service.json
var magic_kingdom_quick_service_default;
var init_magic_kingdom_quick_service = __esm({
  "src/data/eat/quick-service/magic-kingdom-quick-service.json"() {
    magic_kingdom_quick_service_default = [
      {
        id: "cosmic-rays-starlight-cafe",
        parkId: "magic-kingdom",
        name: "Cosmic Ray's Starlight Cafe",
        description: "Quick-service restaurant in Tomorrowland featuring burgers, chicken, and entertainment by Sonny Eclipse.",
        location: "Tomorrowland",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "cosmic-rays-tip-1",
            category: "general",
            content: "Largest quick-service restaurant in Magic Kingdom",
            priority: 3
          },
          {
            id: "cosmic-rays-tip-2",
            category: "general",
            content: "Sonny Eclipse performs regularly - check for showtimes",
            priority: 4
          },
          {
            id: "cosmic-rays-tip-3",
            category: "strategy",
            content: "Mobile order ahead to skip the line",
            priority: 4
          }
        ],
        tags: ["burgers", "large", "convenient"],
        cuisineType: "American",
        kidFriendly: true,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          entertainment: true,
          themedAtmosphere: true,
          vegetarianOptions: true,
          alcoholServed: false,
          kidFriendly: true,
          allergyFriendly: false
        }
      },
      {
        id: "casey-corner",
        parkId: "magic-kingdom",
        name: "Casey's Corner",
        description: "Baseball-themed quick service restaurant famous for its hot dogs and baseball atmosphere.",
        location: "Main Street U.S.A.",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "casey-tip-1",
            category: "strategy",
            content: "Great spot to watch the hub activity while eating",
            priority: 3
          },
          {
            id: "casey-tip-2",
            category: "general",
            content: "Try the corn dog nuggets - they're a fan favorite",
            priority: 4
          },
          {
            id: "casey-tip-3",
            category: "general",
            content: "Baseball memorabilia and vintage atmosphere throughout",
            priority: 3
          }
        ],
        tags: ["hot-dogs", "baseball", "main-street", "americana"],
        features: {
          outdoorSeating: true,
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          themedAtmosphere: true,
          alcoholServed: false,
          kidFriendly: true,
          allergyFriendly: false
        },
        cuisineType: "American",
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: [],
        kidFriendly: true,
        alcoholServed: false,
        operatingHours: {
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0
      },
      {
        id: "pecos-bill-tall-tale-inn",
        parkId: "magic-kingdom",
        name: "Pecos Bill Tall Tale Inn & Cafe",
        description: "Wild West-themed quick service restaurant in Frontierland serving burgers, chicken, and Tex-Mex favorites.",
        location: "Frontierland",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "pecos-bill-tip-1",
            category: "general",
            content: "Great toppings bar with unlimited condiments and fixings",
            priority: 4
          },
          {
            id: "pecos-bill-tip-2",
            category: "strategy",
            content: "Outdoor seating offers nice views of the Rivers of America and Frontierland",
            priority: 3
          }
        ],
        tags: ["burgers", "tex-mex", "outdoor-seating", "frontierland"],
        cuisineType: "Mexican & Southwestern",
        kidFriendly: true,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          themedAtmosphere: true,
          outdoorSeating: true,
          vegetarianOptions: true,
          alcoholServed: false,
          allergyFriendly: true
        }
      },
      {
        id: "pinocchio-village-haus",
        parkId: "magic-kingdom",
        name: "Pinocchio Village Haus",
        description: "Quick service restaurant in Fantasyland serving flatbreads, salads, and kids' meals with views of 'it's a small world'.",
        location: "Fantasyland",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "pinocchio-tip-1",
            category: "strategy",
            content: "Upstairs seating offers great views of 'it's a small world' queue",
            priority: 4
          },
          {
            id: "pinocchio-tip-2",
            category: "general",
            content: "Good spot for a quick bite while in Fantasyland",
            priority: 3
          }
        ],
        tags: ["flatbreads", "fantasyland", "kids-meals", "views"],
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          views: true,
          vegetarianOptions: true,
          alcoholServed: false,
          kidFriendly: true,
          allergyFriendly: true
        },
        cuisineType: "Italian",
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        operatingHours: {
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0
      },
      {
        id: "tortuga-tavern",
        parkId: "magic-kingdom",
        name: "Tortuga Tavern",
        description: "Pirate-themed quick service restaurant serving Mexican and Caribbean-inspired dishes near Pirates of the Caribbean.",
        location: "Adventureland",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "tortuga-tip-1",
            category: "strategy",
            content: "Seasonal operation - often closed during slower periods",
            priority: 5
          },
          {
            id: "tortuga-tip-2",
            category: "general",
            content: "Great pirate theming matches nearby Pirates attraction",
            priority: 3
          }
        ],
        tags: ["seasonal", "mexican", "caribbean", "pirates"],
        features: {
          mobileOrder: true,
          outdoorSeating: true,
          themedAtmosphere: true,
          counterService: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true
        },
        cuisineType: "Mexican & Caribbean",
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 7:00 PM"
        },
        reservationWindow: 0
      },
      {
        id: "tomorrowland-terrace",
        parkId: "magic-kingdom",
        name: "Tomorrowland Terrace Restaurant",
        description: "Seasonal quick service restaurant with burgers, hot dogs, and a great view of Cinderella Castle.",
        location: "Tomorrowland",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "tomorrowland-terrace-tip-1",
            category: "strategy",
            content: "Seasonal operation - typically busy seasons only",
            priority: 4
          },
          {
            id: "tomorrowland-terrace-tip-2",
            category: "strategy",
            content: "Outdoor seating with great castle views",
            priority: 4
          }
        ],
        tags: ["seasonal", "burgers", "castle-views", "outdoor"],
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          outdoorSeating: true,
          views: true,
          counterService: true,
          vegetarianOptions: true,
          alcoholServed: false,
          kidFriendly: true,
          allergyFriendly: true
        },
        cuisineType: "American",
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: [],
        kidFriendly: true,
        alcoholServed: false,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 0
      },
      {
        id: "friars-nook",
        parkId: "magic-kingdom",
        name: "Friar's Nook",
        description: "Quick service restaurant in Fantasyland specializing in mac and cheese dishes, loaded fries, and comfort food favorites.",
        location: "Fantasyland",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "friars-nook-tip-1",
            category: "general",
            content: "Famous for creative mac and cheese variations with different toppings",
            priority: 5
          },
          {
            id: "friars-nook-tip-2",
            category: "strategy",
            content: "Try the loaded fries - they're a hidden gem",
            priority: 4
          },
          {
            id: "friars-nook-tip-3",
            category: "strategy",
            content: "Located near Seven Dwarfs Mine Train - convenient for Fantasyland touring",
            priority: 3
          }
        ],
        tags: ["mac-and-cheese", "comfort-food", "loaded-fries", "fantasyland"],
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          themedAtmosphere: true,
          vegetarianOptions: true,
          alcoholServed: false,
          kidFriendly: true,
          allergyFriendly: true,
          healthyOptions: false,
          largePortions: true
        },
        cuisineType: "American Comfort Food",
        kidFriendly: true,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 0
      }
    ];
  }
});

// src/data/eat/quick-service/epcot-quick-service.json
var epcot_quick_service_default;
var init_epcot_quick_service = __esm({
  "src/data/eat/quick-service/epcot-quick-service.json"() {
    epcot_quick_service_default = [
      {
        id: "sunshine-seasons",
        parkId: "epcot",
        name: "Sunshine Seasons",
        description: "Large food court in The Land Pavilion offering diverse cuisines from different stations including Asian, American, and bakery items.",
        location: "World Nature - The Land Pavilion",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "sunshine-tip-1",
            category: "general",
            content: "Multiple food stations with different cuisines - something for everyone in your group",
            priority: 1
          },
          {
            id: "sunshine-tip-2",
            category: "strategy",
            content: "Large seating area with air conditioning. Great place to escape crowds and heat",
            priority: 2
          }
        ],
        tags: ["food-court", "diverse-options", "air-conditioned", "family-friendly", "large"],
        cuisineType: "International Food Court",
        kidFriendly: true,
        operatingHours: {
          breakfast: "8:00 AM - 11:00 AM",
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          alcoholServed: false,
          vegetarianOptions: true,
          veganOptions: true,
          glutenFreeOptions: true,
          kidFriendly: true
        }
      },
      {
        id: "connections-eatery",
        parkId: "epcot",
        name: "Connections Eatery",
        description: "Modern quick-service restaurant with globally-inspired bowls, burgers, and plant-based options near the front of the park.",
        location: "World Celebration",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "connections-tip-1",
            category: "general",
            content: "Great plant-based options and customizable bowls with fresh ingredients",
            priority: 2
          },
          {
            id: "connections-tip-2",
            category: "strategy",
            content: "Convenient location near park entrance. Good for arrival or departure meals",
            priority: 2
          }
        ],
        tags: ["modern", "plant-based", "bowls", "customizable", "convenient"],
        cuisineType: "Contemporary Global",
        kidFriendly: true,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          healthyOptions: true,
          alcoholServed: false,
          vegetarianOptions: true,
          veganOptions: true,
          glutenFreeOptions: true,
          kidFriendly: true
        }
      },
      {
        id: "les-halles-boulangerie",
        parkId: "epcot",
        name: "Les Halles Boulangerie-Patisserie",
        description: "Authentic French bakery in the France Pavilion serving croissants, quiches, sandwiches, and French pastries.",
        location: "World Showcase - France",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "les-halles-tip-1",
            category: "general",
            content: "Authentic French pastries and baked goods. Try the Napoleon or \xE9clair!",
            priority: 1
          },
          {
            id: "les-halles-tip-2",
            category: "strategy",
            content: "Great for breakfast pastries or afternoon snacks while exploring World Showcase",
            priority: 2
          }
        ],
        tags: ["french", "bakery", "pastries", "authentic", "breakfast"],
        cuisineType: "French Bakery",
        kidFriendly: true,
        operatingHours: {
          breakfast: "8:00 AM - 11:00 AM",
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          themedAtmosphere: true,
          alcoholServed: false,
          vegetarianOptions: true,
          kidFriendly: true
        }
      }
    ];
  }
});

// src/data/eat/quick-service/hollywood-studios-quick-service.json
var hollywood_studios_quick_service_default;
var init_hollywood_studios_quick_service = __esm({
  "src/data/eat/quick-service/hollywood-studios-quick-service.json"() {
    hollywood_studios_quick_service_default = [
      {
        id: "dhs-docking-bay-7",
        parkId: "hollywood-studios",
        name: "Docking Bay 7 Food and Cargo",
        description: "Star Wars-themed quick service restaurant in Galaxy's Edge serving galactic cuisine with unique out-of-this-world flavors.",
        location: "Star Wars: Galaxy's Edge",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 3,
        tips: [
          {
            id: "db7-tip-1",
            category: "general",
            content: "Immersive Star Wars theming with galactic food names. Try the Fried Endorian Tip-Yip!",
            priority: 4
          },
          {
            id: "db7-tip-2",
            category: "strategy",
            content: "Mobile order recommended during peak times. Great for Star Wars fans.",
            priority: 3
          }
        ],
        tags: ["star-wars", "galactic", "themed-dining", "immersive", "unique"],
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          themedAtmosphere: true,
          counterService: true,
          alcoholServed: false,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true
        },
        cuisineType: "Galactic",
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 0
      },
      {
        id: "dhs-woodys-lunchbox",
        parkId: "hollywood-studios",
        name: "Woody's Lunch Box",
        description: "Toy Story Land quick-service restaurant serving nostalgic lunch box treats like totchos, grilled cheese, and s'mores French toast.",
        location: "Toy Story Land",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "wlb-tip-1",
            category: "general",
            content: "Famous for totchos (tater tot nachos) and unique s'mores French toast. Instagram-worthy presentation!",
            priority: 1
          },
          {
            id: "wlb-tip-2",
            category: "strategy",
            content: "Gets very hot in Toy Story Land - try to eat during cooler parts of the day",
            priority: 2
          }
        ],
        tags: ["toy-story", "totchos", "nostalgic", "instagram", "unique"],
        cuisineType: "American Comfort Food",
        kidFriendly: true,
        operatingHours: {
          breakfast: "8:00 AM - 10:30 AM",
          lunch: "10:30 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          themedAtmosphere: true,
          outdoorSeating: true,
          alcoholServed: false,
          vegetarianOptions: true,
          kidFriendly: true
        }
      },
      {
        id: "dhs-backlot-express",
        parkId: "hollywood-studios",
        name: "Backlot Express",
        description: "Movie studio-themed quick-service restaurant featuring burgers, sandwiches, and salads in a Hollywood backlot setting.",
        location: "Echo Lake",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "be-tip-1",
            category: "general",
            content: "Large seating area with air conditioning. Good central location in the park",
            priority: 2
          },
          {
            id: "be-tip-2",
            category: "strategy",
            content: "Less crowded than other quick-service spots. Good for families with different tastes",
            priority: 2
          }
        ],
        tags: ["movie-studio", "burgers", "air-conditioned", "central", "family-friendly"],
        cuisineType: "American",
        kidFriendly: true,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          themedAtmosphere: true,
          alcoholServed: false,
          vegetarianOptions: true,
          kidFriendly: true
        }
      }
    ];
  }
});

// src/data/eat/quick-service/animal-kingdom-quick-service.json
var animal_kingdom_quick_service_default;
var init_animal_kingdom_quick_service = __esm({
  "src/data/eat/quick-service/animal-kingdom-quick-service.json"() {
    animal_kingdom_quick_service_default = [
      {
        id: "ak-satuli-canteen",
        parkId: "animal-kingdom",
        name: "Satu'li Canteen",
        description: "Pandora-themed quick service restaurant offering customizable bowls with unique Na'vi-inspired flavors and ingredients.",
        location: "Pandora - The World of Avatar",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 3,
        tips: [
          {
            id: "sc-tip-1",
            category: "strategy",
            content: "Build-your-own bowls with unique Pandoran ingredients. Very popular, use mobile order.",
            priority: 4
          },
          {
            id: "sc-tip-2",
            category: "general",
            content: "Themed to Pandora with bioluminescent decor. Healthy and flavorful options available.",
            priority: 3
          }
        ],
        tags: ["pandora", "bowls", "navi", "bioluminescent", "healthy"],
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          entertainment: true,
          themedAtmosphere: true,
          counterService: true,
          healthyOptions: true,
          alcoholServed: false,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          veganOptions: true,
          glutenFreeOptions: true
        },
        cuisineType: "Healthy Bowls",
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian", "vegan", "gluten-free"],
        kidFriendly: true,
        alcoholServed: false,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 0
      },
      {
        id: "ak-flame-tree-barbecue",
        parkId: "animal-kingdom",
        name: "Flame Tree Barbecue",
        description: "Popular barbecue restaurant offering ribs, pulled pork, and chicken with waterfront seating overlooking Discovery River.",
        location: "Discovery Island",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 3,
        tips: [
          {
            id: "ftb-tip-1",
            category: "general",
            content: "Some of the best barbecue at Disney World! Try the ribs or pulled pork sandwich",
            priority: 1
          },
          {
            id: "ftb-tip-2",
            category: "strategy",
            content: "Beautiful waterfront seating with views of Expedition Everest. Great for photos!",
            priority: 2
          }
        ],
        tags: ["barbecue", "ribs", "waterfront", "popular", "views"],
        cuisineType: "American Barbecue",
        kidFriendly: true,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          outdoorSeating: true,
          views: true,
          alcoholServed: false,
          kidFriendly: true
        }
      },
      {
        id: "ak-yak-yeti-local-food",
        parkId: "animal-kingdom",
        name: "Yak & Yeti Local Food Cafes",
        description: "Quick-service version of the popular Asian restaurant serving teriyaki bowls, fried rice, and Asian-inspired dishes.",
        location: "Asia",
        type: "quick_service",
        serviceType: "quick",
        priceLevel: 2,
        tips: [
          {
            id: "yylfc-tip-1",
            category: "general",
            content: "Great Asian flavors with teriyaki bowls and fried rice. Lighter options than typical theme park fare",
            priority: 2
          },
          {
            id: "yylfc-tip-2",
            category: "strategy",
            content: "Located in Asia section near Expedition Everest. Good for sharing different dishes",
            priority: 2
          }
        ],
        tags: ["asian", "teriyaki", "bowls", "lighter-options", "expedition-everest"],
        cuisineType: "Asian",
        kidFriendly: true,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: true,
          adrRequired: false,
          walkupAvailable: true,
          counterService: true,
          themedAtmosphere: true,
          alcoholServed: false,
          vegetarianOptions: true,
          kidFriendly: true
        }
      }
    ];
  }
});

// src/data/eat/table-service/magic-kingdom-table-service.json
var magic_kingdom_table_service_default;
var init_magic_kingdom_table_service = __esm({
  "src/data/eat/table-service/magic-kingdom-table-service.json"() {
    magic_kingdom_table_service_default = [
      {
        id: "be-our-guest-restaurant",
        parkId: "magic-kingdom",
        name: "Be Our Guest Restaurant",
        description: "Dine in the Beast's enchanted castle in this popular table service restaurant with three themed rooms.",
        location: "Fantasyland",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "be-our-guest-tip-1",
            category: "strategy",
            content: "Advance dining reservations required - book 60 days ahead",
            priority: 5
          },
          {
            id: "be-our-guest-tip-2",
            category: "general",
            content: "West Wing has the rose and Beast's portrait - most atmospheric",
            priority: 4
          },
          {
            id: "be-our-guest-tip-3",
            category: "general",
            content: "Try the grey stuff - it's delicious (don't believe them? Ask the dishes)",
            priority: 5
          }
        ],
        tags: ["table-service", "beauty-beast", "reservations", "upscale", "themed"],
        cuisineType: "French",
        kidFriendly: true,
        features: {
          mobileOrder: false,
          adrRequired: true,
          walkupAvailable: false,
          tableService: true,
          themedAtmosphere: true,
          fineDining: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true
        },
        operatingHours: {
          breakfast: "8:00 AM - 10:30 AM",
          lunch: "11:30 AM - 2:30 PM",
          dinner: "5:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "cinderella-royal-table",
        parkId: "magic-kingdom",
        name: "Cinderella's Royal Table",
        description: "Dine with Disney Princesses inside Cinderella Castle in this premium character dining experience.",
        location: "Fantasyland",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        tips: [
          {
            id: "royal-table-tip-1",
            category: "strategy",
            content: "Most expensive character meal at Disney - book early, it fills fast",
            priority: 5
          },
          {
            id: "royal-table-tip-2",
            category: "general",
            content: "Each guest gets a photo with Cinderella before being seated",
            priority: 5
          },
          {
            id: "royal-table-tip-3",
            category: "general",
            content: "Multiple princesses visit each table throughout the meal",
            priority: 4
          }
        ],
        tags: ["character-dining", "princesses", "castle", "upscale", "premium"],
        features: {
          characterDining: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "American Fine Dining",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["gluten-free", "vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          breakfast: "8:00 AM - 11:50 AM",
          lunch: "12:00 PM - 2:50 PM",
          dinner: "3:55 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "crystal-palace",
        parkId: "magic-kingdom",
        name: "The Crystal Palace",
        description: "Buffet character dining with Winnie the Pooh and friends in this beautiful Victorian conservatory.",
        location: "Main Street U.S.A.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "crystal-palace-tip-1",
            category: "general",
            content: "Great for families with picky eaters - lots of buffet options",
            priority: 4
          },
          {
            id: "crystal-palace-tip-2",
            category: "general",
            content: "Pooh, Tigger, Piglet, and Eeyore all visit tables",
            priority: 4
          },
          {
            id: "crystal-palace-tip-3",
            category: "general",
            content: "Beautiful natural lighting - great for photos",
            priority: 3
          }
        ],
        tags: ["character-dining", "buffet", "winnie-pooh", "family-friendly", "main-street"],
        features: {
          characterDining: true,
          familyStyle: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "American Buffet",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          breakfast: "8:00 AM - 10:30 AM",
          lunch: "11:30 AM - 2:30 PM",
          dinner: "3:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "plaza-restaurant",
        parkId: "magic-kingdom",
        name: "The Plaza Restaurant",
        description: "Victorian-style restaurant on Main Street serving sandwiches, salads, and classic American fare.",
        location: "Main Street U.S.A.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        tips: [
          {
            id: "plaza-tip-1",
            category: "strategy",
            content: "Great central location with air conditioning",
            priority: 4
          },
          {
            id: "plaza-tip-2",
            category: "general",
            content: "Famous for their sandwiches and milkshakes",
            priority: 4
          },
          {
            id: "plaza-tip-3",
            category: "strategy",
            content: "Advance reservations recommended",
            priority: 3
          }
        ],
        tags: ["table-service", "american", "main-street", "classic", "air-conditioned"],
        features: {
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          tableService: true
        },
        cuisineType: "American",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "liberty-tree-tavern",
        parkId: "magic-kingdom",
        name: "Liberty Tree Tavern",
        description: "Colonial-themed restaurant in Liberty Square serving traditional American cuisine.",
        location: "Liberty Square",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "liberty-tree-tip-1",
            category: "general",
            content: "Dinner is all-you-can-eat family style with turkey, stuffing, and sides",
            priority: 5
          },
          {
            id: "liberty-tree-tip-2",
            category: "general",
            content: "Lunch is \xE0 la carte with sandwiches and salads",
            priority: 4
          },
          {
            id: "liberty-tree-tip-3",
            category: "general",
            content: "Beautiful colonial theming and historical decor",
            priority: 3
          }
        ],
        tags: ["table-service", "colonial", "family-style", "turkey", "historical"],
        features: {
          familyStyle: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          tableService: true
        },
        cuisineType: "American Colonial",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:30 AM - 3:00 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "skipper-canteen",
        parkId: "magic-kingdom",
        name: "Jungle Navigation Co. Ltd. Skipper Canteen",
        description: "Table service restaurant inspired by the Jungle Cruise, serving pan-Asian cuisine with a side of skipper humor.",
        location: "Adventureland",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "skipper-canteen-tip-1",
            category: "strategy",
            content: "Reservations highly recommended - book 60 days in advance",
            priority: 5
          },
          {
            id: "skipper-canteen-tip-2",
            category: "general",
            content: "Try the famous 'Tastes like Chicken' for a fun skipper experience",
            priority: 4
          },
          {
            id: "skipper-canteen-tip-3",
            category: "general",
            content: "Air-conditioned with great atmosphere and theming",
            priority: 3
          }
        ],
        tags: ["table-service", "jungle-cruise", "pan-asian", "air-conditioning", "reservations"],
        features: {
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          tableService: true
        },
        cuisineType: "Pan-Asian",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:30 AM - 3:30 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      }
    ];
  }
});

// src/data/eat/table-service/epcot-table-service.json
var epcot_table_service_default;
var init_epcot_table_service = __esm({
  "src/data/eat/table-service/epcot-table-service.json"() {
    epcot_table_service_default = [
      {
        id: "epcot-monsieur-paul",
        parkId: "epcot",
        name: "Monsieur Paul",
        description: "Upscale French fine dining restaurant offering exquisite cuisine and wine pairings on the second floor of the France Pavilion.",
        location: "World Showcase - France",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        tips: [
          {
            id: "mp-tip-1",
            category: "strategy",
            content: "Signature dining experience requiring advance reservations. Dress code enforced.",
            priority: 4
          },
          {
            id: "mp-tip-2",
            category: "general",
            content: "Perfect for special occasions with beautiful views of World Showcase Lagoon.",
            priority: 3
          }
        ],
        tags: ["signature-dining", "fine-dining", "french", "upscale", "world-showcase"],
        features: {
          fineDining: true,
          views: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "French Fine Dining",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: false,
        alcoholServed: true,
        operatingHours: {
          dinner: "5:30 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "epcot-space-220",
        parkId: "epcot",
        name: "Space 220",
        description: "Unique dining experience that simulates eating in a space station 220 miles above Earth with stunning views of our planet.",
        location: "World Discovery",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        tips: [
          {
            id: "s220-tip-1",
            category: "strategy",
            content: "Most popular dining reservation at EPCOT. Book exactly 60 days in advance.",
            priority: 5
          },
          {
            id: "s220-tip-2",
            category: "general",
            content: "Elevator experience to 'space' before dining. Views of Earth change throughout meal.",
            priority: 4
          }
        ],
        tags: ["signature-dining", "themed-dining", "space", "unique", "immersive"],
        features: {
          themedAtmosphere: true,
          entertainment: true,
          views: true,
          fineDining: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "Contemporary American",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:30 AM - 3:55 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "epcot-le-cellier",
        parkId: "epcot",
        name: "Le Cellier Steakhouse",
        description: "Canadian-inspired steakhouse known for excellent steaks, seafood, and the famous cheddar cheese soup.",
        location: "World Showcase - Canada",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "lc-tip-1",
            category: "general",
            content: "Famous for their cheddar cheese soup and Canadian favorites. Very popular reservation.",
            priority: 4
          },
          {
            id: "lc-tip-2",
            category: "general",
            content: "Located below ground level in Canada pavilion. Cozy, intimate atmosphere.",
            priority: 3
          }
        ],
        tags: ["steakhouse", "canadian", "cheddar-soup", "cozy", "popular"],
        features: {
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "Canadian Steakhouse",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:30 AM - 3:00 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "epcot-akershus",
        parkId: "epcot",
        name: "Akershus Royal Banquet Hall",
        description: "Character dining experience with Disney Princesses serving Norwegian-inspired cuisine in a medieval castle setting.",
        location: "World Showcase - Norway",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "ak-dining-tip-1",
            category: "general",
            content: "Meet multiple Disney Princesses during your meal. Great for princess fans of all ages.",
            priority: 4
          },
          {
            id: "ak-dining-tip-2",
            category: "strategy",
            content: "Buffet-style service with Norwegian and American options. Breakfast is most popular.",
            priority: 3
          }
        ],
        tags: ["character-dining", "princesses", "norwegian", "buffet", "castle"],
        features: {
          characterDining: true,
          familyStyle: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "Norwegian & American",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          breakfast: "8:00 AM - 11:15 AM",
          lunch: "11:45 AM - 3:00 PM",
          dinner: "4:00 PM - 8:30 PM"
        },
        reservationWindow: 60
      },
      {
        id: "epcot-garden-grill",
        parkId: "epcot",
        name: "Garden Grill Restaurant",
        description: "Rotating restaurant offering character dining with Chip 'n' Dale and friends while overlooking Living with the Land attraction.",
        location: "World Nature",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "gg-tip-1",
            category: "general",
            content: "Unique rotating restaurant with views into Living with the Land. Characters visit every table.",
            priority: 4
          },
          {
            id: "gg-tip-2",
            category: "general",
            content: "Farm-fresh ingredients, many from EPCOT's own gardens. Family-style service.",
            priority: 3
          }
        ],
        tags: ["character-dining", "rotating", "farm-fresh", "family-style", "unique"],
        features: {
          entertainment: true,
          characterDining: true,
          views: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "American Farm-to-Table",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:30 AM - 3:00 PM",
          dinner: "4:30 PM - 8:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "epcot-via-napoli",
        parkId: "epcot",
        name: "Via Napoli Ristorante e Pizzeria",
        description: "Authentic Neapolitan pizzeria featuring wood-fired ovens imported from Italy and traditional Italian cuisine.",
        location: "World Showcase - Italy",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "vn-tip-1",
            category: "general",
            content: "Authentic Neapolitan pizza from wood-fired ovens. Large pizzas great for sharing.",
            priority: 3
          },
          {
            id: "vn-tip-2",
            category: "strategy",
            content: "Located in Italy pavilion with outdoor seating available. Popular with families.",
            priority: 2
          }
        ],
        tags: ["italian", "pizza", "wood-fired", "neapolitan", "family"],
        features: {
          entertainment: true,
          outdoorSeating: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "Italian",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:30 AM - 3:30 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "epcot-rose-crown",
        parkId: "epcot",
        name: "Rose & Crown Dining Room",
        description: "Traditional British pub offering fish and chips, bangers and mash, and other UK favorites with World Showcase Lagoon views.",
        location: "World Showcase - United Kingdom",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        tips: [
          {
            id: "rc-dining-tip-1",
            category: "strategy",
            content: "Great views of EPCOT fireworks from outdoor seating. Traditional British pub atmosphere.",
            priority: 4
          },
          {
            id: "rc-dining-tip-2",
            category: "general",
            content: "Try the fish and chips or shepherd's pie. British beers and ales available.",
            priority: 3
          }
        ],
        tags: ["british", "pub", "fish-chips", "fireworks-view", "traditional"],
        features: {
          outdoorSeating: true,
          views: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "British Pub",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:30 AM - 3:30 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "epcot-biergarten",
        parkId: "epcot",
        name: "Biergarten Restaurant",
        description: "Authentic German buffet with live entertainment including traditional folk music and dancing in an Oktoberfest-style hall.",
        location: "World Showcase - Germany",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "bg-tip-1",
            category: "general",
            content: "Authentic German buffet with live oompah band entertainment. Community seating at large tables.",
            priority: 4
          },
          {
            id: "bg-tip-2",
            category: "strategy",
            content: "Great for groups and families. German beers and traditional dishes available.",
            priority: 3
          }
        ],
        tags: ["german", "buffet", "entertainment", "oktoberfest", "community-seating"],
        features: {
          entertainment: true,
          familyStyle: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "German",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "12:00 PM - 3:30 PM",
          dinner: "4:00 PM - 8:30 PM"
        },
        reservationWindow: 60
      }
    ];
  }
});

// src/data/eat/table-service/hollywood-studios-table-service.json
var hollywood_studios_table_service_default;
var init_hollywood_studios_table_service = __esm({
  "src/data/eat/table-service/hollywood-studios-table-service.json"() {
    hollywood_studios_table_service_default = [
      {
        id: "dhs-brown-derby",
        parkId: "hollywood-studios",
        name: "The Hollywood Brown Derby",
        description: "Signature dining restaurant recreating the famous 1940s Hollywood hotspot, known for the original Cobb salad and elegant atmosphere.",
        location: "Hollywood Boulevard",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        tips: [
          {
            id: "hbd-tip-1",
            category: "general",
            content: "Famous for the original Cobb salad and grapefruit cake. Classic Hollywood glamour atmosphere.",
            priority: 4
          },
          {
            id: "hbd-tip-2",
            category: "general",
            content: "Caricatures of Hollywood stars line the walls. Perfect for special occasions.",
            priority: 3
          }
        ],
        tags: ["signature-dining", "hollywood", "cobb-salad", "elegant", "classic"],
        features: {
          fineDining: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "American Fine Dining",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:30 AM - 3:30 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "dhs-sci-fi-dine-in",
        parkId: "hollywood-studios",
        name: "Sci-Fi Dine-In Theater Restaurant",
        description: "Unique dining experience in car-shaped booths watching classic sci-fi movie clips in a drive-in theater setting.",
        location: "Commissary Lane",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "sfd-tip-1",
            category: "general",
            content: "Themed like a 1950s drive-in theater with car booths. Classic B-movie clips play continuously.",
            priority: 4
          },
          {
            id: "sfd-tip-2",
            category: "strategy",
            content: "Popular for the unique atmosphere - food is decent but theming is the main attraction.",
            priority: 3
          }
        ],
        tags: ["themed-dining", "drive-in", "sci-fi", "unique", "1950s"],
        features: {
          themedAtmosphere: true,
          entertainment: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          tableService: true
        },
        cuisineType: "American",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:00 AM - 3:45 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "dhs-50s-prime-time",
        parkId: "hollywood-studios",
        name: "50's Prime Time Caf\xE9",
        description: "Step into Mom's kitchen circa 1950s where servers act like family members and scold you for not eating your vegetables.",
        location: "Echo Lake",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "ptc-tip-1",
            category: "general",
            content: "Servers stay in character as 1950s family members. They may scold you - it's all part of the fun!",
            priority: 4
          },
          {
            id: "ptc-tip-2",
            category: "general",
            content: "Classic comfort food menu. Great for families who enjoy interactive dining experiences.",
            priority: 3
          }
        ],
        tags: ["themed-dining", "1950s", "interactive", "comfort-food", "family"],
        features: {
          entertainment: true,
          themedAtmosphere: true,
          characterDining: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          tableService: true
        },
        cuisineType: "American Comfort Food",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:00 AM - 3:45 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "dhs-mama-melrose",
        parkId: "hollywood-studios",
        name: "Mama Melrose's Ristorante Italiano",
        description: "PERMANENTLY CLOSED as of May 11, 2025. Former Italian restaurant closed to make way for Monsters, Inc. themed land development.",
        location: "Streets of America",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        tips: [
          {
            id: "mm-tip-1",
            category: "strategy",
            content: "PERMANENTLY CLOSED: Closed May 11, 2025 for Monsters, Inc. land construction",
            priority: 5
          },
          {
            id: "mm-tip-2",
            category: "strategy",
            content: "Consider The Hollywood Brown Derby or 50's Prime Time Caf\xE9 for alternative table service dining",
            priority: 3
          }
        ],
        tags: ["italian", "permanently-closed", "monsters-inc-construction"],
        features: {
          entertainment: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          tableService: true
        },
        cuisineType: "Italian",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:30 AM - 3:30 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "dhs-hollywood-vine",
        parkId: "hollywood-studios",
        name: "Hollywood & Vine",
        description: "Art Deco-styled buffet restaurant featuring character dining with Disney Junior characters during breakfast and lunch.",
        location: "Echo Lake",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "hv-tip-1",
            category: "general",
            content: "Disney Junior character dining during breakfast and lunch. Seasonal character dining at dinner.",
            priority: 4
          },
          {
            id: "hv-tip-2",
            category: "strategy",
            content: "Buffet-style service with variety of options. Great for families with young children.",
            priority: 3
          }
        ],
        tags: ["character-dining", "buffet", "disney-junior", "art-deco", "family"],
        features: {
          characterDining: true,
          familyStyle: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "American Buffet",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          breakfast: "8:00 AM - 11:15 AM",
          lunch: "11:45 AM - 2:30 PM",
          dinner: "3:00 PM - 8:00 PM"
        },
        reservationWindow: 60
      }
    ];
  }
});

// src/data/eat/table-service/animal-kingdom-table-service.json
var animal_kingdom_table_service_default;
var init_animal_kingdom_table_service = __esm({
  "src/data/eat/table-service/animal-kingdom-table-service.json"() {
    animal_kingdom_table_service_default = [
      {
        id: "ak-tiffins",
        parkId: "animal-kingdom",
        name: "Tiffins",
        description: "Signature dining restaurant featuring globally-inspired cuisine with dishes inspired by the adventures of Disney Imagineers and their travels.",
        location: "Discovery Island",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        tips: [
          {
            id: "tiff-tip-1",
            category: "general",
            content: "Disney's most upscale restaurant at Animal Kingdom. Award-winning cuisine with global influences.",
            priority: 4
          },
          {
            id: "tiff-tip-2",
            category: "general",
            content: "Artwork throughout restaurant tells stories of Disney Imagineers' adventures. Perfect for special occasions.",
            priority: 3
          }
        ],
        tags: ["signature-dining", "fine-dining", "global-cuisine", "imagineers", "upscale"],
        features: {
          fineDining: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "Global Fine Dining",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:30 AM - 3:30 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "ak-sanaa",
        resortId: "animal-kingdom-lodge-kidani",
        name: "Sanaa",
        description: "African- and Indian-inspired cuisine with stunning views of giraffes, zebras, and other animals on the savanna at Animal Kingdom Lodge.",
        location: "Animal Kingdom Lodge - Kidani Village",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "sanaa-tip-1",
            category: "general",
            content: "Famous bread service with unique dipping sauces. Watch animals from your table!",
            priority: 4
          },
          {
            id: "sanaa-tip-2",
            category: "strategy",
            content: "Located at Animal Kingdom Lodge but accessible to all guests. Bring binoculars for animal viewing.",
            priority: 3
          }
        ],
        tags: ["african", "indian", "animal-views", "bread-service", "savanna"],
        features: {
          views: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "African & Indian",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:30 AM - 3:00 PM",
          dinner: "5:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "ak-boma",
        resortId: "animal-kingdom-lodge-jambo",
        name: "Boma - Flavors of Africa",
        description: "African-inspired buffet featuring over 50 different dishes from across the continent in a vibrant marketplace setting.",
        location: "Animal Kingdom Lodge - Jambo House",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "boma-tip-1",
            category: "general",
            content: "Extensive African-inspired buffet with unique flavors. Great way to try new cuisines.",
            priority: 4
          },
          {
            id: "boma-tip-2",
            category: "strategy",
            content: "Breakfast and dinner service available. Popular with both adventurous eaters and families.",
            priority: 3
          }
        ],
        tags: ["african", "buffet", "marketplace", "50-dishes", "unique-flavors"],
        features: {
          familyStyle: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "African",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          breakfast: "7:00 AM - 11:00 AM",
          dinner: "4:30 PM - 9:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "ak-tusker-house",
        parkId: "animal-kingdom",
        name: "Tusker House Restaurant",
        description: "Character dining buffet featuring Donald Duck and friends in safari outfits with African-inspired cuisine and American favorites.",
        location: "Africa - Harambe",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        tips: [
          {
            id: "th-tip-1",
            category: "general",
            content: "Only character dining in Animal Kingdom. Donald Duck, Mickey, Goofy, and Daisy in safari gear.",
            priority: 4
          },
          {
            id: "th-tip-2",
            category: "strategy",
            content: "Buffet service with African-inspired dishes and kid-friendly options. Popular breakfast spot.",
            priority: 3
          }
        ],
        tags: ["character-dining", "safari", "donald-duck", "african-inspired", "buffet"],
        features: {
          characterDining: true,
          familyStyle: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "African & American",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          breakfast: "8:00 AM - 10:15 AM",
          lunch: "11:30 AM - 3:30 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "ak-yak-yeti",
        parkId: "animal-kingdom",
        name: "Yak & Yeti Restaurant",
        description: "Pan-Asian cuisine featuring dishes from across Asia in a Nepalese-themed restaurant with intricate decor and artifacts.",
        location: "Asia - Anandapur",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        tips: [
          {
            id: "yy-tip-1",
            category: "general",
            content: "Pan-Asian menu with dishes from Thailand, China, Japan, and more. Beautiful themed interior.",
            priority: 3
          },
          {
            id: "yy-tip-2",
            category: "strategy",
            content: "Operated by Landry's Restaurants. Often easier to get reservations than Disney-operated restaurants.",
            priority: 3
          }
        ],
        tags: ["pan-asian", "nepalese", "artifacts", "landry's", "intricate-decor"],
        features: {
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          glutenFreeOptions: true,
          tableService: true
        },
        cuisineType: "Pan-Asian",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:00 AM - 3:30 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 60
      },
      {
        id: "ak-rainforest-cafe",
        parkId: "animal-kingdom",
        name: "Rainforest Cafe",
        description: "Themed restaurant simulating a rainforest environment with animatronic animals, thunderstorms, and jungle sounds.",
        location: "Oasis - Park Entrance",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        tips: [
          {
            id: "rc-tip-1",
            category: "general",
            content: "Immersive rainforest theming with animatronic animals and periodic thunderstorms.",
            priority: 4
          },
          {
            id: "rc-tip-2",
            category: "general",
            content: "Can be loud and overwhelming for some guests. Great for kids who love animals and adventure.",
            priority: 3
          }
        ],
        tags: ["rainforest", "animatronic", "thunderstorms", "immersive", "loud"],
        features: {
          themedAtmosphere: true,
          entertainment: true,
          adrRequired: true,
          alcoholServed: true,
          kidFriendly: true,
          allergyFriendly: true,
          vegetarianOptions: true,
          tableService: true
        },
        cuisineType: "American",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:00 AM - 3:30 PM",
          dinner: "4:00 PM - 8:00 PM"
        },
        reservationWindow: 60
      }
    ];
  }
});

// src/data/eat/snacks/magic-kingdom-snacks.json
var magic_kingdom_snacks_default;
var init_magic_kingdom_snacks = __esm({
  "src/data/eat/snacks/magic-kingdom-snacks.json"() {
    magic_kingdom_snacks_default = [
      {
        id: "dole-whip-aloha-isle",
        parkId: "magic-kingdom",
        name: "Aloha Isle - Dole Whip",
        description: "Get the famous pineapple Dole Whip soft serve treat at this Adventureland snack stand.",
        location: "Adventureland",
        type: "snack",
        serviceType: "snack",
        priceLevel: 1,
        tips: [
          {
            id: "dole-whip-tip-1",
            category: "general",
            content: "Perfect treat for hot Florida days - refreshing and dairy-free",
            priority: 5
          },
          {
            id: "dole-whip-tip-2",
            category: "general",
            content: "Try the float version with pineapple juice",
            priority: 4
          },
          {
            id: "dole-whip-tip-3",
            category: "strategy",
            content: "Often has long lines - consider mobile ordering",
            priority: 4
          }
        ],
        tags: ["snack", "dole-whip", "refreshing", "dairy-free", "iconic"],
        features: {
          mobileOrder: true,
          outdoorSeating: true,
          counterService: true,
          kidFriendly: true,
          allergyFriendly: true,
          veganOptions: true
        },
        cuisineType: "Snacks & Treats",
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["dairy-free", "vegan"],
        kidFriendly: true,
        alcoholServed: false,
        operatingHours: {
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0
      },
      {
        id: "gaston-tavern",
        parkId: "magic-kingdom",
        name: "Gaston's Tavern",
        description: "Beast-themed quick service location famous for its cinnamon rolls and LeFou's Brew in the Beauty and the Beast area.",
        location: "Fantasyland",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "gaston-tavern-tip-1",
            category: "general",
            content: "Famous cinnamon roll is huge and perfect for sharing",
            priority: 5
          },
          {
            id: "gaston-tavern-tip-2",
            category: "general",
            content: "LeFou's Brew is a unique frozen apple juice drink",
            priority: 4
          },
          {
            id: "gaston-tavern-tip-3",
            category: "general",
            content: "Great atmosphere with Beauty and the Beast theming",
            priority: 3
          }
        ],
        tags: ["cinnamon-roll", "lefous-brew", "beauty-beast", "snacks", "themed"],
        features: {
          mobileOrder: true,
          themedAtmosphere: true,
          counterService: true,
          kidFriendly: true
        },
        cuisineType: "Snacks & Treats",
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: [],
        kidFriendly: true,
        alcoholServed: false,
        operatingHours: {
          breakfast: "8:00 AM - 11:00 AM",
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0
      },
      {
        id: "sleepy-hollow",
        parkId: "magic-kingdom",
        name: "Sleepy Hollow",
        description: "Liberty Square snack location famous for its fresh funnel cakes and sweet treats.",
        location: "Liberty Square",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "sleepy-hollow-tip-1",
            category: "general",
            content: "Funnel cakes are made fresh and perfect for sharing",
            priority: 5
          },
          {
            id: "sleepy-hollow-tip-2",
            category: "strategy",
            content: "Great location between Haunted Mansion and Hall of Presidents",
            priority: 3
          }
        ],
        tags: ["funnel-cake", "snacks", "fresh", "liberty-square", "sweet"],
        features: {
          outdoorSeating: true,
          freshMade: true,
          mobileOrder: true,
          counterService: true,
          kidFriendly: true
        },
        cuisineType: "Snacks & Treats",
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: [],
        kidFriendly: true,
        alcoholServed: false,
        operatingHours: {
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0
      }
    ];
  }
});

// src/data/eat/snacks/epcot-snacks.json
var epcot_snacks_default;
var init_epcot_snacks = __esm({
  "src/data/eat/snacks/epcot-snacks.json"() {
    epcot_snacks_default = [
      {
        id: "school-bread-norway",
        parkId: "epcot",
        name: "Kringla Bakeri Og Kafe - School Bread",
        description: "Traditional Norwegian pastry filled with custard, topped with coconut and icing - a must-try EPCOT treat.",
        location: "World Showcase - Norway",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "school-bread-tip-1",
            category: "general",
            content: "Iconic EPCOT snack! Sweet custard-filled pastry that's perfect for sharing",
            priority: 1
          },
          {
            id: "school-bread-tip-2",
            category: "strategy",
            content: "Often sells out later in the day - try to get one earlier during World Showcase touring",
            priority: 1
          }
        ],
        tags: ["iconic", "norwegian", "pastry", "custard", "coconut"],
        cuisineType: "Norwegian Pastry",
        kidFriendly: true,
        operatingHours: {
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: true,
          outdoorSeating: true,
          entertainment: false,
          adrRequired: false,
          alcoholServed: false,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: false,
          characterDining: false
        }
      },
      {
        id: "kakigori-japan",
        parkId: "epcot",
        name: "Kabuki Cafe - Kakigori Shaved Ice",
        description: "Japanese-style shaved ice with unique flavors like cherry blossom, melon, and strawberry in the Japan Pavilion.",
        location: "World Showcase - Japan",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "kakigori-tip-1",
            category: "general",
            content: "Refreshing Japanese shaved ice perfect for hot Florida days. Try the cherry blossom flavor!",
            priority: 2
          },
          {
            id: "kakigori-tip-2",
            category: "general",
            content: "Beautiful presentation and authentic Japanese experience",
            priority: 2
          }
        ],
        tags: ["japanese", "shaved-ice", "refreshing", "authentic", "cherry-blossom"],
        cuisineType: "Japanese Treats",
        kidFriendly: true,
        operatingHours: {
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: false,
          outdoorSeating: true,
          entertainment: false,
          adrRequired: false,
          alcoholServed: false,
          vegetarianOptions: true,
          veganOptions: true,
          glutenFreeOptions: true,
          characterDining: false
        }
      },
      {
        id: "figment-popcorn",
        parkId: "epcot",
        name: "Figment Popcorn",
        description: "Rainbow-colored Figment-themed popcorn available from specialty carts around the park.",
        location: "Various Locations",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "figment-popcorn-tip-1",
            category: "general",
            content: "Instagram-worthy rainbow popcorn that tastes like cotton candy. Kids love the bright colors!",
            priority: 2
          },
          {
            id: "figment-popcorn-tip-2",
            category: "strategy",
            content: "Available from various popcorn carts throughout EPCOT",
            priority: 3
          }
        ],
        tags: ["figment", "rainbow", "popcorn", "instagram", "colorful"],
        cuisineType: "Specialty Snacks",
        kidFriendly: true,
        operatingHours: {
          lunch: "10:00 AM - 8:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: false,
          outdoorSeating: true,
          entertainment: false,
          adrRequired: false,
          alcoholServed: false,
          vegetarianOptions: true,
          veganOptions: true,
          glutenFreeOptions: true,
          characterDining: false
        }
      }
    ];
  }
});

// src/data/eat/snacks/hollywood-studios-snacks.json
var hollywood_studios_snacks_default;
var init_hollywood_studios_snacks = __esm({
  "src/data/eat/snacks/hollywood-studios-snacks.json"() {
    hollywood_studios_snacks_default = [
      {
        id: "dhs-milk-stand",
        parkId: "hollywood-studios",
        name: "Milk Stand",
        description: "Star Wars-themed snack location in Galaxy's Edge serving the famous Blue Milk and Green Milk beverages from the films, both available with alcoholic versions.",
        location: "Star Wars: Galaxy's Edge",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "milk-stand-tip-1",
            category: "general",
            content: "Home to the iconic Blue and Green Milk from Star Wars - a must-try Galaxy's Edge experience",
            priority: 4
          },
          {
            id: "milk-stand-tip-2",
            category: "strategy",
            content: "Both alcoholic (rum/tequila) and non-alcoholic versions available",
            priority: 3
          }
        ],
        tags: ["galaxy's-edge", "star-wars", "blue-milk", "green-milk", "iconic"],
        features: {
          mobileOrder: false,
          outdoorSeating: true,
          entertainment: false,
          adrRequired: false,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: true,
          glutenFreeOptions: false,
          characterDining: false
        },
        cuisineType: "Star Wars Specialty Beverages",
        kidFriendly: true,
        allergyFriendly: ["vegetarian", "vegan"],
        mobileOrderAvailable: false,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        }
      },
      {
        id: "dhs-kat-sakas-kettle",
        parkId: "hollywood-studios",
        name: "Kat Saka's Kettle",
        description: "Galaxy's Edge popcorn and specialty snack location featuring the unique Outpost Popcorn Mix and Cold Brew Black Caf with Star Wars theming.",
        location: "Star Wars: Galaxy's Edge",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "kat-sakas-tip-1",
            category: "general",
            content: "Famous for Outpost Popcorn Mix with sweet purple and spicy red kernels",
            priority: 4
          },
          {
            id: "kat-sakas-tip-2",
            category: "strategy",
            content: "Try the Cold Brew Black Caf with sweet cream cheese and chocolate puffs",
            priority: 3
          }
        ],
        tags: ["galaxy's-edge", "popcorn", "coffee", "unique-flavors", "star-wars"],
        features: {
          mobileOrder: false,
          outdoorSeating: true,
          entertainment: false,
          adrRequired: false,
          alcoholServed: false,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: false,
          characterDining: false
        },
        cuisineType: "Specialty Snacks & Coffee",
        kidFriendly: true,
        allergyFriendly: ["vegetarian"],
        mobileOrderAvailable: false,
        operatingHours: {
          breakfast: "8:00 AM - 11:00 AM",
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        }
      },
      {
        id: "dhs-baseline-tap-house",
        parkId: "hollywood-studios",
        name: "BaseLine Tap House",
        description: "California-inspired lounge and snack spot on Grand Avenue featuring craft beer, wine, and gourmet snacks including the famous Bavarian Pretzel with beer cheese.",
        location: "Grand Avenue",
        type: "snack",
        serviceType: "snack",
        priceLevel: 3,
        tips: [
          {
            id: "baseline-tip-1",
            category: "general",
            content: "Home to the best Bavarian Pretzel in Disney World with beer cheese fondue",
            priority: 4
          },
          {
            id: "baseline-tip-2",
            category: "strategy",
            content: "Great spot for adult beverages and gourmet snacking away from crowds",
            priority: 3
          }
        ],
        tags: ["grand-avenue", "craft-beer", "bavarian-pretzel", "adult-friendly", "gourmet"],
        features: {
          mobileOrder: false,
          entertainment: false,
          adrRequired: false,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: true,
          characterDining: false
        },
        cuisineType: "California-Inspired",
        kidFriendly: true,
        allergyFriendly: ["vegetarian", "gluten-free"],
        mobileOrderAvailable: false,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 10:00 PM"
        }
      },
      {
        id: "dhs-the-market",
        parkId: "hollywood-studios",
        name: "The Market",
        description: "Pixar-themed snack location featuring Jack-Jack's Num Num Cookies from The Incredibles - large, warm, gooey cookies perfect for sharing.",
        location: "Pixar Place",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "market-tip-1",
            category: "general",
            content: "Home to Jack-Jack's Num Num Cookie - contender for best cookie in Disney World",
            priority: 4
          },
          {
            id: "market-tip-2",
            category: "strategy",
            content: "Cookies are served warm and are huge - perfect for sharing",
            priority: 3
          }
        ],
        tags: ["pixar", "incredibles", "num-num-cookie", "warm-cookies", "sharing"],
        features: {
          mobileOrder: false,
          outdoorSeating: true,
          entertainment: false,
          adrRequired: false,
          alcoholServed: false,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: false,
          characterDining: false
        },
        cuisineType: "American Bakery",
        kidFriendly: true,
        allergyFriendly: ["vegetarian"],
        mobileOrderAvailable: false,
        operatingHours: {
          breakfast: "8:00 AM - 11:00 AM",
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        }
      },
      {
        id: "dhs-backlot-express-snacks",
        parkId: "hollywood-studios",
        name: "Backlot Express",
        description: "Quick service location that also offers specialty snacks including the Wookie Cookie - two oatmeal cookies with vanilla cream inspired by Chewbacca's bandolier.",
        location: "Echo Lake",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "backlot-snacks-tip-1",
            category: "general",
            content: "Features the Wookie Cookie with vanilla cream and chocolate sash inspired by Chewbacca",
            priority: 3
          },
          {
            id: "backlot-snacks-tip-2",
            category: "strategy",
            content: "Good option for both meals and specialty Star Wars-themed cookies",
            priority: 2
          }
        ],
        tags: ["star-wars", "wookie-cookie", "chewbacca", "oatmeal-cookies", "echo-lake"],
        features: {
          mobileOrder: true,
          entertainment: false,
          adrRequired: false,
          alcoholServed: false,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: false,
          characterDining: false
        },
        cuisineType: "American",
        kidFriendly: true,
        allergyFriendly: ["vegetarian"],
        mobileOrderAvailable: true,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        }
      }
    ];
  }
});

// src/data/eat/snacks/animal-kingdom-snacks.json
var animal_kingdom_snacks_default;
var init_animal_kingdom_snacks = __esm({
  "src/data/eat/snacks/animal-kingdom-snacks.json"() {
    animal_kingdom_snacks_default = [
      {
        id: "ak-pongu-pongu",
        parkId: "animal-kingdom",
        name: "Pongu Pongu",
        description: "Pandora's signature snack location serving the famous Night Blossom beverage, Pongu Lumpia spring rolls, and other specialty treats themed to the Avatar world.",
        location: "Pandora - The World of Avatar",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "pongu-pongu-tip-1",
            category: "general",
            content: "Home to the famous Night Blossom with passion fruit boba - a must-try Animal Kingdom treat",
            priority: 4
          },
          {
            id: "pongu-pongu-tip-2",
            category: "strategy",
            content: "Try the Pongu Lumpia sweet spring roll paired with Night Blossom for the full Pandora experience",
            priority: 3
          }
        ],
        tags: ["pandora", "avatar", "night-blossom", "signature", "must-try"],
        features: {
          mobileOrder: false,
          outdoorSeating: true,
          entertainment: false,
          adrRequired: false,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: false,
          characterDining: false
        },
        cuisineType: "Specialty Beverages & Snacks",
        kidFriendly: true,
        allergyFriendly: ["vegetarian"],
        mobileOrderAvailable: false,
        operatingHours: {
          breakfast: "8:00 AM - 11:00 AM",
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 9:00 PM"
        }
      },
      {
        id: "ak-kusafiri-coffee-shop",
        parkId: "animal-kingdom",
        name: "Kusafiri Coffee Shop & Bakery",
        description: "Africa-themed coffee shop famous for the Colossal Cinnamon Roll made from three rolls combined into Mickey Mouse shape, plus coffee and light breakfast items.",
        location: "Africa - Harambe",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "kusafiri-tip-1",
            category: "general",
            content: "Home to the iconic Colossal Cinnamon Roll - perfect for sharing and Instagram photos",
            priority: 4
          },
          {
            id: "kusafiri-tip-2",
            category: "best_time",
            content: "Great breakfast spot before starting your Animal Kingdom day",
            priority: 3
          }
        ],
        tags: ["africa", "coffee", "colossal-cinnamon-roll", "breakfast", "mickey-shaped"],
        features: {
          mobileOrder: false,
          entertainment: false,
          adrRequired: false,
          alcoholServed: false,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: false,
          characterDining: false
        },
        cuisineType: "Coffee & Bakery",
        kidFriendly: true,
        allergyFriendly: ["vegetarian"],
        mobileOrderAvailable: false,
        operatingHours: {
          breakfast: "7:30 AM - 11:00 AM",
          lunch: "11:00 AM - 4:00 PM"
        }
      },
      {
        id: "ak-harambe-market",
        parkId: "animal-kingdom",
        name: "Harambe Market",
        description: "Africa-themed marketplace offering quick service meals and specialty snacks. CLOSING LATE 2025/WINTER 2025 for refurbishment, reopening early 2026 with new menu featuring hamburgers and chicken nuggets.",
        location: "Africa - Harambe",
        type: "snack",
        serviceType: "snack",
        priceLevel: 2,
        tips: [
          {
            id: "harambe-market-tip-1",
            category: "strategy",
            content: "TEMPORARY CLOSURE: Closing late 2025 for refurbishment, reopening early 2026 with family-friendly menu",
            priority: 5
          },
          {
            id: "harambe-market-tip-2",
            category: "general",
            content: "Will incorporate menu items from Restaurantosaurus when it reopens in early 2026",
            priority: 4
          },
          {
            id: "harambe-market-tip-3",
            category: "strategy",
            content: "Currently features tropical desserts like Mango Vanilla-Mousse - experience current menu while available",
            priority: 3
          }
        ],
        tags: ["africa", "marketplace", "temporary-closure", "menu-change", "restaurantosaurus-items"],
        features: {
          mobileOrder: true,
          outdoorSeating: true,
          entertainment: false,
          adrRequired: false,
          alcoholServed: false,
          vegetarianOptions: true,
          veganOptions: true,
          glutenFreeOptions: true,
          characterDining: false
        },
        cuisineType: "African-Inspired",
        kidFriendly: true,
        allergyFriendly: ["vegetarian", "vegan", "gluten-free"],
        mobileOrderAvailable: true,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        }
      }
    ];
  }
});

// src/data/eat/lounges/magic-kingdom-lounges.json
var magic_kingdom_lounges_default;
var init_magic_kingdom_lounges = __esm({
  "src/data/eat/lounges/magic-kingdom-lounges.json"() {
    magic_kingdom_lounges_default = [
      {
        id: "enchanted-rose-lounge",
        parkId: "magic-kingdom",
        name: "Enchanted Rose",
        description: "Elegant lounge in Disney's Grand Floridian Resort featuring Belle and Beast-inspired cocktails and small plates.",
        location: "Disney's Grand Floridian Resort & Spa",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 4,
        tips: [
          {
            id: "enchanted-rose-tip-1",
            category: "strategy",
            content: "Reservations highly recommended - this popular lounge fills up quickly",
            priority: 1
          },
          {
            id: "enchanted-rose-tip-2",
            category: "general",
            content: "Try the 'Be Our Guest' cocktail - it changes color as you drink it",
            priority: 1
          }
        ],
        tags: ["upscale", "cocktails", "beauty-beast", "grand-floridian", "reservations"],
        cuisineType: "Cocktails & Small Plates",
        kidFriendly: false,
        operatingHours: {
          evening: "5:00 PM - 12:00 AM"
        },
        reservationWindow: 60,
        features: {
          mobileOrder: false,
          entertainment: false,
          adrRequired: true,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: true,
          characterDining: false
        }
      },
      {
        id: "outer-rim-lounge",
        parkId: "magic-kingdom",
        name: "Outer Rim",
        description: "Star Wars-themed lounge at Disney's Contemporary Resort with galactic cocktails and views of the Magic Kingdom.",
        location: "Disney's Contemporary Resort",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        tips: [
          {
            id: "outer-rim-tip-1",
            category: "general",
            content: "Great views of Magic Kingdom fireworks from the outdoor seating area",
            priority: 2
          },
          {
            id: "outer-rim-tip-2",
            category: "general",
            content: "Try the Fuzzy Tauntaun - it creates a numbing sensation on your tongue",
            priority: 1
          }
        ],
        tags: ["star-wars", "contemporary", "views", "cocktails", "outdoor-seating"],
        cuisineType: "Cocktails & Light Bites",
        kidFriendly: false,
        operatingHours: {
          evening: "4:00 PM - 11:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: false,
          entertainment: false,
          adrRequired: false,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: false,
          characterDining: false
        }
      },
      {
        id: "beak-and-barrel-pirates-lounge",
        parkId: "magic-kingdom",
        name: "The Beak and Barrel",
        description: "Magic Kingdom's first bar! Pirates of the Caribbean-themed lounge featuring cocktails, specialty drinks, and Caribbean-inspired small plates with immersive pirate theming. OPENED AUGUST 29, 2025.",
        location: "Adventureland (near Pirates of the Caribbean exit)",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        tips: [
          {
            id: "beak-barrel-tip-1",
            category: "strategy",
            content: "NEW OPENING: Magic Kingdom's first bar opened August 29, 2025. Reservations highly recommended.",
            priority: 5
          },
          {
            id: "beak-barrel-tip-2",
            category: "general",
            content: "Features Captain's Quarters with themed booths telling different pirate lord stories",
            priority: 4
          },
          {
            id: "beak-barrel-tip-3",
            category: "general",
            content: "Try the Treasure Trove non-alcoholic drink with edible treats or Port of Call gin cocktail",
            priority: 3
          }
        ],
        tags: ["new", "pirates", "historic", "first-bar", "themed", "adventureland", "reservations"],
        cuisineType: "Cocktails & Caribbean Small Plates",
        kidFriendly: true,
        operatingHours: {
          daily: "Check My Disney Experience app for current hours"
        },
        reservationWindow: 60,
        features: {
          mobileOrder: false,
          entertainment: true,
          adrRequired: true,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: true,
          characterDining: false
        }
      }
    ];
  }
});

// src/data/eat/lounges/epcot-lounges.json
var epcot_lounges_default;
var init_epcot_lounges = __esm({
  "src/data/eat/lounges/epcot-lounges.json"() {
    epcot_lounges_default = [
      {
        id: "rose-crown-pub",
        parkId: "epcot",
        name: "Rose & Crown Pub",
        description: "Traditional British pub in the UK Pavilion offering a wide selection of beers, ales, and pub fare with outdoor seating.",
        location: "World Showcase - United Kingdom",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        tips: [
          {
            id: "rose-crown-pub-tip-1",
            category: "strategy",
            content: "Great spot to watch EPCOT fireworks from outdoor seating area",
            priority: 1
          },
          {
            id: "rose-crown-pub-tip-2",
            category: "general",
            content: "Try a flight of British beers and the fish & chips",
            priority: 2
          }
        ],
        tags: ["british", "pub", "beer", "fireworks-view", "outdoor-seating"],
        cuisineType: "British Pub",
        kidFriendly: true,
        operatingHours: {
          afternoon: "2:00 PM - 9:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: false,
          entertainment: false,
          adrRequired: false,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: true,
          characterDining: false
        }
      },
      {
        id: "la-cava-del-tequila",
        parkId: "epcot",
        name: "La Cava del Tequila",
        description: "Tequila and mezcal bar in the Mexico Pavilion with over 200 varieties plus Mexican-inspired appetizers.",
        location: "World Showcase - Mexico",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        tips: [
          {
            id: "la-cava-tip-1",
            category: "general",
            content: "Over 200 tequilas and mezcals to choose from. Try a flight to compare different varieties",
            priority: 1
          },
          {
            id: "la-cava-tip-2",
            category: "general",
            content: "Small intimate space that fills up quickly. Go early for best selection",
            priority: 2
          }
        ],
        tags: ["tequila", "mezcal", "mexican", "intimate", "specialty"],
        cuisineType: "Mexican Cocktails",
        kidFriendly: false,
        operatingHours: {
          afternoon: "12:00 PM - 9:00 PM"
        },
        reservationWindow: 0,
        features: {
          mobileOrder: false,
          entertainment: false,
          adrRequired: false,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: false,
          characterDining: false
        }
      },
      {
        id: "geo-82-spaceship-earth-lounge",
        parkId: "epcot",
        name: "GEO-82",
        description: "Adults-only Spaceship Earth-themed lounge offering innovative cocktails and small plates with stunning views of World Celebration gardens. OPENED JUNE 4, 2025.",
        location: "World Celebration (Spaceship Earth exit area)",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 4,
        tips: [
          {
            id: "geo-82-tip-1",
            category: "strategy",
            content: "NEW OPENING: Adults-only lounge opened June 4, 2025. Advanced dining reservations required 60 days ahead.",
            priority: 5
          },
          {
            id: "geo-82-tip-2",
            category: "general",
            content: "Open even when Spaceship Earth ride is closed for refurbishment",
            priority: 4
          },
          {
            id: "geo-82-tip-3",
            category: "general",
            content: "Beautiful garden views and themed cocktails celebrating human communication and innovation",
            priority: 3
          }
        ],
        tags: ["new", "adults-only", "spaceship-earth", "upscale", "garden-views", "reservations", "21+"],
        cuisineType: "Innovative Cocktails & Small Plates",
        kidFriendly: false,
        operatingHours: {
          daily: "Check My Disney Experience app for current hours"
        },
        reservationWindow: 60,
        features: {
          mobileOrder: false,
          entertainment: false,
          adrRequired: true,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: true,
          glutenFreeOptions: true,
          characterDining: false
        }
      }
    ];
  }
});

// src/data/eat/lounges/hollywood-studios-lounges.json
var hollywood_studios_lounges_default;
var init_hollywood_studios_lounges = __esm({
  "src/data/eat/lounges/hollywood-studios-lounges.json"() {
    hollywood_studios_lounges_default = [
      {
        id: "dhs-oga-cantina",
        parkId: "hollywood-studios",
        name: "Oga's Cantina",
        description: "Immersive Star Wars bar experience with specialty cocktails, music by DJ R-3X, and authentic cantina atmosphere from Galaxy's Edge.",
        location: "Star Wars: Galaxy's Edge",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        tips: [
          {
            id: "oc-tip-1",
            category: "strategy",
            content: "Most popular bar at Disney World. Reservations essential and limited to 45 minutes.",
            priority: 5
          },
          {
            id: "oc-tip-2",
            category: "general",
            content: "Specialty cocktails and unique atmosphere. DJ R-3X provides entertainment.",
            priority: 4
          }
        ],
        tags: ["star-wars", "cantina", "specialty-cocktails", "dj", "immersive"],
        features: {
          starWarsTheming: true,
          specialtyCocktails: true,
          entertainment: true,
          themedAtmosphere: true,
          adrRequired: true,
          alcoholServed: true
        },
        cuisineType: "Bar & Cocktails",
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: [],
        kidFriendly: false,
        alcoholServed: true,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 9:00 PM"
        },
        reservationWindow: 60
      }
    ];
  }
});

// src/data/eat/lounges/animal-kingdom-lounges.json
var animal_kingdom_lounges_default;
var init_animal_kingdom_lounges = __esm({
  "src/data/eat/lounges/animal-kingdom-lounges.json"() {
    animal_kingdom_lounges_default = [
      {
        id: "ak-nomad-lounge",
        parkId: "animal-kingdom",
        name: "Nomad Lounge",
        description: "Sophisticated lounge adjacent to Tiffins restaurant featuring creative cocktails, small plates, and a quieter atmosphere perfect for adults seeking refuge from the park crowds.",
        location: "Discovery Island",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        tips: [
          {
            id: "nomad-tip-1",
            category: "general",
            content: "Hidden gem for adults - sophisticated cocktails and small plates in a quieter park setting",
            priority: 4
          },
          {
            id: "nomad-tip-2",
            category: "strategy",
            content: "Perfect spot for a mid-day break with air conditioning and comfortable seating",
            priority: 3
          },
          {
            id: "nomad-tip-3",
            category: "menu",
            content: "Try the Tempting Tigress cocktail or the Mustang Spring Roll for unique flavors",
            priority: 3
          }
        ],
        tags: ["sophisticated", "cocktails", "adults", "quiet", "discovery-island"],
        features: {
          mobileOrder: false,
          entertainment: false,
          adrRequired: false,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: true,
          characterDining: false
        },
        cuisineType: "Creative Cocktails & Small Plates",
        kidFriendly: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        mobileOrderAvailable: false,
        operatingHours: {
          lunch: "11:30 AM - 3:30 PM",
          dinner: "3:30 PM - 8:00 PM"
        }
      },
      {
        id: "ak-dawa-bar",
        parkId: "animal-kingdom",
        name: "Dawa Bar",
        description: "Outdoor African-themed bar located near Tusker House offering beer, cocktails, and light snacks with authentic African atmosphere and live entertainment.",
        location: "Africa - Harambe",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 2,
        tips: [
          {
            id: "dawa-tip-1",
            category: "general",
            content: "Authentic African atmosphere with outdoor seating and occasional live entertainment",
            priority: 3
          },
          {
            id: "dawa-tip-2",
            category: "strategy",
            content: "Great spot for drinks while waiting for Tusker House reservations or exploring Africa",
            priority: 2
          }
        ],
        tags: ["africa", "outdoor", "authentic", "harambe", "entertainment"],
        features: {
          mobileOrder: false,
          outdoorSeating: true,
          entertainment: true,
          adrRequired: false,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: false,
          characterDining: false
        },
        cuisineType: "African-Inspired Beverages",
        kidFriendly: true,
        allergyFriendly: ["vegetarian"],
        mobileOrderAvailable: false,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 8:00 PM"
        }
      },
      {
        id: "ak-thirsty-river-bar",
        parkId: "animal-kingdom",
        name: "Thirsty River Bar & Trek Snacks",
        description: "Poolside-style bar near Kali River Rapids offering frozen drinks, beer, and light snacks with a casual riverside atmosphere perfect for cooling down.",
        location: "Asia - Anandapur",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 2,
        tips: [
          {
            id: "thirsty-river-tip-1",
            category: "general",
            content: "Perfect spot for frozen drinks after getting soaked on Kali River Rapids",
            priority: 3
          },
          {
            id: "thirsty-river-tip-2",
            category: "strategy",
            content: "Casual outdoor bar with poolside vibe - great for hot Florida days",
            priority: 2
          }
        ],
        tags: ["asia", "frozen-drinks", "casual", "outdoor", "kali-river"],
        features: {
          mobileOrder: false,
          outdoorSeating: true,
          entertainment: false,
          adrRequired: false,
          alcoholServed: true,
          vegetarianOptions: true,
          veganOptions: false,
          glutenFreeOptions: false,
          characterDining: false
        },
        cuisineType: "Frozen Cocktails & Light Snacks",
        kidFriendly: true,
        allergyFriendly: ["vegetarian"],
        mobileOrderAvailable: false,
        operatingHours: {
          lunch: "11:00 AM - 4:00 PM",
          dinner: "4:00 PM - 7:00 PM"
        }
      }
    ];
  }
});

// src/data/eat/resorts/disney-resorts-dining.json
var disney_resorts_dining_default;
var init_disney_resorts_dining = __esm({
  "src/data/eat/resorts/disney-resorts-dining.json"() {
    disney_resorts_dining_default = [
      {
        id: "grand-floridian-victoria-alberts",
        resortId: "grand-floridian",
        name: "Victoria & Albert's",
        description: "Disney's award-winning AAA Five Diamond signature restaurant offering an intimate fine dining experience with a multi-course prix fixe menu.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "American Fine Dining",
        location: "Main Building, Second Floor",
        operatingHours: {
          dinner: "5:30 PM - 9:30 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: false,
        alcoholServed: true,
        features: {
          fineDining: true,
          signatureDining: true,
          adultOnly: true,
          prixFixe: true,
          chefTable: true,
          dressCode: true
        },
        tips: [
          {
            id: "victoria-alberts-tip-1",
            category: "strategy",
            content: "Guests must be 10 years or older to dine here - adults only restaurant",
            priority: 5
          },
          {
            id: "victoria-alberts-tip-2",
            category: "strategy",
            content: "Book exactly 60 days in advance - this is one of the hardest reservations to get",
            priority: 5
          },
          {
            id: "victoria-alberts-tip-3",
            category: "general",
            content: "Dress code enforced - business casual to formal attire required",
            priority: 4
          },
          {
            id: "victoria-alberts-tip-4",
            category: "general",
            content: "Prix fixe menu starting at $295 per person - perfect for special occasions",
            priority: 4
          }
        ],
        tags: ["signature-dining", "fine-dining", "adult-only", "special-occasion", "expensive", "dress-code"]
      },
      {
        id: "grand-floridian-narcoossees",
        resortId: "grand-floridian",
        name: "Narcoossee's",
        description: "Signature seafood restaurant with stunning views of Seven Seas Lagoon and Magic Kingdom fireworks.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "American Seafood",
        location: "Lakeside",
        operatingHours: {
          lunch: "11:30 AM - 3:00 PM",
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          lakefrontViews: true,
          fireworksViews: true,
          seafoodFocused: true
        },
        tips: [
          {
            id: "narcoossees-tip-1",
            category: "strategy",
            content: "Request a window table when booking for Magic Kingdom fireworks views",
            priority: 5
          },
          {
            id: "narcoossees-tip-2",
            category: "strategy",
            content: "Book dinner reservations around fireworks time (8-9 PM) for the best experience",
            priority: 4
          },
          {
            id: "narcoossees-tip-3",
            category: "general",
            content: "Known for fresh seafood and lobster - try the signature seafood tower",
            priority: 4
          }
        ],
        tags: ["signature-dining", "seafood", "views", "fireworks", "romantic"]
      },
      {
        id: "grand-floridian-citricos",
        resortId: "grand-floridian",
        name: "C\xEDtricos",
        description: "Upscale Mediterranean-inspired restaurant offering modern American cuisine with a focus on fresh ingredients and innovative flavors.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "Mediterranean American",
        location: "Main Building, Second Floor",
        operatingHours: {
          dinner: "5:30 PM - 9:30 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          mediterraneanCuisine: true,
          openKitchen: true,
          seasonalMenu: true
        },
        tips: [
          {
            id: "citricos-tip-1",
            category: "general",
            content: "Features an open kitchen where you can watch chefs prepare your meal",
            priority: 4
          },
          {
            id: "citricos-tip-2",
            category: "general",
            content: "Menu changes seasonally featuring Mediterranean-inspired dishes",
            priority: 3
          },
          {
            id: "citricos-tip-3",
            category: "strategy",
            content: "Less crowded than other Grand Floridian signature restaurants but equally excellent",
            priority: 4
          }
        ],
        tags: ["signature-dining", "mediterranean", "open-kitchen", "upscale"]
      },
      {
        id: "grand-floridian-1900-park-fare",
        resortId: "grand-floridian",
        name: "1900 Park Fare",
        description: "Character dining restaurant featuring Disney characters in an elegant Victorian setting with buffet-style dining.",
        type: "table_service",
        serviceType: "buffet",
        priceLevel: 2,
        cuisineType: "American Buffet",
        location: "Main Building, First Floor",
        operatingHours: {
          breakfast: "8:00 AM - 11:30 AM",
          dinner: "4:00 PM - 8:30 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          characterDining: true,
          buffetStyle: true,
          familyFriendly: true,
          victorianTheme: true
        },
        tips: [
          {
            id: "1900-park-fare-tip-1",
            category: "strategy",
            content: "Characters vary by meal - typically Cinderella and friends at breakfast, different characters at dinner",
            priority: 4
          },
          {
            id: "1900-park-fare-tip-2",
            category: "general",
            content: "Beautiful Victorian dining room with elegant atmosphere for character dining",
            priority: 3
          },
          {
            id: "1900-park-fare-tip-3",
            category: "strategy",
            content: "Great option for families wanting character interaction without park admission",
            priority: 4
          }
        ],
        tags: ["character-dining", "buffet", "family-friendly", "victorian", "cinderella"]
      },
      {
        id: "grand-floridian-cafe",
        resortId: "grand-floridian",
        name: "Grand Floridian Cafe",
        description: "Casual dining restaurant offering American cuisine with a relaxed atmosphere and moderate pricing in an elegant setting.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        cuisineType: "American Casual",
        location: "Main Building, First Floor",
        operatingHours: {
          breakfast: "7:00 AM - 11:30 AM",
          lunch: "11:30 AM - 2:00 PM",
          dinner: "5:00 PM - 9:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          casualDining: true,
          allDayDining: true,
          moderatelyPriced: true,
          comfortFood: true
        },
        tips: [
          {
            id: "grand-floridian-cafe-tip-1",
            category: "strategy",
            content: "Hidden gem with Grand Floridian elegance at more affordable prices",
            priority: 5
          },
          {
            id: "grand-floridian-cafe-tip-2",
            category: "general",
            content: "Try the buttermilk fried chicken and waffle or the miso-glazed salmon",
            priority: 4
          },
          {
            id: "grand-floridian-cafe-tip-3",
            category: "strategy",
            content: "Great breakfast spot with avocado toast and Mickey waffles available",
            priority: 4
          }
        ],
        tags: ["casual-dining", "american", "moderate-price", "all-day", "hidden-gem"]
      },
      {
        id: "grand-floridian-gasparilla-grill",
        resortId: "grand-floridian",
        name: "Gasparilla Island Grill",
        description: "Quick service restaurant offering fresh sandwiches, salads, and baked goods made with bread from the Grand Floridian Bakery.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "American Quick Service",
        location: "Main Building, Ground Floor",
        operatingHours: {
          allDay: "6:00 AM - 12:00 AM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          quickService: true,
          mobileOrder: true,
          freshBread: true,
          grabAndGo: true,
          bakeryItems: true
        },
        tips: [
          {
            id: "gasparilla-grill-tip-1",
            category: "general",
            content: "Bread made fresh daily at the Grand Floridian Bakery - try the sandwiches",
            priority: 4
          },
          {
            id: "gasparilla-grill-tip-2",
            category: "strategy",
            content: "Use mobile order to skip the line during busy breakfast and lunch hours",
            priority: 4
          },
          {
            id: "gasparilla-grill-tip-3",
            category: "general",
            content: "Great spot for Mickey waffles, breakfast platters, and artisan burgers",
            priority: 3
          }
        ],
        tags: ["quick-service", "fresh-bread", "mobile-order", "breakfast", "sandwiches"]
      },
      {
        id: "grand-floridian-enchanted-rose",
        resortId: "grand-floridian",
        name: "Enchanted Rose",
        description: "Elegant lounge inspired by Beauty and the Beast, located on the second floor of the resort lobby, offering craft cocktails and small plates.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        cuisineType: "Cocktails & Small Plates",
        location: "Main Building, Second Floor Lobby",
        operatingHours: {
          evening: "4:00 PM - 12:00 AM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          craftCocktails: true,
          beautyAndBeast: true,
          lobbyViews: true,
          romanticSetting: true,
          smallPlates: true
        },
        tips: [
          {
            id: "enchanted-rose-tip-1",
            category: "general",
            content: "Arguably the most elegant bar at Walt Disney World with Beauty and the Beast theming",
            priority: 5
          },
          {
            id: "enchanted-rose-tip-2",
            category: "strategy",
            content: "Perfect spot for a romantic drink before or after dinner at Grand Floridian",
            priority: 4
          },
          {
            id: "enchanted-rose-tip-3",
            category: "general",
            content: "Try the signature cocktails inspired by Beauty and the Beast characters",
            priority: 4
          }
        ],
        tags: ["lounge", "cocktails", "beauty-and-beast", "romantic", "elegant", "lobby-bar"]
      },
      {
        id: "grand-floridian-citricos-lounge",
        resortId: "grand-floridian",
        name: "C\xEDtricos Lounge",
        description: "Intimate lounge adjacent to C\xEDtricos restaurant, offering craft cocktails and appetizers in a sophisticated setting.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        cuisineType: "Cocktails & Appetizers",
        location: "Main Building, Second Floor",
        operatingHours: {
          evening: "5:00 PM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          intimateSetting: true,
          craftCocktails: true,
          appetizers: true,
          adultFocused: true
        },
        tips: [
          {
            id: "citricos-lounge-tip-1",
            category: "strategy",
            content: "Great spot to wait for your C\xEDtricos dinner reservation",
            priority: 4
          },
          {
            id: "citricos-lounge-tip-2",
            category: "general",
            content: "More intimate and quieter than Enchanted Rose for conversation",
            priority: 3
          }
        ],
        tags: ["lounge", "cocktails", "intimate", "appetizers", "quiet"]
      },
      {
        id: "grand-floridian-beaches-pool-bar",
        resortId: "grand-floridian",
        name: "Beaches Pool Bar & Grill",
        description: "Poolside dining offering tropical drinks, light meals, and snacks while enjoying the resort's beach area and pools.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside American",
        location: "Beach Pool Area",
        operatingHours: {
          seasonal: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          tropicalDrinks: true,
          beachViews: true,
          casualDining: true
        },
        tips: [
          {
            id: "beaches-pool-bar-tip-1",
            category: "general",
            content: "Perfect for staying by the pool with food and drinks delivered to your chair",
            priority: 4
          },
          {
            id: "beaches-pool-bar-tip-2",
            category: "general",
            content: "Enjoy tropical cocktails while watching boats on Seven Seas Lagoon",
            priority: 3
          }
        ],
        tags: ["poolside", "tropical-drinks", "beach", "casual", "relaxing"]
      },
      {
        id: "grand-floridian-courtyard-pool-bar",
        resortId: "grand-floridian",
        name: "Courtyard Pool Bar",
        description: "Pool bar serving refreshing beverages and light snacks at the resort's courtyard pool area.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside Beverages",
        location: "Courtyard Pool Area",
        operatingHours: {
          seasonal: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          beverageFocused: true,
          courtyardSetting: true
        },
        tips: [
          {
            id: "courtyard-pool-bar-tip-1",
            category: "general",
            content: "Quieter pool area compared to the main beach pool",
            priority: 3
          }
        ],
        tags: ["poolside", "beverages", "courtyard", "quiet"]
      },
      {
        id: "polynesian-ohana",
        resortId: "polynesian",
        name: "'Ohana",
        description: "One of Disney World's most popular restaurants offering all-you-care-to-enjoy Polynesian family-style dining with character breakfast and traditional dinner.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "Polynesian Family Style",
        location: "Great Ceremonial House, Second Floor",
        operatingHours: {
          breakfast: "7:30 AM - 12:15 PM",
          dinner: "3:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          characterDining: true,
          familyStyle: true,
          allYouCareToEnjoy: true,
          polynesian: true
        },
        tips: [
          {
            id: "ohana-tip-1",
            category: "strategy",
            content: "Book exactly 60 days in advance - this is one of the hardest reservations to get at Disney World",
            priority: 5
          },
          {
            id: "ohana-tip-2",
            category: "strategy",
            content: "Breakfast features character dining with Lilo, Stitch, Mickey, and Pluto",
            priority: 5
          },
          {
            id: "ohana-tip-3",
            category: "general",
            content: "Dinner is all-you-care-to-enjoy family-style feast with grilled meats and famous bread pudding",
            priority: 4
          },
          {
            id: "ohana-tip-4",
            category: "general",
            content: "Adults $62, Children $40 for dinner - excellent value for the amount of food",
            priority: 4
          }
        ],
        tags: ["character-dining", "family-style", "polynesian", "popular", "hard-reservation"]
      },
      {
        id: "polynesian-kona-cafe",
        resortId: "polynesian",
        name: "Kona Cafe",
        description: "A hidden gem serving Pacific Rim cuisine with famous breakfast items like Tonga Toast and Macadamia Nut Pancakes.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        cuisineType: "Pacific Rim",
        location: "Great Ceremonial House, Second Floor",
        operatingHours: {
          breakfast: "7:30 AM - 2:00 PM",
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          hiddenGem: true,
          breakfast: true,
          pacificRim: true,
          signatureItems: true
        },
        tips: [
          {
            id: "kona-cafe-tip-1",
            category: "general",
            content: "Famous for Tonga Toast - French toast stuffed with bananas and rolled in cinnamon sugar",
            priority: 5
          },
          {
            id: "kona-cafe-tip-2",
            category: "general",
            content: "Macadamia Nut Pancakes are a must-try breakfast item",
            priority: 4
          },
          {
            id: "kona-cafe-tip-3",
            category: "strategy",
            content: "Less crowded than other Polynesian restaurants but equally excellent food",
            priority: 4
          }
        ],
        tags: ["hidden-gem", "breakfast", "pacific-rim", "tonga-toast", "casual-dining"]
      },
      {
        id: "polynesian-trader-sams-grog-grotto",
        resortId: "polynesian",
        name: "Trader Sam's Grog Grotto",
        description: "Disney World's most popular tiki bar featuring interactive cocktails with special effects and themed decor.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        cuisineType: "Tiki Bar & Small Plates",
        location: "Great Ceremonial House, Ground Floor",
        operatingHours: {
          evening: "3:00 PM - 12:00 AM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          tikBar: true,
          interactiveEffects: true,
          adultOnlyAfter8PM: true,
          walkUpOnly: true,
          virtualQueue: true
        },
        tips: [
          {
            id: "trader-sams-tip-1",
            category: "strategy",
            content: "Arrive at least one hour before 3:00 PM opening to join virtual queue - no reservations accepted",
            priority: 5
          },
          {
            id: "trader-sams-tip-2",
            category: "general",
            content: "All ages welcome until 8:00 PM, then 21+ only after 8:00 PM",
            priority: 5
          },
          {
            id: "trader-sams-tip-3",
            category: "general",
            content: "Interactive cocktails trigger special effects - order the Uh-Oa! or Krakatoa Punch",
            priority: 4
          },
          {
            id: "trader-sams-tip-4",
            category: "strategy",
            content: "Try the outdoor Tiki Terrace if Grog Grotto is full - same drinks, no wait",
            priority: 4
          }
        ],
        tags: ["tiki-bar", "interactive", "popular", "walk-up-only", "special-effects"]
      },
      {
        id: "polynesian-captain-cooks",
        resortId: "polynesian",
        name: "Captain Cook's",
        description: "Popular quick service restaurant serving Polynesian and Asian-inspired dishes for breakfast, lunch, and dinner.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "Polynesian Quick Service",
        location: "Great Ceremonial House, Ground Floor",
        operatingHours: {
          allDay: "7:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          quickService: true,
          mobileOrder: true,
          allDayDining: true,
          asianFusion: true
        },
        tips: [
          {
            id: "captain-cooks-tip-1",
            category: "general",
            content: "Considered one of the best quick service restaurants at Disney World",
            priority: 4
          },
          {
            id: "captain-cooks-tip-2",
            category: "strategy",
            content: "Use mobile order during peak meal times to skip the lines",
            priority: 4
          },
          {
            id: "captain-cooks-tip-3",
            category: "general",
            content: "Try the Pulled Pork Nachos or Asian dishes for unique flavors",
            priority: 3
          }
        ],
        tags: ["quick-service", "polynesian", "asian-fusion", "mobile-order", "popular"]
      },
      {
        id: "polynesian-tambu-lounge",
        resortId: "polynesian",
        name: "Tambu Lounge",
        description: "Tropical-themed lounge adjacent to 'Ohana serving specialty cocktails including drinks served in fresh pineapples.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        cuisineType: "Tropical Cocktails & Appetizers",
        location: "Great Ceremonial House, Second Floor",
        operatingHours: {
          allDay: "8:30 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          tropicalCocktails: true,
          pineappleDrinks: true,
          adjacentToOhana: true,
          appetizers: true
        },
        tips: [
          {
            id: "tambu-lounge-tip-1",
            category: "general",
            content: "Famous for Lapu Lapu - rum drink served in a fresh pineapple",
            priority: 4
          },
          {
            id: "tambu-lounge-tip-2",
            category: "strategy",
            content: "Perfect spot to wait for your 'Ohana reservation",
            priority: 4
          },
          {
            id: "tambu-lounge-tip-3",
            category: "general",
            content: "Appetizers available after 4:00 PM",
            priority: 3
          }
        ],
        tags: ["lounge", "tropical", "pineapple-drinks", "appetizers", "ohana-adjacent"]
      },
      {
        id: "polynesian-kona-island",
        resortId: "polynesian",
        name: "Kona Island",
        description: "Quick service kiosk offering specialty coffee, pastries, sushi, and grab-and-go items throughout the day.",
        type: "quick_service",
        serviceType: "kiosk",
        priceLevel: 2,
        cuisineType: "Coffee & Sushi",
        location: "Great Ceremonial House, Second Floor",
        operatingHours: {
          allDay: "6:30 AM - 10:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          sushi: true,
          coffee: true,
          pastries: true,
          grabAndGo: true
        },
        tips: [
          {
            id: "kona-island-tip-1",
            category: "general",
            content: "Morning coffee and pastries, afternoon sushi and sandwiches",
            priority: 4
          },
          {
            id: "kona-island-tip-2",
            category: "general",
            content: "Convenient grab-and-go option near Kona Cafe",
            priority: 3
          }
        ],
        tags: ["quick-service", "coffee", "sushi", "grab-and-go", "kiosk"]
      },
      {
        id: "polynesian-pineapple-lanai",
        resortId: "polynesian",
        name: "Pineapple Lanai",
        description: "The only place outside Magic Kingdom to get Dole Whips, featuring multiple flavors and specialty versions.",
        type: "quick_service",
        serviceType: "kiosk",
        priceLevel: 1,
        cuisineType: "Frozen Treats",
        location: "Pool Area",
        operatingHours: {
          seasonal: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["dairy-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          doleWhip: true,
          uniqueLocation: true,
          poolside: true,
          rumFloater: true
        },
        tips: [
          {
            id: "pineapple-lanai-tip-1",
            category: "general",
            content: "Only place outside Magic Kingdom to get Dole Whips",
            priority: 5
          },
          {
            id: "pineapple-lanai-tip-2",
            category: "general",
            content: "Try the Rum Floater version or souvenir Tiki Sipper",
            priority: 4
          },
          {
            id: "pineapple-lanai-tip-3",
            category: "general",
            content: "Multiple Dole Whip flavors available beyond traditional pineapple",
            priority: 3
          }
        ],
        tags: ["dole-whip", "frozen-treats", "poolside", "unique", "family-favorite"]
      },
      {
        id: "polynesian-barefoot-pool-bar",
        resortId: "polynesian",
        name: "Barefoot Pool Bar",
        description: "Poolside bar and grill near the Lava Pool offering tropical cocktails and full meals with views of Seven Seas Lagoon.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside American",
        location: "Lava Pool Area",
        operatingHours: {
          lunch: "11:00 AM - 10:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          tropicalDrinks: true,
          lakeViews: true,
          fullMeals: true,
          beachViews: true
        },
        tips: [
          {
            id: "barefoot-pool-tip-1",
            category: "general",
            content: "Entrees available until 8:00 PM, drinks until 10:00 PM",
            priority: 4
          },
          {
            id: "barefoot-pool-tip-2",
            category: "general",
            content: "Stunning views of Seven Seas Lagoon, Grand Floridian, and Cinderella Castle",
            priority: 4
          },
          {
            id: "barefoot-pool-tip-3",
            category: "strategy",
            content: "Perfect for staying by the pool all day with food and drinks delivered",
            priority: 3
          }
        ],
        tags: ["poolside", "tropical-drinks", "views", "beach", "casual"]
      },
      {
        id: "polynesian-oasis-pool-bar",
        resortId: "polynesian",
        name: "Oasis Bar and Grill",
        description: "Pool bar near the Oasis Pool serving the same menu as Barefoot Pool Bar with tropical cocktails and food.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside American",
        location: "Oasis Pool Area",
        operatingHours: {
          lunch: "11:00 AM - 10:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          tropicalDrinks: true,
          sameMenuAsBarefoot: true,
          quieterLocation: true
        },
        tips: [
          {
            id: "oasis-pool-tip-1",
            category: "general",
            content: "Same great food as Barefoot Pool Bar with two convenient locations",
            priority: 3
          },
          {
            id: "oasis-pool-tip-2",
            category: "strategy",
            content: "Alternative to Barefoot if that location is busy",
            priority: 3
          }
        ],
        tags: ["poolside", "tropical-drinks", "alternative", "casual"]
      },
      {
        id: "polynesian-island-tower-wailulu",
        resortId: "polynesian-island-tower",
        name: "Wailulu Bar & Grill",
        description: "Brand new restaurant celebrating Polynesian flavors with Magic Kingdom fireworks views, opened December 2024.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "Pacific Islands",
        location: "Island Tower, Overlooking Seven Seas Lagoon",
        operatingHours: {
          breakfast: "7:00 AM - 11:00 AM",
          lunch: "11:00 AM - 10:00 PM",
          bar: "11:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          newOpening2024: true,
          fireworksViews: true,
          castleViews: true,
          pacificIslands: true,
          walkUp: true
        },
        tips: [
          {
            id: "wailulu-tip-1",
            category: "strategy",
            content: "Hot new spot for Magic Kingdom fireworks viewing - arrive early for outdoor seating",
            priority: 5
          },
          {
            id: "wailulu-tip-2",
            category: "general",
            content: "Name means 'calm water' in Hawaiian - celebrates Pacific Islands from Easter Island to Fiji",
            priority: 4
          },
          {
            id: "wailulu-tip-3",
            category: "general",
            content: "Try the Beef Short Rib Loco Moco or Wayfinder Burger for unique flavors",
            priority: 4
          },
          {
            id: "wailulu-tip-4",
            category: "strategy",
            content: "Currently no reservations required but may be added to ADR system soon",
            priority: 4
          }
        ],
        tags: ["new-2024", "fireworks-views", "pacific-islands", "walk-up", "trendy"]
      },
      {
        id: "contemporary-california-grill",
        resortId: "contemporary",
        name: "California Grill",
        description: "Signature restaurant on the 15th floor offering contemporary American cuisine with panoramic views of Magic Kingdom fireworks.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Contemporary American",
        location: "15th Floor, Main Tower",
        operatingHours: {
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          fireworksViews: true,
          "15thFloor": true,
          panoramicViews: true,
          openKitchen: true
        },
        tips: [
          {
            id: "california-grill-tip-1",
            category: "strategy",
            content: "Request window table when booking for best fireworks views",
            priority: 5
          },
          {
            id: "california-grill-tip-2",
            category: "general",
            content: "Prix fixe menu: Adults $89, Children $39 - worth it for the experience",
            priority: 4
          },
          {
            id: "california-grill-tip-3",
            category: "strategy",
            content: "Book dinner around fireworks time for outdoor viewing deck access",
            priority: 4
          },
          {
            id: "california-grill-tip-4",
            category: "general",
            content: "Take elevator to 15th floor even without reservation to see the view",
            priority: 3
          }
        ],
        tags: ["signature-dining", "fireworks-views", "15th-floor", "expensive", "romantic"]
      },
      {
        id: "contemporary-chef-mickeys",
        resortId: "contemporary",
        name: "Chef Mickey's",
        description: "Popular character dining buffet featuring Mickey, Minnie, Donald, Goofy, and Pluto in the Grand Canyon Concourse.",
        type: "table_service",
        serviceType: "buffet",
        priceLevel: 3,
        cuisineType: "American Buffet",
        location: "Grand Canyon Concourse, 4th Floor",
        operatingHours: {
          breakfast: "7:00 AM - 11:30 AM",
          brunch: "11:30 AM - 2:30 PM",
          dinner: "5:00 PM - 9:30 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          characterDining: true,
          buffetStyle: true,
          famousCharacters: true,
          monorailViews: true,
          familyFriendly: true
        },
        tips: [
          {
            id: "chef-mickeys-tip-1",
            category: "strategy",
            content: "Book exactly 60 days in advance - extremely popular character meal",
            priority: 5
          },
          {
            id: "chef-mickeys-tip-2",
            category: "general",
            content: "Adults $58 breakfast/$69 dinner, Children $37/$42 - great character interaction",
            priority: 4
          },
          {
            id: "chef-mickeys-tip-3",
            category: "general",
            content: "Watch monorails go by during your meal - unique Disney experience",
            priority: 4
          },
          {
            id: "chef-mickeys-tip-4",
            category: "strategy",
            content: "Bring autograph book and camera for character photos",
            priority: 4
          }
        ],
        tags: ["character-dining", "buffet", "popular", "family-favorite", "monorail-views"]
      },
      {
        id: "contemporary-steakhouse-71",
        resortId: "contemporary",
        name: "Steakhouse 71",
        description: "Upscale steakhouse serving new American cuisine with local and regional organic ingredients for breakfast, lunch, and dinner.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "New American Steakhouse",
        location: "First Floor, Main Tower",
        operatingHours: {
          breakfast: "7:00 AM - 11:00 AM",
          lunch: "11:30 AM - 2:00 PM",
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          casualElegance: true,
          organicIngredients: true,
          localSourcing: true,
          steakhouse: true,
          allDayDining: true
        },
        tips: [
          {
            id: "steakhouse-71-tip-1",
            category: "general",
            content: "Pricing ranges $35-$59.99 per adult - good value for upscale dining",
            priority: 4
          },
          {
            id: "steakhouse-71-tip-2",
            category: "general",
            content: "Focus on local and organic ingredients with new American twist",
            priority: 4
          },
          {
            id: "steakhouse-71-tip-3",
            category: "strategy",
            content: "Great option for upscale dining without signature restaurant pricing",
            priority: 4
          }
        ],
        tags: ["steakhouse", "new-american", "organic", "upscale", "all-day-dining"]
      },
      {
        id: "contemporary-contempo-cafe",
        resortId: "contemporary",
        name: "Contempo Cafe",
        description: "Upscale quick service restaurant on the Grand Canyon Concourse serving artisanal sandwiches, salads, and flatbread pizzas.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "Upscale Quick Service",
        location: "Grand Canyon Concourse, 4th Floor",
        operatingHours: {
          allDay: "7:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          upscaleQuickService: true,
          mobileOrder: true,
          artisanalFood: true,
          monorailViews: true,
          flatbreads: true
        },
        tips: [
          {
            id: "contempo-cafe-tip-1",
            category: "general",
            content: "Upscale quick service - try the Contempo Artisanal Burger ($16.49)",
            priority: 4
          },
          {
            id: "contempo-cafe-tip-2",
            category: "strategy",
            content: "Use mobile ordering for convenience during busy meal times",
            priority: 4
          },
          {
            id: "contempo-cafe-tip-3",
            category: "general",
            content: "Watch monorails pass by while you dine on the 4th floor",
            priority: 3
          }
        ],
        tags: ["quick-service", "upscale", "artisanal", "mobile-order", "monorail-views"]
      },
      {
        id: "contemporary-steakhouse-71-lounge",
        resortId: "contemporary",
        name: "Steakhouse 71 Lounge",
        description: "Sophisticated lounge adjacent to Steakhouse 71 serving craft cocktails and light bites.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        cuisineType: "Cocktails & Light Bites",
        location: "First Floor, Main Tower",
        operatingHours: {
          allDay: "12:00 PM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          craftCocktails: true,
          lightBites: true,
          sophisticatedSetting: true,
          adjacentToSteakhouse: true
        },
        tips: [
          {
            id: "steakhouse-71-lounge-tip-1",
            category: "strategy",
            content: "Perfect spot to wait for Steakhouse 71 reservation",
            priority: 4
          },
          {
            id: "steakhouse-71-lounge-tip-2",
            category: "general",
            content: "Sophisticated atmosphere with craft cocktails and appetizers",
            priority: 3
          }
        ],
        tags: ["lounge", "cocktails", "sophisticated", "light-bites"]
      },
      {
        id: "wilderness-lodge-artist-point",
        resortId: "wilderness-lodge",
        name: "Artist Point",
        description: "Storybook character dining experience featuring Snow White characters including the rare Evil Queen in an elegant Pacific Northwest setting.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "American Character Dining",
        location: "Main Lodge, First Floor",
        operatingHours: {
          dinner: "4:00 PM - 9:15 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          characterDining: true,
          storybook: true,
          evilQueen: true,
          pacificNorthwest: true,
          elegantSetting: true
        },
        tips: [
          {
            id: "artist-point-tip-1",
            category: "strategy",
            content: "One of the few places to meet the Evil Queen - book early for this rare character",
            priority: 5
          },
          {
            id: "artist-point-tip-2",
            category: "general",
            content: "Fixed-price menu with shared appetizers, entree selection, and dessert",
            priority: 4
          },
          {
            id: "artist-point-tip-3",
            category: "general",
            content: "Beautiful Pacific Northwest theming with elegant atmosphere",
            priority: 4
          }
        ],
        tags: ["character-dining", "evil-queen", "storybook", "elegant", "rare-characters"]
      },
      {
        id: "wilderness-lodge-whispering-canyon",
        resortId: "wilderness-lodge",
        name: "Whispering Canyon Cafe",
        description: "Rowdy Wild West themed restaurant famous for all-you-care-to-enjoy skillets and interactive entertainment from cast members.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        cuisineType: "American Wild West",
        location: "Main Lodge, First Floor",
        operatingHours: {
          breakfast: "7:30 AM - 11:00 AM",
          lunch: "11:30 AM - 2:00 PM",
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          allYouCareToEnjoy: true,
          interactiveEntertainment: true,
          wildWest: true,
          familyFun: true,
          rowdyAtmosphere: true
        },
        tips: [
          {
            id: "whispering-canyon-tip-1",
            category: "general",
            content: "TEMPORARY CLOSURE: May 12-21, 2025 for refurbishment",
            priority: 5
          },
          {
            id: "whispering-canyon-tip-2",
            category: "general",
            content: "Famous for cast member antics and games - be prepared for fun interactions",
            priority: 5
          },
          {
            id: "whispering-canyon-tip-3",
            category: "general",
            content: "All-you-care-to-enjoy skillets are the signature - great value for families",
            priority: 4
          },
          {
            id: "whispering-canyon-tip-4",
            category: "strategy",
            content: "Ask for ketchup at your own risk - part of the Wild West experience",
            priority: 4
          }
        ],
        tags: ["wild-west", "interactive", "family-fun", "all-you-care-to-enjoy", "rowdy"]
      },
      {
        id: "animal-kingdom-lodge-jiko",
        resortId: "animal-kingdom-lodge",
        name: "Jiko - The Cooking Place",
        description: "Award-winning signature restaurant featuring African-inspired cuisine with an extensive South African wine selection.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "African-Inspired Fine Dining",
        location: "Jambo House, Ground Floor",
        operatingHours: {
          dinner: "5:30 PM - 9:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          africanInspired: true,
          southAfricanWines: true,
          romanticSetting: true,
          awardWinning: true
        },
        tips: [
          {
            id: "jiko-tip-1",
            category: "strategy",
            content: "One of Disney World's most romantic restaurants - perfect for special occasions",
            priority: 5
          },
          {
            id: "jiko-tip-2",
            category: "general",
            content: "Requires 2 Disney Dining Plan credits as signature restaurant",
            priority: 4
          },
          {
            id: "jiko-tip-3",
            category: "general",
            content: "Extensive South African wine list pairs perfectly with African-inspired dishes",
            priority: 4
          },
          {
            id: "jiko-tip-4",
            category: "general",
            content: "Dress code enforced - business casual to formal attire",
            priority: 4
          }
        ],
        tags: ["signature-dining", "african-inspired", "romantic", "award-winning", "dress-code"]
      },
      {
        id: "animal-kingdom-lodge-boma",
        resortId: "animal-kingdom-lodge",
        name: "Boma - Flavors of Africa",
        description: "Outstanding buffet featuring authentic African cuisine with over 50 dishes from across the continent.",
        type: "table_service",
        serviceType: "buffet",
        priceLevel: 2,
        cuisineType: "African Buffet",
        location: "Jambo House, Ground Floor",
        operatingHours: {
          breakfast: "7:30 AM - 11:00 AM",
          dinner: "4:30 PM - 9:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free", "vegan"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          africanCuisine: true,
          buffetStyle: true,
          over50Dishes: true,
          authenticFlavors: true,
          bestBuffet: true
        },
        tips: [
          {
            id: "boma-tip-1",
            category: "general",
            content: "Widely considered the best buffet at Walt Disney World",
            priority: 5
          },
          {
            id: "boma-tip-2",
            category: "general",
            content: "Over 50 authentic African dishes - try the watermelon salad and seafood",
            priority: 4
          },
          {
            id: "boma-tip-3",
            category: "strategy",
            content: "Excellent value for money with authentic, ambitious flavors",
            priority: 4
          },
          {
            id: "boma-tip-4",
            category: "general",
            content: "Great options for vegetarians and those with dietary restrictions",
            priority: 4
          }
        ],
        tags: ["buffet", "african-cuisine", "best-buffet", "authentic", "value"]
      },
      {
        id: "boardwalk-flying-fish",
        resortId: "boardwalk",
        name: "Flying Fish",
        description: "Upscale seafood restaurant featuring fresh catches and show kitchen with BoardWalk entertainment nearby.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Seafood Fine Dining",
        location: "BoardWalk Promenade",
        operatingHours: {
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          seafoodFocused: true,
          showKitchen: true,
          boardwalkLocation: true,
          upscale: true
        },
        tips: [
          {
            id: "flying-fish-tip-1",
            category: "general",
            content: "Disney World's premier seafood restaurant - requires 2 dining plan credits",
            priority: 5
          },
          {
            id: "flying-fish-tip-2",
            category: "strategy",
            content: "Perfect for adult night out - enjoy BoardWalk entertainment after dinner",
            priority: 4
          },
          {
            id: "flying-fish-tip-3",
            category: "general",
            content: "Show kitchen allows you to watch chefs prepare fresh seafood",
            priority: 4
          }
        ],
        tags: ["signature-dining", "seafood", "upscale", "boardwalk", "show-kitchen"]
      }
    ];
  }
});

// src/data/eat/resorts/universal-resorts-dining.json
var universal_resorts_dining_default;
var init_universal_resorts_dining = __esm({
  "src/data/eat/resorts/universal-resorts-dining.json"() {
    universal_resorts_dining_default = [
      {
        id: "portofino-bice-ristorante",
        resortId: "portofino-bay",
        name: "Bice Ristorante",
        description: "Internationally renowned upscale Italian restaurant offering spectacular harbor views and authentic Northern Italian cuisine with an elegant atmosphere.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Northern Italian Fine Dining",
        location: "Harbor Side, Second Floor",
        operatingHours: {
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          harborViews: true,
          internationalBrand: true,
          romanticSetting: true,
          dressCode: true
        },
        tips: [
          {
            id: "bice-tip-1",
            category: "strategy",
            content: "Request harbor view table when booking for spectacular water views",
            priority: 5
          },
          {
            id: "bice-tip-2",
            category: "general",
            content: "Internationally acclaimed restaurant with locations worldwide - authentic Northern Italian cuisine",
            priority: 4
          },
          {
            id: "bice-tip-3",
            category: "general",
            content: "Smart casual dress code enforced - upscale dining experience",
            priority: 4
          }
        ],
        tags: ["signature-dining", "italian", "harbor-views", "upscale", "international"]
      },
      {
        id: "portofino-trattoria-del-porto",
        resortId: "portofino-bay",
        name: "Trattoria del Porto",
        description: "Waterfront Italian restaurant offering modern Mediterranean cuisine with indoor and outdoor seating overlooking Harbor Piazza.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "Mediterranean Italian",
        location: "Harbor Piazza Level",
        operatingHours: {
          lunch: "11:30 AM - 2:30 PM",
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          waterfrontDining: true,
          outdoorSeating: true,
          harborViews: true,
          modernItalian: true
        },
        tips: [
          {
            id: "trattoria-tip-1",
            category: "strategy",
            content: "Request outdoor seating for the best harbor views and people watching",
            priority: 5
          },
          {
            id: "trattoria-tip-2",
            category: "general",
            content: "Perfect spot for lunch after exploring the resort or before park visits",
            priority: 4
          },
          {
            id: "trattoria-tip-3",
            category: "general",
            content: "Features fresh Mediterranean flavors with modern Italian preparation",
            priority: 4
          }
        ],
        tags: ["waterfront", "outdoor-seating", "mediterranean", "harbor-views", "casual-elegant"]
      },
      {
        id: "portofino-mama-dellas",
        resortId: "portofino-bay",
        name: "Mama Della's Ristorante",
        description: "Authentic family-style Italian restaurant serving traditional dishes from Tuscany, Naples, and Piemonte in a warm, welcoming atmosphere.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        cuisineType: "Traditional Italian Family Style",
        location: "Main Building, Ground Floor",
        operatingHours: {
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          familyStyle: true,
          traditionalItalian: true,
          authenticRecipes: true,
          warmAtmosphere: true
        },
        tips: [
          {
            id: "mama-dellas-tip-1",
            category: "general",
            content: "Perfect for families wanting authentic Italian comfort food in a cozy setting",
            priority: 5
          },
          {
            id: "mama-dellas-tip-2",
            category: "general",
            content: "Features recipes from different regions of Italy - try the handmade pasta",
            priority: 4
          },
          {
            id: "mama-dellas-tip-3",
            category: "strategy",
            content: "Great value for authentic Italian dining at the resort",
            priority: 4
          }
        ],
        tags: ["family-style", "traditional-italian", "authentic", "casual", "family-friendly"]
      },
      {
        id: "portofino-sals-market",
        resortId: "portofino-bay",
        name: "Sal's Market Deli",
        description: "Italian marketplace offering fresh deli meats, cheeses, antipasto, salads, and authentic wood-fired pizzas.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "Italian Deli & Pizza",
        location: "Main Building, Lower Level",
        operatingHours: {
          allDay: "7:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          marketplace: true,
          woodFiredPizza: true,
          freshIngredients: true,
          grabAndGo: true
        },
        tips: [
          {
            id: "sals-market-tip-1",
            category: "general",
            content: "Wood-fired pizzas are made fresh throughout the day - perfect for quick meals",
            priority: 4
          },
          {
            id: "sals-market-tip-2",
            category: "strategy",
            content: "Great for breakfast pastries, lunch sandwiches, or dinner pizza",
            priority: 4
          },
          {
            id: "sals-market-tip-3",
            category: "general",
            content: "Authentic Italian deli experience with imported meats and cheeses",
            priority: 3
          }
        ],
        tags: ["quick-service", "italian-deli", "pizza", "marketplace", "all-day"]
      },
      {
        id: "portofino-splendido-bar-grill",
        resortId: "portofino-bay",
        name: "Splendido Bar & Grill",
        description: "Poolside restaurant and bar offering casual dining with burgers, salads, and light Italian specialties alongside tropical cocktails.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside American Italian",
        location: "Beach Pool Area",
        operatingHours: {
          seasonal: "11:00 AM - 7:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          casualDining: true,
          tropicalDrinks: true,
          beachViews: true
        },
        tips: [
          {
            id: "splendido-tip-1",
            category: "general",
            content: "Perfect for staying poolside all day with food and drinks delivered to your chair",
            priority: 4
          },
          {
            id: "splendido-tip-2",
            category: "general",
            content: "Enjoy Italian-inspired poolside fare with harbor and beach views",
            priority: 3
          }
        ],
        tags: ["poolside", "casual", "italian-american", "beach-views", "tropical-drinks"]
      },
      {
        id: "portofino-gelateria",
        resortId: "portofino-bay",
        name: "Gelateria",
        description: "Authentic Italian gelateria offering artisanal gelato, milkshakes, and smoothies made with premium ingredients.",
        type: "quick_service",
        serviceType: "kiosk",
        priceLevel: 1,
        cuisineType: "Italian Gelato & Desserts",
        location: "Harbor Piazza",
        operatingHours: {
          afternoon: "12:00 PM - 10:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          artisanalGelato: true,
          authenticItalian: true,
          premiumIngredients: true,
          harbourLocation: true
        },
        tips: [
          {
            id: "gelateria-tip-1",
            category: "general",
            content: "Authentic Italian gelato made fresh daily with rotating flavor selections",
            priority: 4
          },
          {
            id: "gelateria-tip-2",
            category: "general",
            content: "Perfect sweet treat while strolling the harbor or after dinner",
            priority: 3
          }
        ],
        tags: ["gelato", "italian", "desserts", "authentic", "family-favorite"]
      },
      {
        id: "hard-rock-kitchen",
        resortId: "hard-rock",
        name: "The Kitchen",
        description: "Signature restaurant featuring New American cuisine with rock and roll flair, offering creative dishes in an energetic atmosphere.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "New American Rock Theme",
        location: "Main Building, Ground Floor",
        operatingHours: {
          breakfast: "7:00 AM - 11:00 AM",
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          rockAndRoll: true,
          newAmerican: true,
          energeticAtmosphere: true
        },
        tips: [
          {
            id: "kitchen-tip-1",
            category: "general",
            content: "Rock and roll themed fine dining with memorabilia throughout the restaurant",
            priority: 4
          },
          {
            id: "kitchen-tip-2",
            category: "strategy",
            content: "Popular with families and music lovers - book early for dinner",
            priority: 4
          },
          {
            id: "kitchen-tip-3",
            category: "general",
            content: "Creative New American dishes with playful rock-themed names",
            priority: 3
          }
        ],
        tags: ["signature-dining", "rock-theme", "new-american", "energetic", "family-friendly"]
      },
      {
        id: "hard-rock-palm-restaurant",
        resortId: "hard-rock",
        name: "Palm Restaurant",
        description: "Classic American steakhouse known for prime steaks, fresh lobster, and traditional New York-style dining experience.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "American Steakhouse",
        location: "Main Building, Second Floor",
        operatingHours: {
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          primeSteak: true,
          classicSteakhouse: true,
          newYorkStyle: true
        },
        tips: [
          {
            id: "palm-tip-1",
            category: "general",
            content: "Famous steakhouse chain known for prime cuts and fresh lobster",
            priority: 5
          },
          {
            id: "palm-tip-2",
            category: "general",
            content: "Walls feature caricatures of celebrities and regular customers",
            priority: 4
          },
          {
            id: "palm-tip-3",
            category: "strategy",
            content: "Perfect for special occasions and steak lovers",
            priority: 4
          }
        ],
        tags: ["signature-dining", "steakhouse", "prime-cuts", "classic", "celebrity-caricatures"]
      },
      {
        id: "hard-rock-emack-bolios",
        resortId: "hard-rock",
        name: "Emack & Bolio's",
        description: "Gourmet ice cream parlor offering unique flavors and premium ice cream with rock and roll attitude.",
        type: "quick_service",
        serviceType: "kiosk",
        priceLevel: 2,
        cuisineType: "Gourmet Ice Cream",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "11:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          gourmetIceCream: true,
          uniqueFlavors: true,
          premiumIngredients: true,
          rockTheme: true
        },
        tips: [
          {
            id: "emack-bolios-tip-1",
            category: "general",
            content: "Famous Boston-based ice cream chain with creative flavors",
            priority: 4
          },
          {
            id: "emack-bolios-tip-2",
            category: "general",
            content: "Try unique flavors like Deep Purple Chip or Grasshopper Pie",
            priority: 3
          }
        ],
        tags: ["ice-cream", "gourmet", "unique-flavors", "boston-brand", "rock-theme"]
      },
      {
        id: "hard-rock-beachclub",
        resortId: "hard-rock",
        name: "Beach Club",
        description: "Poolside bar and grill offering casual dining with burgers, sandwiches, and tropical cocktails in a laid-back beach atmosphere.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside American",
        location: "Pool Deck",
        operatingHours: {
          seasonal: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          casualDining: true,
          tropicalDrinks: true,
          beachAtmosphere: true
        },
        tips: [
          {
            id: "beachclub-tip-1",
            category: "general",
            content: "Perfect for pool day dining without leaving the water recreation area",
            priority: 4
          },
          {
            id: "beachclub-tip-2",
            category: "general",
            content: "Tropical cocktails and light meals in a relaxed rock-themed setting",
            priority: 3
          }
        ],
        tags: ["poolside", "casual", "tropical-drinks", "beach-theme", "relaxed"]
      },
      {
        id: "hard-rock-starbucks",
        resortId: "hard-rock",
        name: "Starbucks",
        description: "Full-service Starbucks location offering specialty coffee, teas, pastries, and breakfast items with rock memorabilia decor.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "Coffee & Pastries",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "6:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian", "dairy-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          starbucks: true,
          mobileOrder: true,
          rockDecor: true,
          allDayService: true
        },
        tips: [
          {
            id: "hard-rock-starbucks-tip-1",
            category: "strategy",
            content: "Use Starbucks mobile app for ordering and earning rewards",
            priority: 4
          },
          {
            id: "hard-rock-starbucks-tip-2",
            category: "general",
            content: "Rock memorabilia decorates this unique Starbucks location",
            priority: 3
          }
        ],
        tags: ["starbucks", "coffee", "mobile-order", "rock-decor", "all-day"]
      },
      {
        id: "royal-pacific-islands-dining",
        resortId: "royal-pacific",
        name: "Islands Dining Room",
        description: "Pacific Rim restaurant offering breakfast buffet and dinner with island-inspired cuisine and tropical atmosphere.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "Pacific Rim",
        location: "Main Building, Ground Floor",
        operatingHours: {
          breakfast: "7:00 AM - 11:00 AM",
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          pacificRim: true,
          buffetBreakfast: true,
          tropicalAtmosphere: true
        },
        tips: [
          {
            id: "islands-dining-tip-1",
            category: "general",
            content: "Breakfast buffet features both American and Asian-inspired dishes",
            priority: 4
          },
          {
            id: "islands-dining-tip-2",
            category: "general",
            content: "Dinner menu focuses on Pacific Rim flavors with fresh seafood",
            priority: 4
          },
          {
            id: "islands-dining-tip-3",
            category: "strategy",
            content: "Beautiful tropical setting perfect for relaxed family dining",
            priority: 3
          }
        ],
        tags: ["signature-dining", "pacific-rim", "breakfast-buffet", "tropical", "family-friendly"]
      },
      {
        id: "royal-pacific-tuk-tuk-market",
        resortId: "royal-pacific",
        name: "Tuk Tuk Market",
        description: "Grab-and-go marketplace in the hotel lobby offering coffee, pastries, sandwiches, and Asian-inspired snacks.",
        type: "quick_service",
        serviceType: "kiosk",
        priceLevel: 2,
        cuisineType: "Asian Fusion Grab & Go",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "6:30 AM - 10:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          grabAndGo: true,
          asianInspired: true,
          convenience: true,
          lobbyLocation: true
        },
        tips: [
          {
            id: "tuk-tuk-tip-1",
            category: "general",
            content: "Perfect for quick breakfast or snacks on the go to the parks",
            priority: 4
          },
          {
            id: "tuk-tuk-tip-2",
            category: "general",
            content: "Features Asian-inspired options alongside American favorites",
            priority: 3
          }
        ],
        tags: ["grab-and-go", "asian-fusion", "convenience", "lobby", "quick-service"]
      },
      {
        id: "royal-pacific-wantilan-luau",
        resortId: "royal-pacific",
        name: "Wantilan Luau",
        description: "Seasonal Polynesian dinner show featuring traditional food, music, and dance in an outdoor lagoon setting (seasonal operation).",
        type: "table_service",
        serviceType: "dinner_show",
        priceLevel: 4,
        cuisineType: "Polynesian Dinner Show",
        location: "Lagoon Area",
        operatingHours: {
          seasonal: "6:00 PM - 8:30 PM (select nights)"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          dinnerShow: true,
          polynesian: true,
          liveEntertainment: true,
          seasonalOperation: true,
          lagoonSetting: true
        },
        tips: [
          {
            id: "wantilan-tip-1",
            category: "strategy",
            content: "Seasonal operation - check availability when booking your stay",
            priority: 5
          },
          {
            id: "wantilan-tip-2",
            category: "general",
            content: "Authentic Polynesian dinner show with fire dancing and live music",
            priority: 4
          },
          {
            id: "wantilan-tip-3",
            category: "general",
            content: "Beautiful lagoon setting for a unique cultural dining experience",
            priority: 4
          }
        ],
        tags: ["dinner-show", "polynesian", "seasonal", "entertainment", "cultural"]
      },
      {
        id: "royal-pacific-bula-bar",
        resortId: "royal-pacific",
        name: "Bula Bar & Grille",
        description: "Poolside bar and restaurant offering tropical cocktails, light meals, and island-inspired cuisine with lagoon views.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside Tropical",
        location: "Pool Area",
        operatingHours: {
          seasonal: "11:00 AM - 7:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          tropicalCocktails: true,
          lagoonViews: true,
          islandInspired: true
        },
        tips: [
          {
            id: "bula-bar-tip-1",
            category: "general",
            content: "Beautiful lagoon views while enjoying tropical drinks and light meals",
            priority: 4
          },
          {
            id: "bula-bar-tip-2",
            category: "general",
            content: "Perfect for relaxing by the pool with Pacific-inspired flavors",
            priority: 3
          }
        ],
        tags: ["poolside", "tropical-cocktails", "lagoon-views", "island-inspired", "relaxing"]
      },
      {
        id: "sapphire-falls-amatista-cookhouse",
        resortId: "sapphire-falls",
        name: "Amatista Cookhouse",
        description: "Caribbean-inspired restaurant featuring bold flavors, fresh seafood, and vibrant island cuisine with waterfall views.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "Caribbean",
        location: "Main Building, Ground Floor",
        operatingHours: {
          breakfast: "7:00 AM - 11:00 AM",
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          caribbean: true,
          waterfallViews: true,
          freshSeafood: true
        },
        tips: [
          {
            id: "amatista-tip-1",
            category: "general",
            content: "Features bold Caribbean flavors with fresh tropical ingredients",
            priority: 4
          },
          {
            id: "amatista-tip-2",
            category: "strategy",
            content: "Request seating near windows for beautiful waterfall views",
            priority: 4
          },
          {
            id: "amatista-tip-3",
            category: "general",
            content: "Excellent fresh seafood preparation with island spices",
            priority: 3
          }
        ],
        tags: ["signature-dining", "caribbean", "waterfall-views", "fresh-seafood", "tropical"]
      },
      {
        id: "sapphire-falls-strong-water-tavern",
        resortId: "sapphire-falls",
        name: "Strong Water Tavern",
        description: "Rum-focused bar and lounge featuring over 50 different rums, Caribbean-inspired cocktails, and small plates.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        cuisineType: "Rum Bar & Small Plates",
        location: "Main Building, Lobby Level",
        operatingHours: {
          evening: "5:00 PM - 12:00 AM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: false,
        alcoholServed: true,
        features: {
          rumFocused: true,
          over50Rums: true,
          craftCocktails: true,
          smallPlates: true,
          adultsOnly: true
        },
        tips: [
          {
            id: "strong-water-tip-1",
            category: "general",
            content: "Over 50 different rums from around the Caribbean and beyond",
            priority: 5
          },
          {
            id: "strong-water-tip-2",
            category: "general",
            content: "Adults only venue - perfect for evening cocktails and conversation",
            priority: 4
          },
          {
            id: "strong-water-tip-3",
            category: "general",
            content: "Expert bartenders can recommend rums based on your taste preferences",
            priority: 4
          }
        ],
        tags: ["rum-bar", "adults-only", "craft-cocktails", "caribbean", "evening"]
      },
      {
        id: "sapphire-falls-new-dutch-trading",
        resortId: "sapphire-falls",
        name: "New Dutch Trading Co.",
        description: "Quick-service marketplace offering grab-and-go items, sandwiches, salads, and beverages in a tropical market setting.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "American Quick Service",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "6:30 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          quickService: true,
          grabAndGo: true,
          marketSetting: true,
          mobileOrder: true
        },
        tips: [
          {
            id: "new-dutch-tip-1",
            category: "strategy",
            content: "Use mobile ordering for faster service during busy park times",
            priority: 4
          },
          {
            id: "new-dutch-tip-2",
            category: "general",
            content: "Convenient for quick breakfast or snacks before heading to parks",
            priority: 3
          }
        ],
        tags: ["quick-service", "grab-and-go", "mobile-order", "convenient", "all-day"]
      },
      {
        id: "sapphire-falls-drhum-club",
        resortId: "sapphire-falls",
        name: "Drhum Club Kantine",
        description: "Poolside bar and grill serving tropical cocktails, light meals, and Caribbean-inspired snacks with water views.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside Caribbean",
        location: "Pool Deck",
        operatingHours: {
          seasonal: "11:00 AM - 7:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          tropicalDrinks: true,
          caribbeanInspired: true,
          waterViews: true
        },
        tips: [
          {
            id: "drhum-tip-1",
            category: "general",
            content: "Perfect for pool day dining with Caribbean-inspired flavors",
            priority: 4
          },
          {
            id: "drhum-tip-2",
            category: "general",
            content: "Enjoy tropical cocktails while relaxing by the beautiful pool",
            priority: 3
          }
        ],
        tags: ["poolside", "caribbean", "tropical-drinks", "water-views", "casual"]
      },
      {
        id: "aventura-bar-17",
        resortId: "aventura",
        name: "Bar 17 Bistro",
        description: "Rooftop bar and bistro on the 17th floor offering panoramic views of Universal Orlando and contemporary cuisine.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "Contemporary American",
        location: "17th Floor Rooftop",
        operatingHours: {
          dinner: "5:00 PM - 11:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          rooftopDining: true,
          panoramicViews: true,
          "17thFloor": true,
          contemporaryAmerican: true,
          skylineViews: true
        },
        tips: [
          {
            id: "bar-17-tip-1",
            category: "strategy",
            content: "Book sunset reservations for incredible views of Universal Orlando",
            priority: 5
          },
          {
            id: "bar-17-tip-2",
            category: "general",
            content: "Highest dining location at Universal Orlando with 360-degree views",
            priority: 5
          },
          {
            id: "bar-17-tip-3",
            category: "general",
            content: "Modern glass tower location offers unique perspective of theme parks",
            priority: 4
          }
        ],
        tags: ["rooftop", "panoramic-views", "17th-floor", "contemporary", "sunset"]
      },
      {
        id: "aventura-urban-pantry",
        resortId: "aventura",
        name: "Urban Pantry",
        description: "Modern quick-service food hall offering diverse cuisines including Asian, Latin, and American options with contemporary styling.",
        type: "quick_service",
        serviceType: "food_court",
        priceLevel: 2,
        cuisineType: "International Food Hall",
        location: "Main Building, Ground Floor",
        operatingHours: {
          allDay: "6:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          foodHall: true,
          diverseCuisines: true,
          modernStyling: true,
          mobileOrder: true
        },
        tips: [
          {
            id: "urban-pantry-tip-1",
            category: "general",
            content: "Multiple cuisine stations offer something for everyone in the family",
            priority: 4
          },
          {
            id: "urban-pantry-tip-2",
            category: "strategy",
            content: "Use mobile ordering to skip lines and try different international options",
            priority: 4
          },
          {
            id: "urban-pantry-tip-3",
            category: "general",
            content: "Modern food hall concept with contemporary design and seating",
            priority: 3
          }
        ],
        tags: ["food-hall", "international", "mobile-order", "diverse-options", "modern"]
      },
      {
        id: "aventura-starbucks",
        resortId: "aventura",
        name: "Starbucks",
        description: "Modern Starbucks location in the hotel lobby offering specialty coffee, teas, pastries, and breakfast items.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "Coffee & Pastries",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "5:30 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian", "dairy-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          starbucks: true,
          mobileOrder: true,
          modernDesign: true,
          lobbyLocation: true
        },
        tips: [
          {
            id: "aventura-starbucks-tip-1",
            category: "strategy",
            content: "Use Starbucks app for mobile ordering and rewards",
            priority: 4
          },
          {
            id: "aventura-starbucks-tip-2",
            category: "general",
            content: "Modern design complements the hotel's contemporary aesthetic",
            priority: 3
          }
        ],
        tags: ["starbucks", "coffee", "mobile-order", "modern", "lobby"]
      },
      {
        id: "cabana-bay-bayliner-diner",
        resortId: "cabana-bay",
        name: "Bayliner Diner",
        description: "1950s-style food court featuring multiple stations with burgers, pizza, international cuisine, and desserts in a retro dining atmosphere.",
        type: "quick_service",
        serviceType: "food_court",
        priceLevel: 2,
        cuisineType: "American Food Court",
        location: "Main Building, Ground Floor",
        operatingHours: {
          allDay: "6:00 AM - 12:00 AM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          foodCourt: true,
          "1950sTheme": true,
          multipleStations: true,
          retroAtmosphere: true,
          mobileOrder: true
        },
        tips: [
          {
            id: "bayliner-tip-1",
            category: "general",
            content: "Multiple food stations offer variety - pizza, burgers, international, and desserts",
            priority: 4
          },
          {
            id: "bayliner-tip-2",
            category: "strategy",
            content: "Use mobile ordering during peak meal times to avoid long lines",
            priority: 4
          },
          {
            id: "bayliner-tip-3",
            category: "general",
            content: "Authentic 1950s diner atmosphere with period music and decor",
            priority: 3
          }
        ],
        tags: ["food-court", "1950s-theme", "family-friendly", "mobile-order", "retro"]
      },
      {
        id: "cabana-bay-starbucks",
        resortId: "cabana-bay",
        name: "Starbucks",
        description: "Retro-themed Starbucks in the hotel lobby offering specialty coffee with 1950s design elements and beachside atmosphere.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "Coffee & Pastries",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "6:00 AM - 10:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian", "dairy-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          starbucks: true,
          retroTheme: true,
          mobileOrder: true,
          beachAtmosphere: true
        },
        tips: [
          {
            id: "cabana-starbucks-tip-1",
            category: "general",
            content: "Unique retro design fits perfectly with resort's 1950s beach theme",
            priority: 4
          },
          {
            id: "cabana-starbucks-tip-2",
            category: "strategy",
            content: "Mobile order available through Starbucks app",
            priority: 3
          }
        ],
        tags: ["starbucks", "retro-theme", "mobile-order", "beach-atmosphere", "1950s"]
      },
      {
        id: "cabana-bay-swizzle-lounge",
        resortId: "cabana-bay",
        name: "Swizzle Lounge",
        description: "Retro cocktail lounge in the hotel lobby serving classic cocktails with a modern twist in a 1950s-themed atmosphere.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 2,
        cuisineType: "Classic Cocktails",
        location: "Main Building, Lobby Level",
        operatingHours: {
          evening: "5:00 PM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: false,
        alcoholServed: true,
        features: {
          retroCocktails: true,
          "1950sTheme": true,
          classicDrinks: true,
          lobbyBar: true,
          adultsOnly: true
        },
        tips: [
          {
            id: "swizzle-tip-1",
            category: "general",
            content: "Classic cocktails with modern twists in authentic 1950s atmosphere",
            priority: 4
          },
          {
            id: "swizzle-tip-2",
            category: "general",
            content: "Perfect for evening drinks after a day at the theme parks",
            priority: 3
          }
        ],
        tags: ["cocktail-lounge", "retro", "1950s-theme", "classic-cocktails", "adults-only"]
      },
      {
        id: "cabana-bay-galaxy-bowl",
        resortId: "cabana-bay",
        name: "Galaxy Bowl Restaurant",
        description: "Unique restaurant inside the resort's retro bowling alley serving burgers, pizza, and classic American fare.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "American Bowling Alley",
        location: "Galaxy Bowl, Second Floor",
        operatingHours: {
          evening: "4:00 PM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          bowlingAlley: true,
          uniqueLocation: true,
          americanClassics: true,
          familyFun: true
        },
        tips: [
          {
            id: "galaxy-bowl-tip-1",
            category: "general",
            content: "One-of-a-kind dining experience inside an actual bowling alley",
            priority: 5
          },
          {
            id: "galaxy-bowl-tip-2",
            category: "strategy",
            content: "Perfect for family entertainment night - bowl and dine together",
            priority: 4
          },
          {
            id: "galaxy-bowl-tip-3",
            category: "general",
            content: "Classic bowling alley food with burgers, pizza, and fries",
            priority: 3
          }
        ],
        tags: ["bowling-alley", "unique", "family-fun", "american-classics", "entertainment"]
      },
      {
        id: "cabana-bay-hideaway-bar",
        resortId: "cabana-bay",
        name: "The Hideaway Bar & Grill",
        description: "Poolside bar and restaurant serving specialty drinks, light meals, and snacks with 1950s beach theming.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside American",
        location: "Cabana Courtyard Pool",
        operatingHours: {
          seasonal: "11:00 AM - 9:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          beachTheming: true,
          specialtyDrinks: true,
          "1950sStyle": true
        },
        tips: [
          {
            id: "hideaway-tip-1",
            category: "general",
            content: "Perfect for pool day dining without leaving the water recreation area",
            priority: 4
          },
          {
            id: "hideaway-tip-2",
            category: "general",
            content: "Retro beach atmosphere with specialty cocktails and light fare",
            priority: 3
          }
        ],
        tags: ["poolside", "beach-theme", "specialty-drinks", "retro", "casual"]
      },
      {
        id: "cabana-bay-atomic-tonic",
        resortId: "cabana-bay",
        name: "Atomic Tonic",
        description: "Additional poolside bar location serving tropical cocktails and refreshments with atomic-age theming.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside Beverages",
        location: "Lazy River Pool Area",
        operatingHours: {
          seasonal: "11:00 AM - 7:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          tropicalCocktails: true,
          atomicTheming: true,
          lazyRiver: true
        },
        tips: [
          {
            id: "atomic-tonic-tip-1",
            category: "general",
            content: "Convenient location near the lazy river for continuous pool enjoyment",
            priority: 4
          },
          {
            id: "atomic-tonic-tip-2",
            category: "general",
            content: "Atomic-age themed cocktails and refreshments",
            priority: 3
          }
        ],
        tags: ["poolside", "lazy-river", "tropical-cocktails", "atomic-theme", "convenient"]
      },
      {
        id: "endless-summer-surfside-beach-break",
        resortId: "endless-summer-surfside",
        name: "Beach Break Cafe",
        description: "Quick-service food court featuring multiple stations with American favorites, international options, and grab-and-go items.",
        type: "quick_service",
        serviceType: "food_court",
        priceLevel: 2,
        cuisineType: "American Food Court",
        location: "Main Building, Ground Floor",
        operatingHours: {
          allDay: "6:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          foodCourt: true,
          multipleStations: true,
          grabAndGo: true,
          mobileOrder: true,
          valueOption: true
        },
        tips: [
          {
            id: "beach-break-tip-1",
            category: "general",
            content: "Multiple food stations provide variety at affordable prices",
            priority: 4
          },
          {
            id: "beach-break-tip-2",
            category: "strategy",
            content: "Use mobile ordering to save time during busy meal periods",
            priority: 4
          },
          {
            id: "beach-break-tip-3",
            category: "general",
            content: "Great value option with surf-themed atmosphere",
            priority: 3
          }
        ],
        tags: ["food-court", "value", "mobile-order", "surf-theme", "family-friendly"]
      },
      {
        id: "endless-summer-dockside-pier-8",
        resortId: "endless-summer-dockside",
        name: "Pier 8 Market",
        description: "Food court offering breakfast, lunch, and dinner with affordable options in a relaxed beach-themed atmosphere.",
        type: "quick_service",
        serviceType: "food_court",
        priceLevel: 2,
        cuisineType: "American Food Court",
        location: "Main Building, Ground Floor",
        operatingHours: {
          allDay: "6:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          foodCourt: true,
          affordableOptions: true,
          beachTheme: true,
          mobileOrder: true,
          valueOption: true
        },
        tips: [
          {
            id: "pier-8-tip-1",
            category: "general",
            content: "Affordable dining options perfect for budget-conscious families",
            priority: 4
          },
          {
            id: "pier-8-tip-2",
            category: "strategy",
            content: "Mobile ordering available for faster service",
            priority: 4
          },
          {
            id: "pier-8-tip-3",
            category: "general",
            content: "Relaxed beach atmosphere with comfortable seating",
            priority: 3
          }
        ],
        tags: ["food-court", "affordable", "beach-theme", "mobile-order", "value"]
      },
      {
        id: "endless-summer-dockside-sunset-lounge",
        resortId: "endless-summer-dockside",
        name: "Sunset Lounge",
        description: "Hotel lobby lounge offering a variety of cocktails, wines, and beers in a casual beach-themed setting.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 2,
        cuisineType: "Cocktails & Beer",
        location: "Main Building, Lobby Level",
        operatingHours: {
          evening: "4:00 PM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: false,
        alcoholServed: true,
        features: {
          lobbyLounge: true,
          casualSetting: true,
          beachTheme: true,
          affordableDrinks: true,
          adultsOnly: true
        },
        tips: [
          {
            id: "sunset-lounge-tip-1",
            category: "general",
            content: "Casual spot for evening drinks at value resort pricing",
            priority: 3
          },
          {
            id: "sunset-lounge-tip-2",
            category: "general",
            content: "Beach-themed decor complements the resort's coastal atmosphere",
            priority: 3
          }
        ],
        tags: ["lobby-lounge", "casual", "beach-theme", "affordable", "evening"]
      },
      {
        id: "endless-summer-dockside-pool-bars",
        resortId: "endless-summer-dockside",
        name: "Pool Bars (Oasis Beach Bar & Wave Maker's)",
        description: "Two poolside bars serving tropical drinks and light refreshments with beachside service to pool chairs.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside Beverages",
        location: "Pool Areas",
        operatingHours: {
          seasonal: "11:00 AM - 7:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          multipleLocations: true,
          tropicalDrinks: true,
          beachsideService: true
        },
        tips: [
          {
            id: "pool-bars-tip-1",
            category: "general",
            content: "Two convenient locations ensure drinks are always nearby while swimming",
            priority: 4
          },
          {
            id: "pool-bars-tip-2",
            category: "general",
            content: "Tropical drinks served to pool chairs for ultimate relaxation",
            priority: 3
          }
        ],
        tags: ["poolside", "multiple-locations", "tropical-drinks", "convenient", "beachside"]
      },
      {
        id: "helios-grand-flora-taverna",
        resortId: "helios-grand",
        name: "Flora Taverna",
        description: "Signature Mediterranean restaurant featuring fresh, authentic dishes with emphasis on Greek and Italian flavors and Epic Universe views.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Mediterranean Fine Dining",
        location: "Main Building, Ground Floor",
        operatingHours: {
          breakfast: "7:00 AM - 11:00 AM",
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          mediterranean: true,
          epicUniverseViews: true,
          freshIngredients: true,
          authenticFlavors: true
        },
        tips: [
          {
            id: "flora-taverna-tip-1",
            category: "strategy",
            content: "NEW 2025 - Book early as this is the premier dining at Universal's newest deluxe hotel",
            priority: 5
          },
          {
            id: "flora-taverna-tip-2",
            category: "general",
            content: "Features authentic Mediterranean cuisine with views of Epic Universe",
            priority: 5
          },
          {
            id: "flora-taverna-tip-3",
            category: "general",
            content: "Emphasis on fresh, high-quality ingredients and traditional preparation",
            priority: 4
          }
        ],
        tags: ["signature-dining", "mediterranean", "new-2025", "epic-universe-views", "premium"]
      },
      {
        id: "helios-grand-bar-helios",
        resortId: "helios-grand",
        name: "Bar Helios",
        description: "Rooftop bar overlooking Epic Universe offering craft cocktails, wine, and small plates with panoramic theme park views.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 4,
        cuisineType: "Rooftop Bar & Small Plates",
        location: "Rooftop Level",
        operatingHours: {
          evening: "4:00 PM - 12:00 AM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          rooftopBar: true,
          epicUniverseViews: true,
          craftCocktails: true,
          panoramicViews: true,
          premiumLocation: true
        },
        tips: [
          {
            id: "bar-helios-tip-1",
            category: "strategy",
            content: "NEW 2025 - Prime location for Epic Universe views and sunset cocktails",
            priority: 5
          },
          {
            id: "bar-helios-tip-2",
            category: "general",
            content: "Rooftop location offers unparalleled views of Universal's newest theme park",
            priority: 5
          },
          {
            id: "bar-helios-tip-3",
            category: "strategy",
            content: "Arrive early for sunset views and best seating options",
            priority: 4
          }
        ],
        tags: ["rooftop-bar", "epic-universe-views", "craft-cocktails", "new-2025", "premium"]
      },
      {
        id: "helios-grand-aurora-market",
        resortId: "helios-grand",
        name: "Aurora Market",
        description: "Upscale coffee shop and marketplace offering Starbucks coffee, pastries, grab-and-go items, and light meals.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 3,
        cuisineType: "Coffee & Gourmet Market",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "5:30 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian", "dairy-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          upscaleMarket: true,
          starbucksCoffee: true,
          gourmetOptions: true,
          mobileOrder: true,
          premiumLocation: true
        },
        tips: [
          {
            id: "aurora-market-tip-1",
            category: "general",
            content: "NEW 2025 - Upscale market with premium grab-and-go options",
            priority: 4
          },
          {
            id: "aurora-market-tip-2",
            category: "strategy",
            content: "Perfect for quick breakfast before early Epic Universe access",
            priority: 4
          },
          {
            id: "aurora-market-tip-3",
            category: "general",
            content: "Mobile ordering available for convenience",
            priority: 3
          }
        ],
        tags: ["upscale-market", "starbucks", "mobile-order", "new-2025", "convenient"]
      },
      {
        id: "helios-grand-lotus-lagoon",
        resortId: "helios-grand",
        name: "Lotus Lagoon",
        description: "Poolside bar and grill offering tropical cocktails, light meals, and upscale poolside dining with lagoon theming.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 3,
        cuisineType: "Upscale Poolside",
        location: "Pool Area",
        operatingHours: {
          seasonal: "11:00 AM - 8:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          upscalePoolside: true,
          lagoonTheming: true,
          tropicalCocktails: true,
          premiumDining: true
        },
        tips: [
          {
            id: "lotus-lagoon-tip-1",
            category: "general",
            content: "NEW 2025 - Upscale poolside dining matching the hotel's premium level",
            priority: 4
          },
          {
            id: "lotus-lagoon-tip-2",
            category: "general",
            content: "Tropical cocktails and elevated poolside fare",
            priority: 3
          }
        ],
        tags: ["upscale-poolside", "tropical-cocktails", "lagoon-theme", "new-2025", "premium"]
      },
      {
        id: "stella-nova-cosmos-cafe",
        resortId: "stella-nova",
        name: "Cosmos Cafe & Market",
        description: "Quick-service restaurant and market featuring high-quality international cuisine with stellar space theming and excellent food quality.",
        type: "quick_service",
        serviceType: "food_court",
        priceLevel: 2,
        cuisineType: "International Quick Service",
        location: "Main Building, Ground Floor",
        operatingHours: {
          allDay: "6:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          highQuality: true,
          internationalCuisine: true,
          spaceTheming: true,
          excellentFood: true,
          mobileOrder: true
        },
        tips: [
          {
            id: "cosmos-cafe-tip-1",
            category: "general",
            content: "OPENED 2025 - Reviewers call this some of the best resort quick-service food",
            priority: 5
          },
          {
            id: "cosmos-cafe-tip-2",
            category: "general",
            content: "Try the salmon fried rice, pulled pork sandwich, or eggs Benedict",
            priority: 5
          },
          {
            id: "cosmos-cafe-tip-3",
            category: "general",
            content: "Space-themed atmosphere with stellar food quality",
            priority: 4
          }
        ],
        tags: ["high-quality", "international", "space-theme", "opened-2025", "excellent-food"]
      },
      {
        id: "stella-nova-galaxy-bar",
        resortId: "stella-nova",
        name: "Galaxy Bar & Grill",
        description: "Poolside bar and restaurant offering refreshments and meals with celestial theming and space-inspired cocktails.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside Space Theme",
        location: "Pool Area",
        operatingHours: {
          seasonal: "11:00 AM - 7:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          celestialTheming: true,
          spaceInspired: true,
          poolsideRefreshments: true
        },
        tips: [
          {
            id: "galaxy-bar-tip-1",
            category: "general",
            content: "OPENED 2025 - Space-themed poolside dining with cosmic cocktails",
            priority: 4
          },
          {
            id: "galaxy-bar-tip-2",
            category: "general",
            content: "Perfect for pool relaxation with celestial atmosphere",
            priority: 3
          }
        ],
        tags: ["poolside", "space-theme", "celestial", "opened-2025", "cosmic-cocktails"]
      },
      {
        id: "terra-luna-omega-cafe",
        resortId: "terra-luna",
        name: "Omega Cafe & Market",
        description: "Adventure-themed quick-service restaurant serving breakfast, lunch, and dinner with planetary theming and hearty portions.",
        type: "quick_service",
        serviceType: "food_court",
        priceLevel: 2,
        cuisineType: "American Adventure Theme",
        location: "Main Building, Ground Floor",
        operatingHours: {
          allDay: "6:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: true,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          adventureTheme: true,
          planetaryTheming: true,
          heartyPortions: true,
          mobileOrder: true,
          allDayDining: true
        },
        tips: [
          {
            id: "omega-cafe-tip-1",
            category: "general",
            content: "OPENED 2025 - Try the Big French Dipper or Earth Shake Fried Chicken Sandwich",
            priority: 4
          },
          {
            id: "omega-cafe-tip-2",
            category: "general",
            content: "Adventure and planetary themed menu and atmosphere",
            priority: 4
          },
          {
            id: "omega-cafe-tip-3",
            category: "strategy",
            content: "Mobile ordering available for convenience",
            priority: 3
          }
        ],
        tags: ["adventure-theme", "planetary", "hearty-portions", "opened-2025", "mobile-order"]
      },
      {
        id: "terra-luna-luna-bar",
        resortId: "terra-luna",
        name: "Luna Bar",
        description: "Evening cocktail lounge featuring lunar libations with creative cocktails inspired by space exploration and celestial themes.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 2,
        cuisineType: "Lunar Cocktails",
        location: "Main Building, Lobby Level",
        operatingHours: {
          evening: "4:00 PM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: false,
        alcoholServed: true,
        features: {
          lunarLibations: true,
          creativeCocktails: true,
          spaceExploration: true,
          celestialThemes: true,
          adultsOnly: true
        },
        tips: [
          {
            id: "luna-bar-tip-1",
            category: "general",
            content: "OPENED 2025 - Try the Hyperion (bourbon cocktail) or Io (gin cocktail)",
            priority: 4
          },
          {
            id: "luna-bar-tip-2",
            category: "general",
            content: "Creative lunar-themed cocktails with space exploration inspiration",
            priority: 4
          },
          {
            id: "luna-bar-tip-3",
            category: "general",
            content: "Perfect evening spot for space-themed cocktails",
            priority: 3
          }
        ],
        tags: ["lunar-cocktails", "creative", "space-exploration", "opened-2025", "evening"]
      },
      {
        id: "terra-luna-moonrise-bar",
        resortId: "terra-luna",
        name: "Moonrise Bar & Grill",
        description: "Poolside bar and restaurant offering space-themed refreshments and meals with lunar atmosphere and cosmic cocktails.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside Space Theme",
        location: "Pool Area",
        operatingHours: {
          seasonal: "11:00 AM - 7:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          spaceThemed: true,
          lunarAtmosphere: true,
          cosmicCocktails: true
        },
        tips: [
          {
            id: "moonrise-bar-tip-1",
            category: "general",
            content: "OPENED 2025 - Space-themed poolside dining with cosmic atmosphere",
            priority: 4
          },
          {
            id: "moonrise-bar-tip-2",
            category: "general",
            content: "Perfect for poolside relaxation with lunar-inspired refreshments",
            priority: 3
          }
        ],
        tags: ["poolside", "space-theme", "lunar-atmosphere", "opened-2025", "cosmic"]
      }
    ];
  }
});

// src/data/eat/resorts/other-hotels-dining.json
var other_hotels_dining_default;
var init_other_hotels_dining = __esm({
  "src/data/eat/resorts/other-hotels-dining.json"() {
    other_hotels_dining_default = [
      {
        id: "four-seasons-capa",
        resortId: "four-seasons",
        name: "Capa",
        description: "Michelin-starred 17th-floor rooftop steakhouse and bar featuring Spanish-influenced cuisine with panoramic views of Magic Kingdom fireworks and an open kitchen with wood-burning grill.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Spanish Steakhouse",
        location: "17th Floor Rooftop",
        operatingHours: {
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          rooftopDining: true,
          fireworksViews: true,
          michelinStarred: true,
          openKitchen: true,
          woodBurningGrill: true
        },
        tips: [
          {
            id: "capa-tip-1",
            category: "strategy",
            content: "Book dinner around fireworks time for spectacular Magic Kingdom views from the 17th floor",
            priority: 5
          },
          {
            id: "capa-tip-2",
            category: "general",
            content: "Michelin-starred restaurant with Spanish-influenced cuisine and expert cuts",
            priority: 5
          },
          {
            id: "capa-tip-3",
            category: "general",
            content: "Open kitchen and wood-burning grill allow diners to watch the culinary action",
            priority: 4
          },
          {
            id: "capa-tip-4",
            category: "strategy",
            content: "Outdoor patio offers unobstructed fireworks views - request patio seating",
            priority: 4
          }
        ],
        tags: ["signature-dining", "michelin-starred", "rooftop", "fireworks-views", "spanish", "steakhouse"]
      },
      {
        id: "four-seasons-ravello",
        resortId: "four-seasons",
        name: "Ravello",
        description: "Destination Italian restaurant serving fresh authentic cuisine inspired by Italy's culinary traditions with house-made pastas, wood-fired pizzas, and character dining with Goofy & His Pals.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "Authentic Italian",
        location: "Main Building, Ground Floor",
        operatingHours: {
          breakfast: "7:00 AM - 11:00 AM",
          lunch: "12:00 PM - 2:30 PM",
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          characterDining: true,
          woodFiredPizza: true,
          houseMadePasta: true,
          indoorOutdoorSeating: true,
          authenticallyItalian: true
        },
        tips: [
          {
            id: "ravello-tip-1",
            category: "strategy",
            content: "Good Morning Breakfast with Goofy & His Pals - unique character dining experience",
            priority: 5
          },
          {
            id: "ravello-tip-2",
            category: "general",
            content: "House-made pastas and wood-fired pizzas celebrate authentic Italian flavors",
            priority: 4
          },
          {
            id: "ravello-tip-3",
            category: "general",
            content: "Special prix-fixe three-course menu available for $60 per person",
            priority: 4
          },
          {
            id: "ravello-tip-4",
            category: "general",
            content: "Indoor-outdoor setting with seasonal ingredients and bold flavors",
            priority: 3
          }
        ],
        tags: ["italian", "character-dining", "wood-fired-pizza", "house-made-pasta", "goofy"]
      },
      {
        id: "four-seasons-pb-and-g",
        resortId: "four-seasons",
        name: "Pool Bar & Grill (PB&G)",
        description: "Lively southern-inspired poolside restaurant serving American coastal fare with locally sourced ingredients from seafood to salads in a lakeside setting.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Southern Coastal American",
        location: "Pool Area, Lakeside",
        operatingHours: {
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          southernInspired: true,
          locallySourced: true,
          lakesideViews: true,
          coastalCuisine: true
        },
        tips: [
          {
            id: "pb-and-g-tip-1",
            category: "general",
            content: "Southern-inspired coastal cuisine with locally sourced ingredients",
            priority: 4
          },
          {
            id: "pb-and-g-tip-2",
            category: "general",
            content: "Beautiful lakeside setting perfect for relaxed poolside dining",
            priority: 4
          },
          {
            id: "pb-and-g-tip-3",
            category: "general",
            content: "Menu draws inspiration from coastal regions with fresh seafood focus",
            priority: 3
          }
        ],
        tags: ["poolside", "southern", "coastal", "locally-sourced", "lakeside-views"]
      },
      {
        id: "four-seasons-plancha",
        resortId: "four-seasons",
        name: "Plancha",
        description: "Golf clubhouse restaurant serving Cuban-American cuisine in a relaxed country club atmosphere with views of the championship golf course.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        cuisineType: "Cuban-American",
        location: "Golf Clubhouse",
        operatingHours: {
          lunch: "11:00 AM - 5:00 PM"
        },
        reservationWindow: 30,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          golfClubhouse: true,
          cubanAmerican: true,
          golfCourseViews: true,
          countryClubSetting: true
        },
        tips: [
          {
            id: "plancha-tip-1",
            category: "general",
            content: "Cuban-American cuisine in a relaxed golf clubhouse setting",
            priority: 4
          },
          {
            id: "plancha-tip-2",
            category: "general",
            content: "Beautiful views of the championship golf course while dining",
            priority: 3
          },
          {
            id: "plancha-tip-3",
            category: "strategy",
            content: "Perfect for golfers and families wanting casual dining with a view",
            priority: 3
          }
        ],
        tags: ["cuban-american", "golf-clubhouse", "golf-course-views", "casual-dining"]
      },
      {
        id: "four-seasons-lobby-bar",
        resortId: "four-seasons",
        name: "The Lobby Bar",
        description: "Elegant lobby lounge offering craft cocktails and a full menu of eclectic food in a sophisticated atmosphere with resort views.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        cuisineType: "Cocktails & Eclectic American",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "11:00 AM - 12:00 AM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          lobbyLounge: true,
          craftCocktails: true,
          eclecticMenu: true,
          sophisticatedSetting: true,
          allDayDining: true
        },
        tips: [
          {
            id: "lobby-bar-tip-1",
            category: "general",
            content: "Elegant lobby setting with craft cocktails and eclectic food menu",
            priority: 4
          },
          {
            id: "lobby-bar-tip-2",
            category: "strategy",
            content: "Perfect for pre-dinner cocktails or casual meeting spot",
            priority: 3
          },
          {
            id: "lobby-bar-tip-3",
            category: "general",
            content: "Sophisticated atmosphere with all-day dining and drink service",
            priority: 3
          }
        ],
        tags: ["lobby-lounge", "craft-cocktails", "eclectic-menu", "sophisticated", "all-day"]
      },
      {
        id: "four-seasons-lickety-split",
        resortId: "four-seasons",
        name: "Lickety-Split",
        description: "Colorful coffee bar offering Starbucks coffee, pastries, and culinary creations to go in a vibrant grab-and-go setting.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "Coffee & Pastries",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "6:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "dairy-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          starbucksCoffee: true,
          grabAndGo: true,
          colorfulSetting: true,
          pastries: true,
          quickService: true
        },
        tips: [
          {
            id: "lickety-split-tip-1",
            category: "general",
            content: "Colorful coffee bar with Starbucks coffee and fresh pastries",
            priority: 4
          },
          {
            id: "lickety-split-tip-2",
            category: "strategy",
            content: "Perfect grab-and-go option for quick breakfast or snacks",
            priority: 4
          },
          {
            id: "lickety-split-tip-3",
            category: "general",
            content: "Culinary creations to go - convenient for park days",
            priority: 3
          }
        ],
        tags: ["coffee-bar", "starbucks", "grab-and-go", "pastries", "colorful"]
      },
      {
        id: "waldorf-astoria-bull-and-bear",
        resortId: "waldorf-astoria",
        name: "Bull & Bear",
        description: "Award-winning signature steakhouse featuring re-imagined classics including tableside Caesar salad, Chateaubriand for Two, and premium steaks in an elegant setting.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "American Steakhouse",
        location: "Main Building, Ground Floor",
        operatingHours: {
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          awardWinning: true,
          tableSideService: true,
          premiumSteaks: true,
          elegantSetting: true
        },
        tips: [
          {
            id: "bull-bear-tip-1",
            category: "general",
            content: "Award-winning signature restaurant with re-imagined steakhouse classics",
            priority: 5
          },
          {
            id: "bull-bear-tip-2",
            category: "general",
            content: "Famous Caesar salad prepared tableside and Chateaubriand for Two",
            priority: 4
          },
          {
            id: "bull-bear-tip-3",
            category: "strategy",
            content: "Recently renovated with new culinary innovations in 2025",
            priority: 4
          },
          {
            id: "bull-bear-tip-4",
            category: "general",
            content: "Elegant atmosphere perfect for special occasions and business dinners",
            priority: 3
          }
        ],
        tags: ["signature-dining", "steakhouse", "award-winning", "tableside-service", "elegant"]
      },
      {
        id: "waldorf-astoria-oscars-brasserie",
        resortId: "waldorf-astoria",
        name: "Oscar's Brasserie",
        description: "Opulent breakfast restaurant featuring a world-class buffet with crepes, omelets, charcuterie, fresh Florida fruit, and cold-pressed juices with croissant bar.",
        type: "table_service",
        serviceType: "buffet",
        priceLevel: 3,
        cuisineType: "European Breakfast",
        location: "Main Building, Ground Floor",
        operatingHours: {
          breakfast: "7:00 AM - 11:00 AM",
          croissantBar: "6:00 AM - 11:00 AM"
        },
        reservationWindow: 30,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          buffetStyle: true,
          worldClass: true,
          croissantBar: true,
          freshFruit: true,
          coldPressedJuices: true
        },
        tips: [
          {
            id: "oscars-tip-1",
            category: "general",
            content: "Opulent breakfast buffet with crepes, omelets, and fresh charcuterie",
            priority: 4
          },
          {
            id: "oscars-tip-2",
            category: "strategy",
            content: "Arrive early for fresh croissants from the croissant bar starting at 6:00 AM",
            priority: 4
          },
          {
            id: "oscars-tip-3",
            category: "general",
            content: "Features fresh Florida fruit and cold-pressed juices",
            priority: 3
          }
        ],
        tags: ["breakfast-buffet", "european", "croissant-bar", "fresh-fruit", "world-class"]
      },
      {
        id: "waldorf-astoria-aquamarine",
        resortId: "waldorf-astoria",
        name: "Aquamarine",
        description: "Poolside dining restaurant serving sandwiches, salads, starters, and cocktails in a relaxed aquatic atmosphere with pool service.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside American",
        location: "Pool Area",
        operatingHours: {
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          poolService: true,
          aquaticAtmosphere: true,
          casualDining: true
        },
        tips: [
          {
            id: "aquamarine-tip-1",
            category: "general",
            content: "Perfect poolside dining with sandwiches, salads, and refreshing cocktails",
            priority: 4
          },
          {
            id: "aquamarine-tip-2",
            category: "general",
            content: "Food and drinks can be served to your pool chair for ultimate relaxation",
            priority: 3
          }
        ],
        tags: ["poolside", "sandwiches", "salads", "cocktails", "pool-service"]
      },
      {
        id: "waldorf-astoria-peacock-alley",
        resortId: "waldorf-astoria",
        name: "Peacock Alley",
        description: "Elegant lobby lounge offering cocktails and smaller plates including the famous Peacock Egg cocktail in the resort's majestic lobby setting.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        cuisineType: "Cocktails & Small Plates",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "11:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          lobbyLounge: true,
          elegantSetting: true,
          signatureCocktails: true,
          smallPlates: true,
          majesticLobby: true
        },
        tips: [
          {
            id: "peacock-alley-tip-1",
            category: "general",
            content: "Try the famous one-of-a-kind Peacock Egg cocktail",
            priority: 5
          },
          {
            id: "peacock-alley-tip-2",
            category: "general",
            content: "Recently renovated with new design innovations in the majestic lobby",
            priority: 4
          },
          {
            id: "peacock-alley-tip-3",
            category: "strategy",
            content: "Perfect for pre-dinner cocktails or evening socializing",
            priority: 3
          }
        ],
        tags: ["lobby-lounge", "cocktails", "peacock-egg", "elegant", "small-plates"]
      },
      {
        id: "waldorf-astoria-clubhouse-grille",
        resortId: "waldorf-astoria",
        name: "The Clubhouse Grille",
        description: "Golf course restaurant at the 19th hole serving menu items from Bull & Bear Smokehouse in a relaxed country club atmosphere.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        cuisineType: "American Smokehouse",
        location: "Waldorf Astoria Golf Club",
        operatingHours: {
          lunch: "11:00 AM - 5:00 PM"
        },
        reservationWindow: 30,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          golfClubhouse: true,
          "19thHole": true,
          smokehouse: true,
          countryClubSetting: true
        },
        tips: [
          {
            id: "clubhouse-grille-tip-1",
            category: "general",
            content: "Located at the 19th hole with menu items from Bull & Bear Smokehouse",
            priority: 4
          },
          {
            id: "clubhouse-grille-tip-2",
            category: "strategy",
            content: "Perfect for golfers wanting quality dining at the golf club",
            priority: 3
          }
        ],
        tags: ["golf-clubhouse", "19th-hole", "smokehouse", "country-club", "casual"]
      },
      {
        id: "hilton-bonnet-creek-la-luce",
        resortId: "hilton-bonnet-creek",
        name: "La Luce",
        description: "Modern Italian country kitchen created by Napa Valley chef Donna Scala, serving thin crust pizzas, homemade pasta, and family tradition dishes.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Modern Italian",
        location: "Main Building, Ground Floor",
        operatingHours: {
          dinner: "6:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          celebrityChef: true,
          modernItalian: true,
          homemadePasta: true,
          thinCrustPizza: true
        },
        tips: [
          {
            id: "la-luce-tip-1",
            category: "general",
            content: "Created by renowned Napa Valley chef Donna Scala",
            priority: 5
          },
          {
            id: "la-luce-tip-2",
            category: "general",
            content: "Features homemade pasta and thin crust pizzas rooted in family tradition",
            priority: 4
          },
          {
            id: "la-luce-tip-3",
            category: "general",
            content: "Modern Italian country kitchen with contemporary takes on classics",
            priority: 4
          }
        ],
        tags: ["signature-dining", "modern-italian", "celebrity-chef", "homemade-pasta", "thin-crust-pizza"]
      },
      {
        id: "hilton-bonnet-creek-zeta-asia",
        resortId: "hilton-bonnet-creek",
        name: "Zeta Asia",
        description: "Sophisticated Pan-Asian restaurant offering traditional and signature sushi rolls, sashimi, and innovative hand-crafted cocktails in swanky surroundings.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Pan-Asian Sushi",
        location: "Lobby Level",
        operatingHours: {
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          panAsian: true,
          sushiBar: true,
          handCraftedCocktails: true,
          swankySurroundings: true
        },
        tips: [
          {
            id: "zeta-asia-tip-1",
            category: "general",
            content: "Sophisticated Pan-Asian cuisine with traditional and signature sushi options",
            priority: 4
          },
          {
            id: "zeta-asia-tip-2",
            category: "general",
            content: "Features innovative hand-crafted cocktails in swanky surroundings",
            priority: 4
          },
          {
            id: "zeta-asia-tip-3",
            category: "strategy",
            content: "Perfect for sushi lovers wanting upscale Pan-Asian dining experience",
            priority: 3
          }
        ],
        tags: ["signature-dining", "pan-asian", "sushi", "cocktails", "sophisticated"]
      },
      {
        id: "hilton-bonnet-creek-myth",
        resortId: "hilton-bonnet-creek",
        name: "Myth",
        description: "Stylish lobby bar offering more than just drinks with charm and style for quick bites or late night drinks in an upscale setting.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 3,
        cuisineType: "Cocktails & Light Bites",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "11:00 AM - 1:00 AM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          lobbyBar: true,
          stylish: true,
          quickBites: true,
          lateNight: true,
          upscaleSetting: true
        },
        tips: [
          {
            id: "myth-tip-1",
            category: "general",
            content: "More than a lobby bar - offers charm and style for quick bites",
            priority: 4
          },
          {
            id: "myth-tip-2",
            category: "strategy",
            content: "Perfect for late night drinks - open until 1:00 AM",
            priority: 3
          },
          {
            id: "myth-tip-3",
            category: "general",
            content: "Stylish upscale setting ideal for business or casual meetings",
            priority: 3
          }
        ],
        tags: ["lobby-bar", "stylish", "quick-bites", "late-night", "upscale"]
      },
      {
        id: "hilton-bonnet-creek-coffee-bar",
        resortId: "hilton-bonnet-creek",
        name: "Coffee Bar",
        description: "Fresh-focused coffee bar offering barista creations with vegan and gluten-free options for convenient grab-and-go service.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "Coffee & Pastries",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "6:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegan", "gluten-free"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          baristaCreations: true,
          freshFocused: true,
          veganOptions: true,
          glutenFreeOptions: true,
          grabAndGo: true
        },
        tips: [
          {
            id: "coffee-bar-tip-1",
            category: "general",
            content: "Fresh-focused coffee bar with barista creations",
            priority: 4
          },
          {
            id: "coffee-bar-tip-2",
            category: "general",
            content: "Excellent vegan and gluten-free options available",
            priority: 4
          },
          {
            id: "coffee-bar-tip-3",
            category: "strategy",
            content: "Perfect grab-and-go option for quick breakfast or coffee",
            priority: 3
          }
        ],
        tags: ["coffee-bar", "barista", "vegan-options", "gluten-free", "grab-and-go"]
      },
      {
        id: "hilton-bonnet-creek-pool-dining",
        resortId: "hilton-bonnet-creek",
        name: "Pool Dining",
        description: "Tropical paradise poolside restaurant and bar with upbeat atmosphere offering burgers, salads, kid-friendly fare, and poolside family fun.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside American",
        location: "Pool Area",
        operatingHours: {
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          tropicalParadise: true,
          upbeatAtmosphere: true,
          familyFun: true,
          kidFriendlyFare: true
        },
        tips: [
          {
            id: "pool-dining-tip-1",
            category: "general",
            content: "Tropical paradise atmosphere with upbeat poolside family fun",
            priority: 4
          },
          {
            id: "pool-dining-tip-2",
            category: "general",
            content: "Kid-friendly fare including burgers and salads",
            priority: 4
          },
          {
            id: "pool-dining-tip-3",
            category: "strategy",
            content: "Perfect for families wanting to stay poolside all day",
            priority: 3
          }
        ],
        tags: ["poolside", "tropical", "family-fun", "kid-friendly", "upbeat"]
      },
      {
        id: "buena-vista-palace-letterpress",
        resortId: "buena-vista-palace",
        name: "LetterPress Restaurant",
        description: "Main dining restaurant serving buffet breakfast daily and offering American cuisine for breakfast, brunch, lunch, and dinner in a casual atmosphere.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        cuisineType: "American Casual",
        location: "Main Building, Ground Floor",
        operatingHours: {
          breakfast: "6:30 AM - 11:00 AM",
          brunch: "11:00 AM - 2:00 PM",
          lunch: "12:00 PM - 5:00 PM",
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 30,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          buffetBreakfast: true,
          allDayDining: true,
          casualAtmosphere: true,
          americanCuisine: true,
          familyFriendly: true
        },
        tips: [
          {
            id: "letterpress-tip-1",
            category: "general",
            content: "Features daily buffet breakfast plus all-day American dining",
            priority: 4
          },
          {
            id: "letterpress-tip-2",
            category: "strategy",
            content: "Great value for families with casual atmosphere and diverse menu",
            priority: 4
          },
          {
            id: "letterpress-tip-3",
            category: "general",
            content: "All-day dining from breakfast through dinner",
            priority: 3
          }
        ],
        tags: ["american-cuisine", "buffet-breakfast", "all-day-dining", "casual", "family-friendly"]
      },
      {
        id: "buena-vista-palace-shades-pool-bar",
        resortId: "buena-vista-palace",
        name: "Shades Pool Bar & Grille",
        description: "Poolside dining serving delicious drinks and casual cuisine with hand-crafted cocktails and light bites by the pool.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside American",
        location: "Pool Area",
        operatingHours: {
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          handCraftedCocktails: true,
          lightBites: true,
          casualCuisine: true
        },
        tips: [
          {
            id: "shades-tip-1",
            category: "general",
            content: "Hand-crafted cocktails and casual cuisine by the pool",
            priority: 4
          },
          {
            id: "shades-tip-2",
            category: "strategy",
            content: "Perfect for poolside relaxation with food and drinks",
            priority: 3
          }
        ],
        tags: ["poolside", "cocktails", "light-bites", "casual", "pool-service"]
      },
      {
        id: "buena-vista-palace-citrus-28",
        resortId: "buena-vista-palace",
        name: "Citrus 28 Marketplace",
        description: "Grab-and-go marketplace offering Starbucks coffee, light meals, pastries, snacks, and convenience items for quick service.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "Coffee & Grab-and-Go",
        location: "Main Building, Lobby Level",
        operatingHours: {
          allDay: "6:00 AM - 10:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          starbucksCoffee: true,
          grabAndGo: true,
          marketplace: true,
          lightMeals: true,
          convenienceItems: true
        },
        tips: [
          {
            id: "citrus-28-tip-1",
            category: "general",
            content: "Features Starbucks coffee and grab-and-go convenience items",
            priority: 4
          },
          {
            id: "citrus-28-tip-2",
            category: "strategy",
            content: "Perfect for quick breakfast before Disney Springs or theme parks",
            priority: 4
          },
          {
            id: "citrus-28-tip-3",
            category: "general",
            content: "Little market with snacks and dry items for convenience",
            priority: 3
          }
        ],
        tags: ["starbucks", "grab-and-go", "marketplace", "convenience", "quick-service"]
      },
      {
        id: "doubletree-seaworld-laguna",
        resortId: "doubletree-disney-springs",
        name: "Laguna Restaurant & Bar",
        description: "Modern American restaurant serving all-day dining with elevated yet laid-back atmosphere, featuring steak, seafood, and kids menu with pool views.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        cuisineType: "Modern American",
        location: "Main Building, Ground Floor",
        operatingHours: {
          breakfast: "6:30 AM - 11:00 AM",
          lunch: "11:30 AM - 5:00 PM",
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 30,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          allDayDining: true,
          modernAmerican: true,
          poolViews: true,
          patioSeating: true,
          elevatedCasual: true
        },
        tips: [
          {
            id: "laguna-tip-1",
            category: "general",
            content: "Elevated yet laid-back modern American fare with pool views",
            priority: 4
          },
          {
            id: "laguna-tip-2",
            category: "general",
            content: "Features outdoor patio seating with ceiling fans",
            priority: 4
          },
          {
            id: "laguna-tip-3",
            category: "general",
            content: "All-day dining from breakfast through dinner with kids menu",
            priority: 3
          }
        ],
        tags: ["modern-american", "all-day-dining", "pool-views", "patio-seating", "family-friendly"]
      },
      {
        id: "doubletree-seaworld-albertos",
        resortId: "doubletree-disney-springs",
        name: "Alberto's Pizzeria",
        description: "Italian restaurant serving gourmet pizzas with made-from-scratch dough, soups, hot subs, and pasta, plus Starbucks coffee and pastries.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "Italian Pizza & Pasta",
        location: "Main Building, Ground Floor",
        operatingHours: {
          allDay: "11:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          gourmetPizza: true,
          scratchMadeDough: true,
          starbucksCoffee: true,
          takeOut: true,
          italianFavorites: true
        },
        tips: [
          {
            id: "albertos-tip-1",
            category: "general",
            content: "Gourmet pizzas made with fresh, from-scratch dough",
            priority: 4
          },
          {
            id: "albertos-tip-2",
            category: "general",
            content: "Also serves Starbucks coffee, pastries, and desserts",
            priority: 4
          },
          {
            id: "albertos-tip-3",
            category: "strategy",
            content: "Perfect for dine-in or take-out pizza and Italian favorites",
            priority: 3
          }
        ],
        tags: ["gourmet-pizza", "italian", "starbucks", "take-out", "scratch-made"]
      },
      {
        id: "doubletree-seaworld-sonoma-lounge",
        resortId: "doubletree-disney-springs",
        name: "Sonoma Lounge",
        description: "Relaxed lobby lounge offering light bites, fine wines, and cocktails in a comfortable setting perfect for easy evenings.",
        type: "lounge",
        serviceType: "lounge",
        priceLevel: 2,
        cuisineType: "Wine & Light Bites",
        location: "Main Building, Lobby Level",
        operatingHours: {
          evening: "4:00 PM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          lobbyLounge: true,
          fineWines: true,
          lightBites: true,
          relaxedSetting: true,
          comfortableSetting: true
        },
        tips: [
          {
            id: "sonoma-tip-1",
            category: "general",
            content: "Relaxed lobby lounge with fine wines and light bites",
            priority: 4
          },
          {
            id: "sonoma-tip-2",
            category: "strategy",
            content: "Perfect for easy evenings with comfortable seating",
            priority: 3
          }
        ],
        tags: ["lobby-lounge", "fine-wines", "light-bites", "relaxed", "comfortable"]
      },
      {
        id: "doubletree-seaworld-barefoot-bar",
        resortId: "doubletree-disney-springs",
        name: "Barefoot Bar",
        description: "Festive poolside bar located at the edge of the Lagoon Pool, serving frozen specialties, tropical cocktails, and light fare.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside Tropical",
        location: "Lagoon Pool Area",
        operatingHours: {
          seasonal: "11:00 AM - 7:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          frozenSpecialties: true,
          tropicalCocktails: true,
          festiveBar: true,
          lagoonPool: true
        },
        tips: [
          {
            id: "barefoot-bar-tip-1",
            category: "general",
            content: "Festive poolside bar with frozen specialties and tropical drinks",
            priority: 4
          },
          {
            id: "barefoot-bar-tip-2",
            category: "general",
            content: "Located at the edge of the resort's beautiful Lagoon Pool",
            priority: 3
          }
        ],
        tags: ["poolside", "frozen-specialties", "tropical-cocktails", "festive", "lagoon-pool"]
      },
      {
        id: "swan-hotel-il-mulino",
        resortId: "swan-hotel",
        name: "Il Mulino New York Trattoria",
        description: "Traditional Italian cuisine from the Abruzzi region served in a lively bistro environment, inspired by the #1 Italian restaurant in NYC according to Zagat.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Traditional Italian",
        location: "Main Building, Ground Floor",
        operatingHours: {
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          traditionalItalian: true,
          abruzziRegion: true,
          livelyBistro: true,
          zagatRated: true
        },
        tips: [
          {
            id: "il-mulino-tip-1",
            category: "general",
            content: "Inspired by NYC's #1 Italian restaurant according to Zagat for two decades",
            priority: 5
          },
          {
            id: "il-mulino-tip-2",
            category: "general",
            content: "Traditional Italian cuisine from the Abruzzi region in lively bistro setting",
            priority: 4
          },
          {
            id: "il-mulino-tip-3",
            category: "strategy",
            content: "Does not accept Disney Dining Plan - make reservations through Swan/Dolphin",
            priority: 4
          }
        ],
        tags: ["signature-dining", "traditional-italian", "zagat-rated", "abruzzi", "lively-bistro"]
      },
      {
        id: "swan-hotel-shulas",
        resortId: "swan-hotel",
        name: "Shula's Steak House",
        description: "Elegant steakhouse featuring premium steak and seafood with the famous 48-ounce porterhouse challenge and 2003 Award of Excellence.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Premium Steakhouse",
        location: "Main Building, Ground Floor",
        operatingHours: {
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          elegantSteakhouse: true,
          "48ozChallenge": true,
          awardWinning: true,
          premiumCuts: true
        },
        tips: [
          {
            id: "shulas-tip-1",
            category: "general",
            content: "Famous 48-ounce porterhouse challenge - join Shula's 48oz. Club if you finish!",
            priority: 5
          },
          {
            id: "shulas-tip-2",
            category: "general",
            content: "2003 Award of Excellence recipient for elegant steakhouse dining",
            priority: 4
          },
          {
            id: "shulas-tip-3",
            category: "strategy",
            content: "Perfect for special occasions and steak enthusiasts",
            priority: 4
          }
        ],
        tags: ["signature-dining", "steakhouse", "48oz-challenge", "award-winning", "elegant"]
      },
      {
        id: "swan-hotel-garden-grove",
        resortId: "swan-hotel",
        name: "Garden Grove",
        description: "American fare restaurant with Central Park garden atmosphere featuring a 25-foot oak tree with twinkling lights, serving breakfast, lunch, and dinner.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 2,
        cuisineType: "American Garden Dining",
        location: "Main Building, Ground Floor",
        operatingHours: {
          breakfast: "6:30 AM - 11:00 AM",
          lunch: "11:30 AM - 2:00 PM",
          dinner: "5:00 PM - 9:30 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          gardenAtmosphere: true,
          centralParkTheme: true,
          "25FootOakTree": true,
          twinklingLights: true,
          allDayDining: true
        },
        tips: [
          {
            id: "garden-grove-tip-1",
            category: "general",
            content: "Beautiful Central Park garden atmosphere with 25-foot oak tree centerpiece",
            priority: 5
          },
          {
            id: "garden-grove-tip-2",
            category: "general",
            content: "Tranquil setting with twinkling lights and paper lanterns",
            priority: 4
          },
          {
            id: "garden-grove-tip-3",
            category: "strategy",
            content: "Perfect for families wanting elegant but comfortable dining",
            priority: 4
          }
        ],
        tags: ["american-fare", "garden-atmosphere", "central-park", "oak-tree", "family-friendly"]
      },
      {
        id: "swan-hotel-bourbon-steak",
        resortId: "swan-hotel",
        name: "Bourbon Steak by Michael Mina",
        description: "New modern steakhouse opened July 2025 by Michelin-starred chef Michael Mina, featuring premium beef and seafood with global flavors.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Modern American Steakhouse",
        location: "Main Building, Ground Floor",
        operatingHours: {
          dinner: "5:30 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          newOpening2025: true,
          michelinStarredChef: true,
          modernSteakhouse: true,
          globalFlavors: true
        },
        tips: [
          {
            id: "bourbon-steak-tip-1",
            category: "strategy",
            content: "NEW 2025 - Opened July 26th by renowned chef Michael Mina",
            priority: 5
          },
          {
            id: "bourbon-steak-tip-2",
            category: "general",
            content: "Michelin-starred chef with restaurants nationwide",
            priority: 5
          },
          {
            id: "bourbon-steak-tip-3",
            category: "general",
            content: "Modern take on American steakhouse with premium cuts and global flavors",
            priority: 4
          }
        ],
        tags: ["signature-dining", "new-2025", "michelin-chef", "modern-steakhouse", "global-flavors"]
      },
      {
        id: "dolphin-hotel-bluezoo",
        resortId: "dolphin-hotel",
        name: "Todd English's bluezoo",
        description: "Award-winning restaurant by celebrity chef Todd English featuring fresh seafood in a chic underwater setting with backlit blue bar and live entertainment.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Contemporary Seafood",
        location: "Main Building, Ground Floor",
        operatingHours: {
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          celebrityChef: true,
          underwaterSetting: true,
          backlitBar: true,
          liveEntertainment: true,
          awardWinning: true
        },
        tips: [
          {
            id: "bluezoo-tip-1",
            category: "general",
            content: "Created by celebrity chef Todd English with chic underwater atmosphere",
            priority: 5
          },
          {
            id: "bluezoo-tip-2",
            category: "general",
            content: "Famous for fresh seafood and signature cocktails like Bazooka Joe Vodka",
            priority: 4
          },
          {
            id: "bluezoo-tip-3",
            category: "general",
            content: "Features live entertainment seasonally and unique blue backlit bar",
            priority: 4
          }
        ],
        tags: ["signature-dining", "celebrity-chef", "seafood", "underwater-theme", "live-entertainment"]
      },
      {
        id: "dolphin-hotel-kimonos",
        resortId: "dolphin-hotel",
        name: "Kimonos",
        description: "Award-winning sushi restaurant and lounge voted top sushi by Orlando Sentinel, featuring traditional Japanese cuisine, karaoke, and Kobe beef satay.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 4,
        cuisineType: "Traditional Japanese Sushi",
        location: "Main Building, Ground Floor",
        operatingHours: {
          dinner: "5:30 PM - 12:00 AM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          awardWinningSushi: true,
          karaoke: true,
          kobeBeef: true,
          traditionalJapanese: true
        },
        tips: [
          {
            id: "kimonos-tip-1",
            category: "general",
            content: "Voted top sushi restaurant by Orlando Sentinel readers",
            priority: 5
          },
          {
            id: "kimonos-tip-2",
            category: "general",
            content: "Features karaoke every evening starting at 9:30 PM",
            priority: 4
          },
          {
            id: "kimonos-tip-3",
            category: "general",
            content: "Specialties include Kobe beef satay, gyoza, and tempura platters",
            priority: 4
          }
        ],
        tags: ["signature-dining", "sushi", "award-winning", "karaoke", "japanese"]
      },
      {
        id: "dolphin-hotel-rosa-mexicano",
        resortId: "dolphin-hotel",
        name: "Rosa Mexicano",
        description: "Stylish Mexican restaurant offering fresh authentic cuisine with award-winning margaritas including the signature frozen pomegranate margarita.",
        type: "table_service",
        serviceType: "table",
        priceLevel: 3,
        cuisineType: "Authentic Mexican",
        location: "Main Building, Ground Floor",
        operatingHours: {
          lunch: "11:30 AM - 3:00 PM",
          dinner: "5:00 PM - 10:00 PM"
        },
        reservationWindow: 60,
        adrRequired: true,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian", "gluten-free"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          signatureDining: true,
          "authentically Mexican": true,
          awardWinningMargaritas: true,
          stylishFestive: true,
          frozenPomegranate: true
        },
        tips: [
          {
            id: "rosa-mexicano-tip-1",
            category: "general",
            content: "Award-winning margaritas - try the signature frozen pomegranate",
            priority: 5
          },
          {
            id: "rosa-mexicano-tip-2",
            category: "general",
            content: "Fresh authentic Mexican cuisine in stylish festive atmosphere",
            priority: 4
          },
          {
            id: "rosa-mexicano-tip-3",
            category: "general",
            content: "Beloved classics and sophisticated dishes for all tastes",
            priority: 4
          }
        ],
        tags: ["mexican", "award-winning-margaritas", "authentic", "stylish", "festive"]
      },
      {
        id: "dolphin-hotel-phins",
        resortId: "dolphin-hotel",
        name: "Phins",
        description: "Casual poolside dining serving American favorites with tropical drinks and light fare in a relaxed pool atmosphere.",
        type: "quick_service",
        serviceType: "poolside",
        priceLevel: 2,
        cuisineType: "Poolside American",
        location: "Pool Area",
        operatingHours: {
          lunch: "11:00 AM - 6:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: true,
        features: {
          poolside: true,
          americanFavorites: true,
          tropicalDrinks: true,
          casualDining: true,
          lightFare: true
        },
        tips: [
          {
            id: "phins-tip-1",
            category: "general",
            content: "Casual poolside dining with American favorites and tropical drinks",
            priority: 4
          },
          {
            id: "phins-tip-2",
            category: "strategy",
            content: "Perfect for staying poolside all day with food and beverage service",
            priority: 3
          }
        ],
        tags: ["poolside", "american-favorites", "tropical-drinks", "casual", "light-fare"]
      },
      {
        id: "dolphin-hotel-fountain",
        resortId: "dolphin-hotel",
        name: "The Fountain",
        description: "Classic American diner and soda fountain serving burgers, sandwiches, ice cream sundaes, and milkshakes in a nostalgic family-friendly setting.",
        type: "quick_service",
        serviceType: "counter",
        priceLevel: 2,
        cuisineType: "American Diner",
        location: "Main Building, Ground Floor",
        operatingHours: {
          allDay: "11:00 AM - 11:00 PM"
        },
        reservationWindow: 0,
        adrRequired: false,
        mobileOrderAvailable: false,
        allergyFriendly: ["vegetarian"],
        kidFriendly: true,
        alcoholServed: false,
        features: {
          classicDiner: true,
          sodaFountain: true,
          iceCreamSundaes: true,
          milkshakes: true,
          nostalgicSetting: true
        },
        tips: [
          {
            id: "fountain-tip-1",
            category: "general",
            content: "Classic American diner with soda fountain and ice cream sundaes",
            priority: 4
          },
          {
            id: "fountain-tip-2",
            category: "strategy",
            content: "Perfect for families wanting casual dining and sweet treats",
            priority: 4
          },
          {
            id: "fountain-tip-3",
            category: "general",
            content: "Nostalgic atmosphere with burgers, sandwiches, and milkshakes",
            priority: 3
          }
        ],
        tags: ["american-diner", "soda-fountain", "ice-cream", "milkshakes", "family-friendly"]
      }
    ];
  }
});

// src/data/eat/index.ts
var eat_exports = {};
__export(eat_exports, {
  disneyResortDining: () => disneyResortDining,
  getAllEatItems: () => getAllEatItems,
  getCharacterDining: () => getCharacterDining,
  getEatItemById: () => getEatItemById,
  getEatItemsByCuisine: () => getEatItemsByCuisine,
  getEatItemsByPark: () => getEatItemsByPark,
  getEatItemsByPriceLevel: () => getEatItemsByPriceLevel,
  getEatItemsByResort: () => getEatItemsByResort,
  getEatItemsByType: () => getEatItemsByType,
  getLoungesByResort: () => getLoungesByResort,
  getQuickServiceByResort: () => getQuickServiceByResort,
  getResortDiningByResortId: () => getResortDiningByResortId,
  getSignatureDining: () => getSignatureDining,
  getTableServiceByResort: () => getTableServiceByResort,
  lounges: () => lounges,
  otherHotelsDining: () => otherHotelsDining,
  quickServiceRestaurants: () => quickServiceRestaurants,
  resortDining: () => resortDining,
  snackStands: () => snackStands,
  tableServiceRestaurants: () => tableServiceRestaurants,
  universalResortDining: () => universalResortDining
});
var quickServiceRestaurants, tableServiceRestaurants, snackStands, lounges, resortDining, disneyResortDining, universalResortDining, otherHotelsDining, getAllEatItems, getEatItemsByPark, getEatItemsByResort, getEatItemsByType, getEatItemsByCuisine, getEatItemsByPriceLevel, getEatItemById, getResortDiningByResortId, getSignatureDining, getCharacterDining, getQuickServiceByResort, getTableServiceByResort, getLoungesByResort;
var init_eat = __esm({
  "src/data/eat/index.ts"() {
    "use strict";
    init_magic_kingdom_quick_service();
    init_epcot_quick_service();
    init_hollywood_studios_quick_service();
    init_animal_kingdom_quick_service();
    init_magic_kingdom_table_service();
    init_epcot_table_service();
    init_hollywood_studios_table_service();
    init_animal_kingdom_table_service();
    init_magic_kingdom_snacks();
    init_epcot_snacks();
    init_hollywood_studios_snacks();
    init_animal_kingdom_snacks();
    init_magic_kingdom_lounges();
    init_epcot_lounges();
    init_hollywood_studios_lounges();
    init_animal_kingdom_lounges();
    init_disney_resorts_dining();
    init_universal_resorts_dining();
    init_other_hotels_dining();
    quickServiceRestaurants = [
      ...magic_kingdom_quick_service_default,
      ...epcot_quick_service_default,
      ...hollywood_studios_quick_service_default,
      ...animal_kingdom_quick_service_default
    ];
    tableServiceRestaurants = [
      ...magic_kingdom_table_service_default,
      ...epcot_table_service_default,
      ...hollywood_studios_table_service_default,
      ...animal_kingdom_table_service_default
    ];
    snackStands = [
      ...magic_kingdom_snacks_default,
      ...epcot_snacks_default,
      ...hollywood_studios_snacks_default,
      ...animal_kingdom_snacks_default
    ];
    lounges = [
      ...magic_kingdom_lounges_default,
      ...epcot_lounges_default,
      ...hollywood_studios_lounges_default,
      ...animal_kingdom_lounges_default
    ];
    resortDining = [
      ...disney_resorts_dining_default,
      ...universal_resorts_dining_default,
      ...other_hotels_dining_default
    ];
    disneyResortDining = disney_resorts_dining_default;
    universalResortDining = universal_resorts_dining_default;
    otherHotelsDining = other_hotels_dining_default;
    getAllEatItems = () => {
      return [...quickServiceRestaurants, ...tableServiceRestaurants, ...snackStands, ...lounges, ...resortDining];
    };
    getEatItemsByPark = (parkId) => {
      return getAllEatItems().filter((item) => item.parkId === parkId);
    };
    getEatItemsByResort = (resortId) => {
      return getAllEatItems().filter((item) => item.resortId === resortId);
    };
    getEatItemsByType = (type) => {
      return getAllEatItems().filter((item) => item.type === type);
    };
    getEatItemsByCuisine = (cuisineType) => {
      return getAllEatItems().filter((item) => item.cuisineType.toLowerCase().includes(cuisineType.toLowerCase()));
    };
    getEatItemsByPriceLevel = (priceLevel) => {
      return getAllEatItems().filter((item) => item.priceLevel === priceLevel);
    };
    getEatItemById = (id) => {
      return getAllEatItems().find((item) => item.id === id);
    };
    getResortDiningByResortId = (resortId) => {
      return resortDining.filter((item) => item.resortId === resortId);
    };
    getSignatureDining = () => {
      return getAllEatItems().filter((item) => item.features?.fineDining || item.priceLevel === 4);
    };
    getCharacterDining = () => {
      return getAllEatItems().filter((item) => item.features?.characterDining);
    };
    getQuickServiceByResort = (resortId) => {
      return resortDining.filter((item) => item.resortId === resortId && item.type === "quick_service");
    };
    getTableServiceByResort = (resortId) => {
      return resortDining.filter((item) => item.resortId === resortId && item.type === "table_service");
    };
    getLoungesByResort = (resortId) => {
      return resortDining.filter((item) => item.resortId === resortId && item.type === "lounge");
    };
  }
});

// src/types/index.ts
var AttractionType = /* @__PURE__ */ ((AttractionType2) => {
  AttractionType2["RIDE"] = "ride";
  AttractionType2["SHOW"] = "show";
  AttractionType2["MEET_GREET"] = "meet_greet";
  AttractionType2["ATTRACTION"] = "attraction";
  AttractionType2["DINING"] = "dining";
  AttractionType2["SHOPPING"] = "shopping";
  return AttractionType2;
})(AttractionType || {});
var IntensityLevel = /* @__PURE__ */ ((IntensityLevel2) => {
  IntensityLevel2["LOW"] = "low";
  IntensityLevel2["MODERATE"] = "moderate";
  IntensityLevel2["HIGH"] = "high";
  IntensityLevel2["EXTREME"] = "extreme";
  return IntensityLevel2;
})(IntensityLevel || {});
var TipCategory = /* @__PURE__ */ ((TipCategory2) => {
  TipCategory2["BEST_TIME"] = "best_time";
  TipCategory2["STRATEGY"] = "strategy";
  TipCategory2["ACCESSIBILITY"] = "accessibility";
  TipCategory2["PHOTO"] = "photo";
  TipCategory2["DINING"] = "dining";
  TipCategory2["GENERAL"] = "general";
  return TipCategory2;
})(TipCategory || {});
var ViewMode = /* @__PURE__ */ ((ViewMode2) => {
  ViewMode2["LIST"] = "list";
  ViewMode2["CARD"] = "card";
  ViewMode2["CALENDAR"] = "calendar";
  return ViewMode2;
})(ViewMode || {});
var Theme = /* @__PURE__ */ ((Theme2) => {
  Theme2["LIGHT"] = "light";
  Theme2["DARK"] = "dark";
  Theme2["SYSTEM"] = "system";
  return Theme2;
})(Theme || {});

// src/utils/date.ts
import { format, parseISO, differenceInDays, addDays, isValid } from "date-fns";
var formatDate = (date, formatString = "MMM d, yyyy") => {
  const dateObj = typeof date === "string" ? parseISO(date) : date;
  return isValid(dateObj) ? format(dateObj, formatString) : "";
};
var formatTime = (time) => {
  const [hoursStr, minutesStr] = time.split(":");
  const hours = Number(hoursStr);
  const minutes = Number(minutesStr);
  if (isNaN(hours) || isNaN(minutes) || hours > 23 || hours < 0 || minutes > 59 || minutes < 0) {
    return time;
  }
  const period = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;
  return `${displayHours}:${minutes.toString().padStart(2, "0")} ${period}`;
};
var getDaysBetween = (startDate, endDate) => {
  return differenceInDays(parseISO(endDate), parseISO(startDate)) + 1;
};
var getTripDates = (startDate, numberOfDays) => {
  const dates = [];
  const start = parseISO(startDate);
  for (let i = 0; i < numberOfDays; i++) {
    dates.push(format(addDays(start, i), "yyyy-MM-dd"));
  }
  return dates;
};
var getCountdownDays = (tripDate) => {
  const today = /* @__PURE__ */ new Date();
  today.setHours(0, 0, 0, 0);
  const trip = parseISO(tripDate);
  trip.setHours(0, 0, 0, 0);
  const days = differenceInDays(trip, today);
  return Math.max(0, days);
};
var formatDuration = (minutes) => {
  if (minutes < 60) {
    return `${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (remainingMinutes === 0) {
    return `${hours} hr`;
  }
  return `${hours} hr ${remainingMinutes} min`;
};

// src/utils/export.ts
var exportToText = (data, includeNotes = true, includeTips = false) => {
  const { trip, parks: parks2, attractions } = data;
  const lines = [];
  lines.push(`\u{1F3A2} ${trip.name}`);
  lines.push(`${formatDate(trip.startDate)} - ${formatDate(trip.endDate)}`);
  lines.push("\u2550".repeat(40));
  lines.push("");
  trip.days.forEach((day, dayIndex) => {
    const park = parks2.find((p) => p.id === day.parkId);
    lines.push(`Day ${dayIndex + 1}: ${formatDate(day.date, "EEEE, MMM d")}`);
    lines.push(`\u{1F4CD} ${park?.name || "Unknown Park"}`);
    if (includeNotes && day.notes) {
      lines.push(`Notes: ${day.notes}`);
    }
    lines.push("\u2500".repeat(30));
    const sortedItems = [...day.items].sort((a, b) => a.order - b.order);
    sortedItems.forEach((item, index) => {
      const attraction = attractions.find((a) => a.id === item.attractionId);
      if (!attraction) return;
      const checkmark = item.completed ? "\u2713" : "\u25CB";
      const timeStr = item.timeSlot ? `${formatTime(item.timeSlot)} - ` : "";
      const duration = formatDuration(item.duration || attraction.duration);
      lines.push(`${checkmark} ${index + 1}. ${timeStr}${attraction.name} (${duration})`);
      if (includeNotes && item.notes) {
        lines.push(`   Note: ${item.notes}`);
      }
      if (includeTips && attraction.tips.length > 0) {
        const topTip = attraction.tips.sort((a, b) => b.priority - a.priority)[0];
        if (topTip) {
          lines.push(`   \u{1F4A1} ${topTip.content}`);
        }
      }
    });
    lines.push("");
  });
  lines.push("\u2500".repeat(40));
  lines.push("Created with Waylight \u2728");
  lines.push(`Exported on ${formatDate(/* @__PURE__ */ new Date())}`);
  return lines.join("\n");
};
var exportToJSON = (data) => {
  return JSON.stringify(data, null, 2);
};
var generateShareText = (trip, park) => {
  const days = trip.days.length;
  const totalAttractions = trip.days.reduce((sum, day) => sum + day.items.length, 0);
  if (park) {
    const dayWithPark = trip.days.find((d) => d.parkId === park.id);
    const attractionCount = dayWithPark?.items.length || 0;
    return `Check out my ${park.name} plan for ${formatDate(dayWithPark?.date || trip.startDate)}! ${attractionCount} attractions planned. Created with Waylight \u{1F3A2}`;
  }
  return `My ${days}-day theme park trip starts ${formatDate(trip.startDate)}! ${totalAttractions} attractions planned across ${days} parks. Created with Waylight \u{1F3A2}`;
};

// src/utils/trip.ts
var createTrip = (name, startDate, endDate) => {
  const tripDates = getTripDates(startDate, Math.ceil((new Date(endDate).getTime() - new Date(startDate).getTime()) / (1e3 * 60 * 60 * 24)) + 1);
  const trip = {
    id: generateTripId(),
    name,
    startDate,
    endDate,
    days: tripDates.map((date) => ({
      id: generateDayId(),
      date,
      parkId: "",
      // To be set by user
      items: [],
      notes: void 0
    })),
    notes: void 0,
    createdAt: (/* @__PURE__ */ new Date()).toISOString(),
    updatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
  return trip;
};
var updateTrip = (trip, updates) => {
  return {
    ...trip,
    ...updates,
    updatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
};
var addDayToTrip = (trip, date, parkId) => {
  const newDay = {
    id: generateDayId(),
    date,
    parkId: parkId || "",
    items: []
  };
  const days = [...trip.days, newDay].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
  );
  return updateTrip(trip, { days });
};
var updateTripDay = (trip, dayId, updates) => {
  const days = trip.days.map(
    (day) => day.id === dayId ? { ...day, ...updates } : day
  );
  return updateTrip(trip, { days });
};
var addItemToDay = (trip, dayId, attractionId, options) => {
  const day = trip.days.find((d) => d.id === dayId);
  if (!day) {
    throw new Error(`Day with id ${dayId} not found`);
  }
  const newItem = {
    id: generateItemId(),
    attractionId,
    order: day.items.length + 1,
    timeSlot: options?.timeSlot,
    duration: options?.duration,
    notes: options?.notes,
    completed: false
  };
  const updatedDay = {
    ...day,
    items: [...day.items, newItem]
  };
  return updateTripDay(trip, dayId, updatedDay);
};
var removeItemFromDay = (trip, dayId, itemId) => {
  const day = trip.days.find((d) => d.id === dayId);
  if (!day) {
    throw new Error(`Day with id ${dayId} not found`);
  }
  const items = day.items.filter((item) => item.id !== itemId).map((item, index) => ({ ...item, order: index + 1 }));
  return updateTripDay(trip, dayId, { items });
};
var reorderDayItems = (trip, dayId, newOrder) => {
  const day = trip.days.find((d) => d.id === dayId);
  if (!day) {
    throw new Error(`Day with id ${dayId} not found`);
  }
  const itemsMap = new Map(day.items.map((item) => [item.id, item]));
  const reorderedItems = newOrder.map((itemId) => itemsMap.get(itemId)).filter((item) => item !== void 0).map((item, index) => ({ ...item, order: index + 1 }));
  return updateTripDay(trip, dayId, { items: reorderedItems });
};
var toggleItemCompleted = (trip, dayId, itemId) => {
  const day = trip.days.find((d) => d.id === dayId);
  if (!day) {
    throw new Error(`Day with id ${dayId} not found`);
  }
  const items = day.items.map(
    (item) => item.id === itemId ? { ...item, completed: !item.completed } : item
  );
  return updateTripDay(trip, dayId, { items });
};
var getTripStats = (trip) => {
  const totalDays = trip.days.length;
  const totalItems = trip.days.reduce((sum, day) => sum + day.items.length, 0);
  const completedItems = trip.days.reduce(
    (sum, day) => sum + day.items.filter((item) => item.completed).length,
    0
  );
  const completionPercentage = totalItems > 0 ? Math.round(completedItems / totalItems * 100) : 0;
  const daysWithPlans = trip.days.filter((day) => day.items.length > 0).length;
  const daysWithParks = trip.days.filter((day) => day.parkId).length;
  return {
    totalDays,
    totalItems,
    completedItems,
    completionPercentage,
    daysWithPlans,
    daysWithParks,
    averageItemsPerDay: totalDays > 0 ? Math.round(totalItems / totalDays) : 0
  };
};
var duplicateTrip = (trip, newName) => {
  return {
    ...trip,
    id: generateTripId(),
    name: newName,
    days: trip.days.map((day) => ({
      ...day,
      id: generateDayId(),
      items: day.items.map((item) => ({
        ...item,
        id: generateItemId(),
        completed: false
        // Reset completion status
      }))
    })),
    createdAt: (/* @__PURE__ */ new Date()).toISOString(),
    updatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
};
function generateTripId() {
  return `trip_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
function generateDayId() {
  return `day_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
function generateItemId() {
  return `item_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

// src/utils/validation.ts
var validateTrip = (trip) => {
  const errors = [];
  const warnings = [];
  if (!trip.name || trip.name.trim().length === 0) {
    errors.push("Trip name is required");
  }
  if (trip.name.length > 100) {
    errors.push("Trip name must be 100 characters or less");
  }
  const startDate = new Date(trip.startDate);
  const endDate = new Date(trip.endDate);
  if (isNaN(startDate.getTime())) {
    errors.push("Invalid start date");
  }
  if (isNaN(endDate.getTime())) {
    errors.push("Invalid end date");
  }
  if (startDate >= endDate) {
    errors.push("End date must be after start date");
  }
  const daysDifference = Math.ceil((endDate.getTime() - startDate.getTime()) / (1e3 * 60 * 60 * 24));
  if (daysDifference > 14) {
    warnings.push("Trips longer than 14 days may be difficult to manage");
  }
  if (daysDifference > 30) {
    errors.push("Trip duration cannot exceed 30 days");
  }
  if (trip.days.length === 0) {
    errors.push("Trip must have at least one day");
  }
  trip.days.forEach((day, index) => {
    const dayValidation = validateTripDay(day, index + 1);
    errors.push(...dayValidation.errors);
    warnings.push(...dayValidation.warnings);
  });
  const dates = trip.days.map((day) => day.date);
  const uniqueDates = new Set(dates);
  if (dates.length !== uniqueDates.size) {
    errors.push("Trip cannot have duplicate dates");
  }
  return {
    isValid: errors.length === 0,
    errors,
    warnings
  };
};
var validateTripDay = (day, dayNumber) => {
  const errors = [];
  const warnings = [];
  const prefix = dayNumber ? `Day ${dayNumber}: ` : "";
  const dayDate = new Date(day.date);
  if (isNaN(dayDate.getTime())) {
    errors.push(`${prefix}Invalid date`);
  }
  if (!day.parkId && day.items.length > 0) {
    warnings.push(`${prefix}No park selected but attractions are planned`);
  }
  if (day.items.length > 20) {
    warnings.push(`${prefix}${day.items.length} attractions may be too many for one day`);
  }
  if (day.items.length > 30) {
    errors.push(`${prefix}Cannot have more than 30 attractions per day`);
  }
  day.items.forEach((item, index) => {
    const itemValidation = validateItineraryItem(item, index + 1, dayNumber);
    errors.push(...itemValidation.errors);
    warnings.push(...itemValidation.warnings);
  });
  const attractionIds = day.items.map((item) => item.attractionId);
  const uniqueAttractions = new Set(attractionIds);
  if (attractionIds.length !== uniqueAttractions.size) {
    warnings.push(`${prefix}Duplicate attractions found`);
  }
  const expectedOrders = day.items.map((_, index) => index + 1);
  const actualOrders = day.items.map((item) => item.order).sort((a, b) => a - b);
  if (!arraysEqual(expectedOrders, actualOrders)) {
    errors.push(`${prefix}Item order is inconsistent`);
  }
  return {
    isValid: errors.length === 0,
    errors,
    warnings
  };
};
var validateItineraryItem = (item, itemNumber, dayNumber) => {
  const errors = [];
  const warnings = [];
  const prefix = dayNumber && itemNumber ? `Day ${dayNumber}, Item ${itemNumber}: ` : "";
  if (!item.attractionId) {
    errors.push(`${prefix}Attraction ID is required`);
  }
  if (item.order < 1) {
    errors.push(`${prefix}Order must be positive`);
  }
  if (item.timeSlot && !isValidTimeFormat(item.timeSlot)) {
    errors.push(`${prefix}Invalid time slot format (use HH:MM)`);
  }
  if (item.duration !== void 0) {
    if (item.duration < 1) {
      errors.push(`${prefix}Duration must be at least 1 minute`);
    }
    if (item.duration > 480) {
      warnings.push(`${prefix}Duration of ${item.duration} minutes seems very long`);
    }
  }
  if (item.notes && item.notes.length > 500) {
    warnings.push(`${prefix}Note is very long (${item.notes.length} characters)`);
  }
  return {
    isValid: errors.length === 0,
    errors,
    warnings
  };
};
var validateAttractionRequirements = (_item, attraction, guestAges) => {
  const errors = [];
  const warnings = [];
  if (attraction.heightRequirement && guestAges) {
    const hasChildren = guestAges.some((age) => age < 12);
    if (hasChildren && attraction.heightRequirement > 40) {
      warnings.push(`${attraction.name} has height requirement of ${attraction.heightRequirement}" - check if all guests meet requirement`);
    }
  }
  if (attraction.intensity === "extreme" /* EXTREME */ && guestAges) {
    const hasYoungGuests = guestAges.some((age) => age < 10);
    if (hasYoungGuests) {
      warnings.push(`${attraction.name} is marked as extreme intensity - may not be suitable for young guests`);
    }
  }
  return {
    isValid: errors.length === 0,
    errors,
    warnings
  };
};
var validateTimeConflicts = (day) => {
  const errors = [];
  const warnings = [];
  const itemsWithTime = day.items.filter((item) => item.timeSlot).sort((a, b) => (a.timeSlot || "").localeCompare(b.timeSlot || ""));
  for (let i = 0; i < itemsWithTime.length - 1; i++) {
    const current = itemsWithTime[i];
    const next = itemsWithTime[i + 1];
    if (current?.timeSlot && next?.timeSlot) {
      const currentEnd = addMinutesToTime(current.timeSlot, current.duration || 60);
      if (currentEnd > next.timeSlot) {
        warnings.push(`Time conflict: ${current.attractionId} may overlap with ${next.attractionId}`);
      }
    }
  }
  return {
    isValid: errors.length === 0,
    errors,
    warnings
  };
};
function isValidTimeFormat(time) {
  const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
  return timeRegex.test(time);
}
function addMinutesToTime(time, minutes) {
  const [hoursStr, minsStr] = time.split(":");
  const hours = Number(hoursStr);
  const mins = Number(minsStr);
  if (isNaN(hours) || isNaN(mins)) {
    return time;
  }
  const totalMinutes = hours * 60 + mins + minutes;
  const newHours = Math.floor(totalMinutes / 60) % 24;
  const newMins = totalMinutes % 60;
  return `${newHours.toString().padStart(2, "0")}:${newMins.toString().padStart(2, "0")}`;
}
function arraysEqual(a, b) {
  return a.length === b.length && a.every((val, index) => val === b[index]);
}

// src/storage/interface.ts
var BaseStorageAdapter = class {
  async searchWaypoints(query, parkId) {
    const attractions = await this.getWaypoints(parkId);
    const searchTerm = query.toLowerCase();
    return attractions.filter(
      (attraction) => attraction.name.toLowerCase().includes(searchTerm) || attraction.description.toLowerCase().includes(searchTerm) || attraction.tags.some((tag) => tag.toLowerCase().includes(searchTerm))
    );
  }
};

// src/data/index.ts
init_parks();

// src/data/hotels/disney-resorts.json
var disney_resorts_default = [
  {
    id: "grand-floridian",
    name: "Disney's Grand Floridian Resort & Spa",
    address: "4401 Floridian Way, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe",
    description: "Victorian elegance with monorail access to Magic Kingdom",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 5, description: "Garden or lagoon view" },
      { id: "club-level", name: "Club Level Room", sleeps: 5, description: "Concierge level with lounge access" },
      { id: "suite", name: "Suite", sleeps: 5, description: "Spacious suite with separate living area" },
      { id: "presidential", name: "Presidential Suite", sleeps: 8, description: "Luxury multi-room suite" }
    ],
    features: {
      transportation: {
        monorail: true,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: true
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: true,
          steam_room: true
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: true,
          signature_dining: true
        },
        recreation: {
          beach: true,
          marina: true,
          boat_rentals: true,
          fishing: false,
          bike_rentals: false,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: true,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "grand-floridian-victoria-alberts",
      "grand-floridian-narcoossees",
      "grand-floridian-citricos",
      "grand-floridian-1900-park-fare",
      "grand-floridian-cafe",
      "grand-floridian-gasparilla-grill",
      "grand-floridian-enchanted-rose",
      "grand-floridian-citricos-lounge",
      "grand-floridian-beaches-pool-bar",
      "grand-floridian-courtyard-pool-bar"
    ]
  },
  {
    id: "polynesian",
    name: "Disney's Polynesian Village Resort",
    address: "1600 Seven Seas Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe",
    description: "South Pacific theming with monorail access and DVC bungalows",
    features: {
      transportation: {
        monorail: true,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: true,
          signature_dining: true
        },
        recreation: {
          beach: true,
          marina: true,
          boat_rentals: true,
          fishing: true,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: true,
          character_meet_greets: true,
          movies_under_stars: true,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: true,
        dvc: true,
        themedRooms: true,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "polynesian-ohana",
      "polynesian-kona-cafe",
      "polynesian-trader-sams-grog-grotto",
      "polynesian-captain-cooks",
      "polynesian-tambu-lounge",
      "polynesian-kona-island",
      "polynesian-pineapple-lanai",
      "polynesian-barefoot-pool-bar",
      "polynesian-oasis-pool-bar"
    ],
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 5, description: "Garden, lagoon, or theme park view" },
      { id: "club-level", name: "Club Level Room", sleeps: 5, description: "Concierge level with lounge access" },
      { id: "suite", name: "Suite", sleeps: 6, description: "One or two-bedroom suite" },
      { id: "bungalow", name: "Bungalow", sleeps: 8, description: "Over-the-water bungalow" }
    ]
  },
  {
    id: "polynesian-island-tower",
    name: "Island Tower at Disney's Polynesian Villas & Bungalows",
    address: "1600 Seven Seas Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe_villa",
    description: "Disney Vacation Club resort with South Pacific theming and monorail access, opened December 2024",
    features: {
      transportation: {
        monorail: true,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: true
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: true,
          marina: true,
          boat_rentals: true,
          fishing: true,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: true,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: true,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "polynesian-island-tower-wailulu"
    ],
    rooms: [
      { id: "duo-studio", name: "Duo Studio", sleeps: 3, description: "Studio villa with kitchenette and modern Polynesian theming" },
      { id: "1br-villa", name: "1 Bedroom Villa", sleeps: 5, description: "One-bedroom villa with full kitchen and washer/dryer" },
      { id: "2br-villa", name: "2 Bedroom Villa", sleeps: 9, description: "Two-bedroom villa with full kitchen and multiple bathrooms" }
    ]
  },
  {
    id: "contemporary",
    name: "Disney's Contemporary Resort",
    address: "4600 N World Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe",
    description: "Modern resort with monorail running through the building",
    features: {
      transportation: {
        monorail: true,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: true,
          signature_dining: true
        },
        recreation: {
          beach: true,
          marina: true,
          boat_rentals: true,
          fishing: false,
          bike_rentals: false,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "contemporary-california-grill",
      "contemporary-chef-mickeys",
      "contemporary-steakhouse-71",
      "contemporary-contempo-cafe",
      "contemporary-steakhouse-71-lounge"
    ],
    rooms: [
      { id: "standard-garden", name: "Standard Room - Garden Wing", sleeps: 5, description: "Garden wing with resort views" },
      { id: "standard-tower", name: "Standard Room - Tower", sleeps: 5, description: "Main tower with Magic Kingdom views" },
      { id: "club-level", name: "Club Level Room", sleeps: 5, description: "Concierge level in main tower" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Bay Lake Tower suite" }
    ]
  },
  {
    id: "wilderness-lodge",
    name: "Disney's Wilderness Lodge",
    address: "901 Timberline Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe",
    description: "Pacific Northwest lodge theming with boat transportation",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: true,
          signature_dining: true
        },
        recreation: {
          beach: true,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "wilderness-lodge-artist-point",
      "wilderness-lodge-whispering-canyon"
    ],
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Woods or courtyard view" },
      { id: "club-level", name: "Club Level Room", sleeps: 4, description: "Concierge level with lounge access" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Junior or presidential suite" }
    ]
  },
  {
    id: "boardwalk",
    name: "Disney's BoardWalk Inn",
    address: "2101 Epcot Resorts Blvd, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe",
    description: "1940s Atlantic City boardwalk theming with walking access to Epcot",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: true
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: true,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "boardwalk-flying-fish"
    ],
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 5, description: "Garden or BoardWalk view" },
      { id: "club-level", name: "Club Level Room", sleeps: 5, description: "Concierge level with lounge access" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Garden or BoardWalk view suite" }
    ]
  },
  {
    id: "yacht-club",
    name: "Disney's Yacht Club Resort",
    address: "1700 Epcot Resorts Blvd, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe",
    description: "New England yacht club theming with Stormalong Bay",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: true
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: true,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: true
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [],
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 5, description: "Garden or water view" },
      { id: "club-level", name: "Club Level Room", sleeps: 5, description: "Concierge level with lounge access" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Garden or water view suite" }
    ]
  },
  {
    id: "beach-club",
    name: "Disney's Beach Club Resort",
    address: "1800 Epcot Resorts Blvd, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe",
    description: "New England beach resort theming with Stormalong Bay",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: true
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: true,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: true
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [],
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 5, description: "Garden or water view" },
      { id: "club-level", name: "Club Level Room", sleeps: 5, description: "Concierge level with lounge access" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Garden or water view suite" }
    ]
  },
  {
    id: "animal-kingdom-lodge",
    name: "Disney's Animal Kingdom Lodge",
    address: "2901 Osceola Pkwy, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe",
    description: "African lodge theming with live animals on savannas. Jambo House guest rooms refurbishment scheduled May 2026 - January 2027.",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: true,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: true,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: true,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "animal-kingdom-lodge-jiko",
      "animal-kingdom-lodge-boma"
    ],
    rooms: [
      { id: "standard-value", name: "Standard Room - Value View", sleeps: 4, description: "Standard view room" },
      { id: "standard-savanna", name: "Standard Room - Savanna View", sleeps: 4, description: "Savanna view with animals" },
      { id: "club-level", name: "Club Level Room", sleeps: 4, description: "Concierge level with lounge access" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Vice presidential or presidential suite" }
    ]
  },
  {
    id: "port-orleans-french",
    name: "Disney's Port Orleans Resort - French Quarter",
    address: "2201 Orleans Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "moderate",
    description: "French Quarter theming with boat transportation to Disney Springs",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: false,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: true,
          boat_rentals: true,
          fishing: true,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: false,
        dvc: false,
        themedRooms: true,
        familyAccommodations: false
      }
    },
    diningOptions: [],
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "River or garden view" },
      { id: "royal", name: "Royal Guest Room", sleeps: 4, description: "Princess and the Frog themed room" }
    ]
  },
  {
    id: "port-orleans-riverside",
    name: "Disney's Port Orleans Resort - Riverside",
    address: "1251 Riverside Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "moderate",
    description: "Southern plantation and bayou theming with boat transportation",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: false,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: true,
          boat_rentals: true,
          fishing: true,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: false,
        dvc: false,
        themedRooms: true,
        familyAccommodations: false
      }
    },
    diningOptions: [],
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "River or garden view" },
      { id: "royal", name: "Royal Guest Room", sleeps: 4, description: "Princess and the Frog themed room" }
    ]
  },
  {
    id: "all-star-music",
    name: "Disney's All-Star Music Resort",
    address: "1801 W Buena Vista Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "value",
    description: "Music theming with giant musical instruments",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Music themed standard room" },
      { id: "family-suite", name: "Family Suite", sleeps: 6, description: "Suite with kitchenette" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: false,
          pool_bar: false,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: false,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: false,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: []
  },
  {
    id: "all-star-sports",
    name: "Disney's All-Star Sports Resort",
    address: "1701 W Buena Vista Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "value",
    description: "Sports theming with giant sports equipment decorations",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: false,
          pool_bar: false,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: false,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: false,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [],
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Sports themed standard room" },
      { id: "preferred", name: "Preferred Room", sleeps: 4, description: "Close to amenities" }
    ]
  },
  {
    id: "riviera",
    name: "Disney's Riviera Resort",
    address: "1080 Esplanade Ave, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe_villa",
    description: "European-inspired Disney Vacation Club resort with Skyliner access",
    features: {
      transportation: {
        monorail: false,
        skyliner: true,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [],
    rooms: [
      { id: "tower-studio", name: "Tower Studio", sleeps: 2, description: "Compact studio with kitchenette" },
      { id: "deluxe-studio", name: "Deluxe Studio", sleeps: 5, description: "Studio villa with kitchenette" },
      { id: "1br-villa", name: "One Bedroom Villa", sleeps: 5, description: "One-bedroom villa with full kitchen" },
      { id: "2br-villa", name: "Two Bedroom Villa", sleeps: 9, description: "Two-bedroom villa with full kitchen" },
      { id: "3br-villa", name: "Three Bedroom Grand Villa", sleeps: 12, description: "Three-bedroom grand villa with full kitchen" }
    ]
  },
  {
    id: "saratoga-springs",
    name: "Disney's Saratoga Springs Resort & Spa",
    address: "1960 Broadway, Lake Buena Vista, FL 32830",
    type: "disney",
    priceLevel: "deluxe_villa",
    description: "Victorian elegance inspired by Saratoga Springs, New York with boat access to Disney Springs",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: true,
          steam_room: true
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: true,
          walking_trails: true,
          golf: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [],
    rooms: [
      { id: "deluxe-studio", name: "Deluxe Studio", sleeps: 4, description: "Studio villa with kitchenette" },
      { id: "1br-villa", name: "One Bedroom Villa", sleeps: 4, description: "One-bedroom villa with full kitchen" },
      { id: "2br-villa", name: "Two Bedroom Villa", sleeps: 8, description: "Two-bedroom villa with full kitchen" },
      { id: "3br-villa", name: "Three Bedroom Grand Villa", sleeps: 12, description: "Three-bedroom grand villa with full kitchen" },
      { id: "treehouse-villa", name: "Treehouse Villa", sleeps: 6, description: "Secluded cabin-style villa in wooded setting" }
    ]
  },
  {
    id: "old-key-west",
    name: "Disney's Old Key West Resort",
    address: "1510 North Cove Rd, Lake Buena Vista, FL 32830",
    type: "disney",
    priceLevel: "deluxe_villa",
    description: "Key West island theming, Disney's original Disney Vacation Club resort",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: true,
          boat_rentals: true,
          fishing: true,
          bike_rentals: true,
          walking_trails: true,
          golf: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [],
    rooms: [
      { id: "deluxe-studio", name: "Deluxe Studio", sleeps: 4, description: "Studio villa with kitchenette" },
      { id: "1br-villa", name: "One Bedroom Villa", sleeps: 4, description: "One-bedroom villa with full kitchen" },
      { id: "2br-villa", name: "Two Bedroom Villa", sleeps: 8, description: "Two-bedroom villa with full kitchen" },
      { id: "3br-villa", name: "Three Bedroom Grand Villa", sleeps: 12, description: "Three-bedroom grand villa with full kitchen" }
    ]
  },
  {
    id: "fort-wilderness-cabins",
    name: "The Cabins at Disney's Fort Wilderness Resort",
    address: "4510 N Fort Wilderness Trail, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "moderate",
    description: "Rustic cabins in a wooded campground setting with boat access to Magic Kingdom",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: false,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: false,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: false,
          room_service: false,
          character_dining: true,
          signature_dining: false
        },
        recreation: {
          beach: true,
          marina: false,
          boat_rentals: true,
          fishing: true,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: true,
          character_meet_greets: false,
          movies_under_stars: true,
          campfire: true
        }
      },
      accommodations: {
        suites: false,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [],
    rooms: [
      { id: "cabin", name: "Wilderness Cabin", sleeps: 6, description: "Rustic cabin with full kitchen and deck" }
    ]
  },
  {
    id: "grand-floridian-villas",
    name: "The Villas at Disney's Grand Floridian Resort & Spa",
    address: "4401 Floridian Way, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe_villa",
    description: "Victorian elegance with monorail access and DVC accommodations at Grand Floridian",
    features: {
      transportation: {
        monorail: true,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: true
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: true,
          steam_room: true
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: true,
          signature_dining: true
        },
        recreation: {
          beach: true,
          marina: true,
          boat_rentals: true,
          fishing: false,
          bike_rentals: false,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: true,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "grand-floridian-victoria-alberts",
      "grand-floridian-narcoossees",
      "grand-floridian-citricos",
      "grand-floridian-1900-park-fare",
      "grand-floridian-cafe",
      "grand-floridian-gasparilla-grill",
      "grand-floridian-enchanted-rose",
      "grand-floridian-citricos-lounge",
      "grand-floridian-beaches-pool-bar",
      "grand-floridian-courtyard-pool-bar"
    ],
    rooms: [
      { id: "deluxe-studio", name: "Deluxe Studio", sleeps: 5, description: "Studio villa with kitchenette" },
      { id: "1br-villa", name: "One Bedroom Villa", sleeps: 5, description: "One-bedroom villa with full kitchen" },
      { id: "2br-villa", name: "Two Bedroom Villa", sleeps: 9, description: "Two-bedroom villa with full kitchen" },
      { id: "3br-villa", name: "Three Bedroom Grand Villa", sleeps: 12, description: "Three-bedroom grand villa with full kitchen" }
    ]
  },
  {
    id: "bay-lake-tower",
    name: "Bay Lake Tower at Disney's Contemporary Resort",
    address: "4600 N World Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe_villa",
    description: "Modern DVC resort adjacent to Contemporary Resort with monorail access",
    features: {
      transportation: {
        monorail: true,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: true,
          signature_dining: true
        },
        recreation: {
          beach: true,
          marina: true,
          boat_rentals: true,
          fishing: false,
          bike_rentals: false,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "contemporary-california-grill",
      "contemporary-chef-mickeys",
      "contemporary-steakhouse-71",
      "contemporary-contempo-cafe",
      "contemporary-steakhouse-71-lounge"
    ],
    rooms: [
      { id: "deluxe-studio", name: "Deluxe Studio", sleeps: 4, description: "Studio villa with kitchenette" },
      { id: "1br-villa", name: "One Bedroom Villa", sleeps: 4, description: "One-bedroom villa with full kitchen" },
      { id: "2br-villa", name: "Two Bedroom Villa", sleeps: 8, description: "Two-bedroom villa with full kitchen" },
      { id: "3br-villa", name: "Three Bedroom Grand Villa", sleeps: 12, description: "Three-bedroom grand villa with full kitchen" }
    ]
  },
  {
    id: "beach-club-villas",
    name: "Disney's Beach Club Villas",
    address: "1800 Epcot Resorts Blvd, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe_villa",
    description: "New England beach resort DVC villas with Stormalong Bay access",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: true
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: true,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: true
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [],
    rooms: [
      { id: "deluxe-studio", name: "Deluxe Studio", sleeps: 5, description: "Studio villa with kitchenette" },
      { id: "1br-villa", name: "One Bedroom Villa", sleeps: 4, description: "One-bedroom villa with full kitchen" },
      { id: "2br-villa", name: "Two Bedroom Villa", sleeps: 8, description: "Two-bedroom villa with full kitchen" },
      { id: "3br-villa", name: "Three Bedroom Grand Villa", sleeps: 12, description: "Three-bedroom grand villa with full kitchen" }
    ]
  },
  {
    id: "boardwalk-villas",
    name: "Disney's BoardWalk Villas",
    address: "2101 Epcot Resorts Blvd, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe_villa",
    description: "1940s Atlantic City boardwalk themed DVC villas with walking access to Epcot",
    rooms: [
      { id: "deluxe-studio", name: "Deluxe Studio", sleeps: 4, description: "Studio villa with kitchenette" },
      { id: "1br-villa", name: "One Bedroom Villa", sleeps: 4, description: "One-bedroom villa with full kitchen" },
      { id: "2br-villa", name: "Two Bedroom Villa", sleeps: 8, description: "Two-bedroom villa with full kitchen" },
      { id: "3br-villa", name: "Three Bedroom Grand Villa", sleeps: 12, description: "Three-bedroom grand villa with full kitchen" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: true
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: true,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "boardwalk-flying-fish"
    ]
  },
  {
    id: "animal-kingdom-kidani",
    name: "Disney's Animal Kingdom Lodge - Kidani Village",
    address: "3701 Osceola Pkwy, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe_villa",
    description: "African lodge themed DVC villas with animal savannas and cultural activities. MAJOR REFURBISHMENT: Guest rooms October 2025 - May 2026, pool slide closed September 8, 2025.",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: true,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: true,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "animal-kingdom-lodge-jiko",
      "animal-kingdom-lodge-boma"
    ],
    rooms: [
      { id: "deluxe-studio", name: "Deluxe Studio", sleeps: 4, description: "Studio villa with kitchenette and savanna views" },
      { id: "1br-villa", name: "One Bedroom Villa", sleeps: 4, description: "One-bedroom villa with full kitchen" },
      { id: "2br-villa", name: "Two Bedroom Villa", sleeps: 8, description: "Two-bedroom villa with full kitchen" },
      { id: "3br-villa", name: "Three Bedroom Grand Villa", sleeps: 12, description: "Three-bedroom grand villa with full kitchen" }
    ]
  },
  {
    id: "wilderness-lodge-copper-creek",
    name: "Copper Creek Villas & Cabins at Disney's Wilderness Lodge",
    address: "901 Timberline Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe_villa",
    description: "Pacific Northwest lodge themed DVC villas and cabins with boat transportation",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: true,
          signature_dining: true
        },
        recreation: {
          beach: true,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "wilderness-lodge-artist-point",
      "wilderness-lodge-whispering-canyon"
    ],
    rooms: [
      { id: "deluxe-studio", name: "Deluxe Studio", sleeps: 4, description: "Studio villa with kitchenette" },
      { id: "1br-villa", name: "One Bedroom Villa", sleeps: 4, description: "One-bedroom villa with full kitchen" },
      { id: "2br-villa", name: "Two Bedroom Villa", sleeps: 8, description: "Two-bedroom villa with full kitchen" },
      { id: "cabin", name: "Cascade Cabin", sleeps: 8, description: "Secluded cabin with full kitchen and outdoor space" }
    ]
  },
  {
    id: "wilderness-lodge-boulder-ridge",
    name: "Boulder Ridge Villas at Disney's Wilderness Lodge",
    address: "901 Timberline Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "deluxe_villa",
    description: "Original DVC villas at Wilderness Lodge with Pacific Northwest theming",
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: true,
          signature_dining: true
        },
        recreation: {
          beach: true,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "wilderness-lodge-artist-point",
      "wilderness-lodge-whispering-canyon"
    ],
    rooms: [
      { id: "deluxe-studio", name: "Deluxe Studio", sleeps: 4, description: "Studio villa with kitchenette" },
      { id: "1br-villa", name: "One Bedroom Villa", sleeps: 4, description: "One-bedroom villa with full kitchen" },
      { id: "2br-villa", name: "Two Bedroom Villa", sleeps: 8, description: "Two-bedroom villa with full kitchen" }
    ]
  },
  {
    id: "coronado-springs",
    name: "Disney's Coronado Springs Resort",
    address: "1000 W Buena Vista Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "moderate",
    description: "Southwest and Mexican theming with convention center and Dig Site Pool",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Casitas, Ranchos, or Cabanas room" },
      { id: "preferred", name: "Preferred Room", sleeps: 4, description: "Closer to amenities" },
      { id: "tower-room", name: "Gran Destino Tower Room", sleeps: 4, description: "New tower with upgraded amenities" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Junior or presidential suite in tower" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: false,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: []
  },
  {
    id: "caribbean-beach",
    name: "Disney's Caribbean Beach Resort",
    address: "900 Cayman Way, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "moderate",
    description: "Caribbean theming with Skyliner transportation to Epcot and Hollywood Studios",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Island-themed room in various villages" },
      { id: "preferred", name: "Preferred Room", sleeps: 4, description: "Closer to amenities and transportation" },
      { id: "pirate-room", name: "Pirate Room", sleeps: 4, description: "Pirates of the Caribbean themed room" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: true,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: true,
          marina: true,
          boat_rentals: true,
          fishing: true,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: true,
        dvc: true,
        themedRooms: true,
        familyAccommodations: false
      }
    },
    diningOptions: []
  },
  {
    id: "pop-century",
    name: "Disney's Pop Century Resort",
    address: "1050 Century Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "value",
    description: "Pop culture theming from different decades with Skyliner transportation",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Pop culture themed room" },
      { id: "preferred", name: "Preferred Room", sleeps: 4, description: "Closer to amenities and transportation" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: true,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: false,
          pool_bar: false,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: false,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: []
  },
  {
    id: "all-star-movies",
    name: "Disney's All-Star Movies Resort",
    address: "1901 W Buena Vista Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "value",
    description: "Movie-themed value resort with larger-than-life decorations",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Movie-themed room" },
      { id: "preferred", name: "Preferred Room", sleeps: 4, description: "Closer to amenities and transportation" },
      { id: "family-suite", name: "Family Suite", sleeps: 6, description: "Two-room family suite with kitchenette" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: false,
          pool_bar: false,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: false,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: false,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: []
  },
  {
    id: "art-of-animation",
    name: "Disney's Art of Animation Resort",
    address: "1850 Century Dr, Bay Lake, FL 32830",
    type: "disney",
    priceLevel: "value",
    description: "Disney animation theming with family suites and Skyliner transportation",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Little Mermaid themed room" },
      { id: "family-suite", name: "Family Suite", sleeps: 6, description: "Cars, Lion King, or Finding Nemo themed suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: true,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: false,
          pool_bar: false,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: false,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: false,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: []
  }
];

// src/data/hotels/universal-resorts.json
var universal_resorts_default = [
  {
    id: "portofino-bay",
    name: "Universal's Portofino Bay Hotel",
    address: "5601 Universal Blvd, Orlando, FL 32819",
    type: "universal",
    priceLevel: "deluxe",
    description: "Italian Riviera theming with Express Pass included",
    rooms: [
      { id: "garden-view", name: "Garden View Room", sleeps: 5, description: "Garden view with Italian d\xE9cor" },
      { id: "bay-view", name: "Bay View Room", sleeps: 5, description: "Portofino Bay view" },
      { id: "club-level", name: "Club Level Room", sleeps: 5, description: "Concierge level with lounge access" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Villa or presidential suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: true
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: true,
          steam_room: true
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "portofino-bice-ristorante",
      "portofino-trattoria-del-porto",
      "portofino-mama-dellas",
      "portofino-sals-market",
      "portofino-splendido-bar-grill",
      "portofino-gelateria"
    ]
  },
  {
    id: "hard-rock",
    name: "Universal's Hard Rock Hotel",
    address: "5800 Universal Blvd, Orlando, FL 32819",
    type: "universal",
    priceLevel: "deluxe",
    description: "Rock and roll theming with Express Pass included",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 5, description: "Pool or garden view" },
      { id: "deluxe", name: "Deluxe Room", sleeps: 5, description: "Upgraded room with better views" },
      { id: "club-level", name: "Club Level Room", sleeps: 5, description: "Concierge level with lounge access" },
      { id: "suite", name: "Suite", sleeps: 8, description: "Rock royalty or presidential suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: true
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: true,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "hard-rock-kitchen",
      "hard-rock-palm-restaurant",
      "hard-rock-emack-bolios",
      "hard-rock-beachclub",
      "hard-rock-starbucks"
    ]
  },
  {
    id: "royal-pacific",
    name: "Universal's Royal Pacific Resort",
    address: "6300 Hollywood Way, Orlando, FL 32819",
    type: "universal",
    priceLevel: "deluxe",
    description: "South Pacific theming with Express Pass included",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 5, description: "Garden or water view" },
      { id: "club-level", name: "Club Level Room", sleeps: 5, description: "Concierge level with lounge access" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Junior or royal suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: true
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: true
        },
        services: {
          concierge: true,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "royal-pacific-islands-dining",
      "royal-pacific-tuk-tuk-market",
      "royal-pacific-wantilan-luau",
      "royal-pacific-bula-bar"
    ]
  },
  {
    id: "sapphire-falls",
    name: "Universal's Sapphire Falls Resort",
    address: "6601 Adventure Way, Orlando, FL 32819",
    type: "universal",
    priceLevel: "moderate",
    description: "Caribbean theming with early park admission",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 5, description: "Garden or water view" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Junior or one-bedroom suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: true,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: true,
          walking_trails: true
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "sapphire-falls-amatista-cookhouse",
      "sapphire-falls-strong-water-tavern",
      "sapphire-falls-new-dutch-trading",
      "sapphire-falls-drhum-club"
    ]
  },
  {
    id: "aventura",
    name: "Universal's Aventura Hotel",
    address: "6725 Adventure Way, Orlando, FL 32819",
    type: "universal",
    priceLevel: "moderate",
    description: "Modern glass tower with early park admission",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "City or theme park view" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Two-bedroom suite with kitchenette" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: false,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: false,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false,
          golf: false
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "aventura-bar-17",
      "aventura-urban-pantry",
      "aventura-starbucks"
    ]
  },
  {
    id: "cabana-bay",
    name: "Universal's Cabana Bay Beach Resort",
    address: "6550 Adventure Way, Orlando, FL 32819",
    type: "universal",
    priceLevel: "value",
    description: "1950s beach resort theming with early park admission",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Pool or courtyard view" },
      { id: "family-suite", name: "Family Suite", sleeps: 6, description: "Suite with kitchenette" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: true,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: true,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "cabana-bay-bayliner-diner",
      "cabana-bay-starbucks",
      "cabana-bay-swizzle-lounge",
      "cabana-bay-galaxy-bowl",
      "cabana-bay-hideaway-bar",
      "cabana-bay-atomic-tonic"
    ]
  },
  {
    id: "endless-summer-surfside",
    name: "Universal's Endless Summer Resort - Surfside Inn",
    address: "7000 Universal Blvd, Orlando, FL 32819",
    type: "universal",
    priceLevel: "value",
    description: "Surf theming with early park admission and shuttle",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Surf themed standard room" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Two-bedroom suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: false,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: false,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false,
          golf: false
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "endless-summer-surfside-beach-break"
    ]
  },
  {
    id: "endless-summer-dockside",
    name: "Universal's Endless Summer Resort - Dockside Inn",
    address: "7125 Universal Blvd, Orlando, FL 32819",
    type: "universal",
    priceLevel: "value",
    description: "Beach theming with early park admission and shuttle",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Beach themed standard room" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Two-bedroom suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: false,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: false,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false,
          golf: false
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "endless-summer-dockside-pier-8",
      "endless-summer-dockside-sunset-lounge",
      "endless-summer-dockside-pool-bars"
    ]
  },
  {
    id: "helios-grand",
    name: "Universal Helios Grand Hotel",
    address: "1000 Universal's Epic Universe Blvd, Orlando, FL 32819",
    type: "universal",
    priceLevel: "signature",
    description: "OPENED APRIL 16, 2025. Premier hotel INSIDE Epic Universe with dedicated park entrance, rooftop lounge, and How to Train Your Dragon themed kids' suites.",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Epic Universe or resort view" },
      { id: "epic-view", name: "Epic Universe View Room", sleeps: 4, description: "Direct park views" },
      { id: "dragon-suite", name: "How to Train Your Dragon Kids' Suite", sleeps: 6, description: "Viking village themed family suite" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Premium suite with park access" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: false,
        walking: true
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: true,
          steam_room: true
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: true,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: true,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "helios-grand-flora-taverna",
      "helios-grand-bar-helios",
      "helios-grand-aurora-market",
      "helios-grand-lotus-lagoon"
    ]
  },
  {
    id: "terra-luna",
    name: "Universal Terra Luna Resort",
    address: "1001 Universal's Epic Universe Blvd, Orlando, FL 32819",
    type: "universal",
    priceLevel: "value",
    description: "OPENED MARCH 25, 2025. Adventure-inspired prime value hotel near Epic Universe with planetary themed design and zero-entry pool.",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Adventure themed standard room" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Two-bedroom suite with kitchenette" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: false,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: false,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false,
          golf: false
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "terra-luna-omega-cafe",
      "terra-luna-luna-bar",
      "terra-luna-moonrise-bar"
    ]
  },
  {
    id: "stella-nova",
    name: "Universal Stella Nova Resort",
    address: "1002 Universal's Epic Universe Blvd, Orlando, FL 32819",
    type: "universal",
    priceLevel: "value",
    description: "OPENED JANUARY 21, 2025. First Epic Universe hotel to open, featuring celestial theming and walking distance to Epic Universe.",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Celestial themed standard room" },
      { id: "suite", name: "Suite", sleeps: 6, description: "Two-bedroom suite with kitchenette" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: false,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: false,
          quick_service: true,
          pool_bar: false,
          room_service: false,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false,
          golf: false
        },
        services: {
          concierge: false,
          business_center: false,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: false
      }
    },
    diningOptions: [
      "stella-nova-cosmos-cafe",
      "stella-nova-galaxy-bar"
    ]
  }
];

// src/data/hotels/other-hotels.json
var other_hotels_default = [
  {
    id: "four-seasons",
    name: "Four Seasons Resort Orlando at Walt Disney World",
    address: "10100 Dream Tree Blvd, Golden Oak, FL 32836",
    type: "other",
    priceLevel: "deluxe",
    description: "Luxury resort within Disney World with theme park views",
    rooms: [
      { id: "park-view", name: "Park View Room", sleeps: 4, description: "Theme park view room" },
      { id: "lake-view", name: "Lake View Room", sleeps: 4, description: "Lake view room" },
      { id: "suite", name: "Suite", sleeps: 6, description: "One or two-bedroom suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: true,
          steam_room: true
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: true,
          golf: true
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: true,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "four-seasons-capa",
      "four-seasons-ravello",
      "four-seasons-pb-and-g",
      "four-seasons-plancha",
      "four-seasons-lobby-bar",
      "four-seasons-lickety-split"
    ]
  },
  {
    id: "waldorf-astoria",
    name: "Waldorf Astoria Orlando",
    address: "14200 Bonnet Creek Resort Ln, Orlando, FL 32821",
    type: "other",
    priceLevel: "deluxe",
    description: "Luxury resort near Disney World with championship golf",
    rooms: [
      { id: "standard", name: "Deluxe Room", sleeps: 4, description: "Luxury room with premium amenities" },
      { id: "suite", name: "Suite", sleeps: 6, description: "One or two-bedroom suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: true,
          steam_room: true
        },
        dining: {
          table_service: true,
          quick_service: false,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: true,
          golf: true
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "waldorf-astoria-bull-bear",
      "waldorf-astoria-oscars-brasserie",
      "waldorf-astoria-aquamarine",
      "waldorf-astoria-peacock-alley",
      "waldorf-astoria-clubhouse-grille"
    ]
  },
  {
    id: "hilton-bonnet-creek",
    name: "Hilton Orlando Bonnet Creek",
    address: "14100 Bonnet Creek Resort Ln, Orlando, FL 32821",
    type: "other",
    priceLevel: "moderate",
    description: "Resort near Disney World with lazy river and waterslide",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Resort or pool view" },
      { id: "suite", name: "Suite", sleeps: 6, description: "One or two-bedroom suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: true,
          water_slides: true,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: true,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: true
        },
        services: {
          concierge: false,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "hilton-bonnet-creek-la-luce",
      "hilton-bonnet-creek-zeta-asia",
      "hilton-bonnet-creek-myth",
      "hilton-bonnet-creek-coffee-bar",
      "hilton-bonnet-creek-pool-dining"
    ]
  },
  {
    id: "buena-vista-palace",
    name: "Buena Vista Palace Hotel & Spa",
    address: "1900 E Buena Vista Dr, Lake Buena Vista, FL 32830",
    type: "other",
    priceLevel: "moderate",
    description: "Resort in Disney Springs area with spa and recreation",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Resort or pool view" },
      { id: "suite", name: "Suite", sleeps: 6, description: "One-bedroom suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: true,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: true,
          steam_room: true
        },
        dining: {
          table_service: true,
          quick_service: false,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: true,
          golf: false
        },
        services: {
          concierge: false,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "buena-vista-palace-letterpress",
      "buena-vista-palace-shades-pool-bar",
      "buena-vista-palace-citrus-28-marketplace"
    ]
  },
  {
    id: "doubletree-disney-springs",
    name: "DoubleTree by Hilton Orlando at SeaWorld",
    address: "10100 International Dr, Orlando, FL 32821",
    type: "other",
    priceLevel: "moderate",
    description: "Resort near SeaWorld with shuttle to theme parks",
    rooms: [
      { id: "standard", name: "Standard Room", sleeps: 4, description: "Resort or pool view" },
      { id: "suite", name: "Suite", sleeps: 6, description: "One-bedroom suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: false,
        bus: true,
        walking: false
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: false,
          kiddie_pool: false,
          zero_entry: false
        },
        spa: {
          full_service: false,
          couples_treatments: false,
          fitness_center: true,
          sauna: false,
          steam_room: false
        },
        dining: {
          table_service: true,
          quick_service: false,
          pool_bar: false,
          room_service: true,
          character_dining: false,
          signature_dining: false
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false,
          golf: false
        },
        services: {
          concierge: false,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: false
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "doubletree-seaworld-laguna-restaurant",
      "doubletree-seaworld-albertos-pizzeria",
      "doubletree-seaworld-sonoma-lounge",
      "doubletree-seaworld-barefoot-bar"
    ]
  },
  {
    id: "swan-hotel",
    name: "Walt Disney World Swan Hotel",
    address: "1200 Epcot Resorts Blvd, Bay Lake, FL 32830",
    type: "other",
    priceLevel: "deluxe",
    description: "Elegant hotel in the heart of Disney World with boat transport to Epcot and Hollywood Studios",
    rooms: [
      { id: "standard", name: "Resort View Room", sleeps: 5, description: "Resort or pool view room" },
      { id: "lake-view", name: "Lake View Room", sleeps: 5, description: "Crescent Lake view room" },
      { id: "suite", name: "Suite", sleeps: 6, description: "One or two-bedroom suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: true
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: false,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: true,
          steam_room: true
        },
        dining: {
          table_service: true,
          quick_service: false,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false,
          golf: false
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "swan-hotel-il-mulino",
      "swan-hotel-shulas-steak-house",
      "swan-hotel-garden-grove",
      "swan-hotel-bourbon-steak"
    ]
  },
  {
    id: "dolphin-hotel",
    name: "Walt Disney World Dolphin Hotel",
    address: "1500 Epcot Resorts Blvd, Bay Lake, FL 32830",
    type: "other",
    priceLevel: "deluxe",
    description: "Iconic hotel with distinctive architecture, boat transport to Epcot and Hollywood Studios",
    rooms: [
      { id: "standard", name: "Resort View Room", sleeps: 5, description: "Resort or pool view room" },
      { id: "lake-view", name: "Lake View Room", sleeps: 5, description: "Crescent Lake view room" },
      { id: "suite", name: "Suite", sleeps: 6, description: "One or two-bedroom suite" }
    ],
    features: {
      transportation: {
        monorail: false,
        skyliner: false,
        boat: true,
        bus: true,
        walking: true
      },
      amenities: {
        pool: {
          basic: true,
          lazy_river: false,
          water_slides: false,
          hot_tub: true,
          pool_bar: true,
          kiddie_pool: false,
          zero_entry: false
        },
        spa: {
          full_service: true,
          couples_treatments: true,
          fitness_center: true,
          sauna: true,
          steam_room: true
        },
        dining: {
          table_service: true,
          quick_service: false,
          pool_bar: true,
          room_service: true,
          character_dining: false,
          signature_dining: true
        },
        recreation: {
          beach: false,
          marina: false,
          boat_rentals: false,
          fishing: false,
          bike_rentals: false,
          walking_trails: false,
          golf: false
        },
        services: {
          concierge: true,
          business_center: true,
          childcare: false,
          laundry: true,
          car_service: true
        },
        entertainment: {
          live_music: false,
          character_meet_greets: false,
          movies_under_stars: false,
          campfire: false
        }
      },
      accommodations: {
        suites: true,
        villas: false,
        dvc: false,
        themedRooms: false,
        familyAccommodations: true
      }
    },
    diningOptions: [
      "dolphin-hotel-bluezoo",
      "dolphin-hotel-kimonos",
      "dolphin-hotel-rosa-mexicano",
      "dolphin-hotel-phins",
      "dolphin-hotel-fountain"
    ]
  }
];

// src/data/hotels/index.ts
var disneyResorts = disney_resorts_default;
var universalResorts = universal_resorts_default;
var otherHotels = other_hotels_default;
var allHotels = [
  ...disneyResorts,
  ...universalResorts,
  ...otherHotels
];
var getHotelById = (id) => {
  return allHotels.find((hotel) => hotel.id === id);
};
var getHotelsByType = (type) => {
  return allHotels.filter((hotel) => hotel.type === type);
};
var getRoomsForHotel = (hotelId) => {
  const hotel = getHotelById(hotelId);
  return hotel ? hotel.rooms : [];
};
var getHotelOptions = () => {
  const createHotelOption = (hotel) => ({
    value: hotel.id,
    label: hotel.name,
    address: hotel.address,
    rooms: hotel.rooms
  });
  const sortHotelsAlphabetically = (hotels) => hotels.sort((a, b) => a.name.localeCompare(b.name));
  const deluxeAndDeluxeVilla = sortHotelsAlphabetically(
    disneyResorts.filter((hotel) => hotel.priceLevel === "deluxe" || hotel.priceLevel === "deluxe_villa")
  );
  const moderate = sortHotelsAlphabetically(
    disneyResorts.filter((hotel) => hotel.priceLevel === "moderate")
  );
  const value = sortHotelsAlphabetically(
    disneyResorts.filter((hotel) => hotel.priceLevel === "value")
  );
  const options = [
    {
      label: "Disney Deluxe & DVC Resorts",
      options: deluxeAndDeluxeVilla.map(createHotelOption)
    },
    {
      label: "Disney Moderate Resorts",
      options: moderate.map(createHotelOption)
    },
    {
      label: "Disney Value Resorts",
      options: value.map(createHotelOption)
    },
    {
      label: "Universal Resorts",
      options: sortHotelsAlphabetically(universalResorts).map(createHotelOption)
    },
    {
      label: "Other Hotels",
      options: sortHotelsAlphabetically(otherHotels).map(createHotelOption)
    }
  ];
  return options;
};

// src/data/index.ts
init_do();
init_eat();
var getContentManifest = () => {
  const parks2 = 4;
  const attractions = 65;
  const tips = attractions * 3;
  return {
    version: "1.0.0",
    lastUpdated: (/* @__PURE__ */ new Date()).toISOString(),
    parks: parks2,
    attractions,
    tips
  };
};
var validateContent = async () => {
  const errors = [];
  const warnings = [];
  try {
    const { getParks: getParks2 } = await Promise.resolve().then(() => (init_parks(), parks_exports));
    const { getAllDoItems: getAllDoItems2 } = await Promise.resolve().then(() => (init_do(), do_exports));
    const { getAllEatItems: getAllEatItems2 } = await Promise.resolve().then(() => (init_eat(), eat_exports));
    const parks2 = getParks2();
    const doItems = getAllDoItems2();
    const eatItems = getAllEatItems2();
    const allItems = [...doItems, ...eatItems];
    if (parks2.length === 0) {
      errors.push("No parks found in database");
    }
    if (allItems.length === 0) {
      errors.push("No items found in database");
    }
    const parkIds = new Set(parks2.map((p) => p.id));
    const orphanedItems = allItems.filter((item) => item.parkId && !parkIds.has(item.parkId));
    if (orphanedItems.length > 0) {
      errors.push(`${orphanedItems.length} items reference non-existent parks`);
    }
    const itemIds = allItems.map((item) => item.id);
    const duplicates = itemIds.filter((id, index) => itemIds.indexOf(id) !== index);
    if (duplicates.length > 0) {
      errors.push(`Duplicate item IDs found: ${duplicates.join(", ")}`);
    }
    allItems.forEach((item) => {
      if (!item.name || item.name.trim().length === 0) {
        errors.push(`Item ${item.id} has empty name`);
      }
      if (!item.description || item.description.length < 10) {
        warnings.push(`Item ${item.id} has very short description`);
      }
      if (item.tips && item.tips.length === 0) {
        warnings.push(`Item ${item.id} has no tips`);
      }
      if (item.tags && item.tags.length === 0) {
        warnings.push(`Item ${item.id} has no tags`);
      }
    });
  } catch (error) {
    errors.push(`Failed to load content: ${error instanceof Error ? error.message : "Unknown error"}`);
  }
  return {
    isValid: errors.length === 0,
    errors,
    warnings
  };
};

// src/config/parkMappings.ts
var PARK_MAPPINGS = [
  // Disney World Parks
  {
    waypointParkId: "magic-kingdom",
    themeParksWikiId: "1c84a229-8862-4648-9c71-378ddd2c7693",
    // Magic Kingdom
    queueTimesId: "magic-kingdom",
    thrillDataId: "magic-kingdom",
    displayName: "Magic Kingdom"
  },
  {
    waypointParkId: "epcot",
    themeParksWikiId: "47f90d2c-e191-4239-a466-5892ef59a88b",
    // EPCOT
    queueTimesId: "epcot",
    thrillDataId: "epcot",
    displayName: "EPCOT"
  },
  {
    waypointParkId: "hollywood-studios",
    themeParksWikiId: "288747d1-8b4f-4a64-867e-ea7c9b27bad8",
    // Hollywood Studios
    queueTimesId: "hollywood-studios",
    thrillDataId: "hollywood-studios",
    displayName: "Disney's Hollywood Studios"
  },
  {
    waypointParkId: "animal-kingdom",
    themeParksWikiId: "cae8aa89-c4b7-4bfd-a2a8-9adaaa4d0df7",
    // Animal Kingdom
    queueTimesId: "animal-kingdom",
    thrillDataId: "animal-kingdom",
    displayName: "Disney's Animal Kingdom"
  }
];
var getParkMapping = (waypointParkId) => {
  return PARK_MAPPINGS.find((mapping) => mapping.waypointParkId === waypointParkId);
};
var getThemeParksWikiId = (waypointParkId) => {
  return getParkMapping(waypointParkId)?.themeParksWikiId;
};
var getQueueTimesId = (waypointParkId) => {
  return getParkMapping(waypointParkId)?.queueTimesId;
};
var getThrillDataId = (waypointParkId) => {
  return getParkMapping(waypointParkId)?.thrillDataId;
};
var getWaypointParkId = (themeParksWikiId) => {
  return PARK_MAPPINGS.find((mapping) => mapping.themeParksWikiId === themeParksWikiId)?.waypointParkId;
};
var SUPPORTED_PARK_IDS = PARK_MAPPINGS.map((mapping) => mapping.waypointParkId);
var isParkSupported = (parkId) => {
  return SUPPORTED_PARK_IDS.includes(parkId);
};

// src/services/supabase.ts
import { createClient } from "@supabase/supabase-js";
var getEnvVar = (key, fallback) => {
  if (typeof process !== "undefined" && process.env) {
    return process.env[key];
  }
  if (typeof import.meta !== "undefined" && import.meta.env) {
    return import.meta.env[key];
  }
  return fallback;
};
var supabaseUrl = getEnvVar("VITE_SUPABASE_URL") || getEnvVar("NEXT_PUBLIC_SUPABASE_URL") || "https://zclzhvkoqwelhfxahaly.supabase.co";
var supabaseAnonKey = getEnvVar("VITE_SUPABASE_ANON_KEY") || getEnvVar("NEXT_PUBLIC_SUPABASE_ANON_KEY") || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpjbHpodmtvcXdlbGhmeGFoYWx5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc1NTAwMDMsImV4cCI6MjA3MzEyNjAwM30.UYjLv3TjT6e-Wv0JEbWTgCmF50vbBEIBduEMKeSVp5s";
var supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  realtime: {
    params: {
      eventsPerSecond: 2
    }
  }
});

// src/services/auth.ts
var AuthService = class _AuthService {
  constructor() {
    this.listeners = [];
    this.currentState = {
      user: null,
      session: null,
      loading: true
    };
    this.initializeAuth();
  }
  static getInstance() {
    if (!_AuthService.instance) {
      _AuthService.instance = new _AuthService();
    }
    return _AuthService.instance;
  }
  async initializeAuth() {
    try {
      console.log("\u{1F511} Initializing auth...");
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error) {
        console.error("\u274C Error getting session:", error);
      } else {
        console.log("\u2705 Initial session:", session?.user?.email || "No session");
      }
      if (session?.user) {
        await this.loadUserProfile(session.user);
      }
      this.updateState({
        session,
        loading: false
      });
      supabase.auth.onAuthStateChange(async (event, session2) => {
        console.log("\u{1F504} Auth state changed:", event, session2?.user?.email);
        if (session2?.user) {
          await this.loadUserProfile(session2.user);
        } else {
          this.updateState({
            user: null,
            session: null,
            loading: false
          });
        }
      });
    } catch (error) {
      console.error("\u274C Failed to initialize auth:", error);
      this.updateState({
        user: null,
        session: null,
        loading: false
      });
    }
  }
  async loadUserProfile(user) {
    try {
      console.log("\u{1F464} Loading profile for user:", user.email);
      const { data: profiles, error } = await supabase.from("profiles").select("*").eq("id", user.id);
      const profile = profiles?.[0] || null;
      if (error) {
        console.warn("\u26A0\uFE0F Profile query error (might not exist yet):", error.message);
      }
      this.updateState({
        user: {
          id: user.id,
          email: user.email || null,
          fullName: profile?.full_name || null
        },
        session: (await supabase.auth.getSession()).data.session,
        loading: false
      });
      console.log("\u2705 User profile loaded:", user.email);
    } catch (error) {
      console.error("\u274C Error loading user profile:", error);
      this.updateState({
        user: {
          id: user.id,
          email: user.email || null,
          fullName: null
        },
        session: (await supabase.auth.getSession()).data.session,
        loading: false
      });
    }
  }
  updateState(updates) {
    this.currentState = { ...this.currentState, ...updates };
    this.listeners.forEach((listener) => listener(this.currentState));
  }
  // Public methods
  getState() {
    return this.currentState;
  }
  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }
  async signUp(email, password, fullName) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          full_name: fullName
        }
      }
    });
    if (error) throw error;
    if (data.user) {
      await supabase.from("profiles").insert({
        id: data.user.id,
        email: data.user.email,
        full_name: fullName || null
      });
    }
    return data;
  }
  async signIn(email, password) {
    console.log("\u{1F510} Attempting sign in for:", email);
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password
    });
    if (error) {
      console.error("\u274C Sign in error:", error.message);
      throw error;
    }
    console.log("\u2705 Sign in successful for:", email);
    return data;
  }
  async signOut() {
    console.log("\u{1F6AA} Signing out...");
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error("\u274C Sign out error:", error);
      throw error;
    }
    console.log("\u2705 Sign out successful");
  }
  async resetPassword(email) {
    const { error } = await supabase.auth.resetPasswordForEmail(email);
    if (error) throw error;
  }
  async updateProfile(updates) {
    const user = this.currentState.user;
    if (!user) throw new Error("No authenticated user");
    if (updates.email && updates.email !== user.email) {
      const { error: error2 } = await supabase.auth.updateUser({
        email: updates.email
      });
      if (error2) throw error2;
    }
    const { error } = await supabase.from("profiles").update({
      full_name: updates.fullName,
      email: updates.email,
      updated_at: (/* @__PURE__ */ new Date()).toISOString()
    }).eq("id", user.id);
    if (error) throw error;
    const { data: { user: authUser } } = await supabase.auth.getUser();
    if (authUser) {
      await this.loadUserProfile(authUser);
    }
  }
};
var authService = AuthService.getInstance();

// src/services/sync.ts
var SyncService = class _SyncService {
  constructor() {
    this.syncStatus = {
      online: navigator.onLine,
      syncing: false,
      lastSync: null,
      error: null
    };
    this.listeners = [];
    this.syncInterval = null;
    window.addEventListener("online", this.handleOnline.bind(this));
    window.addEventListener("offline", this.handleOffline.bind(this));
    authService.subscribe((authState) => {
      if (authState.user && !authState.loading && this.syncStatus.online) {
        this.syncTrips();
      }
    });
  }
  static getInstance() {
    if (!_SyncService.instance) {
      _SyncService.instance = new _SyncService();
    }
    return _SyncService.instance;
  }
  handleOnline() {
    this.updateStatus({ online: true });
    const user = authService.getState().user;
    if (user) {
      this.syncTrips();
    }
  }
  handleOffline() {
    this.updateStatus({ online: false, syncing: false });
  }
  updateStatus(updates) {
    this.syncStatus = { ...this.syncStatus, ...updates };
    this.listeners.forEach((listener) => listener(this.syncStatus));
  }
  getStatus() {
    return this.syncStatus;
  }
  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }
  async syncTrips() {
    const user = authService.getState().user;
    if (!user || !this.syncStatus.online || this.syncStatus.syncing) {
      return;
    }
    this.updateStatus({ syncing: true, error: null });
    try {
      const ownedTripsResult = await supabase.from("trips").select("*").eq("user_id", user.id).order("updated_at", { ascending: false });
      if (ownedTripsResult.error) {
        console.error("Error fetching owned trips:", ownedTripsResult.error);
        throw ownedTripsResult.error;
      }
      let sharedTripsResult = { data: [], error: null };
      try {
        sharedTripsResult = await supabase.from("trips").select(`
            *,
            trip_collaborators!inner(permission_level)
          `).eq("trip_collaborators.user_id", user.id);
      } catch (error) {
        console.log("Collaboration features not available (missing schema):", error);
      }
      const ownedTrips = ownedTripsResult.data || [];
      const sharedTrips = (sharedTripsResult.data || []).map((item) => item?.trips).filter((trip) => trip !== null);
      const allRemoteTrips = [...ownedTrips, ...sharedTrips];
      const localTrips = await this.getLocalTrips();
      const mergedTrips = this.mergeTripsWithCollaboration(localTrips, allRemoteTrips, user.id);
      await this.saveTripsWithCollaboration(mergedTrips, user.id);
      this.updateStatus({
        syncing: false,
        lastSync: /* @__PURE__ */ new Date(),
        error: null
      });
    } catch (error) {
      console.error("Sync error:", error);
      this.updateStatus({
        syncing: false,
        error: error instanceof Error ? error.message : "Sync failed"
      });
    }
  }
  async getLocalTrips() {
    if (this.getLocalTripsCallback) {
      return await this.getLocalTripsCallback();
    }
    return [];
  }
  setLocalDataCallbacks(getLocalTrips, saveLocalTrips) {
    this.getLocalTripsCallback = getLocalTrips;
    this.saveLocalTripsCallback = saveLocalTrips;
  }
  setConflictCallback(conflictHandler) {
    this.conflictCallback = conflictHandler;
  }
  startPeriodicSync(intervalMinutes = 5) {
    this.stopPeriodicSync();
    this.syncInterval = setInterval(() => {
      const authState = authService.getState();
      if (authState.user && !authState.loading && this.syncStatus.online && !this.syncStatus.syncing) {
        this.syncTrips().catch(console.error);
      }
    }, intervalMinutes * 60 * 1e3);
  }
  stopPeriodicSync() {
    if (this.syncInterval) {
      clearInterval(this.syncInterval);
      this.syncInterval = null;
    }
  }
  mergeTripsWithCollaboration(localTrips, remoteTrips, userId) {
    const tripMap = /* @__PURE__ */ new Map();
    localTrips.forEach((trip) => {
      tripMap.set(trip.id, trip);
    });
    remoteTrips.forEach((remoteTrip) => {
      const localTrip = tripMap.get(remoteTrip.id);
      const isOwner = remoteTrip.user_id === userId;
      if (!localTrip || this.shouldUseRemoteVersion(localTrip, remoteTrip, isOwner)) {
        tripMap.set(remoteTrip.id, this.convertRemoteTripToLocal(remoteTrip));
      } else if (localTrip && this.hasVersionConflict(localTrip, remoteTrip)) {
        const conflictedTrip = this.convertRemoteTripToLocal(remoteTrip);
        conflictedTrip.version = -1;
        tripMap.set(remoteTrip.id, conflictedTrip);
      }
    });
    return Array.from(tripMap.values());
  }
  shouldUseRemoteVersion(localTrip, remoteTrip, isOwner) {
    if (!isOwner) {
      return new Date(remoteTrip.updated_at) > new Date(localTrip.updatedAt);
    }
    const localVersion = localTrip.version || 0;
    const remoteVersion = remoteTrip.version || 0;
    return remoteVersion > localVersion;
  }
  hasVersionConflict(localTrip, remoteTrip) {
    const localVersion = localTrip.version || 0;
    const remoteVersion = remoteTrip.version || 0;
    return localVersion > remoteVersion;
  }
  convertRemoteTripToLocal(remoteTrip) {
    return {
      id: remoteTrip.id,
      name: remoteTrip.name,
      startDate: remoteTrip.start_date,
      endDate: remoteTrip.end_date,
      notes: remoteTrip.notes || "",
      accommodation: remoteTrip.accommodation || void 0,
      travelingParty: remoteTrip.traveling_party || void 0,
      days: remoteTrip.days || [],
      createdAt: remoteTrip.created_at,
      updatedAt: remoteTrip.updated_at,
      ownerId: remoteTrip.user_id,
      isShared: remoteTrip.is_shared,
      lastModifiedBy: remoteTrip.last_modified_by,
      version: remoteTrip.version || 0
    };
  }
  async saveTripsWithCollaboration(trips, userId) {
    const ownedTrips = trips.filter((trip) => trip.ownerId === userId);
    if (ownedTrips.length > 0) {
      const tripsForSupabase = ownedTrips.map((trip) => ({
        id: trip.id,
        user_id: userId,
        name: trip.name,
        start_date: trip.startDate,
        end_date: trip.endDate,
        notes: trip.notes || null,
        accommodation: trip.accommodation || null,
        traveling_party: trip.travelingParty || null,
        days: trip.days,
        is_shared: trip.isShared || false,
        last_modified_by: trip.lastModifiedBy || null,
        version: trip.version || 0,
        created_at: trip.createdAt,
        updated_at: trip.updatedAt
      }));
      const { error } = await supabase.from("trips").upsert(tripsForSupabase, { onConflict: "id" });
      if (error) throw error;
    }
    if (this.saveLocalTripsCallback) {
      await this.saveLocalTripsCallback(trips);
    }
    const conflictedTrips = trips.filter((trip) => trip.version === -1);
    if (conflictedTrips.length > 0 && this.conflictCallback) {
      await this.conflictCallback(conflictedTrips);
    }
  }
  async uploadTrip(trip) {
    const user = authService.getState().user;
    if (!user || !this.syncStatus.online) {
      return;
    }
    const tripData = {
      id: trip.id,
      user_id: user.id,
      name: trip.name,
      start_date: trip.startDate,
      end_date: trip.endDate,
      notes: trip.notes || null,
      accommodation: trip.accommodation || null,
      traveling_party: trip.travelingParty || null,
      days: trip.days,
      created_at: trip.createdAt,
      updated_at: (/* @__PURE__ */ new Date()).toISOString()
    };
    if (trip.isShared !== void 0) tripData.is_shared = trip.isShared;
    if (trip.lastModifiedBy !== void 0) tripData.last_modified_by = trip.lastModifiedBy || user.id;
    if (trip.version !== void 0) tripData.version = (trip.version || 0) + 1;
    const { error } = await supabase.from("trips").upsert(tripData, { onConflict: "id" });
    if (error) throw error;
  }
  async deleteTrip(tripId) {
    const user = authService.getState().user;
    if (!user || !this.syncStatus.online) {
      return;
    }
    const { error } = await supabase.from("trips").delete().eq("id", tripId).eq("user_id", user.id);
    if (error) throw error;
  }
};
var syncService = SyncService.getInstance();

// src/services/liveDataRepository.ts
var LiveDataRepository = class {
  // Park Operations
  async getParkData(parkId) {
    try {
      const { data: parkData, error: parkError } = await supabase.from("live_parks").select("*").eq("park_id", parkId).single();
      if (parkError) {
        if (parkError.code === "PGRST116") {
          return null;
        }
        throw parkError;
      }
      const { data: attractions, error: attractionsError } = await supabase.from("live_attractions").select("*").eq("park_id", parkId);
      if (attractionsError) throw attractionsError;
      const { data: entertainment2, error: entertainmentError } = await supabase.from("live_entertainment").select("*").eq("park_id", parkId);
      if (entertainmentError) throw entertainmentError;
      return this.transformDbParkToLive(parkData, attractions || [], entertainment2 || []);
    } catch (error) {
      const liveDataError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Database error",
        details: { parkId, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw liveDataError;
    }
  }
  async getMultipleParkData(parkIds) {
    const results = await Promise.allSettled(
      parkIds.map((parkId) => this.getParkData(parkId))
    );
    return results.map((result) => result.status === "fulfilled" ? result.value : null).filter((data) => data !== null);
  }
  async upsertParkData(parkData) {
    const { error } = await supabase.from("live_parks").upsert(parkData, { onConflict: "park_id" });
    if (error) throw error;
  }
  // Attraction Operations
  async getAttractionWaitTimes(parkId) {
    try {
      const { data, error } = await supabase.from("live_attractions").select("*").eq("park_id", parkId).order("name");
      if (error) throw error;
      return (data || []).map(this.transformDbAttractionToLive);
    } catch (error) {
      const liveDataError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Database error",
        details: { parkId, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw liveDataError;
    }
  }
  async upsertAttractionData(attractionData) {
    if (attractionData.length === 0) return;
    const { error } = await supabase.from("live_attractions").upsert(attractionData, { onConflict: "park_id,external_id" });
    if (error) throw error;
  }
  // Entertainment Operations
  async getEntertainmentSchedule(parkId) {
    try {
      const { data, error } = await supabase.from("live_entertainment").select("*").eq("park_id", parkId).order("name");
      if (error) throw error;
      return (data || []).map(this.transformDbEntertainmentToLive);
    } catch (error) {
      const liveDataError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Database error",
        details: { parkId, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw liveDataError;
    }
  }
  async upsertEntertainmentData(entertainmentData) {
    if (entertainmentData.length === 0) return;
    const { error } = await supabase.from("live_entertainment").upsert(entertainmentData, { onConflict: "park_id,external_id" });
    if (error) throw error;
  }
  // Sync Status Operations
  async getSyncStatus(serviceName) {
    const { data, error } = await supabase.from("live_sync_status").select("*").eq("service_name", serviceName).single();
    if (error && error.code !== "PGRST116") throw error;
    return data;
  }
  async updateSyncStatus(serviceName, success, errorMessage) {
    const now = (/* @__PURE__ */ new Date()).toISOString();
    const updateData = {
      service_name: serviceName,
      last_sync_at: now,
      total_syncs: 1
      // This will be incremented in SQL
    };
    if (success) {
      updateData.last_success_at = now;
      updateData.successful_syncs = 1;
      updateData.last_error = null;
    } else {
      updateData.failed_syncs = 1;
      updateData.last_error = errorMessage || "Unknown error";
    }
    const { error } = await supabase.rpc("update_sync_status", {
      p_service_name: serviceName,
      p_success: success,
      p_error_message: errorMessage || null
    });
    if (error) {
      console.warn("Sync status function not found, using fallback");
      const { error: fallbackError } = await supabase.from("live_sync_status").upsert(updateData, { onConflict: "service_name" });
      if (fallbackError) throw fallbackError;
    }
  }
  // Date-Specific Park Schedule Operations
  async getParkScheduleForDate(parkId, date) {
    try {
      const { data, error } = await supabase.from("live_park_schedules").select("*").eq("park_id", parkId).eq("schedule_date", date).single();
      if (error) {
        if (error.code === "PGRST116") {
          return null;
        }
        throw error;
      }
      return data;
    } catch (error) {
      const liveDataError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Database error",
        details: { parkId, date, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw liveDataError;
    }
  }
  async getParkSchedulesForDateRange(parkId, startDate, endDate) {
    try {
      const { data, error } = await supabase.from("live_park_schedules").select("*").eq("park_id", parkId).gte("schedule_date", startDate).lte("schedule_date", endDate).order("schedule_date");
      if (error) throw error;
      return data || [];
    } catch (error) {
      const liveDataError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Database error",
        details: { parkId, startDate, endDate, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw liveDataError;
    }
  }
  async upsertParkSchedule(scheduleData) {
    const { error } = await supabase.from("live_park_schedules").upsert(scheduleData, { onConflict: "park_id,schedule_date" });
    if (error) throw error;
  }
  // Data Cleanup Operations
  async cleanOldData(olderThanHours = 24) {
    const cutoffTime = new Date(Date.now() - olderThanHours * 60 * 60 * 1e3).toISOString();
    await supabase.from("live_attractions").delete().lt("last_updated", cutoffTime);
    await supabase.from("live_entertainment").delete().lt("last_updated", cutoffTime);
    const parkCutoffTime = new Date(Date.now() - 7 * 24 * 60 * 60 * 1e3).toISOString();
    await supabase.from("live_parks").delete().lt("last_updated", parkCutoffTime);
    const scheduleCutoffTime = new Date(Date.now() - 30 * 24 * 60 * 60 * 1e3).toISOString().split("T")[0];
    await supabase.from("live_park_schedules").delete().lt("schedule_date", scheduleCutoffTime);
  }
  // Transform functions to convert database types to live data types
  transformDbParkToLive(park, attractions, entertainment2) {
    return {
      parkId: park.park_id,
      status: park.status,
      hours: {
        regular: {
          open: park.regular_open,
          close: park.regular_close
        },
        ...park.early_entry_open && { earlyEntry: { open: park.early_entry_open } },
        ...park.extended_evening_close && { extendedEvening: { close: park.extended_evening_close } }
      },
      crowdLevel: park.crowd_level ?? void 0,
      lastUpdated: park.last_updated,
      attractions: attractions.map(this.transformDbAttractionToLive),
      entertainment: entertainment2.map(this.transformDbEntertainmentToLive)
    };
  }
  transformDbAttractionToLive(attraction) {
    return {
      id: attraction.external_id,
      waitTime: attraction.wait_time,
      status: attraction.status,
      ...attraction.lightning_lane_available && {
        lightningLane: {
          available: attraction.lightning_lane_available,
          returnTime: attraction.lightning_lane_return_time || void 0
        }
      },
      ...attraction.single_rider_available && {
        singleRider: {
          available: attraction.single_rider_available,
          waitTime: attraction.single_rider_wait_time || void 0
        }
      },
      lastUpdated: attraction.last_updated
    };
  }
  transformDbEntertainmentToLive(entertainment2) {
    return {
      id: entertainment2.external_id,
      showTimes: entertainment2.show_times || [],
      status: entertainment2.status,
      nextShowTime: entertainment2.next_show_time || void 0,
      lastUpdated: entertainment2.last_updated
    };
  }
  // Park Events Operations
  async getParkEventsForDate(parkId, date) {
    try {
      const { data: events, error } = await supabase.from("live_park_events").select("*").eq("park_id", parkId).eq("event_date", date).order("event_open");
      if (error) throw error;
      return (events || []).map((event) => ({
        id: event.id,
        parkId: event.park_id,
        eventDate: event.event_date,
        eventName: event.event_name,
        eventType: event.event_type,
        eventOpen: event.event_open,
        eventClose: event.event_close,
        description: event.description || event.event_name,
        dataSource: event.data_source || void 0,
        lastUpdated: event.synced_at || (/* @__PURE__ */ new Date()).toISOString()
      }));
    } catch (error) {
      console.error(`[LiveDataRepository] Error fetching park events for ${parkId} on ${date}:`, error);
      throw {
        code: "API_ERROR",
        message: `Failed to fetch park events for ${parkId} on ${date}`,
        details: error,
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
    }
  }
};
var liveDataRepository = new LiveDataRepository();

// src/services/liveDataService.ts
var DEFAULT_CONFIG = {
  refreshIntervals: {
    waitTimes: 5 * 60 * 1e3,
    // 5 minutes (for cache)
    parkHours: 60 * 60 * 1e3,
    // 1 hour (for cache)
    crowdPredictions: 24 * 60 * 60 * 1e3,
    // 24 hours (for cache)
    entertainment: 30 * 60 * 1e3
    // 30 minutes (for cache)
  },
  enabledFeatures: {
    waitTimes: true,
    parkHours: true,
    crowdPredictions: true,
    rideStatus: true,
    entertainment: true
  },
  offlineMode: false
  // Use database mode - no more direct API calls
};
var LiveDataService = class {
  constructor(config) {
    this.config = DEFAULT_CONFIG;
    this.globalCache = /* @__PURE__ */ new Map();
    this.refreshTimers = /* @__PURE__ */ new Map();
    this.errorHandlers = /* @__PURE__ */ new Map();
    if (config) {
      this.config = { ...DEFAULT_CONFIG, ...config };
    }
  }
  updateConfig(config) {
    this.config = { ...this.config, ...config };
    this.refreshTimers.forEach((timer) => clearInterval(timer));
    this.refreshTimers.clear();
  }
  async getParkData(parkId) {
    if (!isParkSupported(parkId)) {
      throw new Error(`Park ${parkId} is not supported for live data`);
    }
    const cacheKey = `park_data_${parkId}`;
    const cached = this.getCachedData(cacheKey, this.config.refreshIntervals.parkHours);
    if (cached) {
      return cached;
    }
    try {
      const parkData = await liveDataRepository.getParkData(parkId);
      if (parkData) {
        this.setCachedData(cacheKey, parkData, this.config.refreshIntervals.parkHours);
        return parkData;
      } else {
        return this.getMockParkData(parkId);
      }
    } catch (error) {
      this.handleError("getParkData", error);
      console.warn(`Database failed for ${parkId}, falling back to mock data`);
      return this.getMockParkData(parkId);
    }
  }
  // Date-specific park data method for trip planning
  async getParkDataForDate(parkId, date) {
    if (!isParkSupported(parkId)) {
      throw new Error(`Park ${parkId} is not supported for live data`);
    }
    const cacheKey = `park_data_${parkId}_${date}`;
    const cached = this.getCachedData(cacheKey, this.config.refreshIntervals.parkHours);
    if (cached) {
      return cached;
    }
    try {
      const scheduleData = await liveDataRepository.getParkScheduleForDate(parkId, date);
      if (scheduleData) {
        const parkData = {
          parkId,
          status: "operating",
          // Assume operating if we have schedule data
          hours: {
            regular: {
              open: scheduleData.regular_open,
              close: scheduleData.regular_close
            },
            ...scheduleData.early_entry_open && {
              earlyEntry: { open: scheduleData.early_entry_open }
            },
            ...scheduleData.extended_evening_close && {
              extendedEvening: { close: scheduleData.extended_evening_close }
            }
          },
          lastUpdated: scheduleData.synced_at,
          attractions: [],
          // Attractions are not date-specific
          entertainment: [],
          // Entertainment is not date-specific
          dataSource: scheduleData.data_source,
          isEstimated: scheduleData.is_estimated
        };
        this.setCachedData(cacheKey, parkData, this.config.refreshIntervals.parkHours);
        return parkData;
      } else {
        const parkData = {
          parkId,
          status: "operating",
          hours: {
            regular: {
              open: null,
              close: null
            }
          },
          lastUpdated: (/* @__PURE__ */ new Date()).toISOString(),
          attractions: [],
          entertainment: [],
          dataSource: "unavailable",
          isEstimated: true
        };
        return parkData;
      }
    } catch (error) {
      this.handleError("getParkDataForDate", error);
      console.warn(`Database failed for ${parkId} on ${date}, falling back to mock data`);
      return this.getMockParkData(parkId);
    }
  }
  getMockParkData(parkId) {
    return {
      parkId,
      status: "operating",
      hours: {
        regular: { open: "09:00", close: "22:00" }
      },
      lastUpdated: (/* @__PURE__ */ new Date()).toISOString(),
      attractions: [],
      // Empty - will be populated by background sync
      entertainment: []
      // Empty - will be populated by background sync
    };
  }
  async getMultipleParkData(parkIds) {
    const promises = parkIds.map(
      (parkId) => this.getParkData(parkId).catch((error) => {
        console.warn(`Failed to get data for park ${parkId}:`, error);
        return null;
      })
    );
    const results = await Promise.allSettled(promises);
    return results.map((result) => result.status === "fulfilled" ? result.value : null).filter((data) => data !== null);
  }
  async getAttractionWaitTimes(parkId) {
    if (!this.config.enabledFeatures.waitTimes) {
      return [];
    }
    const cacheKey = `wait_times_${parkId}`;
    const cached = this.getCachedData(cacheKey, this.config.refreshIntervals.waitTimes);
    if (cached) {
      return cached;
    }
    try {
      const waitTimes = await liveDataRepository.getAttractionWaitTimes(parkId);
      this.setCachedData(cacheKey, waitTimes, this.config.refreshIntervals.waitTimes);
      return waitTimes;
    } catch (error) {
      this.handleError("getAttractionWaitTimes", error);
      return [];
    }
  }
  async getAttractionStatus(_attractionId) {
    throw new Error("getAttractionStatus not implemented - use getAttractionWaitTimes with park filtering");
  }
  async getEntertainmentSchedule(parkId) {
    if (!this.config.enabledFeatures.entertainment) {
      return [];
    }
    const cacheKey = `entertainment_${parkId}`;
    const cached = this.getCachedData(cacheKey, this.config.refreshIntervals.entertainment);
    if (cached) {
      return cached;
    }
    try {
      const entertainment2 = await liveDataRepository.getEntertainmentSchedule(parkId);
      this.setCachedData(cacheKey, entertainment2, this.config.refreshIntervals.entertainment);
      return entertainment2;
    } catch (error) {
      this.handleError("getEntertainmentSchedule", error);
      return [];
    }
  }
  async getParkEventsForDate(parkId, date) {
    if (!isParkSupported(parkId)) {
      throw new Error(`Park ${parkId} is not supported for live data`);
    }
    const cacheKey = `park_events_${parkId}_${date}`;
    const cached = this.getCachedData(cacheKey, this.config.refreshIntervals.parkHours);
    if (cached) {
      return cached;
    }
    try {
      const events = await liveDataRepository.getParkEventsForDate(parkId, date);
      this.setCachedData(cacheKey, events, this.config.refreshIntervals.parkHours);
      return events;
    } catch (error) {
      this.handleError("getParkEventsForDate", error);
      return [];
    }
  }
  async getCrowdPredictions(parkId, days = 7) {
    if (!this.config.enabledFeatures.crowdPredictions) {
      throw new Error("Crowd predictions feature is disabled");
    }
    const cacheKey = `crowd_predictions_${parkId}_${days}`;
    const cached = this.getCachedData(cacheKey, this.config.refreshIntervals.crowdPredictions);
    if (cached) {
      return cached;
    }
    try {
      const parkData = await liveDataRepository.getParkData(parkId);
      if (parkData && parkData.crowdLevel) {
        const getCrowdDescription = (level) => {
          if (level <= 2) return "Very Low";
          if (level <= 4) return "Low";
          if (level <= 6) return "Moderate";
          if (level <= 8) return "High";
          return "Very High";
        };
        const mockCrowdData = {
          parkId,
          predictions: Array.from({ length: days }, (_, i) => ({
            date: new Date(Date.now() + i * 24 * 60 * 60 * 1e3).toISOString().split("T")[0],
            level: parkData.crowdLevel || 5,
            // Use database crowd level
            description: getCrowdDescription(parkData.crowdLevel || 5)
          })),
          lastUpdated: (/* @__PURE__ */ new Date()).toISOString()
        };
        this.setCachedData(cacheKey, mockCrowdData, this.config.refreshIntervals.crowdPredictions);
        return mockCrowdData;
      } else {
        const getCrowdDescription = (level) => {
          if (level <= 2) return "Very Low";
          if (level <= 4) return "Low";
          if (level <= 6) return "Moderate";
          if (level <= 8) return "High";
          return "Very High";
        };
        const mockCrowdData = {
          parkId,
          predictions: Array.from({ length: days }, (_, i) => ({
            date: new Date(Date.now() + i * 24 * 60 * 60 * 1e3).toISOString().split("T")[0],
            level: 5,
            // Default moderate crowd level
            description: getCrowdDescription(5)
          })),
          lastUpdated: (/* @__PURE__ */ new Date()).toISOString()
        };
        this.setCachedData(cacheKey, mockCrowdData, this.config.refreshIntervals.crowdPredictions);
        return mockCrowdData;
      }
    } catch (error) {
      this.handleError("getCrowdPredictions", error);
      throw error;
    }
  }
  // Auto-refresh functionality
  startAutoRefresh(parkIds) {
    parkIds.forEach((parkId) => {
      if (!isParkSupported(parkId)) return;
      const waitTimesTimer = setInterval(async () => {
        try {
          await this.getAttractionWaitTimes(parkId);
        } catch (error) {
          console.warn(`Auto-refresh failed for wait times in ${parkId}:`, error);
        }
      }, this.config.refreshIntervals.waitTimes);
      const parkHoursTimer = setInterval(async () => {
        try {
          await this.getParkData(parkId);
        } catch (error) {
          console.warn(`Auto-refresh failed for park data in ${parkId}:`, error);
        }
      }, this.config.refreshIntervals.parkHours);
      this.refreshTimers.set(`${parkId}_wait_times`, waitTimesTimer);
      this.refreshTimers.set(`${parkId}_park_hours`, parkHoursTimer);
    });
  }
  stopAutoRefresh() {
    this.refreshTimers.forEach((timer) => clearInterval(timer));
    this.refreshTimers.clear();
  }
  // Cache management
  clearCache(type) {
    if (type === "all" || !type) {
      this.globalCache.clear();
      return;
    }
    for (const [key] of this.globalCache.entries()) {
      if (key.includes(type)) {
        this.globalCache.delete(key);
      }
    }
  }
  getCacheStats() {
    const stats = {};
    for (const [key, value] of this.globalCache.entries()) {
      const category = key.split("_")[0] || "general";
      if (!stats[category]) {
        stats[category] = {
          size: 0,
          oldestEntry: new Date(value.timestamp).toISOString(),
          newestEntry: new Date(value.timestamp).toISOString()
        };
      }
      stats[category].size++;
      const entryTime = new Date(value.timestamp).toISOString();
      if (entryTime < stats[category].oldestEntry) {
        stats[category].oldestEntry = entryTime;
      }
      if (entryTime > stats[category].newestEntry) {
        stats[category].newestEntry = entryTime;
      }
    }
    return stats;
  }
  // Error handling
  onError(type, handler) {
    this.errorHandlers.set(type, handler);
  }
  handleError(type, error) {
    const handler = this.errorHandlers.get(type);
    if (handler) {
      handler(error);
    } else {
      console.error(`LiveDataService ${type} error:`, error);
    }
  }
  // Private cache helpers
  getCachedData(key, ttl) {
    const cached = this.globalCache.get(key);
    if (!cached) return null;
    if (Date.now() - cached.timestamp > ttl) {
      this.globalCache.delete(key);
      return null;
    }
    return cached.data;
  }
  setCachedData(key, data, ttl) {
    this.globalCache.set(key, {
      data,
      timestamp: Date.now(),
      ttl
    });
  }
};
var liveDataService = new LiveDataService();

// src/services/themeParksApi.ts
var THEMEPARKS_API_BASE = "https://api.themeparks.wiki/v1";
var ThemeParksAPIClient = class {
  constructor() {
    this.cache = /* @__PURE__ */ new Map();
    this.defaultCacheTTL = 5 * 60 * 1e3;
  }
  // 5 minutes
  async fetchWithCache(url, ttl = this.defaultCacheTTL) {
    const cacheKey = url;
    const cached = this.cache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < cached.ttl) {
      return cached.data;
    }
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 1e4);
      const response = await fetch(url, {
        signal: controller.signal,
        headers: {
          "User-Agent": "Waylight/1.0.0"
        }
      });
      clearTimeout(timeoutId);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const data = await response.json();
      this.cache.set(cacheKey, {
        data,
        timestamp: Date.now(),
        ttl
      });
      return data;
    } catch (error) {
      const apiError = {
        code: error instanceof Error && error.name === "AbortError" ? "NETWORK_ERROR" : "API_ERROR",
        message: error instanceof Error ? error.message : "Unknown API error",
        details: { url, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw apiError;
    }
  }
  async getParkLiveData(waypointParkId) {
    const mapping = getParkMapping(waypointParkId);
    if (!mapping) {
      throw new Error(`No mapping found for park: ${waypointParkId}`);
    }
    try {
      const liveData = await this.fetchWithCache(
        `${THEMEPARKS_API_BASE}/entity/${mapping.themeParksWikiId}/live`
      );
      const parkData = liveData.find((entity) => entity.id === mapping.themeParksWikiId);
      if (!parkData) {
        throw new Error(`Park data not found for ${waypointParkId}`);
      }
      const hours = this.extractParkHours(parkData);
      const attractions = liveData.filter((entity) => entity.entityType === "ATTRACTION").map((entity) => this.transformToAttractionData(entity));
      const entertainment2 = liveData.filter((entity) => entity.entityType === "SHOW").map((entity) => this.transformToEntertainmentData(entity));
      return {
        parkId: waypointParkId,
        status: this.mapParkStatus(parkData.status.status),
        hours,
        lastUpdated: parkData.lastUpdate,
        attractions,
        entertainment: entertainment2
      };
    } catch (error) {
      if (error instanceof Error && "code" in error) {
        throw error;
      }
      const apiError = {
        code: "PARSE_ERROR",
        message: `Failed to parse park data for ${waypointParkId}`,
        details: { waypointParkId, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw apiError;
    }
  }
  async getAttractionWaitTimes(waypointParkId) {
    const parkData = await this.getParkLiveData(waypointParkId);
    return parkData.attractions;
  }
  async getEntertainmentSchedule(waypointParkId) {
    const parkData = await this.getParkLiveData(waypointParkId);
    return parkData.entertainment;
  }
  extractParkHours(parkData) {
    const today = (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
    const todayHours = parkData.operatingHours?.find((hours) => hours.date === today);
    if (!todayHours) {
      return {
        regular: { open: "09:00", close: "22:00" }
        // Default fallback
      };
    }
    const regularHours = parkData.operatingHours?.filter((h) => h.type === "OPERATING" && h.date === today)[0];
    const earlyEntry = parkData.operatingHours?.filter((h) => h.type === "EXTRA_HOURS" && h.date === today)[0];
    const extendedEvening = parkData.operatingHours?.filter((h) => h.type === "PRIVATE" && h.date === today)[0];
    return {
      regular: {
        open: regularHours?.startTime || todayHours.startTime,
        close: regularHours?.endTime || todayHours.endTime
      },
      ...earlyEntry && { earlyEntry: { open: earlyEntry.startTime } },
      ...extendedEvening && { extendedEvening: { close: extendedEvening.endTime } }
    };
  }
  transformToAttractionData(entity) {
    const waitTime = entity.queue?.standBy?.waitTime ?? -1;
    const status = this.mapAttractionStatus(entity.status.status);
    return {
      id: entity.id,
      waitTime,
      status,
      lastUpdated: entity.lastUpdate,
      ...entity.queue?.fastLane && {
        lightningLane: {
          available: entity.queue.fastLane.available,
          returnTime: entity.queue.fastLane.returnTime?.fastLane
        }
      },
      ...entity.queue?.singleRider && {
        singleRider: {
          available: true,
          waitTime: entity.queue.singleRider.waitTime
        }
      }
    };
  }
  transformToEntertainmentData(entity) {
    const showTimes = entity.showtimes?.map((show) => show.startTime) || [];
    const nextShow = showTimes.find((time) => {
      const showTime = new Date(time);
      return showTime > /* @__PURE__ */ new Date();
    });
    return {
      id: entity.id,
      showTimes,
      status: this.mapEntertainmentStatus(entity.status.status),
      nextShowTime: nextShow,
      lastUpdated: entity.lastUpdate
    };
  }
  mapParkStatus(status) {
    switch (status.toLowerCase()) {
      case "operating":
        return "operating";
      case "closed":
        return "closed";
      case "limited":
      case "refurbishment":
        return "limited";
      default:
        return "closed";
    }
  }
  mapAttractionStatus(status) {
    switch (status.toLowerCase()) {
      case "operating":
        return "operating";
      case "down":
        return "down";
      case "delayed":
        return "delayed";
      case "closed":
      case "refurbishment":
        return "temporary_closure";
      default:
        return "down";
    }
  }
  mapEntertainmentStatus(status) {
    switch (status.toLowerCase()) {
      case "operating":
        return "operating";
      case "delayed":
        return "delayed";
      case "closed":
      case "cancelled":
      case "refurbishment":
      case "down":
        return "cancelled";
      default:
        return "cancelled";
    }
  }
  clearCache(pattern) {
    if (!pattern) {
      this.cache.clear();
      return;
    }
    for (const [key] of this.cache.entries()) {
      if (key.includes(pattern)) {
        this.cache.delete(key);
      }
    }
  }
  getCacheStats() {
    const stats = {};
    for (const [key, value] of this.cache.entries()) {
      const category = key.split("/")[4] || "general";
      if (!stats[category]) {
        stats[category] = {
          size: 0,
          oldestEntry: new Date(value.timestamp).toISOString(),
          newestEntry: new Date(value.timestamp).toISOString()
        };
      }
      stats[category].size++;
      const entryTime = new Date(value.timestamp).toISOString();
      if (entryTime < stats[category].oldestEntry) {
        stats[category].oldestEntry = entryTime;
      }
      if (entryTime > stats[category].newestEntry) {
        stats[category].newestEntry = entryTime;
      }
    }
    return stats;
  }
};
var themeParksApiClient = new ThemeParksAPIClient();

// src/services/queueTimesApi.ts
var QUEUE_TIMES_API_BASE = "https://queue-times.com/en-US/parks";
var QueueTimesAPIClient = class {
  constructor() {
    this.cache = /* @__PURE__ */ new Map();
    this.defaultCacheTTL = 24 * 60 * 60 * 1e3;
  }
  // 24 hours for crowd predictions
  async fetchWithCache(url, ttl = this.defaultCacheTTL) {
    const cacheKey = url;
    const cached = this.cache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < cached.ttl) {
      return cached.data;
    }
    try {
      const response = await fetch(url);
      if (!response.ok) {
        if (response.status === 429) {
          const apiError = {
            code: "RATE_LIMITED",
            message: "Queue-Times API rate limit exceeded",
            details: { url, status: response.status },
            timestamp: (/* @__PURE__ */ new Date()).toISOString()
          };
          throw apiError;
        }
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const data = await response.json();
      this.cache.set(cacheKey, {
        data,
        timestamp: Date.now(),
        ttl
      });
      return data;
    } catch (error) {
      if (error instanceof Error && "code" in error) {
        throw error;
      }
      const apiError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Unknown Queue-Times API error",
        details: { url, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw apiError;
    }
  }
  async getCrowdPredictions(waypointParkId, days = 180) {
    const mapping = getParkMapping(waypointParkId);
    if (!mapping?.queueTimesId) {
      throw new Error(`No Queue-Times mapping found for park: ${waypointParkId}`);
    }
    try {
      const queueTimesUrl = this.getQueueTimesUrl(mapping.queueTimesId);
      const response = await this.fetchWithCache(
        `${queueTimesUrl}.json`
      );
      const predictions = response.forecast.slice(0, days).map((forecast) => ({
        date: forecast.date,
        level: forecast.crowd_level,
        description: this.mapCrowdLevelToDescription(forecast.crowd_level),
        recommendation: this.getCrowdRecommendation(forecast.crowd_level)
      }));
      return {
        parkId: waypointParkId,
        predictions,
        lastUpdated: (/* @__PURE__ */ new Date()).toISOString()
      };
    } catch (error) {
      if (error instanceof Error && "code" in error) {
        throw error;
      }
      const apiError = {
        code: "PARSE_ERROR",
        message: `Failed to parse crowd data for ${waypointParkId}`,
        details: { waypointParkId, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw apiError;
    }
  }
  async getCurrentCrowdLevel(waypointParkId) {
    try {
      const crowdData = await this.getCrowdPredictions(waypointParkId, 1);
      const today = (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
      const todayPrediction = crowdData.predictions.find((p) => p.date === today);
      return todayPrediction?.level || null;
    } catch (error) {
      console.warn(`Failed to get current crowd level for ${waypointParkId}:`, error);
      return null;
    }
  }
  /**
   * Get crowd predictions for a specific date range
   * Returns data in ParkCrowdPrediction format for database storage
   */
  async getCrowdPredictionsForDateRange(waypointParkId, startDate, endDate) {
    const mapping = getParkMapping(waypointParkId);
    if (!mapping?.queueTimesId) {
      throw new Error(`No Queue-Times mapping found for park: ${waypointParkId}`);
    }
    try {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const queueTimesUrl = this.getQueueTimesUrl(mapping.queueTimesId);
      const response = await this.fetchWithCache(
        `${queueTimesUrl}.json`,
        48 * 60 * 60 * 1e3
        // 48 hour cache for crowd predictions
      );
      const filteredPredictions = response.forecast.filter((forecast) => {
        const forecastDate = new Date(forecast.date);
        return forecastDate >= start && forecastDate <= end;
      }).map((forecast) => ({
        parkId: waypointParkId,
        predictionDate: forecast.date,
        crowdLevel: forecast.crowd_level,
        description: this.mapCrowdLevelToDescription(forecast.crowd_level),
        recommendation: this.getCrowdRecommendation(forecast.crowd_level),
        dataSource: "queue_times_api",
        lastUpdated: (/* @__PURE__ */ new Date()).toISOString()
      }));
      return filteredPredictions;
    } catch (error) {
      if (error instanceof Error && "code" in error) {
        throw error;
      }
      const apiError = {
        code: "PARSE_ERROR",
        message: `Failed to get crowd predictions for ${waypointParkId} (${startDate} to ${endDate})`,
        details: { waypointParkId, startDate, endDate, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw apiError;
    }
  }
  /**
   * Get crowd predictions for the next N days starting from today
   * Optimized for bulk 180-day forecasts
   */
  async getCrowdPredictionsForDays(waypointParkId, days = 180) {
    const today = /* @__PURE__ */ new Date();
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + days - 1);
    return this.getCrowdPredictionsForDateRange(
      waypointParkId,
      today.toISOString().split("T")[0],
      endDate.toISOString().split("T")[0]
    );
  }
  getQueueTimesUrl(queueTimesId) {
    const urlMappings = {
      "magic-kingdom": `${QUEUE_TIMES_API_BASE}/6/queue_times`,
      "epcot": `${QUEUE_TIMES_API_BASE}/5/queue_times`,
      "hollywood-studios": `${QUEUE_TIMES_API_BASE}/7/queue_times`,
      "animal-kingdom": `${QUEUE_TIMES_API_BASE}/8/queue_times`
    };
    const url = urlMappings[queueTimesId];
    if (!url) {
      throw new Error(`No Queue-Times URL mapping for: ${queueTimesId}`);
    }
    return url;
  }
  mapCrowdLevelToDescription(level) {
    if (level <= 2) return "Very Low";
    if (level <= 4) return "Low";
    if (level <= 6) return "Moderate";
    if (level <= 8) return "High";
    return "Very High";
  }
  getCrowdRecommendation(level) {
    if (level <= 2) {
      return "Perfect day to visit! Short wait times expected.";
    }
    if (level <= 4) {
      return "Great day to visit with manageable crowds.";
    }
    if (level <= 6) {
      return "Moderate crowds. Consider Lightning Lanes for popular attractions.";
    }
    if (level <= 8) {
      return "Busy day. Arrive early and use Lightning Lanes strategically.";
    }
    return "Very busy day. Early arrival and Lightning Lanes highly recommended.";
  }
  clearCache(pattern) {
    if (!pattern) {
      this.cache.clear();
      return;
    }
    for (const [key, _] of this.cache.entries()) {
      if (key.includes(pattern)) {
        this.cache.delete(key);
      }
    }
  }
  getCacheStats() {
    const stats = {};
    for (const [, value] of this.cache.entries()) {
      const category = "crowd_predictions";
      if (!stats[category]) {
        stats[category] = {
          size: 0,
          oldestEntry: new Date(value.timestamp).toISOString(),
          newestEntry: new Date(value.timestamp).toISOString()
        };
      }
      stats[category].size++;
      const entryTime = new Date(value.timestamp).toISOString();
      if (entryTime < stats[category].oldestEntry) {
        stats[category].oldestEntry = entryTime;
      }
      if (entryTime > stats[category].newestEntry) {
        stats[category].newestEntry = entryTime;
      }
    }
    return stats;
  }
};
var queueTimesApiClient = new QueueTimesAPIClient();

// src/services/crowdPredictionRepository.ts
var CrowdPredictionRepository = class {
  /**
   * Get crowd predictions for a specific park and date range
   */
  async getCrowdPredictionsForDateRange(parkId, startDate, endDate) {
    try {
      const { data, error } = await supabase.from("park_crowd_predictions").select("*").eq("park_id", parkId).gte("prediction_date", startDate).lte("prediction_date", endDate).order("prediction_date");
      if (error) throw error;
      return (data || []).map(this.transformDbToPrediction);
    } catch (error) {
      const liveDataError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Database error",
        details: { parkId, startDate, endDate, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw liveDataError;
    }
  }
  /**
   * Get crowd prediction for a specific park and date
   */
  async getCrowdPredictionForDate(parkId, date) {
    try {
      const { data, error } = await supabase.from("park_crowd_predictions").select("*").eq("park_id", parkId).eq("prediction_date", date).single();
      if (error) {
        if (error.code === "PGRST116") {
          return null;
        }
        throw error;
      }
      return this.transformDbToPrediction(data);
    } catch (error) {
      const liveDataError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Database error",
        details: { parkId, date, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw liveDataError;
    }
  }
  /**
   * Get all crowd predictions for multiple parks within a date range
   */
  async getMultipleParkCrowdPredictions(parkIds, startDate, endDate) {
    try {
      const { data, error } = await supabase.from("park_crowd_predictions").select("*").in("park_id", parkIds).gte("prediction_date", startDate).lte("prediction_date", endDate).order("park_id").order("prediction_date");
      if (error) throw error;
      return (data || []).map(this.transformDbToPrediction);
    } catch (error) {
      const liveDataError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Database error",
        details: { parkIds, startDate, endDate, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw liveDataError;
    }
  }
  /**
   * Upsert crowd predictions for a park (bulk operation)
   */
  async upsertCrowdPredictions(predictions) {
    if (predictions.length === 0) return;
    try {
      const { error } = await supabase.from("park_crowd_predictions").upsert(predictions, { onConflict: "park_id,prediction_date" });
      if (error) throw error;
    } catch (error) {
      const liveDataError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Database upsert error",
        details: { predictionsCount: predictions.length, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw liveDataError;
    }
  }
  /**
   * Get crowd predictions by crowd level (for finding low-crowd days)
   */
  async getCrowdPredictionsByLevel(parkId, maxCrowdLevel, startDate, endDate) {
    try {
      const { data, error } = await supabase.from("park_crowd_predictions").select("*").eq("park_id", parkId).lte("crowd_level", maxCrowdLevel).gte("prediction_date", startDate).lte("prediction_date", endDate).order("crowd_level").order("prediction_date");
      if (error) throw error;
      return (data || []).map(this.transformDbToPrediction);
    } catch (error) {
      const liveDataError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Database error",
        details: { parkId, maxCrowdLevel, startDate, endDate, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw liveDataError;
    }
  }
  /**
   * Clean up old crowd predictions (past dates)
   */
  async cleanupOldPredictions() {
    try {
      const { data, error } = await supabase.rpc("cleanup_old_crowd_predictions");
      if (error) throw error;
      return data || 0;
    } catch (error) {
      console.warn("cleanup_old_crowd_predictions function not found, using fallback");
      try {
        const yesterday = /* @__PURE__ */ new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const cutoffDate = yesterday.toISOString().split("T")[0];
        const { count, error: deleteError } = await supabase.from("park_crowd_predictions").delete({ count: "exact" }).lt("prediction_date", cutoffDate);
        if (deleteError) throw deleteError;
        return count || 0;
      } catch (fallbackError) {
        const liveDataError = {
          code: "API_ERROR",
          message: fallbackError instanceof Error ? fallbackError.message : "Cleanup error",
          details: { error: fallbackError },
          timestamp: (/* @__PURE__ */ new Date()).toISOString()
        };
        throw liveDataError;
      }
    }
  }
  /**
   * Get statistics about crowd predictions data
   */
  async getCrowdPredictionStats(parkId) {
    try {
      let query = supabase.from("park_crowd_predictions").select("*");
      if (parkId) {
        query = query.eq("park_id", parkId);
      }
      const { data, error } = await query;
      if (error) throw error;
      if (!data || data.length === 0) {
        return {
          totalPredictions: 0,
          dateRange: { earliest: "", latest: "" },
          avgCrowdLevel: 0,
          lastSyncTime: ""
        };
      }
      const sortedDates = data.map((p) => p.prediction_date).sort();
      const avgCrowdLevel = data.reduce((sum, p) => sum + p.crowd_level, 0) / data.length;
      const latestSync = data.reduce(
        (latest, p) => p.synced_at > latest ? p.synced_at : latest,
        data[0].synced_at
      );
      return {
        totalPredictions: data.length,
        dateRange: {
          earliest: sortedDates[0],
          latest: sortedDates[sortedDates.length - 1]
        },
        avgCrowdLevel: Math.round(avgCrowdLevel * 100) / 100,
        lastSyncTime: latestSync
      };
    } catch (error) {
      const liveDataError = {
        code: "API_ERROR",
        message: error instanceof Error ? error.message : "Stats query error",
        details: { parkId, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw liveDataError;
    }
  }
  /**
   * Transform database row to ParkCrowdPrediction interface
   */
  transformDbToPrediction(row) {
    return {
      parkId: row.park_id,
      predictionDate: row.prediction_date,
      crowdLevel: row.crowd_level,
      description: row.crowd_level_description,
      recommendation: row.recommendation || void 0,
      dataSource: row.data_source,
      confidenceScore: row.confidence_score || void 0,
      lastUpdated: row.synced_at
    };
  }
  /**
   * Transform ParkCrowdPrediction to database insert format
   */
  static transformPredictionToDb(prediction) {
    return {
      park_id: prediction.parkId,
      prediction_date: prediction.predictionDate,
      crowd_level: prediction.crowdLevel,
      crowd_level_description: prediction.description,
      recommendation: prediction.recommendation || null,
      data_source: prediction.dataSource,
      confidence_score: prediction.confidenceScore || null,
      synced_at: prediction.lastUpdated
    };
  }
};
var crowdPredictionRepository = new CrowdPredictionRepository();

// src/services/backgroundSyncService.ts
var DEFAULT_SYNC_CONFIG = {
  syncIntervalMinutes: 15,
  // Sync every 15 minutes
  enabledParks: ["magic-kingdom", "epcot", "hollywood-studios", "animal-kingdom"],
  enabledServices: {
    themeparks: true,
    queueTimes: true
  },
  retryAttempts: 3,
  retryDelayMs: 5e3
};
var BackgroundSyncService = class {
  constructor(config = {}) {
    this.syncTimers = /* @__PURE__ */ new Map();
    this.isRunning = false;
    this.config = { ...DEFAULT_SYNC_CONFIG, ...config };
  }
  /**
   * Start the background sync process
   */
  async start() {
    if (this.isRunning) {
      console.log("Background sync service is already running");
      return;
    }
    this.isRunning = true;
    console.log("Starting background sync service...");
    await this.runFullSync();
    const syncTimer = setInterval(async () => {
      try {
        await this.runFullSync();
      } catch (error) {
        console.error("Scheduled sync failed:", error);
      }
    }, this.config.syncIntervalMinutes * 60 * 1e3);
    this.syncTimers.set("main", syncTimer);
    console.log(`Background sync scheduled every ${this.config.syncIntervalMinutes} minutes`);
  }
  /**
   * Stop the background sync process
   */
  stop() {
    if (!this.isRunning) return;
    this.isRunning = false;
    this.syncTimers.forEach((timer) => clearInterval(timer));
    this.syncTimers.clear();
    console.log("Background sync service stopped");
  }
  /**
   * Run a full sync of all enabled services and parks
   */
  async runFullSync() {
    console.log("Starting full sync...");
    const startTime = Date.now();
    const syncPromises = [];
    if (this.config.enabledServices.themeparks) {
      syncPromises.push(this.syncThemeParksData());
    }
    if (this.config.enabledServices.queueTimes) {
      syncPromises.push(this.syncQueueTimesData());
    }
    await Promise.allSettled(syncPromises);
    await this.cleanupOldData();
    const duration = Date.now() - startTime;
    console.log(`Full sync completed in ${duration}ms`);
  }
  /**
   * Sync all parks data (used by manual sync API)
   */
  async syncAllParks() {
    console.log("\u{1F680} Starting manual sync for all parks...");
    const startTime = Date.now();
    const results = {
      success: true,
      parksProcessed: 0,
      errors: []
    };
    try {
      await this.runFullSync();
      if (this.config.enabledServices.queueTimes) {
        console.log("\u{1F4CA} Adding crowd predictions sync...");
        const crowdResults = await this.syncAllParkCrowdPredictions(180);
        results.parksProcessed = crowdResults.parksProcessed;
        results.errors.push(...crowdResults.errors);
        if (!crowdResults.success) {
          results.success = false;
        }
      } else {
        results.parksProcessed = this.config.enabledParks.length;
      }
      const duration = Date.now() - startTime;
      console.log(`\u{1F680} Manual sync completed in ${duration}ms. Success: ${results.success}`);
      return results;
    } catch (error) {
      results.success = false;
      results.errors.push(`Sync failed: ${error instanceof Error ? error.message : "Unknown error"}`);
      console.error("\u274C Manual sync failed:", error);
      return results;
    }
  }
  /**
   * Sync data from ThemeParks.wiki API
   */
  async syncThemeParksData() {
    const serviceName = "themeparks_api";
    console.log(`Syncing ${serviceName}...`);
    try {
      for (const parkId of this.config.enabledParks) {
        await this.syncSingleParkFromThemeParks(parkId);
      }
      await liveDataRepository.updateSyncStatus(serviceName, true);
      console.log(`${serviceName} sync successful`);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Unknown error";
      await liveDataRepository.updateSyncStatus(serviceName, false, errorMessage);
      console.error(`${serviceName} sync failed:`, error);
    }
  }
  /**
   * Sync data from Queue-Times API
   */
  async syncQueueTimesData() {
    const serviceName = "queue_times_api";
    console.log(`Syncing ${serviceName}...`);
    try {
      for (const parkId of this.config.enabledParks) {
        await this.syncCrowdDataFromQueueTimes(parkId);
      }
      await liveDataRepository.updateSyncStatus(serviceName, true);
      console.log(`${serviceName} sync successful`);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Unknown error";
      await liveDataRepository.updateSyncStatus(serviceName, false, errorMessage);
      console.error(`${serviceName} sync failed:`, error);
    }
  }
  /**
   * Sync a single park's data from ThemeParks.wiki
   */
  async syncSingleParkFromThemeParks(parkId) {
    const mapping = getParkMapping(parkId);
    if (!mapping) {
      console.warn(`No mapping found for park: ${parkId}`);
      return;
    }
    let attempt = 0;
    while (attempt < this.config.retryAttempts) {
      try {
        console.log(`Syncing ${parkId} (attempt ${attempt + 1})`);
        const parkData = await themeParksApiClient.getParkLiveData(parkId);
        const parkInsert = {
          park_id: parkId,
          external_id: mapping.themeParksWikiId,
          name: mapping.displayName,
          status: parkData.status,
          regular_open: parkData.hours.regular.open || "09:00",
          regular_close: parkData.hours.regular.close || "21:00",
          early_entry_open: parkData.hours.earlyEntry?.open || null,
          extended_evening_close: parkData.hours.extendedEvening?.close || null,
          crowd_level: parkData.crowdLevel || null,
          last_updated: parkData.lastUpdated
        };
        await liveDataRepository.upsertParkData(parkInsert);
        if (parkData.attractions.length > 0) {
          const attractionInserts = parkData.attractions.map((attraction) => ({
            park_id: parkId,
            external_id: attraction.id,
            name: this.extractNameFromId(attraction.id),
            wait_time: attraction.waitTime,
            status: attraction.status,
            lightning_lane_available: attraction.lightningLane?.available || false,
            lightning_lane_return_time: attraction.lightningLane?.returnTime || null,
            single_rider_available: attraction.singleRider?.available || false,
            single_rider_wait_time: attraction.singleRider?.waitTime || null,
            last_updated: attraction.lastUpdated
          }));
          await liveDataRepository.upsertAttractionData(attractionInserts);
        }
        if (parkData.entertainment.length > 0) {
          const entertainmentInserts = parkData.entertainment.map((entertainment2) => ({
            park_id: parkId,
            external_id: entertainment2.id,
            name: this.extractNameFromId(entertainment2.id),
            show_times: entertainment2.showTimes,
            status: entertainment2.status,
            next_show_time: entertainment2.nextShowTime || null,
            last_updated: entertainment2.lastUpdated
          }));
          await liveDataRepository.upsertEntertainmentData(entertainmentInserts);
        }
        console.log(`Successfully synced ${parkId}`);
        break;
      } catch (error) {
        attempt++;
        console.error(`Sync attempt ${attempt} failed for ${parkId}:`, error);
        if (attempt < this.config.retryAttempts) {
          await this.delay(this.config.retryDelayMs * attempt);
        } else {
          throw error;
        }
      }
    }
  }
  /**
   * Sync crowd data from Queue-Times API
   */
  async syncCrowdDataFromQueueTimes(parkId) {
    try {
      const crowdLevel = await queueTimesApiClient.getCurrentCrowdLevel(parkId);
      if (crowdLevel !== null) {
        const existingPark = await liveDataRepository.getParkData(parkId);
        if (existingPark) {
          const mapping = getParkMapping(parkId);
          if (mapping) {
            const parkUpdate = {
              park_id: parkId,
              external_id: mapping.themeParksWikiId,
              name: mapping.displayName,
              status: existingPark.status,
              regular_open: existingPark.hours.regular.open || "09:00",
              regular_close: existingPark.hours.regular.close || "21:00",
              early_entry_open: existingPark.hours.earlyEntry?.open || null,
              extended_evening_close: existingPark.hours.extendedEvening?.close || null,
              crowd_level: crowdLevel,
              last_updated: (/* @__PURE__ */ new Date()).toISOString()
            };
            await liveDataRepository.upsertParkData(parkUpdate);
          }
        }
      }
    } catch (error) {
      console.warn(`Failed to sync crowd data for ${parkId}:`, error);
    }
  }
  /**
   * Sync 180-day crowd predictions for a park from Queue-Times API
   */
  async syncCrowdPredictions(parkId, days = 180) {
    try {
      console.log(`Syncing ${days}-day crowd predictions for ${parkId}...`);
      const predictions = await queueTimesApiClient.getCrowdPredictionsForDays(parkId, days);
      if (predictions.length > 0) {
        const dbPredictions = predictions.map(
          (prediction) => CrowdPredictionRepository.transformPredictionToDb(prediction)
        );
        await crowdPredictionRepository.upsertCrowdPredictions(dbPredictions);
        console.log(`\u2705 Synced ${predictions.length} crowd predictions for ${parkId}`);
        await liveDataRepository.updateSyncStatus("crowd_predictions", true);
      } else {
        console.warn(`\u26A0\uFE0F No crowd predictions received for ${parkId}`);
      }
    } catch (error) {
      console.error(`\u274C Failed to sync crowd predictions for ${parkId}:`, error);
      await liveDataRepository.updateSyncStatus(
        "crowd_predictions",
        false,
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
  /**
   * Sync crowd predictions for all supported parks
   */
  async syncAllParkCrowdPredictions(days = 180) {
    const results = {
      success: true,
      parksProcessed: 0,
      errors: []
    };
    console.log(`\u{1F52E} Starting crowd predictions sync for ${days} days...`);
    try {
      const cleanedCount = await crowdPredictionRepository.cleanupOldPredictions();
      if (cleanedCount > 0) {
        console.log(`\u{1F9F9} Cleaned up ${cleanedCount} old crowd predictions`);
      }
      for (const parkId of this.config.enabledParks) {
        if (!this.config.enabledServices.queueTimes) {
          console.log(`Skipping crowd predictions for ${parkId} (Queue-Times disabled)`);
          continue;
        }
        try {
          await this.syncCrowdPredictions(parkId, days);
          results.parksProcessed++;
          if (results.parksProcessed < this.config.enabledParks.length) {
            await this.delay(2e3);
          }
        } catch (error) {
          const errorMsg = `Failed to sync crowd predictions for ${parkId}: ${error instanceof Error ? error.message : "Unknown error"}`;
          results.errors.push(errorMsg);
          console.error(errorMsg);
        }
      }
      results.success = results.errors.length === 0;
      console.log(`\u{1F52E} Crowd predictions sync completed. Parks: ${results.parksProcessed}, Errors: ${results.errors.length}`);
      return results;
    } catch (error) {
      results.success = false;
      results.errors.push(`Crowd predictions sync failed: ${error instanceof Error ? error.message : "Unknown error"}`);
      console.error("\u274C Crowd predictions sync failed:", error);
      return results;
    }
  }
  /**
   * Clean up old data from database
   */
  async cleanupOldData() {
    try {
      await liveDataRepository.cleanOldData(24);
      console.log("Old data cleanup completed");
    } catch (error) {
      console.error("Data cleanup failed:", error);
    }
  }
  /**
   * Extract a readable name from an entity ID
   * This is a fallback for when API doesn't provide names
   */
  extractNameFromId(id) {
    return id.split("-").map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    ).join(" ");
  }
  /**
   * Utility function for delays
   */
  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  /**
   * Get sync statistics
   */
  async getSyncStats() {
    const [themeparksStatus, queueTimesStatus] = await Promise.all([
      liveDataRepository.getSyncStatus("themeparks_api"),
      liveDataRepository.getSyncStatus("queue_times_api")
    ]);
    return {
      themeparks: themeparksStatus,
      queueTimes: queueTimesStatus
    };
  }
  /**
   * Update sync configuration
   */
  updateConfig(newConfig) {
    this.config = { ...this.config, ...newConfig };
    if (this.isRunning) {
      console.log("Restarting sync service with new configuration...");
      this.stop();
      this.start();
    }
  }
  /**
   * Get current configuration
   */
  getConfig() {
    return { ...this.config };
  }
  /**
   * Check if service is running
   */
  isServiceRunning() {
    return this.isRunning;
  }
};
var backgroundSyncService = new BackgroundSyncService();

// src/services/activityRatingsService.ts
var ActivityRatingsService = class {
  /**
   * Get all ratings for a specific trip
   */
  static async getRatingsForTrip(tripId) {
    const { data, error } = await supabase.from("activity_ratings").select("*").eq("trip_id", tripId).order("created_at", { ascending: false });
    if (error) {
      console.error("Error fetching ratings for trip:", error);
      throw new Error(`Failed to fetch ratings: ${error.message}`);
    }
    return (data || []).map(this.mapDatabaseToRating);
  }
  /**
   * Get ratings for a specific attraction within a trip
   */
  static async getRatingsForAttraction(tripId, attractionId) {
    const { data, error } = await supabase.from("activity_ratings").select("*").eq("trip_id", tripId).eq("attraction_id", attractionId).order("created_at", { ascending: false });
    if (error) {
      console.error("Error fetching ratings for attraction:", error);
      throw new Error(`Failed to fetch ratings: ${error.message}`);
    }
    return (data || []).map(this.mapDatabaseToRating);
  }
  /**
   * Get rating summaries for a trip
   */
  static async getRatingSummariesForTrip(tripId) {
    const { data, error } = await supabase.from("activity_rating_summaries").select("*").eq("trip_id", tripId).order("average_rating", { ascending: false });
    if (error) {
      console.error("Error fetching rating summaries:", error);
      throw new Error(`Failed to fetch rating summaries: ${error.message}`);
    }
    return (data || []).map(this.mapDatabaseToSummary);
  }
  /**
   * Create or update a rating
   */
  static async upsertRating(rating) {
    const dbRating = this.mapRatingToDatabase(rating);
    const { data, error } = await supabase.from("activity_ratings").upsert(dbRating, {
      onConflict: "trip_id,party_member_id,attraction_id",
      ignoreDuplicates: false
    }).select().single();
    if (error) {
      console.error("Error upserting rating:", error);
      throw new Error(`Failed to save rating: ${error.message}`);
    }
    return this.mapDatabaseToRating(data);
  }
  /**
   * Delete a rating
   */
  static async deleteRating(ratingId) {
    const { error } = await supabase.from("activity_ratings").delete().eq("id", ratingId);
    if (error) {
      console.error("Error deleting rating:", error);
      throw new Error(`Failed to delete rating: ${error.message}`);
    }
  }
  /**
   * Get a user's rating for a specific attraction
   */
  static async getUserRating(tripId, partyMemberId, attractionId) {
    const { data, error } = await supabase.from("activity_ratings").select("*").eq("trip_id", tripId).eq("party_member_id", partyMemberId).eq("attraction_id", attractionId).maybeSingle();
    if (error) {
      console.error("Error fetching user rating:", error);
      throw new Error(`Failed to fetch user rating: ${error.message}`);
    }
    return data ? this.mapDatabaseToRating(data) : null;
  }
  /**
   * Bulk create/update ratings for a party member
   */
  static async bulkUpsertRatings(ratings) {
    const dbRatings = ratings.map(this.mapRatingToDatabase);
    const { data, error } = await supabase.from("activity_ratings").upsert(dbRatings, {
      onConflict: "trip_id,party_member_id,attraction_id",
      ignoreDuplicates: false
    }).select();
    if (error) {
      console.error("Error bulk upserting ratings:", error);
      throw new Error(`Failed to save ratings: ${error.message}`);
    }
    return (data || []).map(this.mapDatabaseToRating);
  }
  /**
   * Get ratings with consensus issues (conflict level)
   */
  static async getConflictingRatings(tripId) {
    const { data, error } = await supabase.from("activity_rating_summaries").select("*").eq("trip_id", tripId).eq("consensus_level", "conflict").order("average_rating", { ascending: false });
    if (error) {
      console.error("Error fetching conflicting ratings:", error);
      throw new Error(`Failed to fetch conflicting ratings: ${error.message}`);
    }
    return (data || []).map(this.mapDatabaseToSummary);
  }
  /**
   * Get high-priority attractions (must-do items)
   */
  static async getHighPriorityAttractions(tripId) {
    const { data, error } = await supabase.from("activity_rating_summaries").select("*").eq("trip_id", tripId).gt("must_do_count", 0).order("must_do_count", { ascending: false });
    if (error) {
      console.error("Error fetching high priority attractions:", error);
      throw new Error(`Failed to fetch high priority attractions: ${error.message}`);
    }
    return (data || []).map(this.mapDatabaseToSummary);
  }
  // Helper methods for mapping between database and TypeScript types
  static mapDatabaseToRating(dbRating) {
    return {
      id: dbRating.id,
      tripId: dbRating.trip_id,
      partyMemberId: dbRating.party_member_id,
      attractionId: dbRating.attraction_id,
      activityType: dbRating.activity_type,
      rating: dbRating.rating,
      preferenceType: dbRating.preference_type,
      notes: dbRating.notes,
      heightRestrictionOk: dbRating.height_restriction_ok,
      intensityComfortable: dbRating.intensity_comfortable,
      createdAt: dbRating.created_at,
      updatedAt: dbRating.updated_at
    };
  }
  static mapDatabaseToSummary(dbSummary) {
    return {
      id: dbSummary.id,
      tripId: dbSummary.trip_id,
      attractionId: dbSummary.attraction_id,
      activityType: dbSummary.activity_type,
      averageRating: dbSummary.average_rating,
      ratingCount: dbSummary.rating_count,
      mustDoCount: dbSummary.must_do_count,
      avoidCount: dbSummary.avoid_count,
      consensusLevel: dbSummary.consensus_level,
      heightRestrictedCount: dbSummary.height_restricted_count,
      intensityConcernsCount: dbSummary.intensity_concerns_count,
      lastCalculatedAt: dbSummary.last_calculated_at,
      createdAt: dbSummary.created_at,
      updatedAt: dbSummary.updated_at
    };
  }
  static mapRatingToDatabase(rating) {
    const dbRating = {
      trip_id: rating.tripId,
      party_member_id: rating.partyMemberId,
      attraction_id: rating.attractionId,
      activity_type: rating.activityType,
      rating: rating.rating,
      preference_type: rating.preferenceType,
      notes: rating.notes,
      height_restriction_ok: rating.heightRestrictionOk,
      intensity_comfortable: rating.intensityComfortable
    };
    if (rating.id) {
      dbRating.id = rating.id;
    }
    Object.keys(dbRating).forEach((key) => {
      if (dbRating[key] === void 0) {
        delete dbRating[key];
      }
    });
    return dbRating;
  }
};

// src/services/invitationService.ts
var InvitationService = class _InvitationService {
  static getInstance() {
    if (!_InvitationService.instance) {
      _InvitationService.instance = new _InvitationService();
    }
    return _InvitationService.instance;
  }
  async sendInvitation(request) {
    const currentUser = authService.getState().user;
    if (!currentUser) {
      throw new Error("User must be authenticated to send invitations");
    }
    const hasPermission = await this.checkInvitePermission(request.tripId, currentUser.id);
    if (!hasPermission) {
      throw new Error("You do not have permission to invite collaborators to this trip");
    }
    const existingInvitation = await this.getExistingInvitation(request.tripId, request.email);
    if (existingInvitation && existingInvitation.status === "pending") {
      throw new Error("An invitation has already been sent to this email address");
    }
    const existingCollaborator = await this.getExistingCollaborator(request.tripId, request.email);
    if (existingCollaborator) {
      throw new Error("This person is already collaborating on this trip");
    }
    const invitationToken = this.generateInvitationToken();
    const expiresAt = /* @__PURE__ */ new Date();
    expiresAt.setDate(expiresAt.getDate() + (request.expiresInDays || 7));
    const { data: tripData } = await supabase.from("trips").select("name").eq("id", request.tripId).single();
    const { data, error } = await supabase.from("trip_invitations").insert({
      trip_id: request.tripId,
      invited_email: request.email.toLowerCase(),
      invited_by: currentUser.id,
      inviter_name: currentUser.fullName || currentUser.email || "Someone",
      trip_name: tripData?.name || "Trip",
      permission_level: request.permissionLevel,
      invitation_token: invitationToken,
      status: "pending",
      expires_at: expiresAt.toISOString(),
      message: request.message || null
    }).select().single();
    if (error) {
      throw new Error(`Failed to create invitation: ${error.message}`);
    }
    await this.sendInvitationEmail(data, currentUser);
    await this.logTripActivity(
      request.tripId,
      currentUser.id,
      "shared",
      `Invited ${request.email} to collaborate on the trip`,
      { invitedEmail: request.email, permissionLevel: request.permissionLevel }
    );
    return this.formatInvitation(data);
  }
  async acceptInvitation(token) {
    const currentUser = authService.getState().user;
    if (!currentUser) {
      throw new Error("User must be authenticated to accept invitations");
    }
    const { data: invitation, error: inviteError } = await supabase.from("trip_invitations").select("*").eq("invitation_token", token).eq("status", "pending").single();
    if (inviteError || !invitation) {
      throw new Error("Invalid or expired invitation");
    }
    if (new Date(invitation.expires_at) < /* @__PURE__ */ new Date()) {
      await this.updateInvitationStatus(invitation.id, "expired");
      throw new Error("This invitation has expired");
    }
    if (invitation.invited_email.toLowerCase() !== currentUser.email?.toLowerCase()) {
      throw new Error("This invitation was sent to a different email address");
    }
    const existingCollaborator = await this.getExistingCollaboratorByUserId(invitation.trip_id, currentUser.id);
    if (existingCollaborator) {
      throw new Error("You are already a collaborator on this trip");
    }
    const { data: collaborator, error: collabError } = await supabase.from("trip_collaborators").insert({
      trip_id: invitation.trip_id,
      user_id: currentUser.id,
      permission_level: invitation.permission_level,
      invited_by: invitation.invited_by,
      joined_at: (/* @__PURE__ */ new Date()).toISOString()
    }).select().single();
    if (collabError) {
      throw new Error(`Failed to add collaborator: ${collabError.message}`);
    }
    await this.updateInvitationStatus(invitation.id, "accepted");
    await this.markTripAsShared(invitation.trip_id);
    await this.logTripActivity(
      invitation.trip_id,
      currentUser.id,
      "joined",
      `${currentUser.email} joined the trip as a collaborator`,
      { permissionLevel: invitation.permission_level }
    );
    return this.formatCollaborator(collaborator);
  }
  async declineInvitation(token) {
    const { data: invitation, error } = await supabase.from("trip_invitations").select("*").eq("invitation_token", token).eq("status", "pending").single();
    if (error || !invitation) {
      throw new Error("Invalid invitation");
    }
    await this.updateInvitationStatus(invitation.id, "declined");
    await this.logTripActivity(
      invitation.trip_id,
      invitation.invited_by,
      "updated",
      `Invitation to ${invitation.invited_email} was declined`,
      { invitedEmail: invitation.invited_email }
    );
  }
  async removeCollaborator(tripId, collaboratorId) {
    const currentUser = authService.getState().user;
    if (!currentUser) {
      throw new Error("User must be authenticated");
    }
    const hasPermission = await this.checkRemovePermission(tripId, currentUser.id, collaboratorId);
    if (!hasPermission) {
      throw new Error("You do not have permission to remove this collaborator");
    }
    const { data: collaborator } = await supabase.from("trip_collaborators").select("*, profiles(email)").eq("id", collaboratorId).single();
    const { error } = await supabase.from("trip_collaborators").delete().eq("id", collaboratorId).eq("trip_id", tripId);
    if (error) {
      throw new Error(`Failed to remove collaborator: ${error.message}`);
    }
    if (collaborator) {
      await this.logTripActivity(
        tripId,
        currentUser.id,
        "left",
        `${collaborator.profiles?.email || "User"} was removed from the trip`,
        { removedBy: currentUser.id }
      );
    }
  }
  async updateCollaboratorPermission(tripId, collaboratorId, newPermission) {
    const currentUser = authService.getState().user;
    if (!currentUser) {
      throw new Error("User must be authenticated");
    }
    const hasPermission = await this.checkAdminPermission(tripId, currentUser.id);
    if (!hasPermission) {
      throw new Error("You do not have permission to change collaborator permissions");
    }
    const { error } = await supabase.from("trip_collaborators").update({
      permission_level: newPermission,
      updated_at: (/* @__PURE__ */ new Date()).toISOString()
    }).eq("id", collaboratorId).eq("trip_id", tripId);
    if (error) {
      throw new Error(`Failed to update permissions: ${error.message}`);
    }
    await this.logTripActivity(
      tripId,
      currentUser.id,
      "updated",
      `Updated collaborator permissions to ${newPermission}`,
      { collaboratorId, newPermission }
    );
  }
  async getTripCollaborators(tripId) {
    const { data, error } = await supabase.from("trip_collaborators").select("*").eq("trip_id", tripId).order("joined_at", { ascending: true });
    if (error) {
      throw new Error(`Failed to fetch collaborators: ${error.message}`);
    }
    return (data || []).map(this.formatCollaborator);
  }
  async getTripInvitations(tripId) {
    const { data, error } = await supabase.from("trip_invitations").select("*").eq("trip_id", tripId).order("created_at", { ascending: false });
    if (error) {
      throw new Error(`Failed to fetch invitations: ${error.message}`);
    }
    return (data || []).map(this.formatInvitation);
  }
  async getInvitationByToken(token) {
    const { data: invitation, error: inviteError } = await supabase.from("trip_invitations").select("*").eq("invitation_token", token).maybeSingle();
    if (inviteError) {
      throw new Error(`Failed to load invitation: ${inviteError.message}`);
    }
    if (!invitation) {
      throw new Error("Invitation not found or has already been responded to");
    }
    return {
      id: invitation.id,
      tripId: invitation.trip_id,
      tripName: invitation.trip_name || "Trip",
      invitedEmail: invitation.invited_email,
      invitedBy: invitation.invited_by,
      inviterName: invitation.inviter_name || "Someone",
      permissionLevel: invitation.permission_level,
      invitationToken: invitation.invitation_token,
      status: invitation.status,
      expiresAt: invitation.expires_at,
      message: invitation.message,
      createdAt: invitation.created_at,
      updatedAt: invitation.updated_at
    };
  }
  async getUserInvitations(email) {
    const { data, error } = await supabase.from("trip_invitations").select(`
        *,
        profiles!trip_invitations_invited_by_fkey(full_name),
        trips!trip_invitations_trip_id_fkey(name)
      `).eq("invited_email", email.toLowerCase()).eq("status", "pending").gt("expires_at", (/* @__PURE__ */ new Date()).toISOString()).order("created_at", { ascending: false });
    if (error) {
      throw new Error(`Failed to fetch user invitations: ${error.message}`);
    }
    return (data || []).map(this.formatInvitation);
  }
  // Private helper methods
  async checkInvitePermission(tripId, userId) {
    const { data: trip } = await supabase.from("trips").select("user_id").eq("id", tripId).single();
    if (trip?.user_id === userId) return true;
    const { data: collaborator } = await supabase.from("trip_collaborators").select("permission_level").eq("trip_id", tripId).eq("user_id", userId).single();
    return collaborator?.permission_level === "admin";
  }
  async checkRemovePermission(tripId, userId, collaboratorId) {
    const { data: collaborator } = await supabase.from("trip_collaborators").select("user_id").eq("id", collaboratorId).single();
    if (collaborator?.user_id === userId) return true;
    return await this.checkAdminPermission(tripId, userId);
  }
  async checkAdminPermission(tripId, userId) {
    const { data: trip } = await supabase.from("trips").select("user_id").eq("id", tripId).single();
    if (trip?.user_id === userId) return true;
    const { data: collaborator } = await supabase.from("trip_collaborators").select("permission_level").eq("trip_id", tripId).eq("user_id", userId).single();
    return collaborator?.permission_level === "admin";
  }
  async getExistingInvitation(tripId, email) {
    const { data, error } = await supabase.from("trip_invitations").select("*").eq("trip_id", tripId).eq("invited_email", email.toLowerCase()).eq("status", "pending").maybeSingle();
    if (error && error.code !== "PGRST116") {
      console.error("Database error checking existing invitation:", error);
      throw error;
    }
    return data;
  }
  async getExistingCollaborator(_tripId, _email) {
    return null;
  }
  async getExistingCollaboratorByUserId(tripId, userId) {
    const { data } = await supabase.from("trip_collaborators").select("*").eq("trip_id", tripId).eq("user_id", userId).single();
    return data;
  }
  async updateInvitationStatus(invitationId, status) {
    await supabase.from("trip_invitations").update({
      status,
      updated_at: (/* @__PURE__ */ new Date()).toISOString()
    }).eq("id", invitationId);
  }
  async markTripAsShared(tripId) {
    await supabase.from("trips").update({
      is_shared: true,
      updated_at: (/* @__PURE__ */ new Date()).toISOString()
    }).eq("id", tripId);
  }
  async logTripActivity(tripId, userId, actionType, description, metadata) {
    await supabase.from("trip_activity_log").insert({
      trip_id: tripId,
      user_id: userId,
      action_type: actionType,
      description,
      metadata
    });
  }
  generateInvitationToken() {
    return `invite_${Date.now()}_${Math.random().toString(36).substr(2, 16)}`;
  }
  async sendInvitationEmail(invitation, inviter) {
    console.log("\u{1F680} Starting email send process for:", invitation.invited_email);
    const startTime = Date.now();
    try {
      console.log("\u{1F511} Getting user session...");
      const sessionStart = Date.now();
      const { data: { session } } = await supabase.auth.getSession();
      console.log(`\u2705 Session retrieved in ${Date.now() - sessionStart}ms`);
      if (!session) {
        throw new Error("No active session for sending email");
      }
      console.log("\u{1F4CB} Preparing email data...");
      const emailData = {
        invitationId: invitation.id,
        invitedEmail: invitation.invited_email,
        inviterName: invitation.inviter_name || inviter.fullName || inviter.email || "Someone",
        tripName: invitation.trip_name || `Trip (${invitation.trip_id.slice(0, 8)})`,
        invitationToken: invitation.invitation_token,
        permissionLevel: invitation.permission_level,
        message: invitation.message,
        expiresAt: invitation.expires_at
      };
      console.log("\u{1F4E7} Email data prepared:", {
        to: emailData.invitedEmail,
        tripName: emailData.tripName,
        permission: emailData.permissionLevel
      });
      console.log("\u{1F310} Calling Edge Function...");
      const edgeFunctionStart = Date.now();
      const { data, error } = await Promise.race([
        supabase.functions.invoke("send-invitation-simple", {
          body: emailData,
          headers: {
            Authorization: `Bearer ${session.access_token}`
          }
        }),
        new Promise(
          (_, reject) => setTimeout(() => reject(new Error("Email sending timeout after 30 seconds")), 3e4)
        )
      ]);
      const edgeFunctionTime = Date.now() - edgeFunctionStart;
      console.log(`\u{1F4E4} Edge Function completed in ${edgeFunctionTime}ms`);
      if (error) {
        console.error("\u274C Email sending failed:", error);
        throw new Error(`Failed to send invitation email: ${error.message}`);
      }
      const totalTime = Date.now() - startTime;
      console.log(`\u2705 Invitation email sent successfully in ${totalTime}ms:`, {
        emailId: data?.emailId,
        recipient: invitation.invited_email,
        timing: {
          session: `${Date.now() - sessionStart}ms`,
          edgeFunction: `${edgeFunctionTime}ms`,
          total: `${totalTime}ms`
        }
      });
    } catch (error) {
      const totalTime = Date.now() - startTime;
      console.error(`\u274C Error in sendInvitationEmail after ${totalTime}ms:`, error);
      console.log("\u{1F4E7} Invitation email details (for manual sending):", {
        to: invitation.invited_email,
        from: inviter.email,
        subject: `You're invited to collaborate on "${invitation.trips?.name || "a trip"}"`,
        invitationUrl: `${this.getAppUrl()}/invite/${invitation.invitation_token}`,
        message: invitation.message,
        permissionLevel: invitation.permission_level,
        expiresAt: invitation.expires_at
      });
      throw new Error(`Email sending failed: ${error instanceof Error ? error.message : "Unknown error"}. The invitation was created but email delivery failed.`);
    }
  }
  getAppUrl() {
    if (typeof window !== "undefined") {
      return window.location.origin;
    }
    return process.env.VITE_APP_URL || process.env.APP_URL || "https://waylight.app";
  }
  formatCollaborator(data) {
    return {
      id: data.id,
      tripId: data.trip_id,
      userId: data.user_id,
      userEmail: data.user_id,
      // We'll use user_id as placeholder for email
      userFullName: data.user_id,
      // We'll use user_id as placeholder for name
      permissionLevel: data.permission_level,
      invitedBy: data.invited_by,
      joinedAt: data.joined_at,
      createdAt: data.created_at,
      updatedAt: data.updated_at
    };
  }
  formatInvitation(data) {
    return {
      id: data.id,
      tripId: data.trip_id,
      tripName: "Trip",
      // Placeholder since we're not fetching trip details
      invitedEmail: data.invited_email,
      invitedBy: data.invited_by,
      inviterName: data.invited_by,
      // Use user ID as placeholder
      permissionLevel: data.permission_level,
      invitationToken: data.invitation_token,
      status: data.status,
      expiresAt: data.expires_at,
      message: data.message,
      createdAt: data.created_at,
      updatedAt: data.updated_at
    };
  }
};
var invitationService = InvitationService.getInstance();

// src/services/collaborationService.ts
var CollaborationService = class _CollaborationService {
  constructor() {
    this.realtimeChannels = /* @__PURE__ */ new Map();
  }
  static getInstance() {
    if (!_CollaborationService.instance) {
      _CollaborationService.instance = new _CollaborationService();
    }
    return _CollaborationService.instance;
  }
  async getCollaborationContext(tripId) {
    const currentUser = authService.getState().user;
    if (!currentUser) {
      throw new Error("User must be authenticated");
    }
    const { data: tripData, error: tripError } = await supabase.from("trips").select("*").eq("id", tripId).single();
    if (tripError || !tripData) {
      throw new Error("Trip not found");
    }
    const userPermission = await this.getUserPermission(tripId, currentUser.id);
    if (!userPermission) {
      throw new Error("You do not have access to this trip");
    }
    const collaborators = await invitationService.getTripCollaborators(tripId);
    const pendingInvitations = await invitationService.getTripInvitations(tripId);
    const activityLog = await this.getTripActivityLog(tripId);
    const trip = {
      id: tripData.id,
      name: tripData.name,
      startDate: tripData.start_date,
      endDate: tripData.end_date,
      days: tripData.days || [],
      notes: tripData.notes || void 0,
      accommodation: tripData.accommodation,
      travelingParty: tripData.traveling_party,
      createdAt: tripData.created_at,
      updatedAt: tripData.updated_at,
      ownerId: tripData.user_id,
      isShared: tripData.is_shared,
      lastModifiedBy: tripData.last_modified_by,
      version: tripData.version,
      collaborators
    };
    return {
      currentUser: {
        id: currentUser.id,
        email: currentUser.email,
        fullName: currentUser.fullName || void 0
      },
      trip,
      userPermission,
      canEdit: userPermission === "edit" || userPermission === "admin",
      canAdmin: userPermission === "admin" || tripData.user_id === currentUser.id,
      collaborators,
      pendingInvitations,
      activityLog
    };
  }
  async updateTripWithConflictResolution(tripId, updates, expectedVersion) {
    const currentUser = authService.getState().user;
    if (!currentUser) {
      throw new Error("User must be authenticated");
    }
    const userPermission = await this.getUserPermission(tripId, currentUser.id);
    if (!userPermission || userPermission === "view") {
      throw new Error("You do not have permission to edit this trip");
    }
    const { data: currentTrip, error: fetchError } = await supabase.from("trips").select("*").eq("id", tripId).single();
    if (fetchError || !currentTrip) {
      throw new Error("Trip not found");
    }
    if (expectedVersion !== void 0 && currentTrip.version !== expectedVersion) {
      const conflictResolution = {
        tripId,
        conflictType: "version_mismatch",
        serverVersion: currentTrip.version,
        localVersion: expectedVersion,
        conflictedFields: this.identifyConflictedFields(updates, currentTrip),
        suggestedResolution: this.suggestResolution(updates, currentTrip),
        serverData: {
          name: currentTrip.name,
          days: currentTrip.days,
          notes: currentTrip.notes,
          accommodation: currentTrip.accommodation,
          travelingParty: currentTrip.traveling_party
        },
        localData: updates
      };
      const trip2 = this.formatTripFromDatabase(currentTrip);
      return { trip: trip2, conflictResolution };
    }
    const updateData = {
      updated_at: (/* @__PURE__ */ new Date()).toISOString(),
      last_modified_by: currentUser.id,
      version: (currentTrip.version || 0) + 1
    };
    if (updates.name !== void 0) updateData.name = updates.name;
    if (updates.notes !== void 0) updateData.notes = updates.notes;
    if (updates.days !== void 0) updateData.days = updates.days;
    if (updates.accommodation !== void 0) updateData.accommodation = updates.accommodation;
    if (updates.travelingParty !== void 0) updateData.traveling_party = updates.travelingParty;
    if (updates.startDate !== void 0) updateData.start_date = updates.startDate;
    if (updates.endDate !== void 0) updateData.end_date = updates.endDate;
    const { data: updatedTrip, error: updateError } = await supabase.from("trips").update(updateData).eq("id", tripId).eq("version", currentTrip.version).select().single();
    if (updateError) {
      if (updateError.code === "PGRST116") {
        return this.updateTripWithConflictResolution(tripId, updates, expectedVersion);
      }
      throw new Error(`Failed to update trip: ${updateError.message}`);
    }
    await this.logTripActivity(
      tripId,
      currentUser.id,
      "updated",
      this.generateUpdateDescription(updates),
      { updatedFields: Object.keys(updates) }
    );
    await this.broadcastTripChanges(tripId, updates, currentUser.id);
    const trip = this.formatTripFromDatabase(updatedTrip);
    return { trip };
  }
  async resolveConflict(tripId, conflictResolution, resolution, mergedData) {
    const currentUser = authService.getState().user;
    if (!currentUser) {
      throw new Error("User must be authenticated");
    }
    let finalData;
    switch (resolution) {
      case "accept_server":
        const { data: serverTrip } = await supabase.from("trips").select("*").eq("id", tripId).single();
        return this.formatTripFromDatabase(serverTrip);
      case "accept_local":
        finalData = conflictResolution.localData;
        break;
      case "manual_merge":
        if (!mergedData) {
          throw new Error("Merged data is required for manual merge resolution");
        }
        finalData = mergedData;
        break;
      default:
        throw new Error("Invalid conflict resolution type");
    }
    const result = await this.updateTripWithConflictResolution(
      tripId,
      finalData,
      conflictResolution.serverVersion
    );
    if (result.conflictResolution) {
      throw new Error("Unable to resolve conflict - another update occurred during resolution");
    }
    await this.logTripActivity(
      tripId,
      currentUser.id,
      "updated",
      `Resolved conflict using ${resolution} strategy`,
      { conflictType: conflictResolution.conflictType, resolution }
    );
    return result.trip;
  }
  async getUserPermission(tripId, userId) {
    const { data: trip } = await supabase.from("trips").select("user_id").eq("id", tripId).single();
    if (trip?.user_id === userId) {
      return "admin";
    }
    const { data: collaborator } = await supabase.from("trip_collaborators").select("permission_level").eq("trip_id", tripId).eq("user_id", userId).single();
    return collaborator?.permission_level || null;
  }
  async subscribeToTripChanges(tripId, onUpdate, onCollaboratorJoin, onCollaboratorLeave) {
    const channelName = `trip:${tripId}`;
    if (this.realtimeChannels.has(channelName)) {
      await supabase.removeChannel(this.realtimeChannels.get(channelName));
    }
    const channel = supabase.channel(channelName).on(
      "postgres_changes",
      {
        event: "UPDATE",
        schema: "public",
        table: "trips",
        filter: `id=eq.${tripId}`
      },
      (payload) => {
        onUpdate(payload.new);
      }
    ).on(
      "postgres_changes",
      {
        event: "INSERT",
        schema: "public",
        table: "trip_collaborators",
        filter: `trip_id=eq.${tripId}`
      },
      async (payload) => {
        const collaborator = await this.formatCollaboratorFromPayload(payload.new);
        onCollaboratorJoin(collaborator);
      }
    ).on(
      "postgres_changes",
      {
        event: "DELETE",
        schema: "public",
        table: "trip_collaborators",
        filter: `trip_id=eq.${tripId}`
      },
      (payload) => {
        onCollaboratorLeave(payload.old.id);
      }
    ).subscribe();
    this.realtimeChannels.set(channelName, channel);
    return async () => {
      await supabase.removeChannel(channel);
      this.realtimeChannels.delete(channelName);
    };
  }
  async getTripActivityLog(tripId, limit = 50) {
    const { data, error } = await supabase.from("trip_activity_log").select(`
        *,
        profiles!trip_activity_log_user_id_fkey(full_name, email)
      `).eq("trip_id", tripId).order("created_at", { ascending: false }).limit(limit);
    if (error) {
      throw new Error(`Failed to fetch activity log: ${error.message}`);
    }
    return (data || []).map((item) => ({
      id: item.id,
      tripId: item.trip_id,
      userId: item.user_id,
      userName: item.profiles?.full_name || item.profiles?.email,
      actionType: item.action_type,
      description: item.description,
      metadata: item.metadata,
      createdAt: item.created_at
    }));
  }
  // Private helper methods
  identifyConflictedFields(localData, serverData) {
    const conflicts = [];
    if (localData.name && localData.name !== serverData.name) conflicts.push("name");
    if (localData.notes && localData.notes !== serverData.notes) conflicts.push("notes");
    if (localData.days && JSON.stringify(localData.days) !== JSON.stringify(serverData.days)) {
      conflicts.push("days");
    }
    if (localData.accommodation && JSON.stringify(localData.accommodation) !== JSON.stringify(serverData.accommodation)) {
      conflicts.push("accommodation");
    }
    if (localData.travelingParty && JSON.stringify(localData.travelingParty) !== JSON.stringify(serverData.traveling_party)) {
      conflicts.push("travelingParty");
    }
    return conflicts;
  }
  suggestResolution(localData, serverData) {
    const conflicts = this.identifyConflictedFields(localData, serverData);
    if (conflicts.length === 0) return "accept_server";
    if (conflicts.length === 1) return "accept_local";
    return "manual_merge";
  }
  generateUpdateDescription(updates) {
    const descriptions = [];
    if (updates.name) descriptions.push("updated trip name");
    if (updates.notes) descriptions.push("updated trip notes");
    if (updates.days) descriptions.push("updated trip itinerary");
    if (updates.accommodation) descriptions.push("updated accommodation details");
    if (updates.travelingParty) descriptions.push("updated traveling party");
    if (updates.startDate || updates.endDate) descriptions.push("updated trip dates");
    return descriptions.length > 0 ? descriptions.join(", ") : "updated trip details";
  }
  async broadcastTripChanges(tripId, changes, _userId) {
    console.log(`\u{1F4E1} Broadcasting changes for trip ${tripId}:`, changes);
  }
  async logTripActivity(tripId, userId, actionType, description, metadata) {
    await supabase.from("trip_activity_log").insert({
      trip_id: tripId,
      user_id: userId,
      action_type: actionType,
      description,
      metadata
    });
  }
  formatTripFromDatabase(data) {
    return {
      id: data.id,
      name: data.name,
      startDate: data.start_date,
      endDate: data.end_date,
      days: data.days || [],
      notes: data.notes,
      accommodation: data.accommodation,
      travelingParty: data.traveling_party,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
      ownerId: data.user_id,
      isShared: data.is_shared,
      lastModifiedBy: data.last_modified_by,
      version: data.version
    };
  }
  async formatCollaboratorFromPayload(data) {
    const { data: profile } = await supabase.from("profiles").select("email, full_name").eq("id", data.user_id).single();
    return {
      id: data.id,
      tripId: data.trip_id,
      userId: data.user_id,
      userEmail: profile?.email,
      userFullName: profile?.full_name,
      permissionLevel: data.permission_level,
      invitedBy: data.invited_by,
      joinedAt: data.joined_at,
      createdAt: data.created_at,
      updatedAt: data.updated_at
    };
  }
};
var collaborationService = CollaborationService.getInstance();

// src/services/weatherService.ts
import { createClient as createClient2 } from "@supabase/supabase-js";

// src/services/weatherRecommendationEngine.ts
var WeatherRecommendationEngineImpl = class {
  getClothingRecommendations(forecast) {
    const recommendations = [];
    const { temperatureHigh, precipitationChance, weatherCondition } = forecast;
    if (precipitationChance >= 30) {
      recommendations.push("Bring an umbrella or poncho");
    }
    if (precipitationChance >= 60) {
      recommendations.push("Waterproof shoes recommended");
    }
    if (temperatureHigh >= 95) {
      recommendations.push("Light, breathable, light-colored clothing");
      recommendations.push("Wide-brimmed hat for sun protection");
    } else if (temperatureHigh >= 85) {
      recommendations.push("Comfortable, moisture-wicking clothing");
      recommendations.push("Sun hat and sunglasses");
    } else if (temperatureHigh >= 75) {
      recommendations.push("Light layers - it may get warm");
    } else if (temperatureHigh >= 65) {
      recommendations.push("Light jacket or sweater for evening");
    } else {
      recommendations.push("Warm clothing and layers");
    }
    if (weatherCondition === "thunderstorm") {
      recommendations.push("Avoid metal accessories during storms");
    }
    if (temperatureHigh >= 75) {
      recommendations.push("Sunscreen (SPF 30 or higher)");
    }
    return recommendations;
  }
  getActivityRecommendations(forecast, availableAttractions) {
    const { weatherCondition, temperatureHigh, precipitationChance } = forecast;
    const highly_recommended = [];
    const recommended = [];
    const neutral = [];
    const avoid = [];
    for (const attraction of availableAttractions) {
      const features = attraction.features || {};
      if (weatherCondition === "rain" || weatherCondition === "thunderstorm" || precipitationChance >= 70) {
        if (features.rainSafe || features.airConditioning || !features.outdoorExperience) {
          if (attraction.type === "show" || features.airConditioning) {
            highly_recommended.push(attraction);
          } else {
            recommended.push(attraction);
          }
        } else if (features.outdoorExperience) {
          avoid.push(attraction);
        } else {
          neutral.push(attraction);
        }
      } else if (temperatureHigh >= 95) {
        if (features.airConditioning || !features.outdoorExperience) {
          highly_recommended.push(attraction);
        } else if (features.getsWet) {
          recommended.push(attraction);
        } else if (features.outdoorExperience) {
          avoid.push(attraction);
        } else {
          neutral.push(attraction);
        }
      } else if (temperatureHigh >= 85) {
        if (features.getsWet) {
          highly_recommended.push(attraction);
        } else if (features.airConditioning) {
          recommended.push(attraction);
        } else if (features.outdoorExperience && !features.getsWet) {
          neutral.push(attraction);
        } else {
          recommended.push(attraction);
        }
      } else if (weatherCondition === "clear" && temperatureHigh >= 70 && temperatureHigh <= 84) {
        if (features.outdoorExperience) {
          highly_recommended.push(attraction);
        } else {
          recommended.push(attraction);
        }
      } else {
        recommended.push(attraction);
      }
    }
    return {
      highly_recommended,
      recommended,
      neutral,
      avoid
    };
  }
  getPackingRecommendations(forecasts) {
    const recommendations = [];
    const maxTemp = Math.max(...forecasts.map((f) => f.temperatureHigh));
    const minTemp = Math.min(...forecasts.map((f) => f.temperatureLow));
    const maxRainChance = Math.max(...forecasts.map((f) => f.precipitationChance));
    const hasStorms = forecasts.some((f) => f.weatherCondition === "thunderstorm");
    const tempRange = maxTemp - minTemp;
    if (tempRange > 20) {
      recommendations.push("Pack layers - temperature will vary significantly");
    }
    if (maxTemp >= 95) {
      recommendations.push("Cooling towel or personal fan");
      recommendations.push("Extra water bottles");
      recommendations.push("Electrolyte supplements");
    }
    if (minTemp <= 60) {
      recommendations.push("Warm jacket for cooler moments");
    }
    if (maxRainChance >= 50) {
      recommendations.push("Waterproof bag for electronics");
      recommendations.push("Extra clothes in case you get wet");
    }
    if (hasStorms) {
      recommendations.push("Portable phone charger (indoor sheltering may be needed)");
    }
    recommendations.push("Comfortable walking shoes with good grip");
    recommendations.push("Sunscreen and lip balm with SPF");
    if (maxTemp >= 80) {
      recommendations.push("Reusable water bottle");
    }
    return recommendations;
  }
  getDiningRecommendations(forecast, availableDining) {
    const { weatherCondition, temperatureHigh, precipitationChance } = forecast;
    const recommended = [];
    for (const dining of availableDining) {
      const features = dining.features || {};
      if (weatherCondition === "rain" || weatherCondition === "thunderstorm" || precipitationChance >= 70) {
        if (!features.outdoorSeating || features.coveredSeating) {
          recommended.push({
            ...dining,
            weatherReason: "Indoor seating recommended for rain protection"
          });
        }
      } else if (temperatureHigh >= 95) {
        if (features.airConditioning) {
          recommended.push({
            ...dining,
            weatherReason: "Air conditioning provides relief from heat"
          });
        }
      } else if (weatherCondition === "clear" && temperatureHigh >= 70 && temperatureHigh <= 84) {
        if (features.outdoorSeating) {
          recommended.push({
            ...dining,
            weatherReason: "Perfect weather for outdoor dining"
          });
        }
      }
    }
    return recommended;
  }
  calculateComfortIndex(forecast) {
    const { temperatureHigh, temperatureFeelsLike, humidity } = forecast;
    let heatIndex = temperatureFeelsLike;
    if (humidity > 70 && temperatureHigh > 80) {
      heatIndex += 5;
    }
    let comfortLevel = "comfortable";
    const recommendations = [];
    if (heatIndex >= 105) {
      comfortLevel = "dangerous";
      recommendations.push("Limit outdoor exposure");
      recommendations.push("Seek air-conditioned areas frequently");
      recommendations.push("Stay very well hydrated");
      recommendations.push("Consider postponing outdoor activities");
    } else if (heatIndex >= 95) {
      comfortLevel = "hot";
      recommendations.push("Take frequent breaks in shade or AC");
      recommendations.push("Stay well hydrated");
      recommendations.push("Wear light, breathable clothing");
      recommendations.push("Avoid strenuous outdoor activities during peak heat");
    } else if (heatIndex >= 85) {
      comfortLevel = "warm";
      recommendations.push("Stay hydrated");
      recommendations.push("Consider sunscreen and hat");
      recommendations.push("Take breaks in shaded areas");
    } else if (heatIndex >= 70) {
      comfortLevel = "comfortable";
      recommendations.push("Great weather for outdoor activities");
    } else {
      comfortLevel = "comfortable";
      recommendations.push("May need light layers for warmth");
    }
    if (humidity > 70) {
      recommendations.push("High humidity - expect to feel hotter than actual temperature");
    }
    return {
      temperature: temperatureHigh,
      feelsLike: temperatureFeelsLike,
      humidity,
      heatIndex,
      comfortLevel,
      recommendations
    };
  }
  getWeatherAlerts(forecast) {
    const alerts = [];
    if (forecast.weatherCondition === "thunderstorm") {
      alerts.push({
        type: "severe",
        title: "Thunderstorm Warning",
        message: "Outdoor attractions may close. Seek indoor shelter during storms."
      });
    }
    if (forecast.temperatureFeelsLike >= 105) {
      alerts.push({
        type: "severe",
        title: "Extreme Heat Warning",
        message: "Dangerous heat conditions. Limit outdoor exposure and stay hydrated."
      });
    } else if (forecast.temperatureFeelsLike >= 95) {
      alerts.push({
        type: "warning",
        title: "Heat Advisory",
        message: "Very hot conditions expected. Take frequent breaks and stay hydrated."
      });
    }
    if (forecast.precipitationChance >= 80) {
      alerts.push({
        type: "warning",
        title: "Heavy Rain Expected",
        message: "High chance of rain. Bring rain gear and plan indoor activities."
      });
    } else if (forecast.precipitationChance >= 50) {
      alerts.push({
        type: "info",
        title: "Rain Possible",
        message: "Pack an umbrella or poncho just in case."
      });
    }
    return alerts;
  }
};
var weatherRecommendationEngine = new WeatherRecommendationEngineImpl();

// src/services/weatherService.ts
var WeatherService = class {
  constructor(supabaseUrl2, supabaseKey) {
    this.defaultLocationName = "Walt Disney World";
    this.supabase = createClient2(supabaseUrl2, supabaseKey);
  }
  async getForecastForDate(date, locationId) {
    try {
      let query = this.supabase.from("weather_forecasts").select("*").eq("forecast_date", date).order("forecast_time", { ascending: false }).limit(1);
      if (locationId) {
        query = query.eq("location_id", locationId);
      } else {
        const { data: location } = await this.supabase.from("weather_locations").select("id").eq("name", this.defaultLocationName).single();
        if (location) {
          query = query.eq("location_id", location.id);
        }
      }
      const { data, error } = await query;
      if (error) {
        throw this.createWeatherError("API_ERROR", `Failed to fetch forecast: ${error.message}`, error);
      }
      return data && data.length > 0 ? data[0] : null;
    } catch (error) {
      if (error instanceof Error && error.message.includes("WeatherError")) {
        throw error;
      }
      throw this.createWeatherError("NETWORK_ERROR", "Network error while fetching forecast", error);
    }
  }
  async getForecastForDateRange(startDate, endDate, locationId) {
    try {
      let query = this.supabase.from("weather_forecasts").select(`
          *,
          weather_locations!inner(name, latitude, longitude)
        `).gte("forecast_date", startDate).lte("forecast_date", endDate).order("forecast_date", { ascending: true });
      if (locationId) {
        query = query.eq("location_id", locationId);
      } else {
        query = query.eq("weather_locations.name", this.defaultLocationName);
      }
      const { data, error } = await query;
      if (error) {
        throw this.createWeatherError("API_ERROR", `Failed to fetch forecast range: ${error.message}`, error);
      }
      return data || [];
    } catch (error) {
      if (error instanceof Error && error.message.includes("WeatherError")) {
        throw error;
      }
      throw this.createWeatherError("NETWORK_ERROR", "Network error while fetching forecast range", error);
    }
  }
  async getRecommendationsForWeather(condition) {
    try {
      const { data, error } = await this.supabase.from("weather_recommendations").select("*").eq("weather_condition", condition).eq("is_active", true).order("priority", { ascending: false });
      if (error) {
        throw this.createWeatherError("API_ERROR", `Failed to fetch recommendations: ${error.message}`, error);
      }
      return data || [];
    } catch (error) {
      if (error instanceof Error && error.message.includes("WeatherError")) {
        throw error;
      }
      throw this.createWeatherError("NETWORK_ERROR", "Network error while fetching recommendations", error);
    }
  }
  async getWeatherLocation(name) {
    try {
      const { data, error } = await this.supabase.from("weather_locations").select("*").eq("name", name).single();
      if (error && error.code !== "PGRST116") {
        throw this.createWeatherError("API_ERROR", `Failed to fetch location: ${error.message}`, error);
      }
      return data || null;
    } catch (error) {
      if (error instanceof Error && error.message.includes("WeatherError")) {
        throw error;
      }
      throw this.createWeatherError("LOCATION_ERROR", "Error while fetching weather location", error);
    }
  }
  async getDefaultLocation() {
    const location = await this.getWeatherLocation(this.defaultLocationName);
    if (!location) {
      throw this.createWeatherError("LOCATION_ERROR", "Default weather location not found", null);
    }
    return location;
  }
  getIndoorAttractions(attractionIds) {
    return attractionIds.filter((_id) => {
      return true;
    });
  }
  getOutdoorAttractions(attractionIds) {
    return attractionIds.filter((_id) => {
      return true;
    });
  }
  getWeatherAppropriateAttractions(attractionIds, weatherCondition) {
    switch (weatherCondition) {
      case "rain":
      case "thunderstorm":
        return {
          recommended: this.getIndoorAttractions(attractionIds),
          avoid: this.getOutdoorAttractions(attractionIds),
          neutral: []
        };
      case "clear":
        return {
          recommended: attractionIds,
          // All attractions are good in clear weather
          avoid: [],
          neutral: []
        };
      default:
        return {
          recommended: [],
          avoid: [],
          neutral: attractionIds
        };
    }
  }
  // Weather-aware recommendation methods using the recommendation engine
  getActivityRecommendationsForWeather(forecast, availableAttractions) {
    return weatherRecommendationEngine.getActivityRecommendations(forecast, availableAttractions);
  }
  getClothingRecommendations(forecast) {
    return weatherRecommendationEngine.getClothingRecommendations(forecast);
  }
  getPackingRecommendations(forecasts) {
    return weatherRecommendationEngine.getPackingRecommendations(forecasts);
  }
  getDiningRecommendationsForWeather(forecast, availableDining) {
    return weatherRecommendationEngine.getDiningRecommendations(forecast, availableDining);
  }
  async generateBackupPlan(originalPlan, weather, attractionPool) {
    if (weather.weatherCondition === "rain" || weather.weatherCondition === "thunderstorm") {
      const recommendations = this.getActivityRecommendationsForWeather(weather, attractionPool);
      const goodWeatherOptions = [
        ...recommendations.highly_recommended,
        ...recommendations.recommended
      ];
      return originalPlan.map((item) => {
        const originalAttraction = attractionPool.find((a) => a.id === item.attractionId);
        const shouldAvoid = recommendations.avoid.some((avoided) => avoided.id === item.attractionId);
        if (shouldAvoid && originalAttraction) {
          const replacement = goodWeatherOptions.find(
            (option) => option.type === originalAttraction.type && option.parkId === originalAttraction.parkId
          );
          if (replacement) {
            return {
              ...item,
              attractionId: replacement.id,
              notes: `${item.notes || ""} (Weather backup: ${replacement.name} - indoor alternative)`.trim()
            };
          }
        }
        return item;
      });
    }
    if (weather.temperatureHigh >= 95) {
      const recommendations = this.getActivityRecommendationsForWeather(weather, attractionPool);
      const coolOptions = [
        ...recommendations.highly_recommended,
        ...recommendations.recommended
      ];
      return originalPlan.map((item) => {
        const originalAttraction = attractionPool.find((a) => a.id === item.attractionId);
        const shouldAvoid = recommendations.avoid.some((avoided) => avoided.id === item.attractionId);
        if (shouldAvoid && originalAttraction) {
          const replacement = coolOptions.find(
            (option) => option.parkId === originalAttraction.parkId
          );
          if (replacement) {
            return {
              ...item,
              attractionId: replacement.id,
              notes: `${item.notes || ""} (Heat backup: ${replacement.name} - cooler alternative)`.trim()
            };
          }
        }
        return item;
      });
    }
    return originalPlan;
  }
  // Utility methods
  calculateComfortIndex(forecast) {
    return weatherRecommendationEngine.calculateComfortIndex(forecast);
  }
  getWeatherIcon(condition) {
    const iconMap = {
      clear: "\u2600\uFE0F",
      clouds: "\u2601\uFE0F",
      rain: "\u{1F327}\uFE0F",
      thunderstorm: "\u26C8\uFE0F",
      snow: "\u2744\uFE0F",
      cloudy: "\u{1F325}\uFE0F"
    };
    return iconMap[condition] || "\u{1F324}\uFE0F";
  }
  createWeatherError(code, message, details) {
    return {
      code,
      message,
      details,
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
};
var weatherServiceInstance = null;
function createWeatherService(supabaseUrl2, supabaseKey) {
  if (!weatherServiceInstance) {
    weatherServiceInstance = new WeatherService(supabaseUrl2, supabaseKey);
  }
  return weatherServiceInstance;
}

// src/services/thrillDataService.ts
var THRILL_DATA_BASE_URL = "https://www.thrill-data.com/trip-planning/crowd-calendar";
var ThrillDataService = class {
  constructor() {
    this.cache = /* @__PURE__ */ new Map();
    this.defaultCacheTTL = 24 * 60 * 60 * 1e3;
  }
  // 24 hours
  async fetchCrowdPredictionsForYear(waypointParkId, year) {
    const thrillDataId = getThrillDataId(waypointParkId);
    if (!thrillDataId) {
      throw new Error(`No Thrill Data mapping found for park: ${waypointParkId}`);
    }
    try {
      const url = `${THRILL_DATA_BASE_URL}/${thrillDataId}/calendar/${year}`;
      const predictions = await this.scrapeCrowdCalendar(url, year);
      return predictions.map((prediction) => ({
        parkId: waypointParkId,
        predictionDate: prediction.date,
        crowdLevel: this.mapWaitTimeToCrowdLevel(prediction.waitTime),
        description: this.mapCrowdLevelToDescription(this.mapWaitTimeToCrowdLevel(prediction.waitTime)),
        recommendation: this.getCrowdRecommendation(this.mapWaitTimeToCrowdLevel(prediction.waitTime)),
        dataSource: "thrill_data_api",
        lastUpdated: (/* @__PURE__ */ new Date()).toISOString()
      }));
    } catch (error) {
      const apiError = {
        code: "API_ERROR",
        message: `Failed to fetch Thrill Data predictions for ${waypointParkId}`,
        details: { waypointParkId, year, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw apiError;
    }
  }
  async scrapeCrowdCalendar(url, year) {
    const cacheKey = `thrill_data_${url}`;
    const cached = this.cache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < cached.ttl) {
      return cached.data;
    }
    try {
      const response = await fetch(url);
      if (!response.ok) {
        if (response.status === 429) {
          const apiError = {
            code: "RATE_LIMITED",
            message: "Thrill Data rate limit exceeded",
            details: { url, status: response.status },
            timestamp: (/* @__PURE__ */ new Date()).toISOString()
          };
          throw apiError;
        }
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const html = await response.text();
      const predictions = this.parseCalendarHTML(html, year);
      this.cache.set(cacheKey, {
        data: predictions,
        timestamp: Date.now(),
        ttl: this.defaultCacheTTL
      });
      return predictions;
    } catch (error) {
      if (error instanceof Error && "code" in error) {
        throw error;
      }
      const apiError = {
        code: "PARSE_ERROR",
        message: error instanceof Error ? error.message : "Unknown Thrill Data scraping error",
        details: { url, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw apiError;
    }
  }
  parseCalendarHTML(html, year) {
    const predictions = [];
    const linkPattern = /\[([A-Z][a-z]{2})\s+(\d{1,2})\s+(\d+)\]/g;
    let match;
    while ((match = linkPattern.exec(html)) !== null) {
      const [, monthName, dayStr, waitTimeStr] = match;
      if (!monthName || !dayStr || !waitTimeStr) {
        console.warn(`Invalid date data: month=${monthName}, day=${dayStr}, waitTime=${waitTimeStr}`);
        continue;
      }
      const waitTime = parseInt(waitTimeStr, 10);
      const day = parseInt(dayStr, 10);
      const monthMap = {
        "Jan": 1,
        "Feb": 2,
        "Mar": 3,
        "Apr": 4,
        "May": 5,
        "Jun": 6,
        "Jul": 7,
        "Aug": 8,
        "Sep": 9,
        "Oct": 10,
        "Nov": 11,
        "Dec": 12
      };
      const month = monthMap[monthName];
      if (!month) {
        console.warn(`Unknown month: ${monthName}`);
        continue;
      }
      const date = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
      predictions.push({
        date,
        waitTime,
        colorLevel: this.mapWaitTimeToColorLevel(waitTime)
      });
    }
    if (predictions.length === 0) {
      const hrefPattern = /href="[^"]*\/(\d{2})\/(\d{2})"[^>]*>\s*\[([A-Z][a-z]{2})\s+\d{1,2}\s+(\d+)\]/g;
      while ((match = hrefPattern.exec(html)) !== null) {
        const [, monthStr, dayStr, , waitTimeStr] = match;
        if (!monthStr || !dayStr || !waitTimeStr) {
          console.warn(`Invalid href data: month=${monthStr}, day=${dayStr}, waitTime=${waitTimeStr}`);
          continue;
        }
        const waitTime = parseInt(waitTimeStr, 10);
        const month = parseInt(monthStr, 10);
        const day = parseInt(dayStr, 10);
        const date = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
        predictions.push({
          date,
          waitTime,
          colorLevel: this.mapWaitTimeToColorLevel(waitTime)
        });
      }
    }
    if (predictions.length === 0) {
      console.warn("No calendar data found with standard patterns, trying fallback parsing");
      const fallbackPattern = /(\d{4})-(\d{2})-(\d{2})[^>]*>.*?(\d{2,3})/g;
      while ((match = fallbackPattern.exec(html)) !== null) {
        const [, year2, month, day, waitTimeStr] = match;
        if (!year2 || !month || !day || !waitTimeStr) {
          continue;
        }
        const waitTime = parseInt(waitTimeStr, 10);
        if (waitTime >= 10 && waitTime <= 60) {
          predictions.push({
            date: `${year2}-${month}-${day}`,
            waitTime,
            colorLevel: this.mapWaitTimeToColorLevel(waitTime)
          });
        }
      }
    }
    console.log(`Parsed ${predictions.length} predictions from Thrill Data calendar`);
    return predictions;
  }
  mapWaitTimeToColorLevel(waitTime) {
    if (waitTime <= 19) return "Lowest";
    if (waitTime <= 25) return "Lower";
    if (waitTime <= 31) return "Average";
    if (waitTime <= 37) return "Higher";
    return "Highest";
  }
  mapWaitTimeToCrowdLevel(waitTime) {
    if (waitTime <= 19) return 2;
    if (waitTime <= 25) return 4;
    if (waitTime <= 31) return 6;
    if (waitTime <= 37) return 8;
    return 10;
  }
  mapCrowdLevelToDescription(level) {
    if (level <= 2) return "Very Low";
    if (level <= 4) return "Low";
    if (level <= 6) return "Moderate";
    if (level <= 8) return "High";
    return "Very High";
  }
  getCrowdRecommendation(level) {
    if (level <= 2) {
      return "Perfect day to visit! Very short wait times expected.";
    }
    if (level <= 4) {
      return "Great day to visit with manageable crowds.";
    }
    if (level <= 6) {
      return "Moderate crowds. Plan your must-do attractions early.";
    }
    if (level <= 8) {
      return "Busy day. Arrive early and consider Lightning Lanes for popular attractions.";
    }
    return "Very busy day. Early arrival and strategic planning highly recommended.";
  }
  clearCache(pattern) {
    if (!pattern) {
      this.cache.clear();
      return;
    }
    for (const [key, _] of this.cache.entries()) {
      if (key.includes(pattern)) {
        this.cache.delete(key);
      }
    }
  }
  getCacheStats() {
    const stats = {};
    for (const [, value] of this.cache.entries()) {
      const category = "thrill_data_predictions";
      if (!stats[category]) {
        stats[category] = {
          size: 0,
          oldestEntry: new Date(value.timestamp).toISOString(),
          newestEntry: new Date(value.timestamp).toISOString()
        };
      }
      stats[category].size++;
      const entryTime = new Date(value.timestamp).toISOString();
      if (entryTime < stats[category].oldestEntry) {
        stats[category].oldestEntry = entryTime;
      }
      if (entryTime > stats[category].newestEntry) {
        stats[category].newestEntry = entryTime;
      }
    }
    return stats;
  }
};
var thrillDataService = new ThrillDataService();

// src/services/importThrillData.ts
var ThrillDataImporter = class {
  async importCrowdPredictionsForYear(year, onProgress) {
    const result = {
      success: false,
      recordsImported: 0,
      parksProcessed: [],
      errors: [],
      dateRange: { start: "", end: "" }
    };
    const totalParks = SUPPORTED_PARK_IDS.length;
    let parksCompleted = 0;
    onProgress?.({
      currentPark: "",
      parksCompleted: 0,
      totalParks,
      recordsImported: 0,
      status: "starting"
    });
    try {
      for (const parkId of SUPPORTED_PARK_IDS) {
        onProgress?.({
          currentPark: parkId,
          parksCompleted,
          totalParks,
          recordsImported: result.recordsImported,
          status: "in_progress"
        });
        try {
          const predictions = await thrillDataService.fetchCrowdPredictionsForYear(parkId, year);
          if (predictions.length > 0) {
            const dbPredictions = predictions.map(
              (prediction) => CrowdPredictionRepository.transformPredictionToDb(prediction)
            );
            await crowdPredictionRepository.upsertCrowdPredictions(dbPredictions);
            result.recordsImported += predictions.length;
            result.parksProcessed.push(parkId);
            const dates = predictions.map((p) => p.predictionDate).sort();
            if (!result.dateRange.start || dates[0] && dates[0] < result.dateRange.start) {
              result.dateRange.start = dates[0] || "";
            }
            const lastDate = dates[dates.length - 1];
            if (!result.dateRange.end || lastDate && lastDate > result.dateRange.end) {
              result.dateRange.end = lastDate || "";
            }
            console.log(`\u2705 Imported ${predictions.length} predictions for ${parkId}`);
          } else {
            console.warn(`\u26A0\uFE0F No predictions found for ${parkId}`);
            result.errors.push(`No predictions found for ${parkId}`);
          }
        } catch (error) {
          const errorMessage = error instanceof Error ? error.message : `Unknown error for ${parkId}`;
          console.error(`\u274C Failed to import ${parkId}:`, errorMessage);
          result.errors.push(`${parkId}: ${errorMessage}`);
        }
        parksCompleted++;
        onProgress?.({
          currentPark: parkId,
          parksCompleted,
          totalParks,
          recordsImported: result.recordsImported,
          status: "in_progress"
        });
        await new Promise((resolve) => setTimeout(resolve, 1e3));
      }
      result.success = result.parksProcessed.length > 0;
      onProgress?.({
        currentPark: "",
        parksCompleted,
        totalParks,
        recordsImported: result.recordsImported,
        status: result.success ? "completed" : "error"
      });
      return result;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Unknown import error";
      result.errors.push(errorMessage);
      onProgress?.({
        currentPark: "",
        parksCompleted,
        totalParks,
        recordsImported: result.recordsImported,
        status: "error",
        error: errorMessage
      });
      const apiError = {
        code: "API_ERROR",
        message: `Failed to import Thrill Data for ${year}`,
        details: { year, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw apiError;
    }
  }
  async getImportStats() {
    try {
      const stats = await crowdPredictionRepository.getCrowdPredictionStats();
      const parkCounts = {};
      for (const parkId of SUPPORTED_PARK_IDS) {
        const parkStats = await crowdPredictionRepository.getCrowdPredictionStats(parkId);
        parkCounts[parkId] = parkStats.totalPredictions;
      }
      return {
        ...stats,
        parkCounts
      };
    } catch (error) {
      const apiError = {
        code: "API_ERROR",
        message: "Failed to get import statistics",
        details: { error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw apiError;
    }
  }
  async clearExistingPredictions(year) {
    try {
      console.log(`Clearing existing predictions for ${year} (will be overwritten on import)`);
      return 0;
    } catch (error) {
      const apiError = {
        code: "API_ERROR",
        message: `Failed to clear existing predictions for ${year}`,
        details: { year, error },
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      throw apiError;
    }
  }
};
var thrillDataImporter = new ThrillDataImporter();
async function importThrillData2025(onProgress) {
  return thrillDataImporter.importCrowdPredictionsForYear(2025, onProgress);
}

// src/index.ts
var APP_NAME = "Waylight";
var APP_VERSION = "1.0.0";
var APP_TAGLINE = "Plan smarter. Wander farther.";
var colors = {
  ink: "#0F172A",
  surface: "#F8FAFC",
  sea: "#0EA5A8",
  glow: "#FBBF24",
  // Extended palette
  inkLight: "#475569",
  surfaceDark: "#E2E8F0",
  seaLight: "#22D3EE",
  seaDark: "#0891B2",
  glowLight: "#FCD34D",
  glowDark: "#F59E0B"
};
var defaultSettings = {
  showTips: true,
  tipCategories: [
    "best_time",
    "strategy",
    "general"
  ],
  viewMode: "list",
  theme: "system",
  notifications: {
    enabled: false,
    reminderTime: 15,
    dailyPlanReminder: false
  }
};
export {
  APP_NAME,
  APP_TAGLINE,
  APP_VERSION,
  ActivityRatingsService,
  AttractionType,
  AuthService,
  BackgroundSyncService,
  BaseStorageAdapter,
  CollaborationService,
  CrowdPredictionRepository,
  IntensityLevel,
  InvitationService,
  LiveDataService,
  PARK_MAPPINGS,
  QueueTimesAPIClient,
  SUPPORTED_PARK_IDS,
  SyncService,
  Theme,
  ThemeParksAPIClient,
  ThrillDataImporter,
  ThrillDataService,
  TipCategory,
  ViewMode,
  WeatherRecommendationEngineImpl,
  WeatherService,
  addDayToTrip,
  addItemToDay,
  allHotels,
  authService,
  backgroundSyncService,
  collaborationService,
  colors,
  createTrip,
  createWeatherService,
  crowdPredictionRepository,
  defaultSettings,
  disneyResortDining,
  disneyResorts,
  duplicateTrip,
  entertainment,
  experiences,
  exportToJSON,
  exportToText,
  formatDate,
  formatDuration,
  formatTime,
  generateShareText,
  getAllDoItems,
  getAllEatItems,
  getCharacterDining,
  getContentManifest,
  getCountdownDays,
  getDaysBetween,
  getDoItemById,
  getDoItemsByPark,
  getDoItemsByType,
  getEatItemById,
  getEatItemsByCuisine,
  getEatItemsByPark,
  getEatItemsByPriceLevel,
  getEatItemsByResort,
  getEatItemsByType,
  getEntertainmentSchedules,
  getEntertainmentShowTimes,
  getHotelById,
  getHotelOptions,
  getHotelsByType,
  getLoungesByResort,
  getPark,
  getParkMapping,
  getParks,
  getQueueTimesId,
  getQuickServiceByResort,
  getResortDiningByResortId,
  getRoomsForHotel,
  getSignatureDining,
  getTableServiceByResort,
  getThemeParksWikiId,
  getThrillDataId,
  getTripDates,
  getTripStats,
  getWaypointParkId,
  importThrillData2025,
  invitationService,
  isParkSupported,
  liveDataService,
  lounges,
  meetGreets,
  otherHotels,
  otherHotelsDining,
  parks,
  queueTimesApiClient,
  quickServiceRestaurants,
  removeItemFromDay,
  reorderDayItems,
  resortDining,
  rides,
  shows,
  snackStands,
  supabase,
  syncService,
  tableServiceRestaurants,
  themeParksApiClient,
  thrillDataImporter,
  thrillDataService,
  toggleItemCompleted,
  transportation,
  universalResortDining,
  universalResorts,
  updateTrip,
  updateTripDay,
  validateAttractionRequirements,
  validateContent,
  validateItineraryItem,
  validateTimeConflicts,
  validateTrip,
  validateTripDay,
  weatherRecommendationEngine
};
//# sourceMappingURL=index.mjs.map